//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AuthorizedApiBase {
    private readonly config: IConfig;

    protected constructor(config: IConfig) {
        this.config = config;
    }

    protected transformOptions = (options: AxiosRequestConfig): Promise<AxiosRequestConfig> => {

        options.headers = {
            ...options.headers,
            Authorization: this.config.getAuthorization(),
        };
        return Promise.resolve(options);
    };
}

export class Auth0WebhookClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param app_metadata (optional) 
     * @param created_at (optional) 
     * @param email (optional) 
     * @param email_verified (optional) 
     * @param family_name (optional) 
     * @param given_name (optional) 
     * @param last_password_reset (optional) 
     * @param multifactor (optional) 
     * @param name (optional) 
     * @param nickname (optional) 
     * @param phone_number (optional) 
     * @param phone_verified (optional) 
     * @param picture (optional) 
     * @param updated_at (optional) 
     * @param user_id (optional) 
     * @param user_metadata (optional) 
     * @param username (optional) 
     * @return Success
     */
    postRegistration(app_metadata?: { [key: string]: string; } | undefined, created_at?: string | undefined, email?: string | undefined, email_verified?: boolean | undefined, family_name?: string | undefined, given_name?: string | undefined, last_password_reset?: string | undefined, multifactor?: string[] | undefined, name?: string | undefined, nickname?: string | undefined, phone_number?: string | undefined, phone_verified?: boolean | undefined, picture?: string | undefined, updated_at?: string | undefined, user_id?: string | undefined, user_metadata?: { [key: string]: string; } | undefined, username?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/webhooks/auth0/post-registration?";
        if (app_metadata === null)
            throw new Error("The parameter 'app_metadata' cannot be null.");
        else if (app_metadata !== undefined)
            url_ += "app_metadata=" + encodeURIComponent("" + app_metadata) + "&";
        if (created_at === null)
            throw new Error("The parameter 'created_at' cannot be null.");
        else if (created_at !== undefined)
            url_ += "created_at=" + encodeURIComponent("" + created_at) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (email_verified === null)
            throw new Error("The parameter 'email_verified' cannot be null.");
        else if (email_verified !== undefined)
            url_ += "email_verified=" + encodeURIComponent("" + email_verified) + "&";
        if (family_name === null)
            throw new Error("The parameter 'family_name' cannot be null.");
        else if (family_name !== undefined)
            url_ += "family_name=" + encodeURIComponent("" + family_name) + "&";
        if (given_name === null)
            throw new Error("The parameter 'given_name' cannot be null.");
        else if (given_name !== undefined)
            url_ += "given_name=" + encodeURIComponent("" + given_name) + "&";
        if (last_password_reset === null)
            throw new Error("The parameter 'last_password_reset' cannot be null.");
        else if (last_password_reset !== undefined)
            url_ += "last_password_reset=" + encodeURIComponent("" + last_password_reset) + "&";
        if (multifactor === null)
            throw new Error("The parameter 'multifactor' cannot be null.");
        else if (multifactor !== undefined)
            multifactor && multifactor.forEach(item => { url_ += "multifactor=" + encodeURIComponent("" + item) + "&"; });
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (nickname === null)
            throw new Error("The parameter 'nickname' cannot be null.");
        else if (nickname !== undefined)
            url_ += "nickname=" + encodeURIComponent("" + nickname) + "&";
        if (phone_number === null)
            throw new Error("The parameter 'phone_number' cannot be null.");
        else if (phone_number !== undefined)
            url_ += "phone_number=" + encodeURIComponent("" + phone_number) + "&";
        if (phone_verified === null)
            throw new Error("The parameter 'phone_verified' cannot be null.");
        else if (phone_verified !== undefined)
            url_ += "phone_verified=" + encodeURIComponent("" + phone_verified) + "&";
        if (picture === null)
            throw new Error("The parameter 'picture' cannot be null.");
        else if (picture !== undefined)
            url_ += "picture=" + encodeURIComponent("" + picture) + "&";
        if (updated_at === null)
            throw new Error("The parameter 'updated_at' cannot be null.");
        else if (updated_at !== undefined)
            url_ += "updated_at=" + encodeURIComponent("" + updated_at) + "&";
        if (user_id === null)
            throw new Error("The parameter 'user_id' cannot be null.");
        else if (user_id !== undefined)
            url_ += "user_id=" + encodeURIComponent("" + user_id) + "&";
        if (user_metadata === null)
            throw new Error("The parameter 'user_metadata' cannot be null.");
        else if (user_metadata !== undefined)
            url_ += "user_metadata=" + encodeURIComponent("" + user_metadata) + "&";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostRegistration(_response);
        });
    }

    protected processPostRegistration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BookingClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Booking
     * @param checkStripeStatuses (optional) 
     * @return Success
     */
    booking(id: string, checkStripeStatuses?: boolean | undefined, cancelToken?: CancelToken): Promise<BookingSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (checkStripeStatuses === null)
            throw new Error("The parameter 'checkStripeStatuses' cannot be null.");
        else if (checkStripeStatuses !== undefined)
            url_ += "CheckStripeStatuses=" + encodeURIComponent("" + checkStripeStatuses) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking(_response);
        });
    }

    protected processBooking(response: AxiosResponse): Promise<BookingSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingSimpleDto.fromJS(resultData200);
            return Promise.resolve<BookingSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Booking
     * @param checkStripeStatuses (optional) 
     * @return Success
     */
    detailed(id: string, checkStripeStatuses?: boolean | undefined, cancelToken?: CancelToken): Promise<BookingDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/detailed?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (checkStripeStatuses === null)
            throw new Error("The parameter 'checkStripeStatuses' cannot be null.");
        else if (checkStripeStatuses !== undefined)
            url_ += "CheckStripeStatuses=" + encodeURIComponent("" + checkStripeStatuses) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed(_response);
        });
    }

    protected processDetailed(response: AxiosResponse): Promise<BookingDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingDetailedDto.fromJS(resultData200);
            return Promise.resolve<BookingDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingDetailedDto>(null as any);
    }

    /**
     * Gets all Bookings in Simple format
     * @param includeInactive (optional) 
     * @param checkStripeStatuses (optional) 
     * @param isSharer (optional) 
     * @param statuses (optional) 
     * @param showAll (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @param orderBy (optional) 
     * @param userId (optional) Get Bookings exclusively for this User
     * @return Success
     */
    booking2(includeInactive?: boolean | undefined, checkStripeStatuses?: boolean | undefined, isSharer?: boolean | undefined, statuses?: BookingStatus[] | undefined, showAll?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, orderBy?: BookingOrderBy | undefined, userId?: string | undefined, cancelToken?: CancelToken): Promise<BookingSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Booking?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (checkStripeStatuses === null)
            throw new Error("The parameter 'checkStripeStatuses' cannot be null.");
        else if (checkStripeStatuses !== undefined)
            url_ += "CheckStripeStatuses=" + encodeURIComponent("" + checkStripeStatuses) + "&";
        if (isSharer === null)
            throw new Error("The parameter 'isSharer' cannot be null.");
        else if (isSharer !== undefined)
            url_ += "isSharer=" + encodeURIComponent("" + isSharer) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking2(_response);
        });
    }

    protected processBooking2(response: AxiosResponse): Promise<BookingSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<BookingSimpleDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Bookings in the Detailed format
     * @param includeInactive (optional) 
     * @param checkStripeStatuses (optional) 
     * @param isSharer (optional) 
     * @param statuses (optional) 
     * @param showAll (optional) 
     * @param showClaims (optional) 
     * @param orderBy (optional) 
     * @param searchQuery (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @param userId (optional) Get Bookings exclusively for this User
     * @return Success
     */
    detailed2(includeInactive?: boolean | undefined, checkStripeStatuses?: boolean | undefined, isSharer?: boolean | undefined, statuses?: BookingStatus[] | undefined, showAll?: boolean | undefined, showClaims?: boolean | undefined, orderBy?: BookingOrderBy | undefined, searchQuery?: string | undefined, pageSize?: number | undefined, page?: number | undefined, userId?: string | undefined, cancelToken?: CancelToken): Promise<BookingDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (checkStripeStatuses === null)
            throw new Error("The parameter 'checkStripeStatuses' cannot be null.");
        else if (checkStripeStatuses !== undefined)
            url_ += "CheckStripeStatuses=" + encodeURIComponent("" + checkStripeStatuses) + "&";
        if (isSharer === null)
            throw new Error("The parameter 'isSharer' cannot be null.");
        else if (isSharer !== undefined)
            url_ += "isSharer=" + encodeURIComponent("" + isSharer) + "&";
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        if (showClaims === null)
            throw new Error("The parameter 'showClaims' cannot be null.");
        else if (showClaims !== undefined)
            url_ += "showClaims=" + encodeURIComponent("" + showClaims) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed2(_response);
        });
    }

    protected processDetailed2(response: AxiosResponse): Promise<BookingDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<BookingDetailedDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingDetailedDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    upcoming(itemId: string, cancelToken?: CancelToken): Promise<UpcomingBookingsDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/upcoming/{itemId}";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpcoming(_response);
        });
    }

    protected processUpcoming(response: AxiosResponse): Promise<UpcomingBookingsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpcomingBookingsDto.fromJS(resultData200);
            return Promise.resolve<UpcomingBookingsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpcomingBookingsDto>(null as any);
    }

    /**
     * Creates a new Booking
     * @param useStripe (optional) 
     * @param body (optional) 
     * @return Success
     */
    createPOST(useStripe?: boolean | undefined, body?: BookingCreateDto | undefined, cancelToken?: CancelToken): Promise<BookingDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/create?";
        if (useStripe === null)
            throw new Error("The parameter 'useStripe' cannot be null.");
        else if (useStripe !== undefined)
            url_ += "UseStripe=" + encodeURIComponent("" + useStripe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST(_response);
        });
    }

    protected processCreatePOST(response: AxiosResponse): Promise<BookingDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingDetailedDto.fromJS(resultData200);
            return Promise.resolve<BookingDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingDetailedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    publicPricingCheck(body?: BookingCreateDto | undefined, cancelToken?: CancelToken): Promise<BookingPricingDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/public-pricing-check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublicPricingCheck(_response);
        });
    }

    protected processPublicPricingCheck(response: AxiosResponse): Promise<BookingPricingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingPricingDto.fromJS(resultData200);
            return Promise.resolve<BookingPricingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingPricingDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pricingCheck(body?: BookingCreateDto | undefined, cancelToken?: CancelToken): Promise<BookingPricingDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/pricing-check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPricingCheck(_response);
        });
    }

    protected processPricingCheck(response: AxiosResponse): Promise<BookingPricingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingPricingDto.fromJS(resultData200);
            return Promise.resolve<BookingPricingDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingPricingDto>(null as any);
    }

    /**
     * Updates an existing Booking
     * @param body (optional) 
     * @return Success
     */
    update(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<BookingDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<BookingDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<BookingDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Allows for the Handshaking on Handover and DropOff agreements
     * @param id The Booking Id
     * @param status (optional) The Type of Change being done
     * @param disputeReason (optional) If filing a dispute, any additional details for it
     * @param adminAsSharer (optional) 
     * @param body (optional) If there is a Counter Proposal for the booking place it here
     * @return Success
     */
    updateStatus(id: string, status?: BookingStatus | undefined, disputeReason?: string | undefined, adminAsSharer?: boolean | undefined, body?: HandOverCreateDto | undefined, cancelToken?: CancelToken): Promise<BookingDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/update-status?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (disputeReason === null)
            throw new Error("The parameter 'disputeReason' cannot be null.");
        else if (disputeReason !== undefined)
            url_ += "disputeReason=" + encodeURIComponent("" + disputeReason) + "&";
        if (adminAsSharer === null)
            throw new Error("The parameter 'adminAsSharer' cannot be null.");
        else if (adminAsSharer !== undefined)
            url_ += "AdminAsSharer=" + encodeURIComponent("" + adminAsSharer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<BookingDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingDetailedDto.fromJS(resultData200);
            return Promise.resolve<BookingDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingDetailedDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return Success
     */
    checkout(id: string, userId?: string | undefined, body?: StripeCheckoutRedirects | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/checkout?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckout(_response);
        });
    }

    protected processCheckout(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    cancel(id: string, cancelToken?: CancelToken): Promise<BookingDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: AxiosResponse): Promise<BookingDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingDetailedDto.fromJS(resultData200);
            return Promise.resolve<BookingDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    checkPayment(id: string, cancelToken?: CancelToken): Promise<BookingDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/check-payment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckPayment(_response);
        });
    }

    protected processCheckPayment(response: AxiosResponse): Promise<BookingDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingDetailedDto.fromJS(resultData200);
            return Promise.resolve<BookingDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingDetailedDto>(null as any);
    }

    /**
     * Allows the adding of images to a booking
     * @param imageIds (optional) 
     * @param isPickUp (optional) 
     * @return Success
     */
    addImages(id: string, imageIds?: string[] | undefined, isPickUp?: boolean | undefined, cancelToken?: CancelToken): Promise<BookingDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/add-images?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (imageIds === null)
            throw new Error("The parameter 'imageIds' cannot be null.");
        else if (imageIds !== undefined)
            imageIds && imageIds.forEach(item => { url_ += "imageIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPickUp === null)
            throw new Error("The parameter 'isPickUp' cannot be null.");
        else if (isPickUp !== undefined)
            url_ += "isPickUp=" + encodeURIComponent("" + isPickUp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddImages(_response);
        });
    }

    protected processAddImages(response: AxiosResponse): Promise<BookingDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingDetailedDto.fromJS(resultData200);
            return Promise.resolve<BookingDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingDetailedDto>(null as any);
    }

    /**
     * Adds the Specified Time in Either Days or Hours to the Booking
     * @param id The Id of the Booking
     * @param extensionTime (optional) How Long the Extension will be for
     * @param isDays (optional) Whether or not the Extension is in Days or Hours
     * @return Success
     */
    extend(id: string, extensionTime?: number | undefined, isDays?: boolean | undefined, cancelToken?: CancelToken): Promise<BookingDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/Extend?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (extensionTime === null)
            throw new Error("The parameter 'extensionTime' cannot be null.");
        else if (extensionTime !== undefined)
            url_ += "extensionTime=" + encodeURIComponent("" + extensionTime) + "&";
        if (isDays === null)
            throw new Error("The parameter 'isDays' cannot be null.");
        else if (isDays !== undefined)
            url_ += "isDays=" + encodeURIComponent("" + isDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExtend(_response);
        });
    }

    protected processExtend(response: AxiosResponse): Promise<BookingDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingDetailedDto.fromJS(resultData200);
            return Promise.resolve<BookingDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingDetailedDto>(null as any);
    }

    /**
     * @param isDays (optional) 
     * @return Success
     */
    extensionLimit(id: string, isDays?: boolean | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/ExtensionLimit?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isDays === null)
            throw new Error("The parameter 'isDays' cannot be null.");
        else if (isDays !== undefined)
            url_ += "isDays=" + encodeURIComponent("" + isDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExtensionLimit(_response);
        });
    }

    protected processExtensionLimit(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Disables an existing Booking
     * @return Success
     */
    delete(id: string, cancelToken?: CancelToken): Promise<BookingDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<BookingDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingDetailedDto.fromJS(resultData200);
            return Promise.resolve<BookingDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate(id: string, cancelToken?: CancelToken): Promise<BookingDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate(_response);
        });
    }

    protected processReactivate(response: AxiosResponse): Promise<BookingDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingDetailedDto.fromJS(resultData200);
            return Promise.resolve<BookingDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Booking
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges(_response);
        });
    }

    protected processChanges(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    matchupBookings( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/matchup-bookings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMatchupBookings(_response);
        });
    }

    protected processMatchupBookings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param status (optional) 
     * @param paymentStatus (optional) 
     * @return Success
     */
    forceBookingStatus(id: string, status?: BookingStatus | undefined, paymentStatus?: PaymentStatus | undefined, cancelToken?: CancelToken): Promise<BookingDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Booking/{id}/force-booking-status?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (paymentStatus === null)
            throw new Error("The parameter 'paymentStatus' cannot be null.");
        else if (paymentStatus !== undefined)
            url_ += "paymentStatus=" + encodeURIComponent("" + paymentStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForceBookingStatus(_response);
        });
    }

    protected processForceBookingStatus(response: AxiosResponse): Promise<BookingDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookingDetailedDto.fromJS(resultData200);
            return Promise.resolve<BookingDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookingDetailedDto>(null as any);
    }

    /**
     * @param confirmation (optional) 
     * @return Success
     */
    dummyTransfers(confirmation?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Booking/dummy-transfers?";
        if (confirmation === null)
            throw new Error("The parameter 'confirmation' cannot be null.");
        else if (confirmation !== undefined)
            url_ += "confirmation=" + encodeURIComponent("" + confirmation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDummyTransfers(_response);
        });
    }

    protected processDummyTransfers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CategoryClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Category
     * @param id The Id of a Category
     * @return Returns if the Category is found and the User is Authorized appropriately
     */
    category(id: string, cancelToken?: CancelToken): Promise<CategoryWithAspectsSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategory(_response);
        });
    }

    protected processCategory(response: AxiosResponse): Promise<CategoryWithAspectsSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryWithAspectsSimpleDto.fromJS(resultData200);
            return Promise.resolve<CategoryWithAspectsSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Category cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryWithAspectsSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Category
     * @param id The Id of a Category
     * @return Returns if the Category is found and the User is Authorized appropriately
     */
    detailed3(id: string, cancelToken?: CancelToken): Promise<CategoryWithAspectsDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed3(_response);
        });
    }

    protected processDetailed3(response: AxiosResponse): Promise<CategoryWithAspectsDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryWithAspectsDetailedDto.fromJS(resultData200);
            return Promise.resolve<CategoryWithAspectsDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Category cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryWithAspectsDetailedDto>(null as any);
    }

    /**
     * Gets all Categories in the Simple format
     * @param rootOnly (optional) Returns only root categories if set to true, defaults to false
     * @param showCollections (optional) 
     * @param collectionsOnly (optional) 
     * @param searchQuery (optional) 
     * @param orderBy (optional) 
     * @param selectedCategories (optional) 
     * @param exclusionType (optional) 
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Categories are found and the User is Authorized appropriately
     */
    category2(rootOnly?: boolean | undefined, showCollections?: boolean | undefined, collectionsOnly?: boolean | undefined, searchQuery?: string | undefined, orderBy?: CategoryOrderBy | undefined, selectedCategories?: string | undefined, exclusionType?: CategoryExclusionType | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<CategorySimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Category?";
        if (rootOnly === null)
            throw new Error("The parameter 'rootOnly' cannot be null.");
        else if (rootOnly !== undefined)
            url_ += "rootOnly=" + encodeURIComponent("" + rootOnly) + "&";
        if (showCollections === null)
            throw new Error("The parameter 'showCollections' cannot be null.");
        else if (showCollections !== undefined)
            url_ += "showCollections=" + encodeURIComponent("" + showCollections) + "&";
        if (collectionsOnly === null)
            throw new Error("The parameter 'collectionsOnly' cannot be null.");
        else if (collectionsOnly !== undefined)
            url_ += "collectionsOnly=" + encodeURIComponent("" + collectionsOnly) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (selectedCategories === null)
            throw new Error("The parameter 'selectedCategories' cannot be null.");
        else if (selectedCategories !== undefined)
            url_ += "selectedCategories=" + encodeURIComponent("" + selectedCategories) + "&";
        if (exclusionType === null)
            throw new Error("The parameter 'exclusionType' cannot be null.");
        else if (exclusionType !== undefined)
            url_ += "exclusionType=" + encodeURIComponent("" + exclusionType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategory2(_response);
        });
    }

    protected processCategory2(response: AxiosResponse): Promise<CategorySimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategorySimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<CategorySimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategorySimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Categories in the Detailed format
     * @param rootOnly (optional) Returns only root categories if set to true, defaults to false
     * @param showCollections (optional) 
     * @param collectionsOnly (optional) 
     * @param searchQuery (optional) 
     * @param orderBy (optional) 
     * @param selectedCategories (optional) 
     * @param exclusionType (optional) 
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Categories are found and the User is Authorized appropriately
     */
    detailed4(rootOnly?: boolean | undefined, showCollections?: boolean | undefined, collectionsOnly?: boolean | undefined, searchQuery?: string | undefined, orderBy?: CategoryOrderBy | undefined, selectedCategories?: string | undefined, exclusionType?: CategoryExclusionType | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Category/detailed?";
        if (rootOnly === null)
            throw new Error("The parameter 'rootOnly' cannot be null.");
        else if (rootOnly !== undefined)
            url_ += "rootOnly=" + encodeURIComponent("" + rootOnly) + "&";
        if (showCollections === null)
            throw new Error("The parameter 'showCollections' cannot be null.");
        else if (showCollections !== undefined)
            url_ += "showCollections=" + encodeURIComponent("" + showCollections) + "&";
        if (collectionsOnly === null)
            throw new Error("The parameter 'collectionsOnly' cannot be null.");
        else if (collectionsOnly !== undefined)
            url_ += "collectionsOnly=" + encodeURIComponent("" + collectionsOnly) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (selectedCategories === null)
            throw new Error("The parameter 'selectedCategories' cannot be null.");
        else if (selectedCategories !== undefined)
            url_ += "selectedCategories=" + encodeURIComponent("" + selectedCategories) + "&";
        if (exclusionType === null)
            throw new Error("The parameter 'exclusionType' cannot be null.");
        else if (exclusionType !== undefined)
            url_ += "exclusionType=" + encodeURIComponent("" + exclusionType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed4(_response);
        });
    }

    protected processDetailed4(response: AxiosResponse): Promise<CategoryDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDtoPaginationDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param rootOnly (optional) 
     * @param showCollections (optional) 
     * @param collectionsOnly (optional) 
     * @param searchQuery (optional) 
     * @param orderBy (optional) 
     * @param selectedCategories (optional) 
     * @param exclusionType (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    adminSearch(includeInactive?: boolean | undefined, rootOnly?: boolean | undefined, showCollections?: boolean | undefined, collectionsOnly?: boolean | undefined, searchQuery?: string | undefined, orderBy?: CategoryOrderBy | undefined, selectedCategories?: string | undefined, exclusionType?: CategoryExclusionType | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<CategoryAdminSearchDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Category/AdminSearch?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (rootOnly === null)
            throw new Error("The parameter 'rootOnly' cannot be null.");
        else if (rootOnly !== undefined)
            url_ += "rootOnly=" + encodeURIComponent("" + rootOnly) + "&";
        if (showCollections === null)
            throw new Error("The parameter 'showCollections' cannot be null.");
        else if (showCollections !== undefined)
            url_ += "showCollections=" + encodeURIComponent("" + showCollections) + "&";
        if (collectionsOnly === null)
            throw new Error("The parameter 'collectionsOnly' cannot be null.");
        else if (collectionsOnly !== undefined)
            url_ += "collectionsOnly=" + encodeURIComponent("" + collectionsOnly) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (selectedCategories === null)
            throw new Error("The parameter 'selectedCategories' cannot be null.");
        else if (selectedCategories !== undefined)
            url_ += "selectedCategories=" + encodeURIComponent("" + selectedCategories) + "&";
        if (exclusionType === null)
            throw new Error("The parameter 'exclusionType' cannot be null.");
        else if (exclusionType !== undefined)
            url_ += "exclusionType=" + encodeURIComponent("" + exclusionType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdminSearch(_response);
        });
    }

    protected processAdminSearch(response: AxiosResponse): Promise<CategoryAdminSearchDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryAdminSearchDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<CategoryAdminSearchDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryAdminSearchDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    children(id: string, cancelToken?: CancelToken): Promise<CategoryDetailedDto[]> {
        let url_ = this.baseUrl + "/api/v1/Category/{id}/children";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChildren(_response);
        });
    }

    protected processChildren(response: AxiosResponse): Promise<CategoryDetailedDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryDetailedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CategoryDetailedDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getCollections(id: string, cancelToken?: CancelToken): Promise<CategorySimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{id}/get-collections";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCollections(_response);
        });
    }

    protected processGetCollections(response: AxiosResponse): Promise<CategorySimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategorySimpleDto.fromJS(resultData200);
            return Promise.resolve<CategorySimpleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategorySimpleDto>(null as any);
    }

    /**
     * Creates a new Category
     * @param body (optional) 
     * @return Returns if the Categories are found and the User is Authorized appropriately
     */
    createPOST2(body?: CategoryCreateDto | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST2(_response);
        });
    }

    protected processCreatePOST2(response: AxiosResponse): Promise<CategoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto>(null as any);
    }

    /**
     * Updates an existing Category
     * @param id The Id of the Category being Updated
     * @param body (optional) A Dictionairy of Changes to be made to the Category
     * @return Returns if the Category is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    update2(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate2(_response);
        });
    }

    protected processUpdate2(response: AxiosResponse): Promise<CategoryDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    changeType(id: string, cancelToken?: CancelToken): Promise<CategoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{id}/change-type";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeType(_response);
        });
    }

    protected processChangeType(response: AxiosResponse): Promise<CategoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto>(null as any);
    }

    /**
     * Add Child Categories to an Existing Category
     * @param categoryId The Id of the Category
     * @param childrenIds (optional) The List of Child Categories
     * @return Returns if the Category is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addChildren(categoryId: string, childrenIds?: string[] | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/add-children?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (childrenIds === null)
            throw new Error("The parameter 'childrenIds' cannot be null.");
        else if (childrenIds !== undefined)
            childrenIds && childrenIds.forEach(item => { url_ += "childrenIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddChildren(_response);
        });
    }

    protected processAddChildren(response: AxiosResponse): Promise<CategoryDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Remove a List of Child Categories from a Category
     * @param categoryId The Id of the Category
     * @param childrenIds (optional) The List of Child Categories
     * @return Returns if the Category is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeChildren(categoryId: string, childrenIds?: string[] | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/remove-children?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (childrenIds === null)
            throw new Error("The parameter 'childrenIds' cannot be null.");
        else if (childrenIds !== undefined)
            childrenIds && childrenIds.forEach(item => { url_ += "childrenIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveChildren(_response);
        });
    }

    protected processRemoveChildren(response: AxiosResponse): Promise<CategoryDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param parentId (optional) 
     * @return Success
     */
    changeParent(categoryId: string, parentId?: string | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/change-parent?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeParent(_response);
        });
    }

    protected processChangeParent(response: AxiosResponse): Promise<CategoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto>(null as any);
    }

    /**
     * Add Items to a Category
     * @param categoryId Category the Items are being added to
     * @param itemIds (optional) The Ids of the items being added to the Category
     * @return Returns if the Category is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addItems(categoryId: string, itemIds?: string[] | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/add-items?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (itemIds === null)
            throw new Error("The parameter 'itemIds' cannot be null.");
        else if (itemIds !== undefined)
            itemIds && itemIds.forEach(item => { url_ += "itemIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddItems(_response);
        });
    }

    protected processAddItems(response: AxiosResponse): Promise<CategoryDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Remove Items from a Category
     * @param categoryId Category the Items are being remved from
     * @param itemIds (optional) The Ids of the items being from the Category
     * @return Returns if the Category is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeItems(categoryId: string, itemIds?: string[] | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/remove-items?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (itemIds === null)
            throw new Error("The parameter 'itemIds' cannot be null.");
        else if (itemIds !== undefined)
            itemIds && itemIds.forEach(item => { url_ += "itemIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveItems(_response);
        });
    }

    protected processRemoveItems(response: AxiosResponse): Promise<CategoryDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param addToChildren (optional) 
     * @return Success
     */
    addInsurance(categoryId: string, insurancePlanId: string, addToChildren?: boolean | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/add-insurance/{insurancePlanId}?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (insurancePlanId === undefined || insurancePlanId === null)
            throw new Error("The parameter 'insurancePlanId' must be defined.");
        url_ = url_.replace("{insurancePlanId}", encodeURIComponent("" + insurancePlanId));
        if (addToChildren === null)
            throw new Error("The parameter 'addToChildren' cannot be null.");
        else if (addToChildren !== undefined)
            url_ += "AddToChildren=" + encodeURIComponent("" + addToChildren) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddInsurance(_response);
        });
    }

    protected processAddInsurance(response: AxiosResponse): Promise<CategoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto>(null as any);
    }

    /**
     * @param removeFromChildren (optional) 
     * @return Success
     */
    removeInsurancePUT(categoryId: string, insurancePlanId: string, removeFromChildren?: boolean | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/remove-insurance/{insurancePlanId}?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (insurancePlanId === undefined || insurancePlanId === null)
            throw new Error("The parameter 'insurancePlanId' must be defined.");
        url_ = url_.replace("{insurancePlanId}", encodeURIComponent("" + insurancePlanId));
        if (removeFromChildren === null)
            throw new Error("The parameter 'removeFromChildren' cannot be null.");
        else if (removeFromChildren !== undefined)
            url_ += "RemoveFromChildren=" + encodeURIComponent("" + removeFromChildren) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveInsurancePUT(_response);
        });
    }

    protected processRemoveInsurancePUT(response: AxiosResponse): Promise<CategoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeQuotallCategory(categoryId: string, quotallCategoryId: string, body?: boolean | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/change-quotall-category/{quotallCategoryId}";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (quotallCategoryId === undefined || quotallCategoryId === null)
            throw new Error("The parameter 'quotallCategoryId' must be defined.");
        url_ = url_.replace("{quotallCategoryId}", encodeURIComponent("" + quotallCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeQuotallCategory(_response);
        });
    }

    protected processChangeQuotallCategory(response: AxiosResponse): Promise<CategoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto>(null as any);
    }

    /**
     * Disables an existing Category
     * @return Success
     */
    delete2(id: string, cancelToken?: CancelToken): Promise<CategoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete2(_response);
        });
    }

    protected processDelete2(response: AxiosResponse): Promise<CategoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    activate(id: string, cancelToken?: CancelToken): Promise<CategoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<CategoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Category
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes2(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Category/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges2(_response);
        });
    }

    protected processChanges2(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }

    /**
     * Gets the first Aspect belonging to a category in simple format
     * @param aspectName (optional) 
     * @return Success
     */
    aspect(categoryId: string, aspectName?: string | undefined, cancelToken?: CancelToken): Promise<AspectSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/aspect?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (aspectName === null)
            throw new Error("The parameter 'aspectName' cannot be null.");
        else if (aspectName !== undefined)
            url_ += "aspectName=" + encodeURIComponent("" + aspectName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAspect(_response);
        });
    }

    protected processAspect(response: AxiosResponse): Promise<AspectSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AspectSimpleDto.fromJS(resultData200);
            return Promise.resolve<AspectSimpleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AspectSimpleDto>(null as any);
    }

    /**
     * Gets the first Aspect belonging to a category in detailed format
     * @param aspectName (optional) 
     * @return Success
     */
    detailed5(categoryId: string, aspectName?: string | undefined, cancelToken?: CancelToken): Promise<AspectDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/aspect/detailed?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (aspectName === null)
            throw new Error("The parameter 'aspectName' cannot be null.");
        else if (aspectName !== undefined)
            url_ += "aspectName=" + encodeURIComponent("" + aspectName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed5(_response);
        });
    }

    protected processDetailed5(response: AxiosResponse): Promise<AspectDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AspectDetailedDto.fromJS(resultData200);
            return Promise.resolve<AspectDetailedDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AspectDetailedDto>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    aspect2(pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<AspectSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Category/aspect?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAspect2(_response);
        });
    }

    protected processAspect2(response: AxiosResponse): Promise<AspectSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AspectSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<AspectSimpleDtoPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AspectSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    detailed6(pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<AspectSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Category/aspect/detailed?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed6(_response);
        });
    }

    protected processDetailed6(response: AxiosResponse): Promise<AspectSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AspectSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<AspectSimpleDtoPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AspectSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Creates a aspect for an existing collection
     * @param body (optional) 
     * @return Success
     */
    addPOST(categoryId: string, body?: AspectCreateDto | undefined, cancelToken?: CancelToken): Promise<AspectDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/aspects/add";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPOST(_response);
        });
    }

    protected processAddPOST(response: AxiosResponse): Promise<AspectDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AspectDetailedDto.fromJS(resultData200);
            return Promise.resolve<AspectDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AspectDetailedDto>(null as any);
    }

    /**
     * @param aspectName (optional) 
     * @param body (optional) 
     * @return Success
     */
    update3(categoryId: string, aspectName?: string | undefined, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<AspectDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/aspects/update?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (aspectName === null)
            throw new Error("The parameter 'aspectName' cannot be null.");
        else if (aspectName !== undefined)
            url_ += "aspectName=" + encodeURIComponent("" + aspectName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate3(_response);
        });
    }

    protected processUpdate3(response: AxiosResponse): Promise<AspectDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AspectDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<AspectDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AspectDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param aspectName (optional) 
     * @param value (optional) 
     * @return Success
     */
    addValue(categoryId: string, aspectName?: string | undefined, value?: string | undefined, cancelToken?: CancelToken): Promise<AspectDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/aspects/add-value?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (aspectName === null)
            throw new Error("The parameter 'aspectName' cannot be null.");
        else if (aspectName !== undefined)
            url_ += "aspectName=" + encodeURIComponent("" + aspectName) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddValue(_response);
        });
    }

    protected processAddValue(response: AxiosResponse): Promise<AspectDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AspectDetailedDto.fromJS(resultData200);
            return Promise.resolve<AspectDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AspectDetailedDto>(null as any);
    }

    /**
     * @param aspectName (optional) 
     * @param value (optional) 
     * @return Success
     */
    removeValue(categoryId: string, aspectName?: string | undefined, value?: string | undefined, cancelToken?: CancelToken): Promise<AspectDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/aspects/remove-value?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (aspectName === null)
            throw new Error("The parameter 'aspectName' cannot be null.");
        else if (aspectName !== undefined)
            url_ += "aspectName=" + encodeURIComponent("" + aspectName) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveValue(_response);
        });
    }

    protected processRemoveValue(response: AxiosResponse): Promise<AspectDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AspectDetailedDto.fromJS(resultData200);
            return Promise.resolve<AspectDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AspectDetailedDto>(null as any);
    }

    /**
     * @param aspectName (optional) 
     * @return Success
     */
    blacklist(categoryId: string, aspectName?: string | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/aspects/blacklist?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (aspectName === null)
            throw new Error("The parameter 'aspectName' cannot be null.");
        else if (aspectName !== undefined)
            url_ += "aspectName=" + encodeURIComponent("" + aspectName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBlacklist(_response);
        });
    }

    protected processBlacklist(response: AxiosResponse): Promise<CategoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto>(null as any);
    }

    /**
     * @param aspectName (optional) 
     * @return Success
     */
    unblacklist(categoryId: string, aspectName?: string | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/aspects/unblacklist?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (aspectName === null)
            throw new Error("The parameter 'aspectName' cannot be null.");
        else if (aspectName !== undefined)
            url_ += "aspectName=" + encodeURIComponent("" + aspectName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnblacklist(_response);
        });
    }

    protected processUnblacklist(response: AxiosResponse): Promise<CategoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto>(null as any);
    }

    /**
     * @param aspectName (optional) 
     * @return Success
     */
    delete3(categoryId: string, aspectName?: string | undefined, cancelToken?: CancelToken): Promise<CategoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/aspects/delete?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (aspectName === null)
            throw new Error("The parameter 'aspectName' cannot be null.");
        else if (aspectName !== undefined)
            url_ += "aspectName=" + encodeURIComponent("" + aspectName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete3(_response);
        });
    }

    protected processDelete3(response: AxiosResponse): Promise<CategoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<CategoryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    keywords(categoryId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/keywords";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processKeywords(_response);
        });
    }

    protected processKeywords(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    addPUT(categoryId: string, keyword?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/keywords/add?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPUT(_response);
        });
    }

    protected processAddPUT(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    keywordDownload( cancelToken?: CancelToken): Promise<IBrowserFile> {
        let url_ = this.baseUrl + "/api/v1/Category/keyword-download";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processKeywordDownload(_response);
        });
    }

    protected processKeywordDownload(response: AxiosResponse): Promise<IBrowserFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IBrowserFile.fromJS(resultData200);
            return Promise.resolve<IBrowserFile>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IBrowserFile>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    keywordUpload(body?: string | undefined, cancelToken?: CancelToken): Promise<{ [key: string]: string[]; }> {
        let url_ = this.baseUrl + "/api/v1/Category/keyword-upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processKeywordUpload(_response);
        });
    }

    protected processKeywordUpload(response: AxiosResponse): Promise<{ [key: string]: string[]; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: string[]; }>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string[]; }>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    removePUT(categoryId: string, keyword?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Category/{categoryId}/keywords/remove?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemovePUT(_response);
        });
    }

    protected processRemovePUT(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets all Changes made to a Aspect
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes3(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Category/aspects/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges3(_response);
        });
    }

    protected processChanges3(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class ChangeClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Change
     * @return Success
     */
    change(id: string, cancelToken?: CancelToken): Promise<ChangeDto> {
        let url_ = this.baseUrl + "/api/v1/Change/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChange(_response);
        });
    }

    protected processChange(response: AxiosResponse): Promise<ChangeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeDto.fromJS(resultData200);
            return Promise.resolve<ChangeDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto>(null as any);
    }

    /**
     * Gets all changes
     * @param staffOnly (optional) Filter changes from Staff members and regular users
     * @param pageSize (optional) Vary the number of items per page
     * @param page (optional) Page number
     * @param changeType (optional) Returns changes only of this type
     * @param searchQuery (optional) Value to search with, Use "Null" to search for null values
     * @param orderby (optional) How result will be ordered
     * @param searchBy (optional) Given to Search for only Properties or only Values, only works if a search Query is provided
     * @return Success
     */
    change2(staffOnly?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, changeType?: string | undefined, searchQuery?: string | undefined, orderby?: ChangeOrderBy | undefined, searchBy?: ChangeDetailedSearchBy | undefined, cancelToken?: CancelToken): Promise<ChangeDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Change?";
        if (staffOnly === null)
            throw new Error("The parameter 'staffOnly' cannot be null.");
        else if (staffOnly !== undefined)
            url_ += "staffOnly=" + encodeURIComponent("" + staffOnly) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (changeType === null)
            throw new Error("The parameter 'changeType' cannot be null.");
        else if (changeType !== undefined)
            url_ += "changeType=" + encodeURIComponent("" + changeType) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "Orderby=" + encodeURIComponent("" + orderby) + "&";
        if (searchBy === null)
            throw new Error("The parameter 'searchBy' cannot be null.");
        else if (searchBy !== undefined)
            url_ += "searchBy=" + encodeURIComponent("" + searchBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChange2(_response);
        });
    }

    protected processChange2(response: AxiosResponse): Promise<ChangeDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ChangeDetailedDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Gets all changes for a given Object
     * @param objectId (optional) 
     * @param objectType (optional) 
     * @param pageSize (optional) Vary the number of items per page
     * @param page (optional) Page number
     * @param changeType (optional) Returns changes only of this type
     * @param searchQuery (optional) Value to search with, Use "Null" to search for null values
     * @param orderby (optional) How result will be ordered
     * @param searchBy (optional) Given to Search for only Properties or only Values, only works if a search Query is provided
     * @return Success
     */
    object(objectId?: string | undefined, objectType?: string | undefined, pageSize?: number | undefined, page?: number | undefined, changeType?: string | undefined, searchQuery?: string | undefined, orderby?: ChangeOrderBy | undefined, searchBy?: ChangeSearchBy | undefined, cancelToken?: CancelToken): Promise<ChangeDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Change/Object?";
        if (objectId === null)
            throw new Error("The parameter 'objectId' cannot be null.");
        else if (objectId !== undefined)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        if (objectType === null)
            throw new Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (changeType === null)
            throw new Error("The parameter 'changeType' cannot be null.");
        else if (changeType !== undefined)
            url_ += "changeType=" + encodeURIComponent("" + changeType) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "Orderby=" + encodeURIComponent("" + orderby) + "&";
        if (searchBy === null)
            throw new Error("The parameter 'searchBy' cannot be null.");
        else if (searchBy !== undefined)
            url_ += "searchBy=" + encodeURIComponent("" + searchBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processObject(_response);
        });
    }

    protected processObject(response: AxiosResponse): Promise<ChangeDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ChangeDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    asCSV( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Change/asCSV";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAsCSV(_response);
        });
    }

    protected processAsCSV(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    updateEntityTimestamps( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Change/update-entity-timestamps";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEntityTimestamps(_response);
        });
    }

    protected processUpdateEntityTimestamps(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Removes all Updates where the new value and orignal value are Equal
     * @return Success
     */
    removeRedundantUpdates( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Change/remove-redundant-updates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveRedundantUpdates(_response);
        });
    }

    protected processRemoveRedundantUpdates(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CommunityPageClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Community Page
     * @param id The Id of a Community Page
     * @return Returns if the Community Page is found and the User is Authorized appropriately
     */
    communityPage(id: string, cancelToken?: CancelToken): Promise<CommunityPageSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/CommunityPage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCommunityPage(_response);
        });
    }

    protected processCommunityPage(response: AxiosResponse): Promise<CommunityPageSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommunityPageSimpleDto.fromJS(resultData200);
            return Promise.resolve<CommunityPageSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Community Page cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunityPageSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Community Page
     * @return Returns if the Community Page is found and the User is Authorized appropriately
     */
    detailed7(id: string, cancelToken?: CancelToken): Promise<CommunityPageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/CommunityPage/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed7(_response);
        });
    }

    protected processDetailed7(response: AxiosResponse): Promise<CommunityPageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommunityPageDetailedDto.fromJS(resultData200);
            return Promise.resolve<CommunityPageDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Community Page cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunityPageDetailedDto>(null as any);
    }

    /**
     * Gets all Community Pages in the Simple Format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Community Pages, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Community Pages are found and the User is Authorized appropriately
     */
    communityPage2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<CommunityPageSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/CommunityPage?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCommunityPage2(_response);
        });
    }

    protected processCommunityPage2(response: AxiosResponse): Promise<CommunityPageSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommunityPageSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<CommunityPageSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunityPageSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Community Pages in the Detailed format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Community Pages, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Community Pages are found and the User is Authorized appropriately
     */
    detailed8(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<CommunityPageDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/CommunityPage/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed8(_response);
        });
    }

    protected processDetailed8(response: AxiosResponse): Promise<CommunityPageDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommunityPageDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<CommunityPageDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunityPageDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Community Page
     * @param body (optional) 
     * @return Returns if the Community Page is Created, also returns a DetailedDto of the newly created Community Page
     */
    createPOST3(body?: CommunityPageCreateDto | undefined, cancelToken?: CancelToken): Promise<CommunityPageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/CommunityPage/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST3(_response);
        });
    }

    protected processCreatePOST3(response: AxiosResponse): Promise<CommunityPageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommunityPageDetailedDto.fromJS(resultData200);
            return Promise.resolve<CommunityPageDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunityPageDetailedDto>(null as any);
    }

    /**
     * Updates an existing Community Page
     * @param id The Id of the Community Page being Updated
     * @param body (optional) A Dictionairy of Changes to be made to the BusinessAccount
     * @return Returns if the Community Page is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    update4(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<CommunityPageDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/CommunityPage/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate4(_response);
        });
    }

    protected processUpdate4(response: AxiosResponse): Promise<CommunityPageDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommunityPageDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<CommunityPageDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunityPageDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Disables an existing Community Page
     * @return Success
     */
    delete4(id: string, cancelToken?: CancelToken): Promise<CommunityPageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/CommunityPage/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete4(_response);
        });
    }

    protected processDelete4(response: AxiosResponse): Promise<CommunityPageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommunityPageDetailedDto.fromJS(resultData200);
            return Promise.resolve<CommunityPageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunityPageDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate2(id: string, cancelToken?: CancelToken): Promise<CommunityPageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/CommunityPage/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate2(_response);
        });
    }

    protected processReactivate2(response: AxiosResponse): Promise<CommunityPageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommunityPageDetailedDto.fromJS(resultData200);
            return Promise.resolve<CommunityPageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunityPageDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Community Page
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes4(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/CommunityPage/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges4(_response);
        });
    }

    protected processChanges4(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class ContentClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a sas token for a container
     * @return Success
     */
    sas(containerName: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Content/sas/{containerName}";
        if (containerName === undefined || containerName === null)
            throw new Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSas(_response);
        });
    }

    protected processSas(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Transfer a blob from one location to another
     * @param body (optional) 
     * @return Success
     */
    transfer(body?: TransferFileRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Content/transfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransfer(_response);
        });
    }

    protected processTransfer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    transferAll( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Content/transferAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransferAll(_response);
        });
    }

    protected processTransferAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CourierClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Courier
     * @param id The Id of the Courier
     * @return Returns if the Courier is found and the User is Authorized appropriately
     */
    courier(id: string, cancelToken?: CancelToken): Promise<CourierSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Courier/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCourier(_response);
        });
    }

    protected processCourier(response: AxiosResponse): Promise<CourierSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourierSimpleDto.fromJS(resultData200);
            return Promise.resolve<CourierSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Courier cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourierSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Courier
     * @param id The Id of the Courier
     * @return Returns if the Courier is found and the User is Authorized appropriately
     */
    detailed9(id: string, cancelToken?: CancelToken): Promise<CourierDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Courier/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed9(_response);
        });
    }

    protected processDetailed9(response: AxiosResponse): Promise<CourierDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourierDetailedDto.fromJS(resultData200);
            return Promise.resolve<CourierDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Courier cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourierDetailedDto>(null as any);
    }

    /**
     * Gets all Couriers in a Simple format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Couriers, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Couriers are found and the User is Authorized appropriately
     */
    courier2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<CourierSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Courier?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCourier2(_response);
        });
    }

    protected processCourier2(response: AxiosResponse): Promise<CourierSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourierSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<CourierSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourierSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Couriers in a Detailed format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Couriers, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Couriers are found and the User is Authorized appropriately
     */
    detailed10(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<CourierDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Courier/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed10(_response);
        });
    }

    protected processDetailed10(response: AxiosResponse): Promise<CourierDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourierDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<CourierDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourierDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Courier
     * @param body (optional) 
     * @return Returns if the Courier is created and the User is Authorized appropriately
     */
    createPOST4(body?: CourierCreateDto | undefined, cancelToken?: CancelToken): Promise<CourierDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Courier/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST4(_response);
        });
    }

    protected processCreatePOST4(response: AxiosResponse): Promise<CourierDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourierDetailedDto.fromJS(resultData200);
            return Promise.resolve<CourierDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourierDetailedDto>(null as any);
    }

    /**
     * Updates an existing Courier
     * @param id The Id of the Courier being updated
     * @param body (optional) A dictionairy of changes to be made to the Courier
     * @return Returns if the Courier is updated and the User is Authorized appropriately, also returns a DetailedDto of the newly updated Courier
     */
    update5(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<CourierDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Courier/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate5(_response);
        });
    }

    protected processUpdate5(response: AxiosResponse): Promise<CourierDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourierDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<CourierDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourierDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Disables an existing Courier
     * @return Success
     */
    delete5(id: string, cancelToken?: CancelToken): Promise<CourierDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Courier/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete5(_response);
        });
    }

    protected processDelete5(response: AxiosResponse): Promise<CourierDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourierDetailedDto.fromJS(resultData200);
            return Promise.resolve<CourierDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourierDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate3(id: string, cancelToken?: CancelToken): Promise<CourierDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Courier/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate3(_response);
        });
    }

    protected processReactivate3(response: AxiosResponse): Promise<CourierDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CourierDetailedDto.fromJS(resultData200);
            return Promise.resolve<CourierDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CourierDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Courier
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes5(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Courier/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges5(_response);
        });
    }

    protected processChanges5(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class DataClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    applyMissingCreationDates( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Data/ApplyMissingCreationDates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplyMissingCreationDates(_response);
        });
    }

    protected processApplyMissingCreationDates(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DeliveryClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Delivery
     * @param id The Id of a Delivery
     * @return Returns if the Delivery is found and the User is Authorized appropriately
     */
    delivery(id: string, cancelToken?: CancelToken): Promise<DeliverySimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Delivery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelivery(_response);
        });
    }

    protected processDelivery(response: AxiosResponse): Promise<DeliverySimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeliverySimpleDto.fromJS(resultData200);
            return Promise.resolve<DeliverySimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Delivery cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliverySimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Delivery
     * @param id he Id of a Delivery
     * @return Returns if the Delivery is found and the User is Authorized appropriately
     */
    detailed11(id: string, cancelToken?: CancelToken): Promise<DeliveryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Delivery/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed11(_response);
        });
    }

    protected processDetailed11(response: AxiosResponse): Promise<DeliveryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeliveryDetailedDto.fromJS(resultData200);
            return Promise.resolve<DeliveryDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Delivery cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryDetailedDto>(null as any);
    }

    /**
     * Gets all Deliveries in the Simple format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Deliveries, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Deliveries are found and the User is Authorized appropriately
     */
    delivery2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<DeliverySimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Delivery?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelivery2(_response);
        });
    }

    protected processDelivery2(response: AxiosResponse): Promise<DeliverySimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeliverySimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<DeliverySimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliverySimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Deliveries in the Detailed format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Deliveries, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Deliveries are found and the User is Authorized appropriately
     */
    detailed12(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<DeliveryDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Delivery/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed12(_response);
        });
    }

    protected processDetailed12(response: AxiosResponse): Promise<DeliveryDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeliveryDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<DeliveryDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Delivery
     * @param body (optional) 
     * @return Returns if the Delivery is Created, also returns a DetailedDto of the newly created delivery
     */
    createPOST5(body?: DeliveryCreateDto | undefined, cancelToken?: CancelToken): Promise<DeliveryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Delivery/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST5(_response);
        });
    }

    protected processCreatePOST5(response: AxiosResponse): Promise<DeliveryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeliveryDetailedDto.fromJS(resultData200);
            return Promise.resolve<DeliveryDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryDetailedDto>(null as any);
    }

    /**
     * Updates an existing Delivery
     * @param id The Id of the Delivery being Updated
     * @param body (optional) A Dictionairy of Changes to be made to the Delivery
     * @return Returns if the Delivery is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    update6(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<DeliveryDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Delivery/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate6(_response);
        });
    }

    protected processUpdate6(response: AxiosResponse): Promise<DeliveryDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeliveryDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<DeliveryDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Disables an existing Delivery
     * @return Success
     */
    delete6(id: string, cancelToken?: CancelToken): Promise<DeliveryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Delivery/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete6(_response);
        });
    }

    protected processDelete6(response: AxiosResponse): Promise<DeliveryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeliveryDetailedDto.fromJS(resultData200);
            return Promise.resolve<DeliveryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate4(id: string, cancelToken?: CancelToken): Promise<DeliveryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Delivery/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate4(_response);
        });
    }

    protected processReactivate4(response: AxiosResponse): Promise<DeliveryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeliveryDetailedDto.fromJS(resultData200);
            return Promise.resolve<DeliveryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Delivery
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes6(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Delivery/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges6(_response);
        });
    }

    protected processChanges6(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class DiscountClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Discount
     * @param id The Id of a Discount
     * @return Returns if the Discount is found and the User is Authorized appropriately
     */
    discount(id: string, cancelToken?: CancelToken): Promise<DiscountSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Discount/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiscount(_response);
        });
    }

    protected processDiscount(response: AxiosResponse): Promise<DiscountSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiscountSimpleDto.fromJS(resultData200);
            return Promise.resolve<DiscountSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Business Account cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiscountSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Discount
     * @param id The Id of a Discount
     * @return Returns if the Discount is found and the User is Authorized appropriately
     */
    detailed13(id: string, cancelToken?: CancelToken): Promise<DiscountDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Discount/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed13(_response);
        });
    }

    protected processDetailed13(response: AxiosResponse): Promise<DiscountDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiscountDetailedDto.fromJS(resultData200);
            return Promise.resolve<DiscountDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Business Account cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiscountDetailedDto>(null as any);
    }

    /**
     * Gets all Discounts in the Simple format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Discounts, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Discounts are found and the User is Authorized appropriately
     */
    discount2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<DiscountSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Discount?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiscount2(_response);
        });
    }

    protected processDiscount2(response: AxiosResponse): Promise<DiscountSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiscountSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<DiscountSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiscountSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Discounts in the Detailed format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Discounts, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Discounts are found and the User is Authorized appropriately
     */
    detailed14(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<DiscountDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Discount/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed14(_response);
        });
    }

    protected processDetailed14(response: AxiosResponse): Promise<DiscountDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiscountDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<DiscountDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiscountDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Discount
     * @param body (optional) 
     * @return Returns if the Discount is created and the User is Authorized appropriately
     */
    createPOST6(body?: DiscountCreateDto | undefined, cancelToken?: CancelToken): Promise<DiscountDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Discount/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST6(_response);
        });
    }

    protected processCreatePOST6(response: AxiosResponse): Promise<DiscountDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiscountDetailedDto.fromJS(resultData200);
            return Promise.resolve<DiscountDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiscountDetailedDto>(null as any);
    }

    /**
     * Updates an existing Discount
     * @param id The Id of the Discount being Updated
     * @param body (optional) A Dictionairy of Changes to be made to the Discount
     * @return Returns if the Discount is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    update7(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<DiscountDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Discount/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate7(_response);
        });
    }

    protected processUpdate7(response: AxiosResponse): Promise<DiscountDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiscountDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<DiscountDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Business Account cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiscountDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Disables an existing Discount
     * @return Success
     */
    delete7(id: string, cancelToken?: CancelToken): Promise<DiscountDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Discount/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete7(_response);
        });
    }

    protected processDelete7(response: AxiosResponse): Promise<DiscountDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiscountDetailedDto.fromJS(resultData200);
            return Promise.resolve<DiscountDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiscountDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate5(id: string, cancelToken?: CancelToken): Promise<DiscountDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Discount/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate5(_response);
        });
    }

    protected processReactivate5(response: AxiosResponse): Promise<DiscountDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DiscountDetailedDto.fromJS(resultData200);
            return Promise.resolve<DiscountDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DiscountDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Discount
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes7(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Discount/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges7(_response);
        });
    }

    protected processChanges7(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class DynamicSitemapClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    sitemapIndex_xmlGET( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DynamicSitemap/sitemap-index.xml";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSitemapIndex_xmlGET(_response);
        });
    }

    protected processSitemapIndex_xmlGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    sitemapIndex_xmlHEAD( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DynamicSitemap/sitemap-index.xml";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "HEAD",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSitemapIndex_xmlHEAD(_response);
        });
    }

    protected processSitemapIndex_xmlHEAD(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    staticSitemap_xmlGET( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DynamicSitemap/static-sitemap.xml";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticSitemap_xmlGET(_response);
        });
    }

    protected processStaticSitemap_xmlGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    staticSitemap_xmlHEAD( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DynamicSitemap/static-sitemap.xml";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "HEAD",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaticSitemap_xmlHEAD(_response);
        });
    }

    protected processStaticSitemap_xmlHEAD(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param forceNew (optional) 
     * @return Success
     */
    itemSitemap_xmlGET(forceNew?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DynamicSitemap/item-sitemap.xml?";
        if (forceNew === null)
            throw new Error("The parameter 'forceNew' cannot be null.");
        else if (forceNew !== undefined)
            url_ += "ForceNew=" + encodeURIComponent("" + forceNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processItemSitemap_xmlGET(_response);
        });
    }

    protected processItemSitemap_xmlGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param forceNew (optional) 
     * @return Success
     */
    itemSitemap_xmlHEAD(forceNew?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DynamicSitemap/item-sitemap.xml?";
        if (forceNew === null)
            throw new Error("The parameter 'forceNew' cannot be null.");
        else if (forceNew !== undefined)
            url_ += "ForceNew=" + encodeURIComponent("" + forceNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "HEAD",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processItemSitemap_xmlHEAD(_response);
        });
    }

    protected processItemSitemap_xmlHEAD(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param forceNew (optional) 
     * @return Success
     */
    userSitemap_xmlGET(forceNew?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DynamicSitemap/user-sitemap.xml?";
        if (forceNew === null)
            throw new Error("The parameter 'forceNew' cannot be null.");
        else if (forceNew !== undefined)
            url_ += "ForceNew=" + encodeURIComponent("" + forceNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserSitemap_xmlGET(_response);
        });
    }

    protected processUserSitemap_xmlGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param forceNew (optional) 
     * @return Success
     */
    userSitemap_xmlHEAD(forceNew?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DynamicSitemap/user-sitemap.xml?";
        if (forceNew === null)
            throw new Error("The parameter 'forceNew' cannot be null.");
        else if (forceNew !== undefined)
            url_ += "ForceNew=" + encodeURIComponent("" + forceNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "HEAD",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserSitemap_xmlHEAD(_response);
        });
    }

    protected processUserSitemap_xmlHEAD(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FeaturedItemsClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    featuredItems(id: string, cancelToken?: CancelToken): Promise<FeaturedItemsDto> {
        let url_ = this.baseUrl + "/api/v1/FeaturedItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeaturedItems(_response);
        });
    }

    protected processFeaturedItems(response: AxiosResponse): Promise<FeaturedItemsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeaturedItemsDto.fromJS(resultData200);
            return Promise.resolve<FeaturedItemsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeaturedItemsDto>(null as any);
    }

    /**
     * @param searchQuery (optional) 
     * @param orderBy (optional) 
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    featuredItems2(searchQuery?: string | undefined, orderBy?: FeaturedItemsOrderBy | undefined, includeInactive?: boolean | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, cancelToken?: CancelToken): Promise<FeaturedItemsDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/FeaturedItems?";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "IncludeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeaturedItems2(_response);
        });
    }

    protected processFeaturedItems2(response: AxiosResponse): Promise<FeaturedItemsDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeaturedItemsDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<FeaturedItemsDtoPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeaturedItemsDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    container(name: string, cancelToken?: CancelToken): Promise<FeaturedItemsDto> {
        let url_ = this.baseUrl + "/api/v1/FeaturedItems/container/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContainer(_response);
        });
    }

    protected processContainer(response: AxiosResponse): Promise<FeaturedItemsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeaturedItemsDto.fromJS(resultData200);
            return Promise.resolve<FeaturedItemsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeaturedItemsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST7(body?: FeaturedItemsCreateDto | undefined, cancelToken?: CancelToken): Promise<FeaturedItemsDto> {
        let url_ = this.baseUrl + "/api/v1/FeaturedItems/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST7(_response);
        });
    }

    protected processCreatePOST7(response: AxiosResponse): Promise<FeaturedItemsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeaturedItemsDto.fromJS(resultData200);
            return Promise.resolve<FeaturedItemsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeaturedItemsDto>(null as any);
    }

    /**
     * @param newName (optional) 
     * @param newItems (optional) 
     * @return Success
     */
    update(id: string, newName?: string | undefined, newItems?: string[] | undefined, cancelToken?: CancelToken): Promise<FeaturedItemsDto> {
        let url_ = this.baseUrl + "/api/v1/FeaturedItems/Update/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (newName === null)
            throw new Error("The parameter 'newName' cannot be null.");
        else if (newName !== undefined)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        if (newItems === null)
            throw new Error("The parameter 'newItems' cannot be null.");
        else if (newItems !== undefined)
            newItems && newItems.forEach(item => { url_ += "newItems=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<FeaturedItemsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeaturedItemsDto.fromJS(resultData200);
            return Promise.resolve<FeaturedItemsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeaturedItemsDto>(null as any);
    }

    /**
     * @param newItems (optional) 
     * @return Success
     */
    addItems(id: string, newItems?: string[] | undefined, cancelToken?: CancelToken): Promise<FeaturedItemsDto> {
        let url_ = this.baseUrl + "/api/v1/FeaturedItems/AddItems/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (newItems === null)
            throw new Error("The parameter 'newItems' cannot be null.");
        else if (newItems !== undefined)
            newItems && newItems.forEach(item => { url_ += "newItems=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddItems(_response);
        });
    }

    protected processAddItems(response: AxiosResponse): Promise<FeaturedItemsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeaturedItemsDto.fromJS(resultData200);
            return Promise.resolve<FeaturedItemsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeaturedItemsDto>(null as any);
    }

    /**
     * @param itemsToRemoveIds (optional) 
     * @return Success
     */
    removeItems(id: string, itemsToRemoveIds?: string[] | undefined, cancelToken?: CancelToken): Promise<FeaturedItemsDto> {
        let url_ = this.baseUrl + "/api/v1/FeaturedItems/RemoveItems/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (itemsToRemoveIds === null)
            throw new Error("The parameter 'itemsToRemoveIds' cannot be null.");
        else if (itemsToRemoveIds !== undefined)
            itemsToRemoveIds && itemsToRemoveIds.forEach(item => { url_ += "itemsToRemoveIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveItems(_response);
        });
    }

    protected processRemoveItems(response: AxiosResponse): Promise<FeaturedItemsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeaturedItemsDto.fromJS(resultData200);
            return Promise.resolve<FeaturedItemsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeaturedItemsDto>(null as any);
    }

    /**
     * @param newName (optional) 
     * @return Success
     */
    changeContainerName(id: string, newName?: string | undefined, cancelToken?: CancelToken): Promise<FeaturedItemsDto> {
        let url_ = this.baseUrl + "/api/v1/FeaturedItems/ChangeContainerName/{Id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (newName === null)
            throw new Error("The parameter 'newName' cannot be null.");
        else if (newName !== undefined)
            url_ += "NewName=" + encodeURIComponent("" + newName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeContainerName(_response);
        });
    }

    protected processChangeContainerName(response: AxiosResponse): Promise<FeaturedItemsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeaturedItemsDto.fromJS(resultData200);
            return Promise.resolve<FeaturedItemsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeaturedItemsDto>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string, cancelToken?: CancelToken): Promise<FeaturedItemsDto> {
        let url_ = this.baseUrl + "/api/v1/FeaturedItems/Delete/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FeaturedItemsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeaturedItemsDto.fromJS(resultData200);
            return Promise.resolve<FeaturedItemsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeaturedItemsDto>(null as any);
    }

    /**
     * @return Success
     */
    purge(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/FeaturedItems/Purge/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPurge(_response);
        });
    }

    protected processPurge(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    reactivate(id: string, cancelToken?: CancelToken): Promise<FeaturedItemsDto> {
        let url_ = this.baseUrl + "/api/v1/FeaturedItems/Reactivate/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate(_response);
        });
    }

    protected processReactivate(response: AxiosResponse): Promise<FeaturedItemsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeaturedItemsDto.fromJS(resultData200);
            return Promise.resolve<FeaturedItemsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeaturedItemsDto>(null as any);
    }
}

export class FileClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Uploads an Image to cloud storage
     * @param fileExtension (optional) 
     * @param file (optional) 
     * @return Success
     */
    upload(fileExtension?: string | undefined, file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<ImageDto> {
        let url_ = this.baseUrl + "/api/v1/File/image/upload?";
        if (fileExtension === null)
            throw new Error("The parameter 'fileExtension' cannot be null.");
        else if (fileExtension !== undefined)
            url_ += "fileExtension=" + encodeURIComponent("" + fileExtension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<ImageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageDto.fromJS(resultData200);
            return Promise.resolve<ImageDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageDto>(null as any);
    }

    /**
     * @return Success
     */
    convertToWebp( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/File/images/convert-to-webp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConvertToWebp(_response);
        });
    }

    protected processConvertToWebp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Uploads an Image
     * @param body (optional) 
     * @return Success
     */
    upload2(body?: UploadFile | undefined, cancelToken?: CancelToken): Promise<ImageDto> {
        let url_ = this.baseUrl + "/api/v1/File/staff/image/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload2(_response);
        });
    }

    protected processUpload2(response: AxiosResponse): Promise<ImageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageDto.fromJS(resultData200);
            return Promise.resolve<ImageDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageDto>(null as any);
    }

    /**
     * Gets all Images in the simple format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Files, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @param userId (optional) The user of which you want to get the images for
     * @return Returns if the Files are found and the User is Authorized appropriately
     */
    image(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, userId?: string | undefined, cancelToken?: CancelToken): Promise<ImageSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/File/image?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImage(_response);
        });
    }

    protected processImage(response: AxiosResponse): Promise<ImageSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ImageSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param searchQuery (optional) 
     * @param orderBy (optional) 
     * @param page (optional) 
     * @param userId (optional) 
     * @param getFlagged (optional) 
     * @return Success
     */
    detailed15(includeInactive?: boolean | undefined, pageSize?: number | undefined, searchQuery?: string | undefined, orderBy?: ImageOrderBy | undefined, page?: number | undefined, userId?: string | undefined, getFlagged?: boolean | undefined, cancelToken?: CancelToken): Promise<ImageDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/File/image/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (getFlagged === null)
            throw new Error("The parameter 'getFlagged' cannot be null.");
        else if (getFlagged !== undefined)
            url_ += "getFlagged=" + encodeURIComponent("" + getFlagged) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed15(_response);
        });
    }

    protected processDetailed15(response: AxiosResponse): Promise<ImageDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ImageDetailedDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageDetailedDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    image2(id: string, cancelToken?: CancelToken): Promise<ImageSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/File/image/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImage2(_response);
        });
    }

    protected processImage2(response: AxiosResponse): Promise<ImageSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageSimpleDto.fromJS(resultData200);
            return Promise.resolve<ImageSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageSimpleDto>(null as any);
    }

    /**
     * @return Success
     */
    detailed16(id: string, cancelToken?: CancelToken): Promise<ImageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/File/image/detailed/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed16(_response);
        });
    }

    protected processDetailed16(response: AxiosResponse): Promise<ImageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageDetailedDto.fromJS(resultData200);
            return Promise.resolve<ImageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    metadata(id: string, cancelToken?: CancelToken): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/v1/File/image/{id}/metadata";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMetadata(_response);
        });
    }

    protected processMetadata(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * Disables an existing Video
     * @return Success
     */
    delete8(id: string, cancelToken?: CancelToken): Promise<ImageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/File/image/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete8(_response);
        });
    }

    protected processDelete8(response: AxiosResponse): Promise<ImageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageDetailedDto.fromJS(resultData200);
            return Promise.resolve<ImageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate6(id: string, cancelToken?: CancelToken): Promise<ImageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/File/image/reactivate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate6(_response);
        });
    }

    protected processReactivate6(response: AxiosResponse): Promise<ImageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageDetailedDto.fromJS(resultData200);
            return Promise.resolve<ImageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageDetailedDto>(null as any);
    }

    /**
     * Uploads a video to cloud storage
     * @param file (optional) 
     * @return Success
     */
    upload3(file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<VideoDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/File/video/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload3(_response);
        });
    }

    protected processUpload3(response: AxiosResponse): Promise<VideoDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoDetailedDto.fromJS(resultData200);
            return Promise.resolve<VideoDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoDetailedDto>(null as any);
    }

    /**
     * Gets all Videos in the simple format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Files, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @param userId (optional) The user of which you want to get the images for
     * @return Returns if the Files are found and the User is Authorized appropriately
     */
    video(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, userId?: string | undefined, cancelToken?: CancelToken): Promise<VideoSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/File/video?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVideo(_response);
        });
    }

    protected processVideo(response: AxiosResponse): Promise<VideoSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<VideoSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param searchQuery (optional) 
     * @param orderBy (optional) 
     * @param page (optional) 
     * @param userId (optional) 
     * @param getFlagged (optional) 
     * @return Success
     */
    detailed17(includeInactive?: boolean | undefined, pageSize?: number | undefined, searchQuery?: string | undefined, orderBy?: VideoOrderBy | undefined, page?: number | undefined, userId?: string | undefined, getFlagged?: boolean | undefined, cancelToken?: CancelToken): Promise<VideoDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/File/video/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (getFlagged === null)
            throw new Error("The parameter 'getFlagged' cannot be null.");
        else if (getFlagged !== undefined)
            url_ += "getFlagged=" + encodeURIComponent("" + getFlagged) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed17(_response);
        });
    }

    protected processDetailed17(response: AxiosResponse): Promise<VideoDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<VideoDetailedDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoDetailedDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    video2(id: string, cancelToken?: CancelToken): Promise<VideoSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/File/video/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVideo2(_response);
        });
    }

    protected processVideo2(response: AxiosResponse): Promise<VideoSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoSimpleDto.fromJS(resultData200);
            return Promise.resolve<VideoSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoSimpleDto>(null as any);
    }

    /**
     * @return Success
     */
    detailed18(id: string, cancelToken?: CancelToken): Promise<VideoDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/File/video/detailed/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed18(_response);
        });
    }

    protected processDetailed18(response: AxiosResponse): Promise<VideoDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoDetailedDto.fromJS(resultData200);
            return Promise.resolve<VideoDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoDetailedDto>(null as any);
    }

    /**
     * Disables an existing video
     * @return Success
     */
    delete9(id: string, cancelToken?: CancelToken): Promise<VideoDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/File/video/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete9(_response);
        });
    }

    protected processDelete9(response: AxiosResponse): Promise<VideoDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoDetailedDto.fromJS(resultData200);
            return Promise.resolve<VideoDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate7(id: string, cancelToken?: CancelToken): Promise<VideoDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/File/video/reactivate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate7(_response);
        });
    }

    protected processReactivate7(response: AxiosResponse): Promise<VideoDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VideoDetailedDto.fromJS(resultData200);
            return Promise.resolve<VideoDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoDetailedDto>(null as any);
    }

    /**
     * @param fileExtension (optional) 
     * @param file (optional) 
     * @return Success
     */
    upload4(fileExtension?: string | undefined, file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/v1/File/document/upload?";
        if (fileExtension === null)
            throw new Error("The parameter 'fileExtension' cannot be null.");
        else if (fileExtension !== undefined)
            url_ += "fileExtension=" + encodeURIComponent("" + fileExtension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload4(_response);
        });
    }

    protected processUpload4(response: AxiosResponse): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentDto.fromJS(resultData200);
            return Promise.resolve<DocumentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @param userId (optional) 
     * @return Success
     */
    document(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, userId?: string | undefined, cancelToken?: CancelToken): Promise<DocumentDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/File/document?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument(_response);
        });
    }

    protected processDocument(response: AxiosResponse): Promise<DocumentDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<DocumentDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    document2(id: string, cancelToken?: CancelToken): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/v1/File/document/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument2(_response);
        });
    }

    protected processDocument2(response: AxiosResponse): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentDto.fromJS(resultData200);
            return Promise.resolve<DocumentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto>(null as any);
    }

    /**
     * @return Success
     */
    delete10(id: string, cancelToken?: CancelToken): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/v1/File/document/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete10(_response);
        });
    }

    protected processDelete10(response: AxiosResponse): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentDto.fromJS(resultData200);
            return Promise.resolve<DocumentDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentDto>(null as any);
    }

    /**
     * @return Success
     */
    recompress( cancelToken?: CancelToken): Promise<VideoDetailedDto[]> {
        let url_ = this.baseUrl + "/api/v1/File/image/recompress";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecompress(_response);
        });
    }

    protected processRecompress(response: AxiosResponse): Promise<VideoDetailedDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VideoDetailedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VideoDetailedDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VideoDetailedDto[]>(null as any);
    }

    /**
     * @return Success
     */
    flagImage(id: string, cancelToken?: CancelToken): Promise<ImageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/File/{id}/flagImage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlagImage(_response);
        });
    }

    protected processFlagImage(response: AxiosResponse): Promise<ImageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageDetailedDto.fromJS(resultData200);
            return Promise.resolve<ImageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    resolveFlaggedImage(id: string, cancelToken?: CancelToken): Promise<ImageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/File/{id}/resolveFlaggedImage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveFlaggedImage(_response);
        });
    }

    protected processResolveFlaggedImage(response: AxiosResponse): Promise<ImageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageDetailedDto.fromJS(resultData200);
            return Promise.resolve<ImageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    flagVideo(id: string, cancelToken?: CancelToken): Promise<ImageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/File/{id}/flagVideo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlagVideo(_response);
        });
    }

    protected processFlagVideo(response: AxiosResponse): Promise<ImageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageDetailedDto.fromJS(resultData200);
            return Promise.resolve<ImageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    resolveFlaggedVideo(id: string, cancelToken?: CancelToken): Promise<ImageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/File/{id}/resolveFlaggedVideo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveFlaggedVideo(_response);
        });
    }

    protected processResolveFlaggedVideo(response: AxiosResponse): Promise<ImageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImageDetailedDto.fromJS(resultData200);
            return Promise.resolve<ImageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImageDetailedDto>(null as any);
    }
}

export class FlaggedClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get summary of all flagged content
     * @return Success
     */
    flagged( cancelToken?: CancelToken): Promise<FlaggedOverviewDto> {
        let url_ = this.baseUrl + "/api/v1/Flagged";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlagged(_response);
        });
    }

    protected processFlagged(response: AxiosResponse): Promise<FlaggedOverviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FlaggedOverviewDto.fromJS(resultData200);
            return Promise.resolve<FlaggedOverviewDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlaggedOverviewDto>(null as any);
    }
}

export class ForumPostClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Forum Post
     * @param id The Id of the Forum Post
     * @return Returns if the Forum Post is found and the User is Authorized appropriately
     */
    forumPost(id: string, cancelToken?: CancelToken): Promise<ForumPostSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/ForumPost/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForumPost(_response);
        });
    }

    protected processForumPost(response: AxiosResponse): Promise<ForumPostSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForumPostSimpleDto.fromJS(resultData200);
            return Promise.resolve<ForumPostSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the forum Post cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForumPostSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Forum Post
     * @param id The Id of the Forum Post
     * @return Returns if the Forum Post is found and the User is Authorized appropriately
     */
    detailed19(id: string, cancelToken?: CancelToken): Promise<ForumPostDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/ForumPost/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed19(_response);
        });
    }

    protected processDetailed19(response: AxiosResponse): Promise<ForumPostDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForumPostDetailedDto.fromJS(resultData200);
            return Promise.resolve<ForumPostDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Forum Post cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForumPostDetailedDto>(null as any);
    }

    /**
     * Gets all Forum Posts in a Simple Format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Posts, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Forum Posts are found and the User is Authorized appropriately
     */
    forumPost2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ForumPostSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/ForumPost?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForumPost2(_response);
        });
    }

    protected processForumPost2(response: AxiosResponse): Promise<ForumPostSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForumPostSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ForumPostSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForumPostSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Forum Posts in a Detailed Format
     * @param includeInactive (optional) Whether or not to include Disabled Posts
     * @param pageSize (optional) How much data to display per page
     * @param page (optional) The Page number
     * @return Returns if the Forum Posts are found and the User is Authorized appropriately
     */
    detailed20(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ForumPostDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/ForumPost/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed20(_response);
        });
    }

    protected processDetailed20(response: AxiosResponse): Promise<ForumPostDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForumPostDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ForumPostDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForumPostDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Forum Post
     * @param body (optional) 
     * @return Returns if the Forum Post is Created, also returns a DetailedDto of the newly created Forum Post
     */
    createPOST8(body?: ForumPostCreateDto | undefined, cancelToken?: CancelToken): Promise<ForumPostDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/ForumPost/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST8(_response);
        });
    }

    protected processCreatePOST8(response: AxiosResponse): Promise<ForumPostDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForumPostDetailedDto.fromJS(resultData200);
            return Promise.resolve<ForumPostDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForumPostDetailedDto>(null as any);
    }

    /**
     * Updates an existing Forum Post
     * @param id The Id of the Forum Post being Updated
     * @param body (optional) A Dictionairy of Changes to be made to the Forum Post
     * @return Returns if the Forum Post is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    update8(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<ForumPostDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/ForumPost/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate8(_response);
        });
    }

    protected processUpdate8(response: AxiosResponse): Promise<ForumPostDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForumPostDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ForumPostDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForumPostDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Add a new Comment
     * @param id The Id of the Forum Post being commented on
     * @param body (optional) 
     * @return Returns if the Forum Post is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addComment(id: string, body?: ForumCommentCreateDto | undefined, cancelToken?: CancelToken): Promise<ForumPostDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/ForumPost/{id}/add-comment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddComment(_response);
        });
    }

    protected processAddComment(response: AxiosResponse): Promise<ForumPostDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForumPostDetailedDto.fromJS(resultData200);
            return Promise.resolve<ForumPostDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForumPostDetailedDto>(null as any);
    }

    /**
     * Remove a Comment
     * @param id The Id of the comment to be removed
     * @return Returns if the Forum Post is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeComment(id: string, cancelToken?: CancelToken): Promise<ForumPostDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/ForumPost/remove-comment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveComment(_response);
        });
    }

    protected processRemoveComment(response: AxiosResponse): Promise<ForumPostDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForumPostDetailedDto.fromJS(resultData200);
            return Promise.resolve<ForumPostDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForumPostDetailedDto>(null as any);
    }

    /**
     * Edit an Existing Comment
     * @param id The Id of the Comment to be Editted
     * @param body (optional) The updated comment contents
     * @return Success
     */
    editComment(id: string, body?: string | undefined, cancelToken?: CancelToken): Promise<ForumPostDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/ForumPost/edit-comment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditComment(_response);
        });
    }

    protected processEditComment(response: AxiosResponse): Promise<ForumPostDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForumPostDetailedDto.fromJS(resultData200);
            return Promise.resolve<ForumPostDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForumPostDetailedDto>(null as any);
    }

    /**
     * Disables an existing Forum Post
     * @return Success
     */
    delete11(id: string, cancelToken?: CancelToken): Promise<ForumPostDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/ForumPost/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete11(_response);
        });
    }

    protected processDelete11(response: AxiosResponse): Promise<ForumPostDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForumPostDetailedDto.fromJS(resultData200);
            return Promise.resolve<ForumPostDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForumPostDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate8(id: string, cancelToken?: CancelToken): Promise<ForumPostDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/ForumPost/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate8(_response);
        });
    }

    protected processReactivate8(response: AxiosResponse): Promise<ForumPostDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ForumPostDetailedDto.fromJS(resultData200);
            return Promise.resolve<ForumPostDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ForumPostDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Forum Post
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes8(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/ForumPost/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges8(_response);
        });
    }

    protected processChanges8(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class GenderClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Gender
     * @param id The Id of a Gender
     * @return Returns if the Gender is found and the User is Authorized appropriately
     */
    gender(id: string, cancelToken?: CancelToken): Promise<GenderSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Gender/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGender(_response);
        });
    }

    protected processGender(response: AxiosResponse): Promise<GenderSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenderSimpleDto.fromJS(resultData200);
            return Promise.resolve<GenderSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Business Account cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenderSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Gender
     * @param id The Id of a Gender
     * @return Returns if the Gender is found and the User is Authorized appropriately
     */
    detailed21(id: string, cancelToken?: CancelToken): Promise<GenderDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Gender/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed21(_response);
        });
    }

    protected processDetailed21(response: AxiosResponse): Promise<GenderDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenderDetailedDto.fromJS(resultData200);
            return Promise.resolve<GenderDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Business Account cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenderDetailedDto>(null as any);
    }

    /**
     * Gets all Genders in the Simple format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Genders, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @param searchQuery (optional) What you would like to search records by
     * @param orderBy (optional) How you want the result to be ordered
     * @return Returns if the Genders are found and the User is Authorized appropriately
     */
    gender2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, searchQuery?: string | undefined, orderBy?: GenderOrderBy | undefined, cancelToken?: CancelToken): Promise<GenderSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Gender?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGender2(_response);
        });
    }

    protected processGender2(response: AxiosResponse): Promise<GenderSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenderSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<GenderSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenderSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Genders in the Detailed format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Genders, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Genders are found and the User is Authorized appropriately
     */
    detailed22(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<GenderDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Gender/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed22(_response);
        });
    }

    protected processDetailed22(response: AxiosResponse): Promise<GenderDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenderDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<GenderDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenderDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Gender
     * @param body (optional) 
     * @return Success
     */
    createPOST9(body?: GenderCreateDto | undefined, cancelToken?: CancelToken): Promise<GenderDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Gender/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST9(_response);
        });
    }

    protected processCreatePOST9(response: AxiosResponse): Promise<GenderDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenderDetailedDto.fromJS(resultData200);
            return Promise.resolve<GenderDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenderDetailedDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update9(id?: string | undefined, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<GenderDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Gender/update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate9(_response);
        });
    }

    protected processUpdate9(response: AxiosResponse): Promise<GenderDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenderDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<GenderDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenderDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Disables an existing Gender
     * @return Success
     */
    delete12(id: string, cancelToken?: CancelToken): Promise<GenderDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Gender/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete12(_response);
        });
    }

    protected processDelete12(response: AxiosResponse): Promise<GenderDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenderDetailedDto.fromJS(resultData200);
            return Promise.resolve<GenderDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenderDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate9(id: string, cancelToken?: CancelToken): Promise<GenderDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Gender/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate9(_response);
        });
    }

    protected processReactivate9(response: AxiosResponse): Promise<GenderDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenderDetailedDto.fromJS(resultData200);
            return Promise.resolve<GenderDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenderDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Gender
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes9(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Gender/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges9(_response);
        });
    }

    protected processChanges9(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class InsuranceCompanyClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    insuranceCompany(id: string, cancelToken?: CancelToken): Promise<InsuranceCompanyDto> {
        let url_ = this.baseUrl + "/api/v1/InsuranceCompany/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsuranceCompany(_response);
        });
    }

    protected processInsuranceCompany(response: AxiosResponse): Promise<InsuranceCompanyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsuranceCompanyDto.fromJS(resultData200);
            return Promise.resolve<InsuranceCompanyDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsuranceCompanyDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    insuranceCompany2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<InsuranceCompanyDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/InsuranceCompany?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsuranceCompany2(_response);
        });
    }

    protected processInsuranceCompany2(response: AxiosResponse): Promise<InsuranceCompanyDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsuranceCompanyDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<InsuranceCompanyDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsuranceCompanyDtoPaginationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST10(body?: InsuranceCompanyCreateDto | undefined, cancelToken?: CancelToken): Promise<InsuranceCompanyDto> {
        let url_ = this.baseUrl + "/api/v1/InsuranceCompany/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST10(_response);
        });
    }

    protected processCreatePOST10(response: AxiosResponse): Promise<InsuranceCompanyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsuranceCompanyDto.fromJS(resultData200);
            return Promise.resolve<InsuranceCompanyDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsuranceCompanyDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update10(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<InsuranceCompanyDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/InsuranceCompany/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate10(_response);
        });
    }

    protected processUpdate10(response: AxiosResponse): Promise<InsuranceCompanyDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsuranceCompanyDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<InsuranceCompanyDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsuranceCompanyDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param imageId (optional) 
     * @return Success
     */
    changeImage(insuranceCompanyId: string, imageId?: string | undefined, cancelToken?: CancelToken): Promise<InsuranceCompanyDto> {
        let url_ = this.baseUrl + "/api/v1/InsuranceCompany/{insuranceCompanyId}/change-image?";
        if (insuranceCompanyId === undefined || insuranceCompanyId === null)
            throw new Error("The parameter 'insuranceCompanyId' must be defined.");
        url_ = url_.replace("{insuranceCompanyId}", encodeURIComponent("" + insuranceCompanyId));
        if (imageId === null)
            throw new Error("The parameter 'imageId' cannot be null.");
        else if (imageId !== undefined)
            url_ += "imageId=" + encodeURIComponent("" + imageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeImage(_response);
        });
    }

    protected processChangeImage(response: AxiosResponse): Promise<InsuranceCompanyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsuranceCompanyDto.fromJS(resultData200);
            return Promise.resolve<InsuranceCompanyDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsuranceCompanyDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLocationPUT(id: string, body?: Location | undefined, cancelToken?: CancelToken): Promise<InsuranceCompanyDto> {
        let url_ = this.baseUrl + "/api/v1/InsuranceCompany/{id}/change-location";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeLocationPUT(_response);
        });
    }

    protected processChangeLocationPUT(response: AxiosResponse): Promise<InsuranceCompanyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsuranceCompanyDto.fromJS(resultData200);
            return Promise.resolve<InsuranceCompanyDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsuranceCompanyDto>(null as any);
    }

    /**
     * @return Success
     */
    delete13(id: string, cancelToken?: CancelToken): Promise<InsuranceCompanyDto> {
        let url_ = this.baseUrl + "/api/v1/InsuranceCompany/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete13(_response);
        });
    }

    protected processDelete13(response: AxiosResponse): Promise<InsuranceCompanyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsuranceCompanyDto.fromJS(resultData200);
            return Promise.resolve<InsuranceCompanyDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsuranceCompanyDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate10(id: string, cancelToken?: CancelToken): Promise<InsuranceCompanyDto> {
        let url_ = this.baseUrl + "/api/v1/InsuranceCompany/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate10(_response);
        });
    }

    protected processReactivate10(response: AxiosResponse): Promise<InsuranceCompanyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsuranceCompanyDto.fromJS(resultData200);
            return Promise.resolve<InsuranceCompanyDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsuranceCompanyDto>(null as any);
    }
}

export class InsurancePlanClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    insurancePlan(id: string, cancelToken?: CancelToken): Promise<InsurancePlanDto> {
        let url_ = this.baseUrl + "/api/v1/InsurancePlan/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsurancePlan(_response);
        });
    }

    protected processInsurancePlan(response: AxiosResponse): Promise<InsurancePlanDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsurancePlanDto.fromJS(resultData200);
            return Promise.resolve<InsurancePlanDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsurancePlanDto>(null as any);
    }

    /**
     * @param insuranceCompanyId (optional) 
     * @param categoryId (optional) 
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    insurancePlan2(insuranceCompanyId?: string | undefined, categoryId?: string | undefined, includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<InsurancePlanDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/InsurancePlan?";
        if (insuranceCompanyId === null)
            throw new Error("The parameter 'insuranceCompanyId' cannot be null.");
        else if (insuranceCompanyId !== undefined)
            url_ += "insuranceCompanyId=" + encodeURIComponent("" + insuranceCompanyId) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsurancePlan2(_response);
        });
    }

    protected processInsurancePlan2(response: AxiosResponse): Promise<InsurancePlanDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsurancePlanDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<InsurancePlanDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsurancePlanDtoPaginationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST11(body?: InsurancePlanCreateDto | undefined, cancelToken?: CancelToken): Promise<InsurancePlanDto> {
        let url_ = this.baseUrl + "/api/v1/InsurancePlan/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST11(_response);
        });
    }

    protected processCreatePOST11(response: AxiosResponse): Promise<InsurancePlanDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsurancePlanDto.fromJS(resultData200);
            return Promise.resolve<InsurancePlanDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsurancePlanDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update11(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<InsurancePlanDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/InsurancePlan/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate11(_response);
        });
    }

    protected processUpdate11(response: AxiosResponse): Promise<InsurancePlanDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsurancePlanDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<InsurancePlanDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsurancePlanDtoUpdateResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    changeInsuranceCompany(insurancePlanId: string, insuranceCompanyId: string, cancelToken?: CancelToken): Promise<InsurancePlanDto> {
        let url_ = this.baseUrl + "/api/v1/InsurancePlan/{insurancePlanId}/change-insurance-company/{insuranceCompanyId}";
        if (insurancePlanId === undefined || insurancePlanId === null)
            throw new Error("The parameter 'insurancePlanId' must be defined.");
        url_ = url_.replace("{insurancePlanId}", encodeURIComponent("" + insurancePlanId));
        if (insuranceCompanyId === undefined || insuranceCompanyId === null)
            throw new Error("The parameter 'insuranceCompanyId' must be defined.");
        url_ = url_.replace("{insuranceCompanyId}", encodeURIComponent("" + insuranceCompanyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeInsuranceCompany(_response);
        });
    }

    protected processChangeInsuranceCompany(response: AxiosResponse): Promise<InsurancePlanDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsurancePlanDto.fromJS(resultData200);
            return Promise.resolve<InsurancePlanDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsurancePlanDto>(null as any);
    }

    /**
     * @return Success
     */
    delete14(id: string, cancelToken?: CancelToken): Promise<InsurancePlanDto> {
        let url_ = this.baseUrl + "/api/v1/InsurancePlan/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete14(_response);
        });
    }

    protected processDelete14(response: AxiosResponse): Promise<InsurancePlanDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsurancePlanDto.fromJS(resultData200);
            return Promise.resolve<InsurancePlanDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsurancePlanDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate11(id: string, cancelToken?: CancelToken): Promise<InsurancePlanDto> {
        let url_ = this.baseUrl + "/api/v1/InsurancePlan/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate11(_response);
        });
    }

    protected processReactivate11(response: AxiosResponse): Promise<InsurancePlanDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsurancePlanDto.fromJS(resultData200);
            return Promise.resolve<InsurancePlanDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsurancePlanDto>(null as any);
    }

    /**
     * @return Success
     */
    deactivateOrphanedPolicies( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/InsurancePlan/deactivate-orphaned-policies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateOrphanedPolicies(_response);
        });
    }

    protected processDeactivateOrphanedPolicies(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ItemClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Item
     * @param id The id of the Item
     * @return Returns if the Item is found and the User is Authorized appropriately
     */
    item(id: string, cancelToken?: CancelToken): Promise<ItemPublicDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processItem(_response);
        });
    }

    protected processItem(response: AxiosResponse): Promise<ItemPublicDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemPublicDto.fromJS(resultData200);
            return Promise.resolve<ItemPublicDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemPublicDto>(null as any);
    }

    /**
     * Gets a Simple Item with private info if User is staff or the sharer
     * @param id The id of the Item
     * @return Returns if the Item is found and the User is Authorized appropriately
     */
    private(id: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}/private";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrivate(_response);
        });
    }

    protected processPrivate(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * @return Success
     * @deprecated
     */
    detailed23(id: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}/private/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed23(_response);
        });
    }

    protected processDetailed23(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * Gets a Detailed Item
     * @param id The id of the Item
     * @return Returns if the Item is found and the User is Authorized appropriately
     * @deprecated
     */
    detailed24(id: string, cancelToken?: CancelToken): Promise<ItemPublicDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed24(_response);
        });
    }

    protected processDetailed24(response: AxiosResponse): Promise<ItemPublicDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemPublicDto.fromJS(resultData200);
            return Promise.resolve<ItemPublicDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemPublicDto>(null as any);
    }

    /**
     * Gets all Items
     * @param latitude (optional) The Latitude to be used for the Radius Search
     * @param longitude (optional) The Longitude to be used for Radius Search
     * @param ip (optional) Optional ip parameter that can convert to longitude and latitude
     * @param radius (optional) A Radius for the API to search for in Miles, originating at the Long/Lat values above - An approximation not exact
     * @param minDailyPrice (optional) 
     * @param maxDailyPrice (optional) 
     * @param minHourlyPrice (optional) 
     * @param maxHourlyPrice (optional) 
     * @param minDate (optional) 
     * @param maxDate (optional) 
     * @param publishMinDate (optional) 
     * @param publishMaxDate (optional) 
     * @param allAvailable (optional) 
     * @param hourly (optional) 
     * @param categoryIds (optional) Any Categories to filter by
     * @param searchQuery (optional) Any Search Terms to Filter by
     * @param searchAspects (optional) 
     * @param multiAspectSearchMode (optional) 
     * @param orderBy (optional) A specific way to sort the Data
     * @param userId (optional) Limit to Items from a Specific user
     * @param getFlagged (optional) only get flagged content
     * @param tenantId (optional) 
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Items are found and the User is Authorized appropriately
     */
    item2(latitude?: number | undefined, longitude?: number | undefined, ip?: string | undefined, radius?: number | undefined, minDailyPrice?: number | undefined, maxDailyPrice?: number | undefined, minHourlyPrice?: number | undefined, maxHourlyPrice?: number | undefined, minDate?: Date | undefined, maxDate?: Date | undefined, publishMinDate?: Date | undefined, publishMaxDate?: Date | undefined, allAvailable?: boolean | undefined, hourly?: boolean | undefined, categoryIds?: string[] | undefined, searchQuery?: string | undefined, searchAspects?: string | undefined, multiAspectSearchMode?: MultiAspectSearchMode | undefined, orderBy?: ItemOrderBy | undefined, userId?: string | undefined, getFlagged?: boolean | undefined, tenantId?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ItemPublicDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Item?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (ip === null)
            throw new Error("The parameter 'ip' cannot be null.");
        else if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        if (radius === null)
            throw new Error("The parameter 'radius' cannot be null.");
        else if (radius !== undefined)
            url_ += "radius=" + encodeURIComponent("" + radius) + "&";
        if (minDailyPrice === null)
            throw new Error("The parameter 'minDailyPrice' cannot be null.");
        else if (minDailyPrice !== undefined)
            url_ += "minDailyPrice=" + encodeURIComponent("" + minDailyPrice) + "&";
        if (maxDailyPrice === null)
            throw new Error("The parameter 'maxDailyPrice' cannot be null.");
        else if (maxDailyPrice !== undefined)
            url_ += "maxDailyPrice=" + encodeURIComponent("" + maxDailyPrice) + "&";
        if (minHourlyPrice === null)
            throw new Error("The parameter 'minHourlyPrice' cannot be null.");
        else if (minHourlyPrice !== undefined)
            url_ += "minHourlyPrice=" + encodeURIComponent("" + minHourlyPrice) + "&";
        if (maxHourlyPrice === null)
            throw new Error("The parameter 'maxHourlyPrice' cannot be null.");
        else if (maxHourlyPrice !== undefined)
            url_ += "maxHourlyPrice=" + encodeURIComponent("" + maxHourlyPrice) + "&";
        if (minDate === null)
            throw new Error("The parameter 'minDate' cannot be null.");
        else if (minDate !== undefined)
            url_ += "minDate=" + encodeURIComponent(minDate ? "" + minDate.toISOString() : "") + "&";
        if (maxDate === null)
            throw new Error("The parameter 'maxDate' cannot be null.");
        else if (maxDate !== undefined)
            url_ += "maxDate=" + encodeURIComponent(maxDate ? "" + maxDate.toISOString() : "") + "&";
        if (publishMinDate === null)
            throw new Error("The parameter 'publishMinDate' cannot be null.");
        else if (publishMinDate !== undefined)
            url_ += "publishMinDate=" + encodeURIComponent(publishMinDate ? "" + publishMinDate.toISOString() : "") + "&";
        if (publishMaxDate === null)
            throw new Error("The parameter 'publishMaxDate' cannot be null.");
        else if (publishMaxDate !== undefined)
            url_ += "publishMaxDate=" + encodeURIComponent(publishMaxDate ? "" + publishMaxDate.toISOString() : "") + "&";
        if (allAvailable === null)
            throw new Error("The parameter 'allAvailable' cannot be null.");
        else if (allAvailable !== undefined)
            url_ += "allAvailable=" + encodeURIComponent("" + allAvailable) + "&";
        if (hourly === null)
            throw new Error("The parameter 'hourly' cannot be null.");
        else if (hourly !== undefined)
            url_ += "hourly=" + encodeURIComponent("" + hourly) + "&";
        if (categoryIds === null)
            throw new Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (searchAspects === null)
            throw new Error("The parameter 'searchAspects' cannot be null.");
        else if (searchAspects !== undefined)
            url_ += "searchAspects=" + encodeURIComponent("" + searchAspects) + "&";
        if (multiAspectSearchMode === null)
            throw new Error("The parameter 'multiAspectSearchMode' cannot be null.");
        else if (multiAspectSearchMode !== undefined)
            url_ += "multiAspectSearchMode=" + encodeURIComponent("" + multiAspectSearchMode) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (getFlagged === null)
            throw new Error("The parameter 'getFlagged' cannot be null.");
        else if (getFlagged !== undefined)
            url_ += "getFlagged=" + encodeURIComponent("" + getFlagged) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processItem2(_response);
        });
    }

    protected processItem2(response: AxiosResponse): Promise<ItemPublicDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemPublicDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ItemPublicDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemPublicDtoPaginationDto>(null as any);
    }

    /**
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @param ip (optional) 
     * @param radius (optional) 
     * @param minDailyPrice (optional) 
     * @param maxDailyPrice (optional) 
     * @param minHourlyPrice (optional) 
     * @param maxHourlyPrice (optional) 
     * @param minDate (optional) 
     * @param maxDate (optional) 
     * @param publishMinDate (optional) 
     * @param publishMaxDate (optional) 
     * @param allAvailable (optional) 
     * @param hourly (optional) 
     * @param categoryIds (optional) 
     * @param searchQuery (optional) 
     * @param searchAspects (optional) 
     * @param multiAspectSearchMode (optional) 
     * @param orderBy (optional) 
     * @param userId (optional) 
     * @param getFlagged (optional) 
     * @param tenantId (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     * @deprecated
     */
    detailed25(latitude?: number | undefined, longitude?: number | undefined, ip?: string | undefined, radius?: number | undefined, minDailyPrice?: number | undefined, maxDailyPrice?: number | undefined, minHourlyPrice?: number | undefined, maxHourlyPrice?: number | undefined, minDate?: Date | undefined, maxDate?: Date | undefined, publishMinDate?: Date | undefined, publishMaxDate?: Date | undefined, allAvailable?: boolean | undefined, hourly?: boolean | undefined, categoryIds?: string[] | undefined, searchQuery?: string | undefined, searchAspects?: string | undefined, multiAspectSearchMode?: MultiAspectSearchMode | undefined, orderBy?: ItemOrderBy | undefined, userId?: string | undefined, getFlagged?: boolean | undefined, tenantId?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ItemDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Item/detailed?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (ip === null)
            throw new Error("The parameter 'ip' cannot be null.");
        else if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        if (radius === null)
            throw new Error("The parameter 'radius' cannot be null.");
        else if (radius !== undefined)
            url_ += "radius=" + encodeURIComponent("" + radius) + "&";
        if (minDailyPrice === null)
            throw new Error("The parameter 'minDailyPrice' cannot be null.");
        else if (minDailyPrice !== undefined)
            url_ += "minDailyPrice=" + encodeURIComponent("" + minDailyPrice) + "&";
        if (maxDailyPrice === null)
            throw new Error("The parameter 'maxDailyPrice' cannot be null.");
        else if (maxDailyPrice !== undefined)
            url_ += "maxDailyPrice=" + encodeURIComponent("" + maxDailyPrice) + "&";
        if (minHourlyPrice === null)
            throw new Error("The parameter 'minHourlyPrice' cannot be null.");
        else if (minHourlyPrice !== undefined)
            url_ += "minHourlyPrice=" + encodeURIComponent("" + minHourlyPrice) + "&";
        if (maxHourlyPrice === null)
            throw new Error("The parameter 'maxHourlyPrice' cannot be null.");
        else if (maxHourlyPrice !== undefined)
            url_ += "maxHourlyPrice=" + encodeURIComponent("" + maxHourlyPrice) + "&";
        if (minDate === null)
            throw new Error("The parameter 'minDate' cannot be null.");
        else if (minDate !== undefined)
            url_ += "minDate=" + encodeURIComponent(minDate ? "" + minDate.toISOString() : "") + "&";
        if (maxDate === null)
            throw new Error("The parameter 'maxDate' cannot be null.");
        else if (maxDate !== undefined)
            url_ += "maxDate=" + encodeURIComponent(maxDate ? "" + maxDate.toISOString() : "") + "&";
        if (publishMinDate === null)
            throw new Error("The parameter 'publishMinDate' cannot be null.");
        else if (publishMinDate !== undefined)
            url_ += "publishMinDate=" + encodeURIComponent(publishMinDate ? "" + publishMinDate.toISOString() : "") + "&";
        if (publishMaxDate === null)
            throw new Error("The parameter 'publishMaxDate' cannot be null.");
        else if (publishMaxDate !== undefined)
            url_ += "publishMaxDate=" + encodeURIComponent(publishMaxDate ? "" + publishMaxDate.toISOString() : "") + "&";
        if (allAvailable === null)
            throw new Error("The parameter 'allAvailable' cannot be null.");
        else if (allAvailable !== undefined)
            url_ += "allAvailable=" + encodeURIComponent("" + allAvailable) + "&";
        if (hourly === null)
            throw new Error("The parameter 'hourly' cannot be null.");
        else if (hourly !== undefined)
            url_ += "hourly=" + encodeURIComponent("" + hourly) + "&";
        if (categoryIds === null)
            throw new Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (searchAspects === null)
            throw new Error("The parameter 'searchAspects' cannot be null.");
        else if (searchAspects !== undefined)
            url_ += "searchAspects=" + encodeURIComponent("" + searchAspects) + "&";
        if (multiAspectSearchMode === null)
            throw new Error("The parameter 'multiAspectSearchMode' cannot be null.");
        else if (multiAspectSearchMode !== undefined)
            url_ += "multiAspectSearchMode=" + encodeURIComponent("" + multiAspectSearchMode) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (getFlagged === null)
            throw new Error("The parameter 'getFlagged' cannot be null.");
        else if (getFlagged !== undefined)
            url_ += "getFlagged=" + encodeURIComponent("" + getFlagged) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed25(_response);
        });
    }

    protected processDetailed25(response: AxiosResponse): Promise<ItemDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Items
     * @param includeSuspended (optional) Whether or not you want to Include Suspended Items
     * @param includeInactive (optional) Whether or not you want to Include Inactive Items
     * @param latitude (optional) The Latitude to be used for the Radius Search
     * @param longitude (optional) The Longitude to be used for Radius Search
     * @param ip (optional) Optional ip parameter that can convert to longitude and latitude
     * @param radius (optional) A Radius for the API to search for in Miles, originating at the Long/Lat values above
     * @param minDailyPrice (optional) 
     * @param maxDailyPrice (optional) 
     * @param minHourlyPrice (optional) 
     * @param maxHourlyPrice (optional) 
     * @param minDate (optional) 
     * @param maxDate (optional) 
     * @param publishMinDate (optional) 
     * @param publishMaxDate (optional) 
     * @param allAvailable (optional) 
     * @param hourly (optional) 
     * @param categoryIds (optional) Any Categories to filter by
     * @param searchQuery (optional) Any Search Terms to Filter by
     * @param searchAspects (optional) 
     * @param multiAspectSearchMode (optional) 
     * @param orderBy (optional) A specific way to sort the Data
     * @param userId (optional) Limit to Items from a Specific user
     * @param includeUnpublished (optional) Whether items that have not been published should be included
     * @param onlyUnpublished (optional) 
     * @param getFlagged (optional) Filter only flagged items
     * @param tenantId (optional) 
     * @param pageSize (optional) 
     * @param page (optional) The page number you want to start from
     * @return Returns if the Items are found and the User is Authorized appropriately
     */
    private2(includeSuspended?: boolean | undefined, includeInactive?: boolean | undefined, latitude?: number | undefined, longitude?: number | undefined, ip?: string | undefined, radius?: number | undefined, minDailyPrice?: number | undefined, maxDailyPrice?: number | undefined, minHourlyPrice?: number | undefined, maxHourlyPrice?: number | undefined, minDate?: Date | undefined, maxDate?: Date | undefined, publishMinDate?: Date | undefined, publishMaxDate?: Date | undefined, allAvailable?: boolean | undefined, hourly?: boolean | undefined, categoryIds?: string[] | undefined, searchQuery?: string | undefined, searchAspects?: string | undefined, multiAspectSearchMode?: MultiAspectSearchMode | undefined, orderBy?: ItemOrderBy | undefined, userId?: string | undefined, includeUnpublished?: boolean | undefined, onlyUnpublished?: boolean | undefined, getFlagged?: boolean | undefined, tenantId?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ItemDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Item/private?";
        if (includeSuspended === null)
            throw new Error("The parameter 'includeSuspended' cannot be null.");
        else if (includeSuspended !== undefined)
            url_ += "includeSuspended=" + encodeURIComponent("" + includeSuspended) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (ip === null)
            throw new Error("The parameter 'ip' cannot be null.");
        else if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        if (radius === null)
            throw new Error("The parameter 'radius' cannot be null.");
        else if (radius !== undefined)
            url_ += "radius=" + encodeURIComponent("" + radius) + "&";
        if (minDailyPrice === null)
            throw new Error("The parameter 'minDailyPrice' cannot be null.");
        else if (minDailyPrice !== undefined)
            url_ += "minDailyPrice=" + encodeURIComponent("" + minDailyPrice) + "&";
        if (maxDailyPrice === null)
            throw new Error("The parameter 'maxDailyPrice' cannot be null.");
        else if (maxDailyPrice !== undefined)
            url_ += "maxDailyPrice=" + encodeURIComponent("" + maxDailyPrice) + "&";
        if (minHourlyPrice === null)
            throw new Error("The parameter 'minHourlyPrice' cannot be null.");
        else if (minHourlyPrice !== undefined)
            url_ += "minHourlyPrice=" + encodeURIComponent("" + minHourlyPrice) + "&";
        if (maxHourlyPrice === null)
            throw new Error("The parameter 'maxHourlyPrice' cannot be null.");
        else if (maxHourlyPrice !== undefined)
            url_ += "maxHourlyPrice=" + encodeURIComponent("" + maxHourlyPrice) + "&";
        if (minDate === null)
            throw new Error("The parameter 'minDate' cannot be null.");
        else if (minDate !== undefined)
            url_ += "minDate=" + encodeURIComponent(minDate ? "" + minDate.toISOString() : "") + "&";
        if (maxDate === null)
            throw new Error("The parameter 'maxDate' cannot be null.");
        else if (maxDate !== undefined)
            url_ += "maxDate=" + encodeURIComponent(maxDate ? "" + maxDate.toISOString() : "") + "&";
        if (publishMinDate === null)
            throw new Error("The parameter 'publishMinDate' cannot be null.");
        else if (publishMinDate !== undefined)
            url_ += "publishMinDate=" + encodeURIComponent(publishMinDate ? "" + publishMinDate.toISOString() : "") + "&";
        if (publishMaxDate === null)
            throw new Error("The parameter 'publishMaxDate' cannot be null.");
        else if (publishMaxDate !== undefined)
            url_ += "publishMaxDate=" + encodeURIComponent(publishMaxDate ? "" + publishMaxDate.toISOString() : "") + "&";
        if (allAvailable === null)
            throw new Error("The parameter 'allAvailable' cannot be null.");
        else if (allAvailable !== undefined)
            url_ += "allAvailable=" + encodeURIComponent("" + allAvailable) + "&";
        if (hourly === null)
            throw new Error("The parameter 'hourly' cannot be null.");
        else if (hourly !== undefined)
            url_ += "hourly=" + encodeURIComponent("" + hourly) + "&";
        if (categoryIds === null)
            throw new Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (searchAspects === null)
            throw new Error("The parameter 'searchAspects' cannot be null.");
        else if (searchAspects !== undefined)
            url_ += "searchAspects=" + encodeURIComponent("" + searchAspects) + "&";
        if (multiAspectSearchMode === null)
            throw new Error("The parameter 'multiAspectSearchMode' cannot be null.");
        else if (multiAspectSearchMode !== undefined)
            url_ += "multiAspectSearchMode=" + encodeURIComponent("" + multiAspectSearchMode) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (includeUnpublished === null)
            throw new Error("The parameter 'includeUnpublished' cannot be null.");
        else if (includeUnpublished !== undefined)
            url_ += "includeUnpublished=" + encodeURIComponent("" + includeUnpublished) + "&";
        if (onlyUnpublished === null)
            throw new Error("The parameter 'onlyUnpublished' cannot be null.");
        else if (onlyUnpublished !== undefined)
            url_ += "onlyUnpublished=" + encodeURIComponent("" + onlyUnpublished) + "&";
        if (getFlagged === null)
            throw new Error("The parameter 'getFlagged' cannot be null.");
        else if (getFlagged !== undefined)
            url_ += "getFlagged=" + encodeURIComponent("" + getFlagged) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrivate2(_response);
        });
    }

    protected processPrivate2(response: AxiosResponse): Promise<ItemDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoPaginationDto>(null as any);
    }

    /**
     * @param includeSuspended (optional) 
     * @param includeInactive (optional) 
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @param ip (optional) 
     * @param radius (optional) 
     * @param minDailyPrice (optional) 
     * @param maxDailyPrice (optional) 
     * @param minHourlyPrice (optional) 
     * @param maxHourlyPrice (optional) 
     * @param minDate (optional) 
     * @param maxDate (optional) 
     * @param publishMinDate (optional) 
     * @param publishMaxDate (optional) 
     * @param allAvailable (optional) 
     * @param hourly (optional) 
     * @param categoryIds (optional) 
     * @param searchQuery (optional) 
     * @param searchAspects (optional) 
     * @param multiAspectSearchMode (optional) 
     * @param orderBy (optional) 
     * @param userId (optional) 
     * @param includeUnpublished (optional) 
     * @param onlyUnpublished (optional) 
     * @param tenantId (optional) 
     * @param getFlagged (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     * @deprecated
     */
    detailed26(includeSuspended?: boolean | undefined, includeInactive?: boolean | undefined, latitude?: number | undefined, longitude?: number | undefined, ip?: string | undefined, radius?: number | undefined, minDailyPrice?: number | undefined, maxDailyPrice?: number | undefined, minHourlyPrice?: number | undefined, maxHourlyPrice?: number | undefined, minDate?: Date | undefined, maxDate?: Date | undefined, publishMinDate?: Date | undefined, publishMaxDate?: Date | undefined, allAvailable?: boolean | undefined, hourly?: boolean | undefined, categoryIds?: string[] | undefined, searchQuery?: string | undefined, searchAspects?: string | undefined, multiAspectSearchMode?: MultiAspectSearchMode | undefined, orderBy?: ItemOrderBy | undefined, userId?: string | undefined, includeUnpublished?: boolean | undefined, onlyUnpublished?: boolean | undefined, tenantId?: string | undefined, getFlagged?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ItemDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Item/private/detailed?";
        if (includeSuspended === null)
            throw new Error("The parameter 'includeSuspended' cannot be null.");
        else if (includeSuspended !== undefined)
            url_ += "includeSuspended=" + encodeURIComponent("" + includeSuspended) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (ip === null)
            throw new Error("The parameter 'ip' cannot be null.");
        else if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        if (radius === null)
            throw new Error("The parameter 'radius' cannot be null.");
        else if (radius !== undefined)
            url_ += "radius=" + encodeURIComponent("" + radius) + "&";
        if (minDailyPrice === null)
            throw new Error("The parameter 'minDailyPrice' cannot be null.");
        else if (minDailyPrice !== undefined)
            url_ += "minDailyPrice=" + encodeURIComponent("" + minDailyPrice) + "&";
        if (maxDailyPrice === null)
            throw new Error("The parameter 'maxDailyPrice' cannot be null.");
        else if (maxDailyPrice !== undefined)
            url_ += "maxDailyPrice=" + encodeURIComponent("" + maxDailyPrice) + "&";
        if (minHourlyPrice === null)
            throw new Error("The parameter 'minHourlyPrice' cannot be null.");
        else if (minHourlyPrice !== undefined)
            url_ += "minHourlyPrice=" + encodeURIComponent("" + minHourlyPrice) + "&";
        if (maxHourlyPrice === null)
            throw new Error("The parameter 'maxHourlyPrice' cannot be null.");
        else if (maxHourlyPrice !== undefined)
            url_ += "maxHourlyPrice=" + encodeURIComponent("" + maxHourlyPrice) + "&";
        if (minDate === null)
            throw new Error("The parameter 'minDate' cannot be null.");
        else if (minDate !== undefined)
            url_ += "minDate=" + encodeURIComponent(minDate ? "" + minDate.toISOString() : "") + "&";
        if (maxDate === null)
            throw new Error("The parameter 'maxDate' cannot be null.");
        else if (maxDate !== undefined)
            url_ += "maxDate=" + encodeURIComponent(maxDate ? "" + maxDate.toISOString() : "") + "&";
        if (publishMinDate === null)
            throw new Error("The parameter 'publishMinDate' cannot be null.");
        else if (publishMinDate !== undefined)
            url_ += "publishMinDate=" + encodeURIComponent(publishMinDate ? "" + publishMinDate.toISOString() : "") + "&";
        if (publishMaxDate === null)
            throw new Error("The parameter 'publishMaxDate' cannot be null.");
        else if (publishMaxDate !== undefined)
            url_ += "publishMaxDate=" + encodeURIComponent(publishMaxDate ? "" + publishMaxDate.toISOString() : "") + "&";
        if (allAvailable === null)
            throw new Error("The parameter 'allAvailable' cannot be null.");
        else if (allAvailable !== undefined)
            url_ += "allAvailable=" + encodeURIComponent("" + allAvailable) + "&";
        if (hourly === null)
            throw new Error("The parameter 'hourly' cannot be null.");
        else if (hourly !== undefined)
            url_ += "hourly=" + encodeURIComponent("" + hourly) + "&";
        if (categoryIds === null)
            throw new Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (searchAspects === null)
            throw new Error("The parameter 'searchAspects' cannot be null.");
        else if (searchAspects !== undefined)
            url_ += "searchAspects=" + encodeURIComponent("" + searchAspects) + "&";
        if (multiAspectSearchMode === null)
            throw new Error("The parameter 'multiAspectSearchMode' cannot be null.");
        else if (multiAspectSearchMode !== undefined)
            url_ += "multiAspectSearchMode=" + encodeURIComponent("" + multiAspectSearchMode) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (includeUnpublished === null)
            throw new Error("The parameter 'includeUnpublished' cannot be null.");
        else if (includeUnpublished !== undefined)
            url_ += "includeUnpublished=" + encodeURIComponent("" + includeUnpublished) + "&";
        if (onlyUnpublished === null)
            throw new Error("The parameter 'onlyUnpublished' cannot be null.");
        else if (onlyUnpublished !== undefined)
            url_ += "onlyUnpublished=" + encodeURIComponent("" + onlyUnpublished) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (getFlagged === null)
            throw new Error("The parameter 'getFlagged' cannot be null.");
        else if (getFlagged !== undefined)
            url_ += "getFlagged=" + encodeURIComponent("" + getFlagged) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed26(_response);
        });
    }

    protected processDetailed26(response: AxiosResponse): Promise<ItemDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoPaginationDto>(null as any);
    }

    /**
     * Gets all flagged content
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @param includeInactive (optional) Whether or not you want to Include Inactive items, useful for Admins/Moderators
     * @param includeUnpublished (optional) Whether or not you want to Include unpublished items
     * @param searchQuery (optional) How should the results be filtered.
     * @param orderBy (optional) How the response should be ordered
     * @return Returns if the User is Authorized appropriately
     */
    flagged(pageSize?: number | undefined, page?: number | undefined, includeInactive?: boolean | undefined, includeUnpublished?: boolean | undefined, searchQuery?: string | undefined, orderBy?: ItemOrderBy | undefined, cancelToken?: CancelToken): Promise<FlaggedItemDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Item/flagged?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (includeUnpublished === null)
            throw new Error("The parameter 'includeUnpublished' cannot be null.");
        else if (includeUnpublished !== undefined)
            url_ += "includeUnpublished=" + encodeURIComponent("" + includeUnpublished) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlagged(_response);
        });
    }

    protected processFlagged(response: AxiosResponse): Promise<FlaggedItemDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FlaggedItemDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<FlaggedItemDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlaggedItemDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Suspended Items in the Detailed Format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Items
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Items are found and the User is Authorized appropriately
     */
    suspended(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ItemDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Item/suspended?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSuspended(_response);
        });
    }

    protected processSuspended(response: AxiosResponse): Promise<ItemDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoPaginationDto>(null as any);
    }

    /**
     * Get items within a given location page URL
     * @return Success
     */
    location(url: string, cancelToken?: CancelToken): Promise<LocationPageResultsDto> {
        let url_ = this.baseUrl + "/api/v1/Item/location/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocation(_response);
        });
    }

    protected processLocation(response: AxiosResponse): Promise<LocationPageResultsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageResultsDto.fromJS(resultData200);
            return Promise.resolve<LocationPageResultsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageResultsDto>(null as any);
    }

    /**
     * Gets items only with necessary information for the admin Panel
     * @param orderBy (optional) 
     * @param showUnpublished (optional) 
     * @param showInactive (optional) 
     * @param searchQuery (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @param userId (optional) Return only items belonging to this User
     * @return Success
     */
    adminSearch(orderBy?: ItemOrderBy | undefined, showUnpublished?: boolean | undefined, showInactive?: boolean | undefined, searchQuery?: string | undefined, pageSize?: number | undefined, page?: number | undefined, userId?: string | undefined, cancelToken?: CancelToken): Promise<ItemAdminSearchDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Item/adminSearch?";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (showUnpublished === null)
            throw new Error("The parameter 'showUnpublished' cannot be null.");
        else if (showUnpublished !== undefined)
            url_ += "showUnpublished=" + encodeURIComponent("" + showUnpublished) + "&";
        if (showInactive === null)
            throw new Error("The parameter 'showInactive' cannot be null.");
        else if (showInactive !== undefined)
            url_ += "showInactive=" + encodeURIComponent("" + showInactive) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdminSearch(_response);
        });
    }

    protected processAdminSearch(response: AxiosResponse): Promise<ItemAdminSearchDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemAdminSearchDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ItemAdminSearchDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemAdminSearchDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Item
     * @param userId (optional) to create an item for another user or for a user to create an item for a business account they moderate.
     * @param body (optional) The CreationDto of an Item
     * @return Returns if the Item is Created, also returns a DetailedDto of the newly created Item
     */
    createPOST12(userId?: string | undefined, body?: ItemCreateDto | undefined, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/create?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST12(_response);
        });
    }

    protected processCreatePOST12(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * Updates an existing Item
     * @param id The Id of the Item being Updated
     * @param body (optional) A Dictionairy of Changes to be made to the Item
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    update12(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<ItemDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate12(_response);
        });
    }

    protected processUpdate12(response: AxiosResponse): Promise<ItemDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoUpdateResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    publish(id: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}/publish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublish(_response);
        });
    }

    protected processPublish(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    addUser(itemId: string, userId?: string | undefined, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/add-user?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUser(_response);
        });
    }

    protected processAddUser(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * Add Files to an Item
     * @param itemId The Id of the Item the Categories are being added to
     * @param imageIds (optional) The List of fileIds being added to the Item
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addImages2(itemId: string, imageIds?: string[] | undefined, cancelToken?: CancelToken): Promise<ItemDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/add-images?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (imageIds === null)
            throw new Error("The parameter 'imageIds' cannot be null.");
        else if (imageIds !== undefined)
            imageIds && imageIds.forEach(item => { url_ += "imageIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddImages2(_response);
        });
    }

    protected processAddImages2(response: AxiosResponse): Promise<ItemDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoUpdateResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    changeFrontImage(itemId: string, imageId: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/change-front-image/{imageId}";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeFrontImage(_response);
        });
    }

    protected processChangeFrontImage(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * Remove Files from an Item
     * @param itemId The Id of the Item the Categories are being removed from
     * @param imageIds (optional) The List of FileIds being removed from the Item
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeImages(itemId: string, imageIds?: string[] | undefined, cancelToken?: CancelToken): Promise<ItemDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/remove-images?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (imageIds === null)
            throw new Error("The parameter 'imageIds' cannot be null.");
        else if (imageIds !== undefined)
            imageIds && imageIds.forEach(item => { url_ += "imageIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveImages(_response);
        });
    }

    protected processRemoveImages(response: AxiosResponse): Promise<ItemDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoUpdateResponseDto>(null as any);
    }

    /**
     * Add Videos to an Item
     * @param itemId The Id of the Item the Categories are being added to
     * @param videoIds (optional) The List of videoIds being added to the Item
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addVideos(itemId: string, videoIds?: string[] | undefined, cancelToken?: CancelToken): Promise<ItemDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/add-videos?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (videoIds === null)
            throw new Error("The parameter 'videoIds' cannot be null.");
        else if (videoIds !== undefined)
            videoIds && videoIds.forEach(item => { url_ += "videoIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddVideos(_response);
        });
    }

    protected processAddVideos(response: AxiosResponse): Promise<ItemDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoUpdateResponseDto>(null as any);
    }

    /**
     * Remove Videos from an Item
     * @param itemId The Id of the Item the Categories are being removed from
     * @param videoIds (optional) The List of FileIds being removed from the Item
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeVideos(itemId: string, videoIds?: string[] | undefined, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/remove-videos?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (videoIds === null)
            throw new Error("The parameter 'videoIds' cannot be null.");
        else if (videoIds !== undefined)
            videoIds && videoIds.forEach(item => { url_ += "videoIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveVideos(_response);
        });
    }

    protected processRemoveVideos(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * Add Categories to an Item
     * @param itemId The Id of the Item the Categories are being added to
     * @param categoryIds (optional) The List of CategoryIds being added to the Item
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addCategories(itemId: string, categoryIds?: string[] | undefined, cancelToken?: CancelToken): Promise<ItemDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/add-categories?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (categoryIds === null)
            throw new Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCategories(_response);
        });
    }

    protected processAddCategories(response: AxiosResponse): Promise<ItemDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoUpdateResponseDto>(null as any);
    }

    /**
     * Remove Categories from an Item
     * @param itemId The Id of the Item the Categories are being removed from
     * @param categoryIds (optional) The List of CategoryIds being removed from the Item
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeCategories(itemId: string, categoryIds?: string[] | undefined, cancelToken?: CancelToken): Promise<ItemDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/remove-categories?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (categoryIds === null)
            throw new Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCategories(_response);
        });
    }

    protected processRemoveCategories(response: AxiosResponse): Promise<ItemDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoUpdateResponseDto>(null as any);
    }

    /**
     * Add Collections to an Item
     * @param itemId The Id of the Item the Categories are being added to
     * @param collectionIds (optional) The List of CollectionIds being added to the Item
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addCollections(itemId: string, collectionIds?: string[] | undefined, cancelToken?: CancelToken): Promise<ItemDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/add-collections?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (collectionIds === null)
            throw new Error("The parameter 'collectionIds' cannot be null.");
        else if (collectionIds !== undefined)
            collectionIds && collectionIds.forEach(item => { url_ += "collectionIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCollections(_response);
        });
    }

    protected processAddCollections(response: AxiosResponse): Promise<ItemDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoUpdateResponseDto>(null as any);
    }

    /**
     * Remove Categories from an Item
     * @param itemId The Id of the Item the Categories are being removed from
     * @param collectionIds (optional) The List of CategoryIds being removed from the Item
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeCollections(itemId: string, collectionIds?: string[] | undefined, cancelToken?: CancelToken): Promise<ItemDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/remove-collections?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (collectionIds === null)
            throw new Error("The parameter 'collectionIds' cannot be null.");
        else if (collectionIds !== undefined)
            collectionIds && collectionIds.forEach(item => { url_ += "collectionIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCollections(_response);
        });
    }

    protected processRemoveCollections(response: AxiosResponse): Promise<ItemDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeAspects(id: string, body?: { [key: string]: string[]; } | undefined, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}/change-aspects";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeAspects(_response);
        });
    }

    protected processChangeAspects(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * Add Locations to an Item
     * @param itemId The Id of the Item the Locations are being added to
     * @param body (optional) A List of Location Objects to be added
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addLocations(itemId: string, body?: Location[] | undefined, cancelToken?: CancelToken): Promise<ItemDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/add-locations";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddLocations(_response);
        });
    }

    protected processAddLocations(response: AxiosResponse): Promise<ItemDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoUpdateResponseDto>(null as any);
    }

    /**
     * Remove Locations from an Item
     * @param itemId The Id of the Item the Locations are being removed from
     * @param body (optional) A List of Location Objects to be removed
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeLocations(itemId: string, body?: Location[] | undefined, cancelToken?: CancelToken): Promise<ItemDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/remove-locations";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveLocations(_response);
        });
    }

    protected processRemoveLocations(response: AxiosResponse): Promise<ItemDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoUpdateResponseDto>(null as any);
    }

    /**
     * Add Offers to an Item
     * @param itemId The Id of the Item having Offers added to it
     * @param offerIds (optional) The List of Offers being added to the Item
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addOffers(itemId: string, offerIds?: string[] | undefined, cancelToken?: CancelToken): Promise<ItemDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/add-offers?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (offerIds === null)
            throw new Error("The parameter 'offerIds' cannot be null.");
        else if (offerIds !== undefined)
            offerIds && offerIds.forEach(item => { url_ += "offerIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOffers(_response);
        });
    }

    protected processAddOffers(response: AxiosResponse): Promise<ItemDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoUpdateResponseDto>(null as any);
    }

    /**
     * Remove Offers from an Item
     * @param itemId The Id of the Item having Offers removed from it
     * @param offerIds (optional) The List of Offers being removed from the Item
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeOffers(itemId: string, offerIds?: string[] | undefined, cancelToken?: CancelToken): Promise<ItemDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/remove-offers?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (offerIds === null)
            throw new Error("The parameter 'offerIds' cannot be null.");
        else if (offerIds !== undefined)
            offerIds && offerIds.forEach(item => { url_ += "offerIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveOffers(_response);
        });
    }

    protected processRemoveOffers(response: AxiosResponse): Promise<ItemDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ItemDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDtoUpdateResponseDto>(null as any);
    }

    /**
     * Adds a Link between 2 Items, allowing them to be related to eachother easily
     * @param item1Id The 1st Item being linked
     * @param item2Id The 2nd Item being linked
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addLink(item1Id: string, item2Id: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{item1Id}/add-link/{item2Id}";
        if (item1Id === undefined || item1Id === null)
            throw new Error("The parameter 'item1Id' must be defined.");
        url_ = url_.replace("{item1Id}", encodeURIComponent("" + item1Id));
        if (item2Id === undefined || item2Id === null)
            throw new Error("The parameter 'item2Id' must be defined.");
        url_ = url_.replace("{item2Id}", encodeURIComponent("" + item2Id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddLink(_response);
        });
    }

    protected processAddLink(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * Removes a Link between 2 Items
     * @param item1Id The 1st Item being unlinked
     * @param item2Id The 2nd Item being unlinked
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeLink(item1Id: string, item2Id: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{item1Id}/remove-link/{item2Id}";
        if (item1Id === undefined || item1Id === null)
            throw new Error("The parameter 'item1Id' must be defined.");
        url_ = url_.replace("{item1Id}", encodeURIComponent("" + item1Id));
        if (item2Id === undefined || item2Id === null)
            throw new Error("The parameter 'item2Id' must be defined.");
        url_ = url_.replace("{item2Id}", encodeURIComponent("" + item2Id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveLink(_response);
        });
    }

    protected processRemoveLink(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * Allows the uploading of a Different Pricing Model
     * @param itemId The Id of the Item having its pricing Updated
     * @param body (optional) A List of updated Price Periods
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    pricing(itemId: string, body?: PricePeriod[] | undefined, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/pricing";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPricing(_response);
        });
    }

    protected processPricing(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * Updates the Preprocessed DayPrices of an Item
     * @param itemId The Id of the Item having its pricing updated
     * @return Returns if the Item is Updated successfully, also returns a Detailed Dto of the newly updated object
     * @deprecated
     */
    update13(itemId: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/pricing/update";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate13(_response);
        });
    }

    protected processUpdate13(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Item cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * @return Success
     */
    removeOverrides(id: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}/pricing/remove-overrides";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveOverrides(_response);
        });
    }

    protected processRemoveOverrides(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * @return Success
     */
    flagItem(id: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}/flagItem";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlagItem(_response);
        });
    }

    protected processFlagItem(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * @return Success
     */
    resolveFlaggedItem(id: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}/resolveFlaggedItem";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveFlaggedItem(_response);
        });
    }

    protected processResolveFlaggedItem(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * @return Success
     */
    addInsurance2(itemId: string, insurancePlanId: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/add-insurance/{insurancePlanId}";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (insurancePlanId === undefined || insurancePlanId === null)
            throw new Error("The parameter 'insurancePlanId' must be defined.");
        url_ = url_.replace("{insurancePlanId}", encodeURIComponent("" + insurancePlanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddInsurance2(_response);
        });
    }

    protected processAddInsurance2(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * @return Success
     */
    removeInsuranceDELETE(itemId: string, insurancePlanId: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/remove-insurance/{insurancePlanId}";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (insurancePlanId === undefined || insurancePlanId === null)
            throw new Error("The parameter 'insurancePlanId' must be defined.");
        url_ = url_.replace("{insurancePlanId}", encodeURIComponent("" + insurancePlanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveInsuranceDELETE(_response);
        });
    }

    protected processRemoveInsuranceDELETE(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * @return Success
     */
    changeRequireInsurance(itemId: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/change-require-insurance";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeRequireInsurance(_response);
        });
    }

    protected processChangeRequireInsurance(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * @return Success
     */
    applyOptionalInsurances( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Item/apply-optional-insurances";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplyOptionalInsurances(_response);
        });
    }

    protected processApplyOptionalInsurances(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    removeInvalidInsurances( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Item/remove-invalid-insurances";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveInvalidInsurances(_response);
        });
    }

    protected processRemoveInvalidInsurances(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create a Review for an Item
     * @param itemId The Id of the Item being Reviewed
     * @param body (optional) The CreateDto of the Review
     * @return Returns if the Review is Created, also returns a DetailedDto of the newly created Review
     */
    createPOST13(itemId: string, body?: ReviewCreateDto | undefined, cancelToken?: CancelToken): Promise<ReviewDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/review/create";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST13(_response);
        });
    }

    protected processCreatePOST13(response: AxiosResponse): Promise<ReviewDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReviewDetailedDto.fromJS(resultData200);
            return Promise.resolve<ReviewDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReviewDetailedDto>(null as any);
    }

    /**
     * Gets all Reviews for an Item in the SimpleDto Format
     * @param itemId The Id of the Item
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Returns if the Reviews are found and the User is Authorized appropriately
     */
    review(itemId: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ReviewSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/review?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReview(_response);
        });
    }

    protected processReview(response: AxiosResponse): Promise<ReviewSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReviewSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ReviewSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReviewSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Reviews for an Item in the DetailedDto Format
     * @param itemId The Id of the Item
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Returns if the Reviews are found and the User is Authorized appropriately
     */
    detailed27(itemId: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ReviewDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/review/detailed?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed27(_response);
        });
    }

    protected processDetailed27(response: AxiosResponse): Promise<ReviewDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReviewDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ReviewDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReviewDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Gets a Review in the SimpleDto format
     * @param id The id of the Review
     * @return Returns if the Review is found and the User is Authorized appropriately
     */
    review2(id: string, cancelToken?: CancelToken): Promise<ReviewSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Item/review/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReview2(_response);
        });
    }

    protected processReview2(response: AxiosResponse): Promise<ReviewSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReviewSimpleDto.fromJS(resultData200);
            return Promise.resolve<ReviewSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Review cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReviewSimpleDto>(null as any);
    }

    /**
     * Gets a Review in the DetailedDto format
     * @param id The Id of the Review
     * @return Returns if the Review is found and the User is Authorized appropriately
     */
    detailed28(id: string, cancelToken?: CancelToken): Promise<ReviewDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Item/review/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed28(_response);
        });
    }

    protected processDetailed28(response: AxiosResponse): Promise<ReviewDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReviewDetailedDto.fromJS(resultData200);
            return Promise.resolve<ReviewDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Review cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReviewDetailedDto>(null as any);
    }

    /**
     * Updates an existing Review
     * @param id The Id of the Review being updated
     * @param body (optional) A Dictionairy containing the information to update the Review with
     * @return Returns if the Review is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    edit(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<ReviewDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Item/review/{id}/edit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<ReviewDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReviewDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ReviewDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Review cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReviewDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Disables an existing Review
     * @return Returns if the Review is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    delete15(id: string, cancelToken?: CancelToken): Promise<ReviewDetailedDto> {
        let url_ = this.baseUrl + "/review/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete15(_response);
        });
    }

    protected processDelete15(response: AxiosResponse): Promise<ReviewDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReviewDetailedDto.fromJS(resultData200);
            return Promise.resolve<ReviewDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Review cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReviewDetailedDto>(null as any);
    }

    /**
     * Creates a new Availability of the Item, availabiliy being a peroid the Item is available for purchase on
     * @param itemId The Id of the Item being made Available
     * @param body (optional) 
     * @return Returns if the Availability is created successfully, also returns a Detailed Dto of the newly created object
     */
    createPOST14(itemId: string, body?: AvailabilityCreateDto | undefined, cancelToken?: CancelToken): Promise<AvailabilityDetailedDto> {
        let url_ = this.baseUrl + "/{itemId}/availability/create";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST14(_response);
        });
    }

    protected processCreatePOST14(response: AxiosResponse): Promise<AvailabilityDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AvailabilityDetailedDto.fromJS(resultData200);
            return Promise.resolve<AvailabilityDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityDetailedDto>(null as any);
    }

    /**
     * Gets all the Availabilities of an Item in the SimpleDto Format
     * @param itemId The Id of the Item
     * @param includeInactive (optional) Whether or not to include Inactive Availabilities
     * @return Returns if the Availabilities are found and the User is Authorized appropriately
     */
    availabilityAll(itemId: string, includeInactive?: boolean | undefined, cancelToken?: CancelToken): Promise<AvailabilitySimpleDto[]> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/availability?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAvailabilityAll(_response);
        });
    }

    protected processAvailabilityAll(response: AxiosResponse): Promise<AvailabilitySimpleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailabilitySimpleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AvailabilitySimpleDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilitySimpleDto[]>(null as any);
    }

    /**
     * Gets the Availabilities of an Item in the DetailedDto Format
     * @param includeInactive (optional) 
     * @return Returns if the Availabilities are found and the User is Authorized appropriately
     */
    detailedAll(itemId: string, includeInactive?: boolean | undefined, cancelToken?: CancelToken): Promise<AvailabilityDetailedDto[]> {
        let url_ = this.baseUrl + "/api/v1/Item/{itemId}/availability/detailed?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailedAll(_response);
        });
    }

    protected processDetailedAll(response: AxiosResponse): Promise<AvailabilityDetailedDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailabilityDetailedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AvailabilityDetailedDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityDetailedDto[]>(null as any);
    }

    /**
     * @return Success
     */
    availability(id: string, cancelToken?: CancelToken): Promise<AvailabilitySimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Item/availability/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAvailability(_response);
        });
    }

    protected processAvailability(response: AxiosResponse): Promise<AvailabilitySimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AvailabilitySimpleDto.fromJS(resultData200);
            return Promise.resolve<AvailabilitySimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilitySimpleDto>(null as any);
    }

    /**
     * @return Success
     */
    detailed29(id: string, cancelToken?: CancelToken): Promise<AvailabilityDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Item/availability/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed29(_response);
        });
    }

    protected processDetailed29(response: AxiosResponse): Promise<AvailabilityDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AvailabilityDetailedDto.fromJS(resultData200);
            return Promise.resolve<AvailabilityDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    delete16(id: string, cancelToken?: CancelToken): Promise<AvailabilityDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Item/availability/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete16(_response);
        });
    }

    protected processDelete16(response: AxiosResponse): Promise<AvailabilityDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AvailabilityDetailedDto.fromJS(resultData200);
            return Promise.resolve<AvailabilityDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    geocodeMissing( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Item/geocode-missing";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeocodeMissing(_response);
        });
    }

    protected processGeocodeMissing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param searchQuery (optional) 
     * @return Success
     */
    asCSV2(searchQuery?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Item/asCSV?";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAsCSV2(_response);
        });
    }

    protected processAsCSV2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Disables an existing Item
     * @return Success
     */
    delete17(id: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete17(_response);
        });
    }

    protected processDelete17(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate12(id: string, cancelToken?: CancelToken): Promise<ItemDto> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate12(_response);
        });
    }

    protected processReactivate12(response: AxiosResponse): Promise<ItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemDto.fromJS(resultData200);
            return Promise.resolve<ItemDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto>(null as any);
    }

    /**
     * Update and create items from Tradedoubler profile feed
     * @param max (optional) Maximum number of updates/creates
     * @return Success
     */
    importTradedoubler(tradedoublerProfileId: string, max?: number | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Item/importTradedoubler/{tradedoublerProfileId}?";
        if (tradedoublerProfileId === undefined || tradedoublerProfileId === null)
            throw new Error("The parameter 'tradedoublerProfileId' must be defined.");
        url_ = url_.replace("{tradedoublerProfileId}", encodeURIComponent("" + tradedoublerProfileId));
        if (max === null)
            throw new Error("The parameter 'max' cannot be null.");
        else if (max !== undefined)
            url_ += "max=" + encodeURIComponent("" + max) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportTradedoubler(_response);
        });
    }

    protected processImportTradedoubler(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets all Changes made to a Item
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes10(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Item/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges10(_response);
        });
    }

    protected processChanges10(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    dailyPriceRange(startDate?: Date | undefined, endDate?: Date | undefined, cancelToken?: CancelToken): Promise<ListingsAnalyticsDto> {
        let url_ = this.baseUrl + "/api/v1/Item/daily-price-range?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyPriceRange(_response);
        });
    }

    protected processDailyPriceRange(response: AxiosResponse): Promise<ListingsAnalyticsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingsAnalyticsDto.fromJS(resultData200);
            return Promise.resolve<ListingsAnalyticsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingsAnalyticsDto>(null as any);
    }

    /**
     * @return Success
     */
    updateUrls( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Item/update-urls";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUrls(_response);
        });
    }

    protected processUpdateUrls(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    addGeoPoints( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Item/add-geo-points";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddGeoPoints(_response);
        });
    }

    protected processAddGeoPoints(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ItemPageClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param numberOfReviews (optional) 
     * @return Success
     */
    id(id: string, numberOfReviews?: number | undefined, cancelToken?: CancelToken): Promise<ItemViewDto> {
        let url_ = this.baseUrl + "/api/v1/ItemPage/id/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (numberOfReviews === null)
            throw new Error("The parameter 'numberOfReviews' cannot be null.");
        else if (numberOfReviews !== undefined)
            url_ += "numberOfReviews=" + encodeURIComponent("" + numberOfReviews) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processId(_response);
        });
    }

    protected processId(response: AxiosResponse): Promise<ItemViewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemViewDto.fromJS(resultData200);
            return Promise.resolve<ItemViewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemViewDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    itemUrl(body?: string | undefined, cancelToken?: CancelToken): Promise<ItemViewDto> {
        let url_ = this.baseUrl + "/api/v1/ItemPage/item-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processItemUrl(_response);
        });
    }

    protected processItemUrl(response: AxiosResponse): Promise<ItemViewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemViewDto.fromJS(resultData200);
            return Promise.resolve<ItemViewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemViewDto>(null as any);
    }
}

export class LocationPageClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    locationPage(id: string, cancelToken?: CancelToken): Promise<LocationPageSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocationPage(_response);
        });
    }

    protected processLocationPage(response: AxiosResponse): Promise<LocationPageSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageSimpleDto.fromJS(resultData200);
            return Promise.resolve<LocationPageSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageSimpleDto>(null as any);
    }

    /**
     * @return Success
     */
    detailed30(id: string, cancelToken?: CancelToken): Promise<LocationPageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed30(_response);
        });
    }

    protected processDetailed30(response: AxiosResponse): Promise<LocationPageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageDetailedDto.fromJS(resultData200);
            return Promise.resolve<LocationPageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageDetailedDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    locationPage2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<LocationPageSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocationPage2(_response);
        });
    }

    protected processLocationPage2(response: AxiosResponse): Promise<LocationPageSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<LocationPageSimpleDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    detailed31(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<LocationPageDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed31(_response);
        });
    }

    protected processDetailed31(response: AxiosResponse): Promise<LocationPageDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<LocationPageDetailedDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageDetailedDtoPaginationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST15(body?: LocationPageCreateDto | undefined, cancelToken?: CancelToken): Promise<LocationPageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST15(_response);
        });
    }

    protected processCreatePOST15(response: AxiosResponse): Promise<LocationPageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageDetailedDto.fromJS(resultData200);
            return Promise.resolve<LocationPageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageDetailedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update14(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<LocationPageDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate14(_response);
        });
    }

    protected processUpdate14(response: AxiosResponse): Promise<LocationPageDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<LocationPageDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param imageId (optional) 
     * @return Success
     */
    changeImage2(locationPageId: string, imageId?: string | undefined, cancelToken?: CancelToken): Promise<LocationPageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/{locationPageId}/change-image?";
        if (locationPageId === undefined || locationPageId === null)
            throw new Error("The parameter 'locationPageId' must be defined.");
        url_ = url_.replace("{locationPageId}", encodeURIComponent("" + locationPageId));
        if (imageId === null)
            throw new Error("The parameter 'imageId' cannot be null.");
        else if (imageId !== undefined)
            url_ += "imageId=" + encodeURIComponent("" + imageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeImage2(_response);
        });
    }

    protected processChangeImage2(response: AxiosResponse): Promise<LocationPageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageDetailedDto.fromJS(resultData200);
            return Promise.resolve<LocationPageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageDetailedDto>(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @return Success
     */
    changeCategory(locationPageId: string, categoryId?: string | undefined, cancelToken?: CancelToken): Promise<LocationPageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/{locationPageId}/change-category?";
        if (locationPageId === undefined || locationPageId === null)
            throw new Error("The parameter 'locationPageId' must be defined.");
        url_ = url_.replace("{locationPageId}", encodeURIComponent("" + locationPageId));
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeCategory(_response);
        });
    }

    protected processChangeCategory(response: AxiosResponse): Promise<LocationPageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageDetailedDto.fromJS(resultData200);
            return Promise.resolve<LocationPageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageDetailedDto>(null as any);
    }

    /**
     * @param categoryIds (optional) 
     * @return Success
     */
    addSimilarCategories(locationPageId: string, categoryIds?: string[] | undefined, cancelToken?: CancelToken): Promise<LocationPageDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/{locationPageId}/add-similar-categories?";
        if (locationPageId === undefined || locationPageId === null)
            throw new Error("The parameter 'locationPageId' must be defined.");
        url_ = url_.replace("{locationPageId}", encodeURIComponent("" + locationPageId));
        if (categoryIds === null)
            throw new Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSimilarCategories(_response);
        });
    }

    protected processAddSimilarCategories(response: AxiosResponse): Promise<LocationPageDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<LocationPageDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param categoryIds (optional) 
     * @return Success
     */
    removeSimilarCategories(locationPageId: string, categoryIds?: string[] | undefined, cancelToken?: CancelToken): Promise<LocationPageDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/{locationPageId}/remove-similar-categories?";
        if (locationPageId === undefined || locationPageId === null)
            throw new Error("The parameter 'locationPageId' must be defined.");
        url_ = url_.replace("{locationPageId}", encodeURIComponent("" + locationPageId));
        if (categoryIds === null)
            throw new Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveSimilarCategories(_response);
        });
    }

    protected processRemoveSimilarCategories(response: AxiosResponse): Promise<LocationPageDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<LocationPageDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param locationPageId (optional) 
     * @param body (optional) 
     * @return Success
     */
    changeLocationPOST(locationPageId?: string | undefined, body?: SeoLocation | undefined, cancelToken?: CancelToken): Promise<LocationPageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/change-location?";
        if (locationPageId === null)
            throw new Error("The parameter 'locationPageId' cannot be null.");
        else if (locationPageId !== undefined)
            url_ += "locationPageId=" + encodeURIComponent("" + locationPageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeLocationPOST(_response);
        });
    }

    protected processChangeLocationPOST(response: AxiosResponse): Promise<LocationPageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageDetailedDto.fromJS(resultData200);
            return Promise.resolve<LocationPageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageDetailedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeBreadcrumbs(locationPageId: string, body?: SeoBreadcrumb[] | undefined, cancelToken?: CancelToken): Promise<LocationPageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/{locationPageId}/change-breadcrumbs";
        if (locationPageId === undefined || locationPageId === null)
            throw new Error("The parameter 'locationPageId' must be defined.");
        url_ = url_.replace("{locationPageId}", encodeURIComponent("" + locationPageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeBreadcrumbs(_response);
        });
    }

    protected processChangeBreadcrumbs(response: AxiosResponse): Promise<LocationPageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageDetailedDto.fromJS(resultData200);
            return Promise.resolve<LocationPageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    delete18(id: string, cancelToken?: CancelToken): Promise<LocationPageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete18(_response);
        });
    }

    protected processDelete18(response: AxiosResponse): Promise<LocationPageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageDetailedDto.fromJS(resultData200);
            return Promise.resolve<LocationPageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate13(id: string, cancelToken?: CancelToken): Promise<LocationPageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate13(_response);
        });
    }

    protected processReactivate13(response: AxiosResponse): Promise<LocationPageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationPageDetailedDto.fromJS(resultData200);
            return Promise.resolve<LocationPageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationPageDetailedDto>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes11(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/LocationPage/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges11(_response);
        });
    }

    protected processChanges11(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class MessageClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Message
     * @param id The Id of the Message
     * @return Returns if the Message is found and the User is Authorized appropriately
     */
    message(id: string, cancelToken?: CancelToken): Promise<MessageSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Message/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMessage(_response);
        });
    }

    protected processMessage(response: AxiosResponse): Promise<MessageSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageSimpleDto.fromJS(resultData200);
            return Promise.resolve<MessageSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Business Account cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Message
     * @param id The Id of the Message
     * @return Returns if the Message is found and the User is Authorized appropriately
     */
    detailed32(id: string, cancelToken?: CancelToken): Promise<MessageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Message/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed32(_response);
        });
    }

    protected processDetailed32(response: AxiosResponse): Promise<MessageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageDetailedDto.fromJS(resultData200);
            return Promise.resolve<MessageDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Business Account cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageDetailedDto>(null as any);
    }

    /**
     * Gets all Messages in the Simple format
     * @param userId1 (optional) The UserId of the 1st Member of the Conversation
     * @param userId2 (optional) The UserId of the 2nd Member of the Conversation
     * @param subject (optional) The Subject of the Conversation, can be an Item
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @param includeInactive (optional) Whether or not you want to Include Inactive Messages, useful for Admins/Moderators
     * @param allSubjects (optional) Whether or not you want to grab from all Subjects
     * @param onlyGetFlagged (optional) 
     * @return Returns if the Message is found and the User is Authorized appropriately
     */
    message2(userId1?: string | undefined, userId2?: string | undefined, subject?: string | undefined, pageSize?: number | undefined, page?: number | undefined, includeInactive?: boolean | undefined, allSubjects?: boolean | undefined, onlyGetFlagged?: boolean | undefined, cancelToken?: CancelToken): Promise<MessageSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Message?";
        if (userId1 === null)
            throw new Error("The parameter 'userId1' cannot be null.");
        else if (userId1 !== undefined)
            url_ += "userId1=" + encodeURIComponent("" + userId1) + "&";
        if (userId2 === null)
            throw new Error("The parameter 'userId2' cannot be null.");
        else if (userId2 !== undefined)
            url_ += "userId2=" + encodeURIComponent("" + userId2) + "&";
        if (subject === null)
            throw new Error("The parameter 'subject' cannot be null.");
        else if (subject !== undefined)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (allSubjects === null)
            throw new Error("The parameter 'allSubjects' cannot be null.");
        else if (allSubjects !== undefined)
            url_ += "allSubjects=" + encodeURIComponent("" + allSubjects) + "&";
        if (onlyGetFlagged === null)
            throw new Error("The parameter 'onlyGetFlagged' cannot be null.");
        else if (onlyGetFlagged !== undefined)
            url_ += "onlyGetFlagged=" + encodeURIComponent("" + onlyGetFlagged) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMessage2(_response);
        });
    }

    protected processMessage2(response: AxiosResponse): Promise<MessageSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<MessageSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Messages in the Detailed format
     * @param userId1 (optional) The UserId of the 1st Member of the Conversation
     * @param userId2 (optional) The UserId of the 2nd Member of the Conversation
     * @param subject (optional) The Subject of the Conversation, can be an Item
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @param includeInactive (optional) Whether or not you want to Include Inactive Messages, useful for Admins/Moderators
     * @param allSubjects (optional) Whether or not you want to grab from all Subjects
     * @param onlyGetFlagged (optional) 
     * @return Returns if the Message is found and the User is Authorized appropriately
     */
    detailed33(userId1?: string | undefined, userId2?: string | undefined, subject?: string | undefined, pageSize?: number | undefined, page?: number | undefined, includeInactive?: boolean | undefined, allSubjects?: boolean | undefined, onlyGetFlagged?: boolean | undefined, cancelToken?: CancelToken): Promise<MessageDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Message/detailed?";
        if (userId1 === null)
            throw new Error("The parameter 'userId1' cannot be null.");
        else if (userId1 !== undefined)
            url_ += "userId1=" + encodeURIComponent("" + userId1) + "&";
        if (userId2 === null)
            throw new Error("The parameter 'userId2' cannot be null.");
        else if (userId2 !== undefined)
            url_ += "userId2=" + encodeURIComponent("" + userId2) + "&";
        if (subject === null)
            throw new Error("The parameter 'subject' cannot be null.");
        else if (subject !== undefined)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (allSubjects === null)
            throw new Error("The parameter 'allSubjects' cannot be null.");
        else if (allSubjects !== undefined)
            url_ += "allSubjects=" + encodeURIComponent("" + allSubjects) + "&";
        if (onlyGetFlagged === null)
            throw new Error("The parameter 'onlyGetFlagged' cannot be null.");
        else if (onlyGetFlagged !== undefined)
            url_ += "onlyGetFlagged=" + encodeURIComponent("" + onlyGetFlagged) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed33(_response);
        });
    }

    protected processDetailed33(response: AxiosResponse): Promise<MessageDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<MessageDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Gets all flagged content
     * @param userId1 (optional) The UserId of the 1st Member of the Conversation
     * @param userId2 (optional) The UserId of the 2nd Member of the Conversation
     * @param subject (optional) The Subject of the Conversation, can be an Item
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @param includeInactive (optional) Whether or not you want to Include Inactive Messages, useful for Admins/Moderators
     * @param allSubjects (optional) Whether or not you want to grab from all Subjects
     * @param searchQuery (optional) How should the results be filtered.
     * @param orderBy (optional) How the response should be ordered
     * @return Returns if the User is Authorized appropriately
     */
    flagged2(userId1?: string | undefined, userId2?: string | undefined, subject?: string | undefined, pageSize?: number | undefined, page?: number | undefined, includeInactive?: boolean | undefined, allSubjects?: boolean | undefined, searchQuery?: string | undefined, orderBy?: FlaggedMessageOrderBy | undefined, cancelToken?: CancelToken): Promise<FlaggedMessageDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Message/flagged?";
        if (userId1 === null)
            throw new Error("The parameter 'userId1' cannot be null.");
        else if (userId1 !== undefined)
            url_ += "userId1=" + encodeURIComponent("" + userId1) + "&";
        if (userId2 === null)
            throw new Error("The parameter 'userId2' cannot be null.");
        else if (userId2 !== undefined)
            url_ += "userId2=" + encodeURIComponent("" + userId2) + "&";
        if (subject === null)
            throw new Error("The parameter 'subject' cannot be null.");
        else if (subject !== undefined)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (allSubjects === null)
            throw new Error("The parameter 'allSubjects' cannot be null.");
        else if (allSubjects !== undefined)
            url_ += "allSubjects=" + encodeURIComponent("" + allSubjects) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlagged2(_response);
        });
    }

    protected processFlagged2(response: AxiosResponse): Promise<FlaggedMessageDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FlaggedMessageDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<FlaggedMessageDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlaggedMessageDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Message
     * @param body (optional) 
     * @return Success
     */
    createPOST16(body?: MessageCreateDto | undefined, cancelToken?: CancelToken): Promise<MessageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Message/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST16(_response);
        });
    }

    protected processCreatePOST16(response: AxiosResponse): Promise<MessageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageDetailedDto.fromJS(resultData200);
            return Promise.resolve<MessageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageDetailedDto>(null as any);
    }

    /**
     * Disables an existing Message
     * @return Success
     */
    delete19(id: string, cancelToken?: CancelToken): Promise<MessageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Message/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete19(_response);
        });
    }

    protected processDelete19(response: AxiosResponse): Promise<MessageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageDetailedDto.fromJS(resultData200);
            return Promise.resolve<MessageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Message
     * @return Success
     */
    changes12(id: string, cancelToken?: CancelToken): Promise<Change[]> {
        let url_ = this.baseUrl + "/api/v1/Message/{id}/changes";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges12(_response);
        });
    }

    protected processChanges12(response: AxiosResponse): Promise<Change[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Change.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Change[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Change[]>(null as any);
    }

    /**
     * Updates an existing Message
     * @param id The Id of the Message being Updated
     * @param body (optional) A Dictionairy of Changes to be made to the Message
     * @return Returns if the Messages is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    update15(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<MessageDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Message/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate15(_response);
        });
    }

    protected processUpdate15(response: AxiosResponse): Promise<MessageDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<MessageDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Business Account cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Gets all Messages sent from a specific user
     * @param id The Id of the User whose sending the messages
     * @param includeInactive (optional) Whether or not you want to Include Inactive Messages, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Success
     */
    allSent(id: string, includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<MessageDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Message/all-sent/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllSent(_response);
        });
    }

    protected processAllSent(response: AxiosResponse): Promise<MessageDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<MessageDetailedDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Messages received by a specific user
     * @param id The Id of the User whose recieving the messages
     * @param includeInactive (optional) Whether or not you want to Include Inactive Messages, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Success
     */
    allReceived(id: string, includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<MessageDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Message/all-received/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAllReceived(_response);
        });
    }

    protected processAllReceived(response: AxiosResponse): Promise<MessageDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<MessageDetailedDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageDetailedDtoPaginationDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    conversations(userId?: string | undefined, cancelToken?: CancelToken): Promise<ConversationDto[]> {
        let url_ = this.baseUrl + "/api/v1/Message/conversations?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConversations(_response);
        });
    }

    protected processConversations(response: AxiosResponse): Promise<ConversationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConversationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ConversationDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversationDto[]>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param page (optional) 
     * @param searchQuery (optional) 
     * @param orderBy (optional) 
     * @param includeInactive (optional) 
     * @param userId (optional) 
     * @return Success
     */
    staff(pageSize?: number | undefined, page?: number | undefined, searchQuery?: string | undefined, orderBy?: ConversationOrderBy | undefined, includeInactive?: boolean | undefined, userId?: string | undefined, cancelToken?: CancelToken): Promise<ConversationDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Message/conversations/staff?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaff(_response);
        });
    }

    protected processStaff(response: AxiosResponse): Promise<ConversationDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConversationDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ConversationDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversationDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    read(id: string, cancelToken?: CancelToken): Promise<MessageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Message/{id}/read";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRead(_response);
        });
    }

    protected processRead(response: AxiosResponse): Promise<MessageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageDetailedDto.fromJS(resultData200);
            return Promise.resolve<MessageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    flagMessage(id: string, cancelToken?: CancelToken): Promise<MessageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Message/{id}/flagMessage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlagMessage(_response);
        });
    }

    protected processFlagMessage(response: AxiosResponse): Promise<MessageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageDetailedDto.fromJS(resultData200);
            return Promise.resolve<MessageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    resolveFlaggedMessage(id: string, cancelToken?: CancelToken): Promise<MessageDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Message/{id}/resolveFlaggedMessage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveFlaggedMessage(_response);
        });
    }

    protected processResolveFlaggedMessage(response: AxiosResponse): Promise<MessageDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageDetailedDto.fromJS(resultData200);
            return Promise.resolve<MessageDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    adjustOldNames( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Message/adjust-old-names";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdjustOldNames(_response);
        });
    }

    protected processAdjustOldNames(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MicroshopClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Microshop
     * @param id The Microshops Id
     * @return Returns if the Microshop is found and the User is Authorized appropriately
     */
    microshop(id: string, cancelToken?: CancelToken): Promise<MicroshopSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Microshop/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMicroshop(_response);
        });
    }

    protected processMicroshop(response: AxiosResponse): Promise<MicroshopSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicroshopSimpleDto.fromJS(resultData200);
            return Promise.resolve<MicroshopSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Microshop cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicroshopSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Microshop
     * @param id The Microshops Id
     * @return Returns if the Microshop is found and the User is Authorized appropriately
     */
    detailed34(id: string, cancelToken?: CancelToken): Promise<MicroshopDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Microshop/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed34(_response);
        });
    }

    protected processDetailed34(response: AxiosResponse): Promise<MicroshopDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicroshopDetailedDto.fromJS(resultData200);
            return Promise.resolve<MicroshopDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Microshop cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicroshopDetailedDto>(null as any);
    }

    /**
     * Gets all Microshops in the Simple format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Accounts, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Microshops are found and the User is Authorized appropriately
     */
    microshop2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<MicroshopSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Microshop?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMicroshop2(_response);
        });
    }

    protected processMicroshop2(response: AxiosResponse): Promise<MicroshopSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicroshopSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<MicroshopSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Microshop cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicroshopSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Microshops in the Detailed format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Accounts, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Microshops are found and the User is Authorized appropriately
     */
    detailed35(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<MicroshopDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Microshop/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed35(_response);
        });
    }

    protected processDetailed35(response: AxiosResponse): Promise<MicroshopDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicroshopDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<MicroshopDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Microshop cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicroshopDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Microshop
     * @param body (optional) 
     * @return Returns if the Microshop is created, also returns a DetailedDto of the newly Created Microshop
     */
    createPOST17(body?: MicroshopCreateDto | undefined, cancelToken?: CancelToken): Promise<MicroshopDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Microshop/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST17(_response);
        });
    }

    protected processCreatePOST17(response: AxiosResponse): Promise<MicroshopDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicroshopDetailedDto.fromJS(resultData200);
            return Promise.resolve<MicroshopDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicroshopDetailedDto>(null as any);
    }

    /**
     * Updates an existing Microshop
     * @param body (optional) 
     * @return Returns if the Microshop is created, also returns a DetailedDto of the updated Created Microshop
     */
    update16(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<MicroshopDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Microshop/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate16(_response);
        });
    }

    protected processUpdate16(response: AxiosResponse): Promise<MicroshopDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicroshopDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<MicroshopDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Microshop cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicroshopDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Adds an Item to a Microshop
     * @param microshopId The Microshop having Items added to
     * @param itemIds (optional) The Ids of the items being added to the Microshop
     * @return Returns if the Microshop is created, also returns a DetailedDto of the newly updated Microshop
     */
    addItems2(microshopId: string, itemIds?: string[] | undefined, cancelToken?: CancelToken): Promise<MicroshopDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Microshop/{microshopId}/add-items?";
        if (microshopId === undefined || microshopId === null)
            throw new Error("The parameter 'microshopId' must be defined.");
        url_ = url_.replace("{microshopId}", encodeURIComponent("" + microshopId));
        if (itemIds === null)
            throw new Error("The parameter 'itemIds' cannot be null.");
        else if (itemIds !== undefined)
            itemIds && itemIds.forEach(item => { url_ += "itemIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddItems2(_response);
        });
    }

    protected processAddItems2(response: AxiosResponse): Promise<MicroshopDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicroshopDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<MicroshopDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Microshop cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicroshopDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Removes an Item from a Microshop
     * @param microshopId The Microshop having Items added to
     * @param itemIds (optional) The Ids of the items being removed to the Microshop
     * @return Returns if the Microshop is created, also returns a DetailedDto of the newly updated Microshop
     */
    removeItems2(microshopId: string, itemIds?: string[] | undefined, cancelToken?: CancelToken): Promise<MicroshopDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Microshop/{microshopId}/remove-items?";
        if (microshopId === undefined || microshopId === null)
            throw new Error("The parameter 'microshopId' must be defined.");
        url_ = url_.replace("{microshopId}", encodeURIComponent("" + microshopId));
        if (itemIds === null)
            throw new Error("The parameter 'itemIds' cannot be null.");
        else if (itemIds !== undefined)
            itemIds && itemIds.forEach(item => { url_ += "itemIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveItems2(_response);
        });
    }

    protected processRemoveItems2(response: AxiosResponse): Promise<MicroshopDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicroshopDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<MicroshopDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Microshop cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicroshopDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Disables an existing Microshop
     * @return Success
     */
    delete20(id: string, cancelToken?: CancelToken): Promise<MicroshopDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Microshop/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete20(_response);
        });
    }

    protected processDelete20(response: AxiosResponse): Promise<MicroshopDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicroshopDetailedDto.fromJS(resultData200);
            return Promise.resolve<MicroshopDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicroshopDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate14(id: string, cancelToken?: CancelToken): Promise<MicroshopDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Microshop/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate14(_response);
        });
    }

    protected processReactivate14(response: AxiosResponse): Promise<MicroshopDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MicroshopDetailedDto.fromJS(resultData200);
            return Promise.resolve<MicroshopDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MicroshopDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Microshop
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes13(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Microshop/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges13(_response);
        });
    }

    protected processChanges13(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class OfferClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Offer
     * @param id The Id of the Offer
     * @return Returns if the Offer is found and the User is Authorized appropriately
     */
    offer(id: string, cancelToken?: CancelToken): Promise<OfferSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Offer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOffer(_response);
        });
    }

    protected processOffer(response: AxiosResponse): Promise<OfferSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfferSimpleDto.fromJS(resultData200);
            return Promise.resolve<OfferSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Offer cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfferSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Offer
     * @param id The Id of the Offer
     * @return Returns if the Offer is found and the User is Authorized appropriately
     */
    detailed36(id: string, cancelToken?: CancelToken): Promise<OfferDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Offer/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed36(_response);
        });
    }

    protected processDetailed36(response: AxiosResponse): Promise<OfferDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfferDetailedDto.fromJS(resultData200);
            return Promise.resolve<OfferDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Offer cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfferDetailedDto>(null as any);
    }

    /**
     * Gets all Offers in the SimpleDto format
     * @param includeInactive (optional) Whether or not the Include Inactive Offers
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Offers are found and the User is Authorized appropriately
     */
    offer2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<OfferSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Offer?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOffer2(_response);
        });
    }

    protected processOffer2(response: AxiosResponse): Promise<OfferSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfferSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<OfferSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfferSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Offers in the DetailedDto format
     * @param includeInactive (optional) Whether or not the Include Inactive Offers
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Offers are found and the User is Authorized appropriately
     */
    detailed37(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<OfferDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Offer/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed37(_response);
        });
    }

    protected processDetailed37(response: AxiosResponse): Promise<OfferDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfferDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<OfferDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfferDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Offer
     * @param body (optional) 
     * @return Success
     */
    createPOST18(body?: OfferCreateDto | undefined, cancelToken?: CancelToken): Promise<OfferDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Offer/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST18(_response);
        });
    }

    protected processCreatePOST18(response: AxiosResponse): Promise<OfferDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfferDetailedDto.fromJS(resultData200);
            return Promise.resolve<OfferDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfferDetailedDto>(null as any);
    }

    /**
     * Updates an existing Offer
     * @param body (optional) 
     * @return Success
     */
    update17(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<OfferDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Offer/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate17(_response);
        });
    }

    protected processUpdate17(response: AxiosResponse): Promise<OfferDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfferDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<OfferDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfferDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Disables an existing Offer
     * @return Success
     */
    delete21(id: string, cancelToken?: CancelToken): Promise<OfferDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Offer/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete21(_response);
        });
    }

    protected processDelete21(response: AxiosResponse): Promise<OfferDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfferDetailedDto.fromJS(resultData200);
            return Promise.resolve<OfferDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfferDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate15(id: string, cancelToken?: CancelToken): Promise<OfferDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Offer/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate15(_response);
        });
    }

    protected processReactivate15(response: AxiosResponse): Promise<OfferDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OfferDetailedDto.fromJS(resultData200);
            return Promise.resolve<OfferDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OfferDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Offer
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes14(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Offer/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges14(_response);
        });
    }

    protected processChanges14(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class PdfWebhookClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param file (optional) 
     * @param transaction_ref (optional) 
     * @return Success
     */
    pdfs(file?: string | undefined, transaction_ref?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/webhooks/pdfs?";
        if (file === null)
            throw new Error("The parameter 'file' cannot be null.");
        else if (file !== undefined)
            url_ += "file=" + encodeURIComponent("" + file) + "&";
        if (transaction_ref === null)
            throw new Error("The parameter 'transaction_ref' cannot be null.");
        else if (transaction_ref !== undefined)
            url_ += "transaction_ref=" + encodeURIComponent("" + transaction_ref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPdfs(_response);
        });
    }

    protected processPdfs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class QuotallCategoryClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    quotallCategory(id: string, cancelToken?: CancelToken): Promise<QuotallCategoryDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuotallCategory(_response);
        });
    }

    protected processQuotallCategory(response: AxiosResponse): Promise<QuotallCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallCategoryDto.fromJS(resultData200);
            return Promise.resolve<QuotallCategoryDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallCategoryDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param selectedCategories (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @param orderBy (optional) 
     * @param searchQuery (optional) 
     * @return Success
     */
    quotallCategory2(includeInactive?: boolean | undefined, selectedCategories?: string | undefined, pageSize?: number | undefined, page?: number | undefined, orderBy?: QuotallOrderBy | undefined, searchQuery?: string | undefined, cancelToken?: CancelToken): Promise<QuotallCategoryDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallCategory?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (selectedCategories === null)
            throw new Error("The parameter 'selectedCategories' cannot be null.");
        else if (selectedCategories !== undefined)
            url_ += "selectedCategories=" + encodeURIComponent("" + selectedCategories) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuotallCategory2(_response);
        });
    }

    protected processQuotallCategory2(response: AxiosResponse): Promise<QuotallCategoryDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallCategoryDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<QuotallCategoryDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallCategoryDtoPaginationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST19(body?: QuotallCategoryCreateDto | undefined, cancelToken?: CancelToken): Promise<QuotallCategoryDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallCategory/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST19(_response);
        });
    }

    protected processCreatePOST19(response: AxiosResponse): Promise<QuotallCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallCategoryDto.fromJS(resultData200);
            return Promise.resolve<QuotallCategoryDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallCategoryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update18(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<QuotallCategoryDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallCategory/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate18(_response);
        });
    }

    protected processUpdate18(response: AxiosResponse): Promise<QuotallCategoryDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallCategoryDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<QuotallCategoryDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallCategoryDtoUpdateResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    delete22(id: string, cancelToken?: CancelToken): Promise<QuotallCategoryDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallCategory/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete22(_response);
        });
    }

    protected processDelete22(response: AxiosResponse): Promise<QuotallCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallCategoryDto.fromJS(resultData200);
            return Promise.resolve<QuotallCategoryDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallCategoryDto>(null as any);
    }

    /**
     * @return Success
     */
    activate2(id: string, cancelToken?: CancelToken): Promise<QuotallCategoryDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallCategory/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate2(_response);
        });
    }

    protected processActivate2(response: AxiosResponse): Promise<QuotallCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallCategoryDto.fromJS(resultData200);
            return Promise.resolve<QuotallCategoryDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallCategoryDto>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes15(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/QuotallCategory/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges15(_response);
        });
    }

    protected processChanges15(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class QuotallClaimsClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    quotallClaims(id: string, cancelToken?: CancelToken): Promise<QuotallClaimDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallClaims/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuotallClaims(_response);
        });
    }

    protected processQuotallClaims(response: AxiosResponse): Promise<QuotallClaimDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallClaimDto.fromJS(resultData200);
            return Promise.resolve<QuotallClaimDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallClaimDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @param lossTypeCode (optional) 
     * @param outcomeTypecode (optional) 
     * @param outcomeView (optional) 
     * @param lossView (optional) 
     * @param orderBy (optional) 
     * @param searchQuery (optional) 
     * @param filterBelowThreshold (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    quotallClaims2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, lossTypeCode?: string | undefined, outcomeTypecode?: string | undefined, outcomeView?: OutcomeView | undefined, lossView?: LossView | undefined, orderBy?: ClaimsOrderBy | undefined, searchQuery?: string | undefined, filterBelowThreshold?: boolean | undefined, startDate?: Date | undefined, endDate?: Date | undefined, cancelToken?: CancelToken): Promise<QuotallClaimDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallClaims?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (lossTypeCode === null)
            throw new Error("The parameter 'lossTypeCode' cannot be null.");
        else if (lossTypeCode !== undefined)
            url_ += "lossTypeCode=" + encodeURIComponent("" + lossTypeCode) + "&";
        if (outcomeTypecode === null)
            throw new Error("The parameter 'outcomeTypecode' cannot be null.");
        else if (outcomeTypecode !== undefined)
            url_ += "outcomeTypecode=" + encodeURIComponent("" + outcomeTypecode) + "&";
        if (outcomeView === null)
            throw new Error("The parameter 'outcomeView' cannot be null.");
        else if (outcomeView !== undefined)
            url_ += "outcomeView=" + encodeURIComponent("" + outcomeView) + "&";
        if (lossView === null)
            throw new Error("The parameter 'lossView' cannot be null.");
        else if (lossView !== undefined)
            url_ += "lossView=" + encodeURIComponent("" + lossView) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (filterBelowThreshold === null)
            throw new Error("The parameter 'filterBelowThreshold' cannot be null.");
        else if (filterBelowThreshold !== undefined)
            url_ += "filterBelowThreshold=" + encodeURIComponent("" + filterBelowThreshold) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuotallClaims2(_response);
        });
    }

    protected processQuotallClaims2(response: AxiosResponse): Promise<QuotallClaimDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallClaimDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<QuotallClaimDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallClaimDtoPaginationDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @param lossTypeCode (optional) 
     * @param outcomeTypecode (optional) 
     * @return Success
     */
    myClaims(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, lossTypeCode?: string | undefined, outcomeTypecode?: string | undefined, cancelToken?: CancelToken): Promise<QuotallClaimDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallClaims/myClaims?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (lossTypeCode === null)
            throw new Error("The parameter 'lossTypeCode' cannot be null.");
        else if (lossTypeCode !== undefined)
            url_ += "lossTypeCode=" + encodeURIComponent("" + lossTypeCode) + "&";
        if (outcomeTypecode === null)
            throw new Error("The parameter 'outcomeTypecode' cannot be null.");
        else if (outcomeTypecode !== undefined)
            url_ += "outcomeTypecode=" + encodeURIComponent("" + outcomeTypecode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMyClaims(_response);
        });
    }

    protected processMyClaims(response: AxiosResponse): Promise<QuotallClaimDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallClaimDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<QuotallClaimDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallClaimDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    booking(bookingId: string, cancelToken?: CancelToken): Promise<QuotallClaimDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallClaims/booking/{bookingId}";
        if (bookingId === undefined || bookingId === null)
            throw new Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBooking(_response);
        });
    }

    protected processBooking(response: AxiosResponse): Promise<QuotallClaimDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallClaimDto.fromJS(resultData200);
            return Promise.resolve<QuotallClaimDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallClaimDto>(null as any);
    }

    /**
     * @return Success
     * @deprecated
     */
    losstypes(id: string, cancelToken?: CancelToken): Promise<QuotallLossTypeDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallClaims/losstypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLosstypes(_response);
        });
    }

    protected processLosstypes(response: AxiosResponse): Promise<QuotallLossTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallLossTypeDto.fromJS(resultData200);
            return Promise.resolve<QuotallLossTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallLossTypeDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     * @deprecated
     */
    losstypes2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<QuotallLossTypeDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallClaims/losstypes?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLosstypes2(_response);
        });
    }

    protected processLosstypes2(response: AxiosResponse): Promise<QuotallLossTypeDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallLossTypeDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<QuotallLossTypeDtoPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallLossTypeDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     * @deprecated
     */
    outcometypes(id: string, cancelToken?: CancelToken): Promise<QuotallOutcomeTypeDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallClaims/outcometypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOutcometypes(_response);
        });
    }

    protected processOutcometypes(response: AxiosResponse): Promise<QuotallOutcomeTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallOutcomeTypeDto.fromJS(resultData200);
            return Promise.resolve<QuotallOutcomeTypeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallOutcomeTypeDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     * @deprecated
     */
    outcometypes2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<QuotallOutcomeTypeDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallClaims/outcometypes?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOutcometypes2(_response);
        });
    }

    protected processOutcometypes2(response: AxiosResponse): Promise<QuotallOutcomeTypeDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallOutcomeTypeDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<QuotallOutcomeTypeDtoPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallOutcomeTypeDtoPaginationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST20(body?: QuotallClaimCreateDto | undefined, cancelToken?: CancelToken): Promise<QuotallClaimDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallClaims/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST20(_response);
        });
    }

    protected processCreatePOST20(response: AxiosResponse): Promise<QuotallClaimDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallClaimDto.fromJS(resultData200);
            return Promise.resolve<QuotallClaimDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallClaimDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update19(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<QuotallClaimDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallClaims/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate19(_response);
        });
    }

    protected processUpdate19(response: AxiosResponse): Promise<QuotallClaimDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallClaimDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<QuotallClaimDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallClaimDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    outcome(id: string, outcomeId: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<QuotallClaimDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallClaims/{id}/outcome/{outcomeId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (outcomeId === undefined || outcomeId === null)
            throw new Error("The parameter 'outcomeId' must be defined.");
        url_ = url_.replace("{outcomeId}", encodeURIComponent("" + outcomeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOutcome(_response);
        });
    }

    protected processOutcome(response: AxiosResponse): Promise<QuotallClaimDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallClaimDto.fromJS(resultData200);
            return Promise.resolve<QuotallClaimDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallClaimDto>(null as any);
    }
}

export class QuotallLossTypeClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    quotallLossType(id: string, cancelToken?: CancelToken): Promise<QuotallLossTypeDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallLossType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuotallLossType(_response);
        });
    }

    protected processQuotallLossType(response: AxiosResponse): Promise<QuotallLossTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallLossTypeDto.fromJS(resultData200);
            return Promise.resolve<QuotallLossTypeDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallLossTypeDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param selectedLossTypes (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @param orderBy (optional) 
     * @param searchQuery (optional) 
     * @return Success
     */
    quotallLossType2(includeInactive?: boolean | undefined, selectedLossTypes?: string | undefined, pageSize?: number | undefined, page?: number | undefined, orderBy?: QuotallOrderBy | undefined, searchQuery?: string | undefined, cancelToken?: CancelToken): Promise<QuotallLossTypeDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallLossType?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (selectedLossTypes === null)
            throw new Error("The parameter 'selectedLossTypes' cannot be null.");
        else if (selectedLossTypes !== undefined)
            url_ += "selectedLossTypes=" + encodeURIComponent("" + selectedLossTypes) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuotallLossType2(_response);
        });
    }

    protected processQuotallLossType2(response: AxiosResponse): Promise<QuotallLossTypeDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallLossTypeDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<QuotallLossTypeDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallLossTypeDtoPaginationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST21(body?: QuotallLossTypeCreateDto | undefined, cancelToken?: CancelToken): Promise<QuotallLossTypeDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallLossType/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST21(_response);
        });
    }

    protected processCreatePOST21(response: AxiosResponse): Promise<QuotallLossTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallLossTypeDto.fromJS(resultData200);
            return Promise.resolve<QuotallLossTypeDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallLossTypeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update20(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<QuotallLossTypeDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallLossType/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate20(_response);
        });
    }

    protected processUpdate20(response: AxiosResponse): Promise<QuotallLossTypeDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallLossTypeDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<QuotallLossTypeDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallLossTypeDtoUpdateResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    delete23(id: string, cancelToken?: CancelToken): Promise<QuotallLossTypeDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallLossType/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete23(_response);
        });
    }

    protected processDelete23(response: AxiosResponse): Promise<QuotallLossTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallLossTypeDto.fromJS(resultData200);
            return Promise.resolve<QuotallLossTypeDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallLossTypeDto>(null as any);
    }

    /**
     * @return Success
     */
    activate3(id: string, cancelToken?: CancelToken): Promise<QuotallLossTypeDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallLossType/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate3(_response);
        });
    }

    protected processActivate3(response: AxiosResponse): Promise<QuotallLossTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallLossTypeDto.fromJS(resultData200);
            return Promise.resolve<QuotallLossTypeDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallLossTypeDto>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes16(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/QuotallLossType/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges16(_response);
        });
    }

    protected processChanges16(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class QuotallOutcomeTypeClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    quotallOutcomeType(id: string, cancelToken?: CancelToken): Promise<QuotallOutcomeTypeDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallOutcomeType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuotallOutcomeType(_response);
        });
    }

    protected processQuotallOutcomeType(response: AxiosResponse): Promise<QuotallOutcomeTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallOutcomeTypeDto.fromJS(resultData200);
            return Promise.resolve<QuotallOutcomeTypeDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallOutcomeTypeDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param selectedLossTypes (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @param orderBy (optional) 
     * @param searchQuery (optional) 
     * @return Success
     */
    quotallOutcomeType2(includeInactive?: boolean | undefined, selectedLossTypes?: string | undefined, pageSize?: number | undefined, page?: number | undefined, orderBy?: QuotallOrderBy | undefined, searchQuery?: string | undefined, cancelToken?: CancelToken): Promise<QuotallOutcomeTypeDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallOutcomeType?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (selectedLossTypes === null)
            throw new Error("The parameter 'selectedLossTypes' cannot be null.");
        else if (selectedLossTypes !== undefined)
            url_ += "selectedLossTypes=" + encodeURIComponent("" + selectedLossTypes) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuotallOutcomeType2(_response);
        });
    }

    protected processQuotallOutcomeType2(response: AxiosResponse): Promise<QuotallOutcomeTypeDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallOutcomeTypeDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<QuotallOutcomeTypeDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallOutcomeTypeDtoPaginationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST22(body?: QuotallOutcomeTypeCreateDto | undefined, cancelToken?: CancelToken): Promise<QuotallOutcomeTypeDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallOutcomeType/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST22(_response);
        });
    }

    protected processCreatePOST22(response: AxiosResponse): Promise<QuotallOutcomeTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallOutcomeTypeDto.fromJS(resultData200);
            return Promise.resolve<QuotallOutcomeTypeDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallOutcomeTypeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update21(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<QuotallOutcomeTypeDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallOutcomeType/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate21(_response);
        });
    }

    protected processUpdate21(response: AxiosResponse): Promise<QuotallOutcomeTypeDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallOutcomeTypeDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<QuotallOutcomeTypeDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallOutcomeTypeDtoUpdateResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    delete24(id: string, cancelToken?: CancelToken): Promise<QuotallOutcomeTypeDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallOutcomeType/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete24(_response);
        });
    }

    protected processDelete24(response: AxiosResponse): Promise<QuotallOutcomeTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallOutcomeTypeDto.fromJS(resultData200);
            return Promise.resolve<QuotallOutcomeTypeDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallOutcomeTypeDto>(null as any);
    }

    /**
     * @return Success
     */
    activate4(id: string, cancelToken?: CancelToken): Promise<QuotallOutcomeTypeDto> {
        let url_ = this.baseUrl + "/api/v1/QuotallOutcomeType/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate4(_response);
        });
    }

    protected processActivate4(response: AxiosResponse): Promise<QuotallOutcomeTypeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuotallOutcomeTypeDto.fromJS(resultData200);
            return Promise.resolve<QuotallOutcomeTypeDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuotallOutcomeTypeDto>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes17(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/QuotallOutcomeType/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges17(_response);
        });
    }

    protected processChanges17(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class ReferralClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    referral(id: string, cancelToken?: CancelToken): Promise<ReferralSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Referral/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReferral(_response);
        });
    }

    protected processReferral(response: AxiosResponse): Promise<ReferralSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReferralSimpleDto.fromJS(resultData200);
            return Promise.resolve<ReferralSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReferralSimpleDto>(null as any);
    }

    /**
     * @return Success
     */
    exists(code: string, cancelToken?: CancelToken): Promise<ReferralSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Referral/exists/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExists(_response);
        });
    }

    protected processExists(response: AxiosResponse): Promise<ReferralSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReferralSimpleDto.fromJS(resultData200);
            return Promise.resolve<ReferralSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReferralSimpleDto>(null as any);
    }

    /**
     * @return Success
     */
    detailed38(id: string, cancelToken?: CancelToken): Promise<ReferralDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Referral/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed38(_response);
        });
    }

    protected processDetailed38(response: AxiosResponse): Promise<ReferralDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReferralDetailedDto.fromJS(resultData200);
            return Promise.resolve<ReferralDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReferralDetailedDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param isReferrer (optional) 
     * @param orderBy (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    referral2(userId?: string | undefined, isReferrer?: boolean | undefined, orderBy?: ReferralOrderBy | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ReferralSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Referral?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isReferrer === null)
            throw new Error("The parameter 'isReferrer' cannot be null.");
        else if (isReferrer !== undefined)
            url_ += "isReferrer=" + encodeURIComponent("" + isReferrer) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReferral2(_response);
        });
    }

    protected processReferral2(response: AxiosResponse): Promise<ReferralSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReferralSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ReferralSimpleDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReferralSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param isReferrer (optional) 
     * @param orderBy (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    detailed39(userId?: string | undefined, isReferrer?: boolean | undefined, orderBy?: ReferralOrderBy | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ReferralDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Referral/detailed?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (isReferrer === null)
            throw new Error("The parameter 'isReferrer' cannot be null.");
        else if (isReferrer !== undefined)
            url_ += "isReferrer=" + encodeURIComponent("" + isReferrer) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed39(_response);
        });
    }

    protected processDetailed39(response: AxiosResponse): Promise<ReferralDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReferralDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ReferralDetailedDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReferralDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Allows the changing of a Referrals Code
     * @param id (optional) The Id of the Referral you are trying to Change
     * @param newCode (optional) The new Code of the Referral
     * @return Success
     */
    changeCode(id?: string | undefined, newCode?: string | undefined, cancelToken?: CancelToken): Promise<ReferralDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Referral/changeCode?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newCode === null)
            throw new Error("The parameter 'newCode' cannot be null.");
        else if (newCode !== undefined)
            url_ += "newCode=" + encodeURIComponent("" + newCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeCode(_response);
        });
    }

    protected processChangeCode(response: AxiosResponse): Promise<ReferralDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReferralDetailedDto.fromJS(resultData200);
            return Promise.resolve<ReferralDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReferralDetailedDto>(null as any);
    }

    /**
     * For a User To Create their ReferralCode
     * @param code (optional) 
     * @return Success
     */
    createPOST23(code?: string | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Referral/create?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST23(_response);
        });
    }

    protected processCreatePOST23(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reformatReferrals( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Referral/reformatReferrals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReformatReferrals(_response);
        });
    }

    protected processReformatReferrals(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    emailReferral(emailAddress?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Referral/emailReferral?";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmailReferral(_response);
        });
    }

    protected processEmailReferral(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ReportClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Report
     * @param id The Id of the Report
     * @return Returns if the Report is found and the User is Authorized appropriately
     */
    report(id: string, cancelToken?: CancelToken): Promise<ReportPublicSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReport(_response);
        });
    }

    protected processReport(response: AxiosResponse): Promise<ReportPublicSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportPublicSimpleDto.fromJS(resultData200);
            return Promise.resolve<ReportPublicSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Report cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportPublicSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Report
     * @param id The Id of the Report
     * @return Returns if the Report is found and the User is Authorized appropriately
     */
    detailed40(id: string, cancelToken?: CancelToken): Promise<ReportPublicDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Report/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed40(_response);
        });
    }

    protected processDetailed40(response: AxiosResponse): Promise<ReportPublicDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportPublicDetailedDto.fromJS(resultData200);
            return Promise.resolve<ReportPublicDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Report cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportPublicDetailedDto>(null as any);
    }

    /**
     * Gets all Reports in a Simple format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Reports, useful for Admins/Moderators
     * @param objectType (optional) Allows the Filtering by Object Type
     * @param userId (optional) Allows the Filtering of Users
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Reports are found and the User is Authorized appropriately
     */
    report2(includeInactive?: boolean | undefined, objectType?: string | undefined, userId?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ReportPublicSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Report?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (objectType === null)
            throw new Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReport2(_response);
        });
    }

    protected processReport2(response: AxiosResponse): Promise<ReportPublicSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportPublicSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ReportPublicSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportPublicSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Reports in a Detailed format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Reports, useful for Admins/Moderators
     * @param objectType (optional) Allows the Filtering by Object Type
     * @param userId (optional) Allows the filtering by User
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Reports are found and the User is Authorized appropriately
     */
    detailed41(includeInactive?: boolean | undefined, objectType?: string | undefined, userId?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ReportPublicDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Report/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (objectType === null)
            throw new Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed41(_response);
        });
    }

    protected processDetailed41(response: AxiosResponse): Promise<ReportPublicDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportPublicDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ReportPublicDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportPublicDetailedDtoPaginationDto>(null as any);
    }

    /**
     * @param idQuery (optional) 
     * @return Success
     */
    staff2(idPath: string, idQuery?: string | undefined, cancelToken?: CancelToken): Promise<ReportSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Report/staff/{id}?";
        if (idPath === undefined || idPath === null)
            throw new Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaff2(_response);
        });
    }

    protected processStaff2(response: AxiosResponse): Promise<ReportSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportSimpleDto.fromJS(resultData200);
            return Promise.resolve<ReportSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportSimpleDto>(null as any);
    }

    /**
     * @param idQuery (optional) 
     * @return Success
     */
    detailed42(idPath: string, idQuery?: string | undefined, cancelToken?: CancelToken): Promise<ReportDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Report/staff/detailed/{id}?";
        if (idPath === undefined || idPath === null)
            throw new Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed42(_response);
        });
    }

    protected processDetailed42(response: AxiosResponse): Promise<ReportDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDetailedDto.fromJS(resultData200);
            return Promise.resolve<ReportDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDetailedDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param objectType (optional) 
     * @param userId (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    staff3(includeInactive?: boolean | undefined, objectType?: string | undefined, userId?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ReportSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Report/staff?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (objectType === null)
            throw new Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStaff3(_response);
        });
    }

    protected processStaff3(response: AxiosResponse): Promise<ReportSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ReportSimpleDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param objectType (optional) 
     * @param userId (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    detailed43(includeInactive?: boolean | undefined, objectType?: string | undefined, userId?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ReportDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Report/staff/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (objectType === null)
            throw new Error("The parameter 'objectType' cannot be null.");
        else if (objectType !== undefined)
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed43(_response);
        });
    }

    protected processDetailed43(response: AxiosResponse): Promise<ReportDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ReportDetailedDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Report
     * @param body (optional) 
     * @return Returns if the Report is Created, also returns a DetailedDto of the newly created business
     */
    createPOST24(body?: ReportCreateDto | undefined, cancelToken?: CancelToken): Promise<ReportPublicDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Report/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST24(_response);
        });
    }

    protected processCreatePOST24(response: AxiosResponse): Promise<ReportPublicDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportPublicDetailedDto.fromJS(resultData200);
            return Promise.resolve<ReportPublicDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportPublicDetailedDto>(null as any);
    }

    /**
     * Updates an existing Report
     * @param id The Id of the Report being Updated
     * @param body (optional) A Dictionairy of Changes to be made to the Report
     * @return Returns if the Report is updated, also returns a DetailedDto of the newly updated business
     */
    update22(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<ReportDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Report/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate22(_response);
        });
    }

    protected processUpdate22(response: AxiosResponse): Promise<ReportDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ReportDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Disables an existing Report
     * @return Success
     */
    delete25(id: string, cancelToken?: CancelToken): Promise<ReportDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Report/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete25(_response);
        });
    }

    protected processDelete25(response: AxiosResponse): Promise<ReportDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDetailedDto.fromJS(resultData200);
            return Promise.resolve<ReportDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate16(id: string, cancelToken?: CancelToken): Promise<ReportDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Report/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate16(_response);
        });
    }

    protected processReactivate16(response: AxiosResponse): Promise<ReportDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportDetailedDto.fromJS(resultData200);
            return Promise.resolve<ReportDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Report
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes18(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Report/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges18(_response);
        });
    }

    protected processChanges18(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class SarClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param created (optional) 
     * @param expired (optional) 
     * @return Success
     */
    generatesaractivity(id: string, created?: Date | undefined, expired?: Date | undefined, cancelToken?: CancelToken): Promise<SarUserActivityDto> {
        let url_ = this.baseUrl + "/api/v1/Sar/{id}/generatesaractivity?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (created === null)
            throw new Error("The parameter 'created' cannot be null.");
        else if (created !== undefined)
            url_ += "created=" + encodeURIComponent(created ? "" + created.toISOString() : "") + "&";
        if (expired === null)
            throw new Error("The parameter 'expired' cannot be null.");
        else if (expired !== undefined)
            url_ += "expired=" + encodeURIComponent(expired ? "" + expired.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeneratesaractivity(_response);
        });
    }

    protected processGeneratesaractivity(response: AxiosResponse): Promise<SarUserActivityDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SarUserActivityDto.fromJS(resultData200);
            return Promise.resolve<SarUserActivityDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SarUserActivityDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    asCSV3(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Sar/sar/asCSV?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAsCSV3(_response);
        });
    }

    protected processAsCSV3(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SearchLogClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param pageSize (optional) 
     * @param page (optional) 
     * @param orderBy (optional) 
     * @param searchQuery (optional) 
     * @param asc (optional) 
     * @return Success
     */
    searchLog(pageSize?: number | undefined, page?: number | undefined, orderBy?: SearchOrderBy | undefined, searchQuery?: string | undefined, asc?: boolean | undefined, cancelToken?: CancelToken): Promise<SearchLogSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/SearchLog?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (asc === null)
            throw new Error("The parameter 'asc' cannot be null.");
        else if (asc !== undefined)
            url_ += "asc=" + encodeURIComponent("" + asc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchLog(_response);
        });
    }

    protected processSearchLog(response: AxiosResponse): Promise<SearchLogSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchLogSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<SearchLogSimpleDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchLogSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @param orderBy (optional) 
     * @param searchQuery (optional) 
     * @return Success
     */
    asCSV4(orderBy?: SearchOrderBy | undefined, searchQuery?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/SearchLog/asCSV?";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAsCSV4(_response);
        });
    }

    protected processAsCSV4(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    nullSearches( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/SearchLog/nullSearches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNullSearches(_response);
        });
    }

    protected processNullSearches(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param amount (optional) 
     * @return Success
     */
    recentSearches(amount?: number | undefined, cancelToken?: CancelToken): Promise<SearchLogPublicSimpleDto[]> {
        let url_ = this.baseUrl + "/api/v1/SearchLog/recentSearches?";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecentSearches(_response);
        });
    }

    protected processRecentSearches(response: AxiosResponse): Promise<SearchLogPublicSimpleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchLogPublicSimpleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SearchLogPublicSimpleDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchLogPublicSimpleDto[]>(null as any);
    }
}

export class SearchPageClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @param ip (optional) 
     * @param radius (optional) 
     * @param minDailyPrice (optional) 
     * @param maxDailyPrice (optional) 
     * @param minHourlyPrice (optional) 
     * @param maxHourlyPrice (optional) 
     * @param minDate (optional) 
     * @param maxDate (optional) 
     * @param publishMinDate (optional) 
     * @param publishMaxDate (optional) 
     * @param allAvailable (optional) 
     * @param hourly (optional) 
     * @param categoryIds (optional) 
     * @param searchQuery (optional) 
     * @param searchAspects (optional) 
     * @param multiAspectSearchMode (optional) 
     * @param orderBy (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @param hasInsurance (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    searchPage(latitude?: number | undefined, longitude?: number | undefined, ip?: string | undefined, radius?: number | undefined, minDailyPrice?: number | undefined, maxDailyPrice?: number | undefined, minHourlyPrice?: number | undefined, maxHourlyPrice?: number | undefined, minDate?: Date | undefined, maxDate?: Date | undefined, publishMinDate?: Date | undefined, publishMaxDate?: Date | undefined, allAvailable?: boolean | undefined, hourly?: boolean | undefined, categoryIds?: string[] | undefined, searchQuery?: string | undefined, searchAspects?: string | undefined, multiAspectSearchMode?: MultiAspectSearchMode | undefined, orderBy?: ItemOrderBy | undefined, userId?: string | undefined, tenantId?: string | undefined, hasInsurance?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ItemSearchResultDto> {
        let url_ = this.baseUrl + "/api/v1/SearchPage?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (ip === null)
            throw new Error("The parameter 'ip' cannot be null.");
        else if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        if (radius === null)
            throw new Error("The parameter 'radius' cannot be null.");
        else if (radius !== undefined)
            url_ += "radius=" + encodeURIComponent("" + radius) + "&";
        if (minDailyPrice === null)
            throw new Error("The parameter 'minDailyPrice' cannot be null.");
        else if (minDailyPrice !== undefined)
            url_ += "minDailyPrice=" + encodeURIComponent("" + minDailyPrice) + "&";
        if (maxDailyPrice === null)
            throw new Error("The parameter 'maxDailyPrice' cannot be null.");
        else if (maxDailyPrice !== undefined)
            url_ += "maxDailyPrice=" + encodeURIComponent("" + maxDailyPrice) + "&";
        if (minHourlyPrice === null)
            throw new Error("The parameter 'minHourlyPrice' cannot be null.");
        else if (minHourlyPrice !== undefined)
            url_ += "minHourlyPrice=" + encodeURIComponent("" + minHourlyPrice) + "&";
        if (maxHourlyPrice === null)
            throw new Error("The parameter 'maxHourlyPrice' cannot be null.");
        else if (maxHourlyPrice !== undefined)
            url_ += "maxHourlyPrice=" + encodeURIComponent("" + maxHourlyPrice) + "&";
        if (minDate === null)
            throw new Error("The parameter 'minDate' cannot be null.");
        else if (minDate !== undefined)
            url_ += "minDate=" + encodeURIComponent(minDate ? "" + minDate.toISOString() : "") + "&";
        if (maxDate === null)
            throw new Error("The parameter 'maxDate' cannot be null.");
        else if (maxDate !== undefined)
            url_ += "maxDate=" + encodeURIComponent(maxDate ? "" + maxDate.toISOString() : "") + "&";
        if (publishMinDate === null)
            throw new Error("The parameter 'publishMinDate' cannot be null.");
        else if (publishMinDate !== undefined)
            url_ += "publishMinDate=" + encodeURIComponent(publishMinDate ? "" + publishMinDate.toISOString() : "") + "&";
        if (publishMaxDate === null)
            throw new Error("The parameter 'publishMaxDate' cannot be null.");
        else if (publishMaxDate !== undefined)
            url_ += "publishMaxDate=" + encodeURIComponent(publishMaxDate ? "" + publishMaxDate.toISOString() : "") + "&";
        if (allAvailable === null)
            throw new Error("The parameter 'allAvailable' cannot be null.");
        else if (allAvailable !== undefined)
            url_ += "allAvailable=" + encodeURIComponent("" + allAvailable) + "&";
        if (hourly === null)
            throw new Error("The parameter 'hourly' cannot be null.");
        else if (hourly !== undefined)
            url_ += "hourly=" + encodeURIComponent("" + hourly) + "&";
        if (categoryIds === null)
            throw new Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (searchAspects === null)
            throw new Error("The parameter 'searchAspects' cannot be null.");
        else if (searchAspects !== undefined)
            url_ += "searchAspects=" + encodeURIComponent("" + searchAspects) + "&";
        if (multiAspectSearchMode === null)
            throw new Error("The parameter 'multiAspectSearchMode' cannot be null.");
        else if (multiAspectSearchMode !== undefined)
            url_ += "multiAspectSearchMode=" + encodeURIComponent("" + multiAspectSearchMode) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (hasInsurance === null)
            throw new Error("The parameter 'hasInsurance' cannot be null.");
        else if (hasInsurance !== undefined)
            url_ += "hasInsurance=" + encodeURIComponent("" + hasInsurance) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPage(_response);
        });
    }

    protected processSearchPage(response: AxiosResponse): Promise<ItemSearchResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ItemSearchResultDto.fromJS(resultData200);
            return Promise.resolve<ItemSearchResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemSearchResultDto>(null as any);
    }
}

export class StatsClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    stats( cancelToken?: CancelToken): Promise<StatsOverview> {
        let url_ = this.baseUrl + "/api/v1/Stats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStats(_response);
        });
    }

    protected processStats(response: AxiosResponse): Promise<StatsOverview> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatsOverview.fromJS(resultData200);
            return Promise.resolve<StatsOverview>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatsOverview>(null as any);
    }

    /**
     * @return Success
     */
    transactions( cancelToken?: CancelToken): Promise<TransactionStatsDto[]> {
        let url_ = this.baseUrl + "/api/v1/Stats/transactions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransactions(_response);
        });
    }

    protected processTransactions(response: AxiosResponse): Promise<TransactionStatsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionStatsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TransactionStatsDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransactionStatsDto[]>(null as any);
    }

    /**
     * @return Success
     */
    claims( cancelToken?: CancelToken): Promise<ClaimsStatsDto> {
        let url_ = this.baseUrl + "/api/v1/Stats/claims";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClaims(_response);
        });
    }

    protected processClaims(response: AxiosResponse): Promise<ClaimsStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClaimsStatsDto.fromJS(resultData200);
            return Promise.resolve<ClaimsStatsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClaimsStatsDto>(null as any);
    }

    /**
     * @return Success
     */
    claimsByMonth( cancelToken?: CancelToken): Promise<ClaimsStatsDto[]> {
        let url_ = this.baseUrl + "/api/v1/Stats/claimsByMonth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClaimsByMonth(_response);
        });
    }

    protected processClaimsByMonth(response: AxiosResponse): Promise<ClaimsStatsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimsStatsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClaimsStatsDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClaimsStatsDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTopCategories( cancelToken?: CancelToken): Promise<CategoryDetailedDto[]> {
        let url_ = this.baseUrl + "/api/v1/Stats/getTopCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTopCategories(_response);
        });
    }

    protected processGetTopCategories(response: AxiosResponse): Promise<CategoryDetailedDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryDetailedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CategoryDetailedDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDetailedDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTopBookedItems( cancelToken?: CancelToken): Promise<ItemDto[]> {
        let url_ = this.baseUrl + "/api/v1/Stats/getTopBookedItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTopBookedItems(_response);
        });
    }

    protected processGetTopBookedItems(response: AxiosResponse): Promise<ItemDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ItemDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTopUserStats( cancelToken?: CancelToken): Promise<TopStatsDto> {
        let url_ = this.baseUrl + "/api/v1/Stats/getTopUserStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTopUserStats(_response);
        });
    }

    protected processGetTopUserStats(response: AxiosResponse): Promise<TopStatsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TopStatsDto.fromJS(resultData200);
            return Promise.resolve<TopStatsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopStatsDto>(null as any);
    }

    /**
     * @return Success
     */
    getUserDemographics( cancelToken?: CancelToken): Promise<UserDemographicsDto> {
        let url_ = this.baseUrl + "/api/v1/Stats/getUserDemographics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserDemographics(_response);
        });
    }

    protected processGetUserDemographics(response: AxiosResponse): Promise<UserDemographicsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDemographicsDto.fromJS(resultData200);
            return Promise.resolve<UserDemographicsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDemographicsDto>(null as any);
    }

    /**
     * @return Success
     */
    getItemPrices( cancelToken?: CancelToken): Promise<ListingsAnalyticsDto> {
        let url_ = this.baseUrl + "/api/v1/Stats/getItemPrices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItemPrices(_response);
        });
    }

    protected processGetItemPrices(response: AxiosResponse): Promise<ListingsAnalyticsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListingsAnalyticsDto.fromJS(resultData200);
            return Promise.resolve<ListingsAnalyticsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingsAnalyticsDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    topLocations(startDate?: Date | undefined, endDate?: Date | undefined, cancelToken?: CancelToken): Promise<TopSearchedLocationsDto[]> {
        let url_ = this.baseUrl + "/api/v1/Stats/topLocations?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTopLocations(_response);
        });
    }

    protected processTopLocations(response: AxiosResponse): Promise<TopSearchedLocationsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TopSearchedLocationsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TopSearchedLocationsDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TopSearchedLocationsDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    insightCounts(startDate?: Date | undefined, endDate?: Date | undefined, cancelToken?: CancelToken): Promise<StatsOverview> {
        let url_ = this.baseUrl + "/api/v1/Stats/insightCounts?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsightCounts(_response);
        });
    }

    protected processInsightCounts(response: AxiosResponse): Promise<StatsOverview> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatsOverview.fromJS(resultData200);
            return Promise.resolve<StatsOverview>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatsOverview>(null as any);
    }
}

export class StripeWebhookClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    stripe( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/webhooks/stripe";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStripe(_response);
        });
    }

    protected processStripe(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TenantClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @param orderBy (optional) 
     * @param searchQuery (optional) 
     * @return Success
     */
    tenant(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, orderBy?: TenantOrderBy | undefined, searchQuery?: string | undefined, cancelToken?: CancelToken): Promise<TenantSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Tenant?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTenant(_response);
        });
    }

    protected processTenant(response: AxiosResponse): Promise<TenantSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<TenantSimpleDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    detailed44(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<TenantDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Tenant/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed44(_response);
        });
    }

    protected processDetailed44(response: AxiosResponse): Promise<TenantDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<TenantDetailedDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDetailedDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    tenant2(id: string, cancelToken?: CancelToken): Promise<TenantSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Tenant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTenant2(_response);
        });
    }

    protected processTenant2(response: AxiosResponse): Promise<TenantSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantSimpleDto.fromJS(resultData200);
            return Promise.resolve<TenantSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantSimpleDto>(null as any);
    }

    /**
     * @return Success
     */
    detailed45(id: string, cancelToken?: CancelToken): Promise<TenantDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Tenant/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed45(_response);
        });
    }

    protected processDetailed45(response: AxiosResponse): Promise<TenantDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDetailedDto.fromJS(resultData200);
            return Promise.resolve<TenantDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDetailedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPUT(body?: TenantCreateDto | undefined, cancelToken?: CancelToken): Promise<TenantDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Tenant/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePUT(_response);
        });
    }

    protected processCreatePUT(response: AxiosResponse): Promise<TenantDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDetailedDto.fromJS(resultData200);
            return Promise.resolve<TenantDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDetailedDto>(null as any);
    }

    /**
     * @param tenantName (optional) 
     * @return Success
     */
    delete26(id: string, tenantName?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Tenant/{id}/delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantName === null)
            throw new Error("The parameter 'tenantName' cannot be null.");
        else if (tenantName !== undefined)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete26(_response);
        });
    }

    protected processDelete26(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TermsClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    terms(id: string, cancelToken?: CancelToken): Promise<TermsSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Terms/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTerms(_response);
        });
    }

    protected processTerms(response: AxiosResponse): Promise<TermsSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TermsSimpleDto.fromJS(resultData200);
            return Promise.resolve<TermsSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsSimpleDto>(null as any);
    }

    /**
     * @return Success
     */
    detailed46(id: string, cancelToken?: CancelToken): Promise<TermsDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Terms/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed46(_response);
        });
    }

    protected processDetailed46(response: AxiosResponse): Promise<TermsDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TermsDetailedDto.fromJS(resultData200);
            return Promise.resolve<TermsDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsDetailedDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param includeUnissued (optional) 
     * @param latestOnly (optional) 
     * @param termType (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    terms2(includeInactive?: boolean | undefined, includeUnissued?: boolean | undefined, latestOnly?: boolean | undefined, termType?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<TermsSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Terms?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (includeUnissued === null)
            throw new Error("The parameter 'includeUnissued' cannot be null.");
        else if (includeUnissued !== undefined)
            url_ += "includeUnissued=" + encodeURIComponent("" + includeUnissued) + "&";
        if (latestOnly === null)
            throw new Error("The parameter 'latestOnly' cannot be null.");
        else if (latestOnly !== undefined)
            url_ += "latestOnly=" + encodeURIComponent("" + latestOnly) + "&";
        if (termType === null)
            throw new Error("The parameter 'termType' cannot be null.");
        else if (termType !== undefined)
            url_ += "termType=" + encodeURIComponent("" + termType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTerms2(_response);
        });
    }

    protected processTerms2(response: AxiosResponse): Promise<TermsSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TermsSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<TermsSimpleDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param includeUnissued (optional) 
     * @param latestOnly (optional) 
     * @param termType (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    detailed47(includeInactive?: boolean | undefined, includeUnissued?: boolean | undefined, latestOnly?: boolean | undefined, termType?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<TermsSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Terms/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (includeUnissued === null)
            throw new Error("The parameter 'includeUnissued' cannot be null.");
        else if (includeUnissued !== undefined)
            url_ += "includeUnissued=" + encodeURIComponent("" + includeUnissued) + "&";
        if (latestOnly === null)
            throw new Error("The parameter 'latestOnly' cannot be null.");
        else if (latestOnly !== undefined)
            url_ += "latestOnly=" + encodeURIComponent("" + latestOnly) + "&";
        if (termType === null)
            throw new Error("The parameter 'termType' cannot be null.");
        else if (termType !== undefined)
            url_ += "termType=" + encodeURIComponent("" + termType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed47(_response);
        });
    }

    protected processDetailed47(response: AxiosResponse): Promise<TermsSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TermsSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<TermsSimpleDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST25(body?: TermsCreateDto | undefined, cancelToken?: CancelToken): Promise<TermsDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Terms/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST25(_response);
        });
    }

    protected processCreatePOST25(response: AxiosResponse): Promise<TermsDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TermsDetailedDto.fromJS(resultData200);
            return Promise.resolve<TermsDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    issue(id: string, cancelToken?: CancelToken): Promise<TermsDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Terms/{id}/issue";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIssue(_response);
        });
    }

    protected processIssue(response: AxiosResponse): Promise<TermsDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TermsDetailedDto.fromJS(resultData200);
            return Promise.resolve<TermsDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    accept(id: string, cancelToken?: CancelToken): Promise<AcceptedTermsDto> {
        let url_ = this.baseUrl + "/api/v1/Terms/accept/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccept(_response);
        });
    }

    protected processAccept(response: AxiosResponse): Promise<AcceptedTermsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcceptedTermsDto.fromJS(resultData200);
            return Promise.resolve<AcceptedTermsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptedTermsDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param latestOnly (optional) 
     * @param termType (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    accepted(userId?: string | undefined, latestOnly?: boolean | undefined, termType?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<AcceptedTermsDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Terms/accepted?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (latestOnly === null)
            throw new Error("The parameter 'latestOnly' cannot be null.");
        else if (latestOnly !== undefined)
            url_ += "latestOnly=" + encodeURIComponent("" + latestOnly) + "&";
        if (termType === null)
            throw new Error("The parameter 'termType' cannot be null.");
        else if (termType !== undefined)
            url_ += "termType=" + encodeURIComponent("" + termType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccepted(_response);
        });
    }

    protected processAccepted(response: AxiosResponse): Promise<AcceptedTermsDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcceptedTermsDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<AcceptedTermsDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptedTermsDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    accepted2(termType: string, cancelToken?: CancelToken): Promise<AcceptedTermsDto> {
        let url_ = this.baseUrl + "/api/v1/Terms/{termType}/accepted";
        if (termType === undefined || termType === null)
            throw new Error("The parameter 'termType' must be defined.");
        url_ = url_.replace("{termType}", encodeURIComponent("" + termType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccepted2(_response);
        });
    }

    protected processAccepted2(response: AxiosResponse): Promise<AcceptedTermsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AcceptedTermsDto.fromJS(resultData200);
            return Promise.resolve<AcceptedTermsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptedTermsDto>(null as any);
    }

    /**
     * @return Success
     */
    toAccept( cancelToken?: CancelToken): Promise<AcceptedTermsDto[]> {
        let url_ = this.baseUrl + "/api/v1/Terms/to-accept";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToAccept(_response);
        });
    }

    protected processToAccept(response: AxiosResponse): Promise<AcceptedTermsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AcceptedTermsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AcceptedTermsDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptedTermsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update23(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<TermsDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Terms/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate23(_response);
        });
    }

    protected processUpdate23(response: AxiosResponse): Promise<TermsDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TermsDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<TermsDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsDetailedDtoUpdateResponseDto>(null as any);
    }
}

export class TradedoublerClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    tradedoubler(id: string, cancelToken?: CancelToken): Promise<TradedoublerProfileDto> {
        let url_ = this.baseUrl + "/api/v1/Tradedoubler/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTradedoubler(_response);
        });
    }

    protected processTradedoubler(response: AxiosResponse): Promise<TradedoublerProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TradedoublerProfileDto.fromJS(resultData200);
            return Promise.resolve<TradedoublerProfileDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradedoublerProfileDto>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    tradedoubler2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<TradedoublerProfileDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Tradedoubler?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTradedoubler2(_response);
        });
    }

    protected processTradedoubler2(response: AxiosResponse): Promise<TradedoublerProfileDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TradedoublerProfileDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<TradedoublerProfileDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradedoublerProfileDtoPaginationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST26(body?: TradedoublerProfileCreateDto | undefined, cancelToken?: CancelToken): Promise<TradedoublerProfileDto> {
        let url_ = this.baseUrl + "/api/v1/Tradedoubler/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST26(_response);
        });
    }

    protected processCreatePOST26(response: AxiosResponse): Promise<TradedoublerProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TradedoublerProfileDto.fromJS(resultData200);
            return Promise.resolve<TradedoublerProfileDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradedoublerProfileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update24(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<TradedoublerProfileDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Tradedoubler/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate24(_response);
        });
    }

    protected processUpdate24(response: AxiosResponse): Promise<TradedoublerProfileDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TradedoublerProfileDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<TradedoublerProfileDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradedoublerProfileDtoUpdateResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    changeCategory2(profileId: string, categoryId: string, cancelToken?: CancelToken): Promise<TradedoublerProfileDto> {
        let url_ = this.baseUrl + "/api/v1/Tradedoubler/{profileId}/change-category/{categoryId}";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeCategory2(_response);
        });
    }

    protected processChangeCategory2(response: AxiosResponse): Promise<TradedoublerProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TradedoublerProfileDto.fromJS(resultData200);
            return Promise.resolve<TradedoublerProfileDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradedoublerProfileDto>(null as any);
    }

    /**
     * @return Success
     */
    delete27(id: string, cancelToken?: CancelToken): Promise<TradedoublerProfileDto> {
        let url_ = this.baseUrl + "/api/v1/Tradedoubler/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete27(_response);
        });
    }

    protected processDelete27(response: AxiosResponse): Promise<TradedoublerProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TradedoublerProfileDto.fromJS(resultData200);
            return Promise.resolve<TradedoublerProfileDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradedoublerProfileDto>(null as any);
    }

    /**
     * @return Success
     */
    activate5(id: string, cancelToken?: CancelToken): Promise<TradedoublerProfileDto> {
        let url_ = this.baseUrl + "/api/v1/Tradedoubler/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate5(_response);
        });
    }

    protected processActivate5(response: AxiosResponse): Promise<TradedoublerProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TradedoublerProfileDto.fromJS(resultData200);
            return Promise.resolve<TradedoublerProfileDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TradedoublerProfileDto>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes19(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Tradedoubler/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges19(_response);
        });
    }

    protected processChanges19(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class TrainingLogClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Training Log
     * @param id The Id of a TrainingLog
     * @return Returns if the TrainingLog is found and the User is Authorized appropriately
     */
    trainingLog(id: string, cancelToken?: CancelToken): Promise<TrainingLogSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/TrainingLog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTrainingLog(_response);
        });
    }

    protected processTrainingLog(response: AxiosResponse): Promise<TrainingLogSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrainingLogSimpleDto.fromJS(resultData200);
            return Promise.resolve<TrainingLogSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the TrainingLog cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingLogSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Training Log
     * @param id The Id of a TrainingLog
     * @return Returns if the TrainingLog is found and the User is Authorized appropriately
     */
    detailed48(id: string, cancelToken?: CancelToken): Promise<TrainingLogDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/TrainingLog/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed48(_response);
        });
    }

    protected processDetailed48(response: AxiosResponse): Promise<TrainingLogDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrainingLogDetailedDto.fromJS(resultData200);
            return Promise.resolve<TrainingLogDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the TrainingLog cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingLogDetailedDto>(null as any);
    }

    /**
     * Gets all Training Logs in the Simple Format
     * @param includeInactive (optional) Whether or not you want to Include Inactive TrainingLogs, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the TrainingLogs are found and the User is Authorized appropriately
     */
    trainingLog2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<TrainingLogSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/TrainingLog?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTrainingLog2(_response);
        });
    }

    protected processTrainingLog2(response: AxiosResponse): Promise<TrainingLogSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrainingLogSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<TrainingLogSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingLogSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Training Logs in the Detailed format
     * @param includeInactive (optional) Whether or not you want to Include Inactive TrainingLogs, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the TrainingLogs are found and the User is Authorized appropriately
     */
    detailed49(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<TrainingLogDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/TrainingLog/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed49(_response);
        });
    }

    protected processDetailed49(response: AxiosResponse): Promise<TrainingLogDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrainingLogDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<TrainingLogDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingLogDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Training Log
     * @param body (optional) 
     * @return Success
     */
    createPOST27(body?: TrainingLogCreateDto | undefined, cancelToken?: CancelToken): Promise<TrainingLogDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/TrainingLog/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST27(_response);
        });
    }

    protected processCreatePOST27(response: AxiosResponse): Promise<TrainingLogDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrainingLogDetailedDto.fromJS(resultData200);
            return Promise.resolve<TrainingLogDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingLogDetailedDto>(null as any);
    }

    /**
     * Updates an existing Training Log
     * @param id The Id of the TrainingLog being Updated
     * @param body (optional) A Dictionairy of Changes to be made to the TrainingLog
     * @return Success
     */
    update25(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<TrainingLogDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/TrainingLog/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate25(_response);
        });
    }

    protected processUpdate25(response: AxiosResponse): Promise<TrainingLogDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrainingLogDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<TrainingLogDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingLogDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Disables an existing Training Log
     * @return Success
     */
    delete28(id: string, cancelToken?: CancelToken): Promise<TrainingLogDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/TrainingLog/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete28(_response);
        });
    }

    protected processDelete28(response: AxiosResponse): Promise<TrainingLogDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrainingLogDetailedDto.fromJS(resultData200);
            return Promise.resolve<TrainingLogDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingLogDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate17(id: string, cancelToken?: CancelToken): Promise<TrainingLogDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/TrainingLog/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate17(_response);
        });
    }

    protected processReactivate17(response: AxiosResponse): Promise<TrainingLogDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrainingLogDetailedDto.fromJS(resultData200);
            return Promise.resolve<TrainingLogDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingLogDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Training Log
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes20(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/TrainingLog/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges20(_response);
        });
    }

    protected processChanges20(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class TransactionHistoryClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Transaction History
     * @param id The Id of a TransactionHistory
     * @return Returns if the TransactionHistory is found and the User is Authorized appropriately
     */
    transactionHistory(id: string, cancelToken?: CancelToken): Promise<TransactionHistorySimpleDto> {
        let url_ = this.baseUrl + "/api/v1/TransactionHistory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransactionHistory(_response);
        });
    }

    protected processTransactionHistory(response: AxiosResponse): Promise<TransactionHistorySimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TransactionHistorySimpleDto.fromJS(resultData200);
            return Promise.resolve<TransactionHistorySimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the TransactionHistory cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransactionHistorySimpleDto>(null as any);
    }

    /**
     * Gets a Detailed Transaction History
     * @param id The Id of a TransactionHistory
     * @return Returns if the TransactionHistory is found and the User is Authorized appropriately
     */
    detailed50(id: string, cancelToken?: CancelToken): Promise<TransactionHistoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/TransactionHistory/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed50(_response);
        });
    }

    protected processDetailed50(response: AxiosResponse): Promise<TransactionHistoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TransactionHistoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<TransactionHistoryDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the TransactionHistory cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransactionHistoryDetailedDto>(null as any);
    }

    /**
     * Gets all Transaction Histories in the Simple format
     * @param includeInactive (optional) Whether or not you want to Include Inactive TransactionHistories, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the TransactionHistories is found and the User is Authorized appropriately
     */
    transactionHistory2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<TransactionHistorySimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/TransactionHistory?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransactionHistory2(_response);
        });
    }

    protected processTransactionHistory2(response: AxiosResponse): Promise<TransactionHistorySimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TransactionHistorySimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<TransactionHistorySimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransactionHistorySimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Transaction Histories in the Detailed format
     * @param includeInactive (optional) Whether or not you want to Include Inactive TransactionHistories, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the TransactionHistories is found and the User is Authorized appropriately
     */
    detailed51(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<TransactionHistoryDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/TransactionHistory/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed51(_response);
        });
    }

    protected processDetailed51(response: AxiosResponse): Promise<TransactionHistoryDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TransactionHistoryDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<TransactionHistoryDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransactionHistoryDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Transaction History
     * @param body (optional) 
     * @return Returns if the TransactionHistory is Created, also returns a DetailedDto of the newly created TransactionHistory
     */
    createPOST28(body?: TransactionHistoryCreateDto | undefined, cancelToken?: CancelToken): Promise<TransactionHistoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/TransactionHistory/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST28(_response);
        });
    }

    protected processCreatePOST28(response: AxiosResponse): Promise<TransactionHistoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TransactionHistoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<TransactionHistoryDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransactionHistoryDetailedDto>(null as any);
    }

    /**
     * Disables an existing Transaction History
     * @return Success
     */
    delete29(id: string, cancelToken?: CancelToken): Promise<TransactionHistoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/TransactionHistory/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete29(_response);
        });
    }

    protected processDelete29(response: AxiosResponse): Promise<TransactionHistoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TransactionHistoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<TransactionHistoryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransactionHistoryDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate18(id: string, cancelToken?: CancelToken): Promise<TransactionHistoryDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/TransactionHistory/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate18(_response);
        });
    }

    protected processReactivate18(response: AxiosResponse): Promise<TransactionHistoryDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TransactionHistoryDetailedDto.fromJS(resultData200);
            return Promise.resolve<TransactionHistoryDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransactionHistoryDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Transaction History
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes21(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/TransactionHistory/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges21(_response);
        });
    }

    protected processChanges21(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }
}

export class UserClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple User
     * @param id The Id of the User
     * @return Returns if the User is found and the User Request is Authorized appropriately
     */
    user(id: string, cancelToken?: CancelToken): Promise<RentMyUserPublicDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUser(_response);
        });
    }

    protected processUser(response: AxiosResponse): Promise<RentMyUserPublicDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserPublicDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserPublicDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the USer cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserPublicDetailedDto>(null as any);
    }

    /**
     * Gets a Detailed User
     * @param id The Id of the User
     * @return Returns if the User is found and the User Request is Authorized appropriately
     */
    detailed52(id: string, cancelToken?: CancelToken): Promise<RentMyUserPublicDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed52(_response);
        });
    }

    protected processDetailed52(response: AxiosResponse): Promise<RentMyUserPublicDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserPublicDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserPublicDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the USer cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserPublicDetailedDto>(null as any);
    }

    /**
     * @param checkStripeOnboarding (optional) 
     * @param checkStripeVerification (optional) 
     * @return Success
     */
    current(checkStripeOnboarding?: boolean | undefined, checkStripeVerification?: boolean | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/current?";
        if (checkStripeOnboarding === null)
            throw new Error("The parameter 'checkStripeOnboarding' cannot be null.");
        else if (checkStripeOnboarding !== undefined)
            url_ += "checkStripeOnboarding=" + encodeURIComponent("" + checkStripeOnboarding) + "&";
        if (checkStripeVerification === null)
            throw new Error("The parameter 'checkStripeVerification' cannot be null.");
        else if (checkStripeVerification !== undefined)
            url_ += "checkStripeVerification=" + encodeURIComponent("" + checkStripeVerification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCurrent(_response);
        });
    }

    protected processCurrent(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Gets all Users in the Simple format
     * @param includeSuspended (optional) Whether or not you want to Include Suspended Users
     * @param searchQuery (optional) 
     * @param orderBy (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Users are found and the User Request is Authorized appropriately
     */
    user2(includeSuspended?: boolean | undefined, searchQuery?: string | undefined, orderBy?: UserOrderBy | undefined, startDate?: Date | undefined, endDate?: Date | undefined, tenantId?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<RentMyUserPublicSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/User?";
        if (includeSuspended === null)
            throw new Error("The parameter 'includeSuspended' cannot be null.");
        else if (includeSuspended !== undefined)
            url_ += "includeSuspended=" + encodeURIComponent("" + includeSuspended) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUser2(_response);
        });
    }

    protected processUser2(response: AxiosResponse): Promise<RentMyUserPublicSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserPublicSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserPublicSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserPublicSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Users in the Detailed format
     * @param includeSuspended (optional) Whether or not you want to Include Suspended Users
     * @param searchQuery (optional) 
     * @param orderBy (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Users are found and the User Request is Authorized appropriately
     */
    detailed53(includeSuspended?: boolean | undefined, searchQuery?: string | undefined, orderBy?: UserOrderBy | undefined, startDate?: Date | undefined, endDate?: Date | undefined, tenantId?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<RentMyUserPublicDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/User/detailed?";
        if (includeSuspended === null)
            throw new Error("The parameter 'includeSuspended' cannot be null.");
        else if (includeSuspended !== undefined)
            url_ += "includeSuspended=" + encodeURIComponent("" + includeSuspended) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed53(_response);
        });
    }

    protected processDetailed53(response: AxiosResponse): Promise<RentMyUserPublicDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserPublicDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserPublicDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserPublicDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Users in the Simple format
     * @param includeSuspended (optional) Whether or not you want to Include Suspended Users
     * @param includeInactive (optional) Whether or not you want to Include Inactive Items
     * @param searchQuery (optional) 
     * @param orderBy (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @param isEmailSearch (optional) 
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @param getFlagged (optional) 
     * @return Returns if the Users are found and the User Request is Authorized appropriately
     */
    private3(includeSuspended?: boolean | undefined, includeInactive?: boolean | undefined, searchQuery?: string | undefined, orderBy?: UserOrderBy | undefined, startDate?: Date | undefined, endDate?: Date | undefined, tenantId?: string | undefined, isEmailSearch?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, getFlagged?: boolean | undefined, cancelToken?: CancelToken): Promise<RentMyUserSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/User/private?";
        if (includeSuspended === null)
            throw new Error("The parameter 'includeSuspended' cannot be null.");
        else if (includeSuspended !== undefined)
            url_ += "includeSuspended=" + encodeURIComponent("" + includeSuspended) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (isEmailSearch === null)
            throw new Error("The parameter 'isEmailSearch' cannot be null.");
        else if (isEmailSearch !== undefined)
            url_ += "isEmailSearch=" + encodeURIComponent("" + isEmailSearch) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (getFlagged === null)
            throw new Error("The parameter 'getFlagged' cannot be null.");
        else if (getFlagged !== undefined)
            url_ += "getFlagged=" + encodeURIComponent("" + getFlagged) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrivate3(_response);
        });
    }

    protected processPrivate3(response: AxiosResponse): Promise<RentMyUserSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Users in the Detailed format
     * @param includeSuspended (optional) Whether or not you want to Include Suspended Users
     * @param includeInactive (optional) Whether or not you want to Include Inactive Items
     * @param searchQuery (optional) 
     * @param orderBy (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Users are found and the User Request is Authorized appropriately
     */
    detailed54(includeSuspended?: boolean | undefined, includeInactive?: boolean | undefined, searchQuery?: string | undefined, orderBy?: UserOrderBy | undefined, startDate?: Date | undefined, endDate?: Date | undefined, tenantId?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/User/private/detailed?";
        if (includeSuspended === null)
            throw new Error("The parameter 'includeSuspended' cannot be null.");
        else if (includeSuspended !== undefined)
            url_ += "includeSuspended=" + encodeURIComponent("" + includeSuspended) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed54(_response);
        });
    }

    protected processDetailed54(response: AxiosResponse): Promise<RentMyUserDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Gets a Simple UserDto with expanded information about Location, Friends etc.
     * @param id The Id of the User
     * @return Returns if the User is found and the User Request is Authorized appropriately
     */
    private4(id: string, cancelToken?: CancelToken): Promise<RentMyUserSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/private";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrivate4(_response);
        });
    }

    protected processPrivate4(response: AxiosResponse): Promise<RentMyUserSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserSimpleDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the USer cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserSimpleDto>(null as any);
    }

    /**
     * Gets a Detailed UserDto with expanded information about Location, Friends etc.
     * @param id The Id of the User
     * @return Returns if the User is found and the User Request is Authorized appropriately
     */
    detailed55(id: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/private/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed55(_response);
        });
    }

    protected processDetailed55(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the USer cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Gets all Suspended Users in the Detailed format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Suspended Accounts
     * @param searchQuery (optional) 
     * @param orderBy (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @param isEmailSearch (optional) 
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @return Returns if the Users are found and the User Request is Authorized appropriately
     */
    suspended2(includeInactive?: boolean | undefined, searchQuery?: string | undefined, orderBy?: UserOrderBy | undefined, startDate?: Date | undefined, endDate?: Date | undefined, tenantId?: string | undefined, isEmailSearch?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/User/suspended?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (isEmailSearch === null)
            throw new Error("The parameter 'isEmailSearch' cannot be null.");
        else if (isEmailSearch !== undefined)
            url_ += "isEmailSearch=" + encodeURIComponent("" + isEmailSearch) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSuspended2(_response);
        });
    }

    protected processSuspended2(response: AxiosResponse): Promise<RentMyUserDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDtoPaginationDto>(null as any);
    }

    /**
     * @param orderBy (optional) 
     * @param showInactive (optional) 
     * @param searchQuery (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    adminSearch2(orderBy?: UserOrderBy | undefined, showInactive?: boolean | undefined, searchQuery?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<UserAdminSearchDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/User/adminSearch?";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (showInactive === null)
            throw new Error("The parameter 'showInactive' cannot be null.");
        else if (showInactive !== undefined)
            url_ += "showInactive=" + encodeURIComponent("" + showInactive) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdminSearch2(_response);
        });
    }

    protected processAdminSearch2(response: AxiosResponse): Promise<UserAdminSearchDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserAdminSearchDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<UserAdminSearchDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAdminSearchDtoPaginationDto>(null as any);
    }

    /**
     * @param searchQuery (optional) 
     * @return Success
     */
    asCSV5(searchQuery?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/asCSV?";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAsCSV5(_response);
        });
    }

    protected processAsCSV5(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    role(id: string, cancelToken?: CancelToken): Promise<RentMyRole> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/role";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRole(_response);
        });
    }

    protected processRole(response: AxiosResponse): Promise<RentMyRole> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<RentMyRole>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyRole>(null as any);
    }

    /**
     * Creates a new User
     * @param body (optional) Role is an enum and can be assigned the non-spaced name of the enum rather than the index.
     * @return Returns if the User is Created, also returns a DetailedDto of the newly created User
     */
    createPOST29(body?: UserCreateDto | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST29(_response);
        });
    }

    protected processCreatePOST29(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Updates an existing User
     * @param id (optional) The Id of the User being updated (Staff only)
     * @param body (optional) A Dictionairy containing the information to update the User with
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    update26(id?: string | undefined, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/User/update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate26(_response);
        });
    }

    protected processUpdate26(response: AxiosResponse): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    makeAnonymous(id: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/make-anonymous";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMakeAnonymous(_response);
        });
    }

    protected processMakeAnonymous(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * @param newName (optional) 
     * @return Success
     */
    changeName(id: string, newName?: string | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/change-name?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (newName === null)
            throw new Error("The parameter 'newName' cannot be null.");
        else if (newName !== undefined)
            url_ += "newName=" + encodeURIComponent("" + newName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeName(_response);
        });
    }

    protected processChangeName(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * @param newEmail (optional) 
     * @return Success
     */
    changeEmailAddress(id: string, newEmail?: string | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/change-email-address?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (newEmail === null)
            throw new Error("The parameter 'newEmail' cannot be null.");
        else if (newEmail !== undefined)
            url_ += "newEmail=" + encodeURIComponent("" + newEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeEmailAddress(_response);
        });
    }

    protected processChangeEmailAddress(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param accountType (optional) 
     * @return Success
     */
    changeType2(id?: string | undefined, accountType?: AccountType | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/User/change-type?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (accountType === null)
            throw new Error("The parameter 'accountType' cannot be null.");
        else if (accountType !== undefined)
            url_ += "accountType=" + encodeURIComponent("" + accountType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeType2(_response);
        });
    }

    protected processChangeType2(response: AxiosResponse): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    wallet(id?: string | undefined, cancelToken?: CancelToken): Promise<WalletDto> {
        let url_ = this.baseUrl + "/api/v1/User/wallet?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWallet(_response);
        });
    }

    protected processWallet(response: AxiosResponse): Promise<WalletDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WalletDto.fromJS(resultData200);
            return Promise.resolve<WalletDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WalletDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    payout(id?: string | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/User/payout?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayout(_response);
        });
    }

    protected processPayout(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    onboardStripe(id?: string | undefined, body?: StripeOnboardingRedirects | undefined, cancelToken?: CancelToken): Promise<AccountLinkDto> {
        let url_ = this.baseUrl + "/api/v1/User/onboard-stripe?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOnboardStripe(_response);
        });
    }

    protected processOnboardStripe(response: AxiosResponse): Promise<AccountLinkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountLinkDto.fromJS(resultData200);
            return Promise.resolve<AccountLinkDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountLinkDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param newStripeID (optional) 
     * @param iDtype (optional) 
     * @return Success
     */
    updateStripeId(userId?: string | undefined, newStripeID?: string | undefined, iDtype?: string | undefined, cancelToken?: CancelToken): Promise<HttpResponseMessage> {
        let url_ = this.baseUrl + "/api/v1/User/update-stripe-id?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (newStripeID === null)
            throw new Error("The parameter 'newStripeID' cannot be null.");
        else if (newStripeID !== undefined)
            url_ += "NewStripeID=" + encodeURIComponent("" + newStripeID) + "&";
        if (iDtype === null)
            throw new Error("The parameter 'iDtype' cannot be null.");
        else if (iDtype !== undefined)
            url_ += "IDtype=" + encodeURIComponent("" + iDtype) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStripeId(_response);
        });
    }

    protected processUpdateStripeId(response: AxiosResponse): Promise<HttpResponseMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HttpResponseMessage.fromJS(resultData200);
            return Promise.resolve<HttpResponseMessage>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpResponseMessage>(null as any);
    }

    /**
     * @return Success
     */
    deleteStripe( cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/delete-stripe";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStripe(_response);
        });
    }

    protected processDeleteStripe(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    deleteStripe2(stripeId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/delete-stripe/{stripeId}";
        if (stripeId === undefined || stripeId === null)
            throw new Error("The parameter 'stripeId' must be defined.");
        url_ = url_.replace("{stripeId}", encodeURIComponent("" + stripeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStripe2(_response);
        });
    }

    protected processDeleteStripe2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    unverify(id: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/unverify";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnverify(_response);
        });
    }

    protected processUnverify(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return Success
     */
    addStripeBank(userId?: string | undefined, body?: string | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/add-stripe-bank?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddStripeBank(_response);
        });
    }

    protected processAddStripeBank(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    listStripeBanks(userId?: string | undefined, cancelToken?: CancelToken): Promise<BankAccountDto[]> {
        let url_ = this.baseUrl + "/api/v1/User/list-stripe-banks?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListStripeBanks(_response);
        });
    }

    protected processListStripeBanks(response: AxiosResponse): Promise<BankAccountDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankAccountDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BankAccountDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BankAccountDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param bankAccountId (optional) 
     * @return Success
     */
    deleteStripeBank(userId?: string | undefined, bankAccountId?: string | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/delete-stripe-bank?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (bankAccountId === null)
            throw new Error("The parameter 'bankAccountId' cannot be null.");
        else if (bankAccountId !== undefined)
            url_ += "bankAccountId=" + encodeURIComponent("" + bankAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStripeBank(_response);
        });
    }

    protected processDeleteStripeBank(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Takes a Dictionairy of LinkTypes and Urls, filling the appropriate Username and Url for that Social Media Platform.
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateLinks(id?: string | undefined, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/User/update-links?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLinks(_response);
        });
    }

    protected processUpdateLinks(response: AxiosResponse): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param moderatorIds (optional) 
     * @param userId (optional) 
     * @return Success
     */
    addModerators(businessAccountId: string, moderatorIds?: string[] | undefined, userId?: string | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/add-moderators/{businessAccountId}?";
        if (businessAccountId === undefined || businessAccountId === null)
            throw new Error("The parameter 'businessAccountId' must be defined.");
        url_ = url_.replace("{businessAccountId}", encodeURIComponent("" + businessAccountId));
        if (moderatorIds === null)
            throw new Error("The parameter 'moderatorIds' cannot be null.");
        else if (moderatorIds !== undefined)
            moderatorIds && moderatorIds.forEach(item => { url_ += "moderatorIds=" + encodeURIComponent("" + item) + "&"; });
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddModerators(_response);
        });
    }

    protected processAddModerators(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * @param moderatorIds (optional) 
     * @param userId (optional) 
     * @return Success
     */
    removeModerators(businessAccountId: string, moderatorIds?: string[] | undefined, userId?: string | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/remove-moderators/{businessAccountId}?";
        if (businessAccountId === undefined || businessAccountId === null)
            throw new Error("The parameter 'businessAccountId' must be defined.");
        url_ = url_.replace("{businessAccountId}", encodeURIComponent("" + businessAccountId));
        if (moderatorIds === null)
            throw new Error("The parameter 'moderatorIds' cannot be null.");
        else if (moderatorIds !== undefined)
            moderatorIds && moderatorIds.forEach(item => { url_ += "moderatorIds=" + encodeURIComponent("" + item) + "&"; });
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveModerators(_response);
        });
    }

    protected processRemoveModerators(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Changes a Users Profile BrandImage
     * @param imageId The Id of the BrandImage the Users Profile BrandImage is being changed to
     * @param userId (optional) The Id of the User having their Profile BrandImage changed
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    changeProfileImage(imageId: string, userId?: string | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/change-profile-image/{imageId}?";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeProfileImage(_response);
        });
    }

    protected processChangeProfileImage(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Removes a Users Profile BrandImage
     * @param userId (optional) 
     * @return Success
     */
    removeProfileImage(userId?: string | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/remove-profile-image?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveProfileImage(_response);
        });
    }

    protected processRemoveProfileImage(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Change a Users Banner BrandImage
     * @param userId (optional) 
     * @param imageId (optional) 
     * @return Success
     */
    changeBannerImage(userId?: string | undefined, imageId?: string | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/change-banner-image?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (imageId === null)
            throw new Error("The parameter 'imageId' cannot be null.");
        else if (imageId !== undefined)
            url_ += "imageId=" + encodeURIComponent("" + imageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeBannerImage(_response);
        });
    }

    protected processChangeBannerImage(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Removes the Currently Logged in Users Banner BrandImage
     * @param userId (optional) 
     * @return Success
     */
    removeBannerImage(userId?: string | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/remove-banner-image?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveBannerImage(_response);
        });
    }

    protected processRemoveBannerImage(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Updates the Users Location
     * @param userId (optional) 
     * @param body (optional) 
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    changeLocationPOST2(userId?: string | undefined, body?: Location | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/User/change-location?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeLocationPOST2(_response);
        });
    }

    protected processChangeLocationPOST2(response: AxiosResponse): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Adds a List of Locations to the Users Favourites
     * @param userId (optional) The Id of the User
     * @param locations (optional) The list of Locations being added
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addFavouriteLocations(userId?: string | undefined, locations?: Location[] | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/add-favourite-locations?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (locations === null)
            throw new Error("The parameter 'locations' cannot be null.");
        else if (locations !== undefined)
            locations && locations.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "locations[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFavouriteLocations(_response);
        });
    }

    protected processAddFavouriteLocations(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Takes a UserId and a List of Locations and removes them from the Users Favourite Location List
     * @param userId (optional) The Id of the User
     * @param locations (optional) The list of Locations being removed
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeFavouriteLocations(userId?: string | undefined, locations?: Location[] | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/remove-favourite-locations?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (locations === null)
            throw new Error("The parameter 'locations' cannot be null.");
        else if (locations !== undefined)
            locations && locations.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "locations[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFavouriteLocations(_response);
        });
    }

    protected processRemoveFavouriteLocations(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Takes a UserId and a List of Items and adds them to the Users Favourite Items List
     * @param userId (optional) The Id of the User
     * @param itemIds (optional) The List containing the Favourited ItemIds being added
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addFavouriteItems(userId?: string | undefined, itemIds?: string[] | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/User/add-favourite-items?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (itemIds === null)
            throw new Error("The parameter 'itemIds' cannot be null.");
        else if (itemIds !== undefined)
            itemIds && itemIds.forEach(item => { url_ += "itemIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFavouriteItems(_response);
        });
    }

    protected processAddFavouriteItems(response: AxiosResponse): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Takes a UserId and a List of ItemIds and removes them from the Users Favourite Items List
     * @param userId (optional) The Id of the User
     * @param itemIds (optional) The List containing the Favourited ItemIds that are being removed
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeFavouriteItems(userId?: string | undefined, itemIds?: string[] | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/remove-favourite-items?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (itemIds === null)
            throw new Error("The parameter 'itemIds' cannot be null.");
        else if (itemIds !== undefined)
            itemIds && itemIds.forEach(item => { url_ += "itemIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFavouriteItems(_response);
        });
    }

    protected processRemoveFavouriteItems(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Takes a UserId and adds it to the Signed in Users Friend List
     * @param userId The Id of the User being added
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addFriend(userId: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/User/add-friend/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFriend(_response);
        });
    }

    protected processAddFriend(response: AxiosResponse): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Takes a UserId and removed it from the Signed in Users Friend List
     * @param userId The Id of the User being added
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeFriend(userId: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/remove-friend/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFriend(_response);
        });
    }

    protected processRemoveFriend(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Takes a UserId and adds the User to the Currently Signed in Users Follow List
     * @param userId The Id of the User being added
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    followUser(userId: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/follow-user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFollowUser(_response);
        });
    }

    protected processFollowUser(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Takes a UserId and removes the User from the Currently Signed in Users Follow List
     * @param userId The Id of the User being added
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    unfollowUser(userId: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/unfollow-user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnfollowUser(_response);
        });
    }

    protected processUnfollowUser(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Blocks the User given by the Id
     * @param userId The Id of the User being blocked
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    blockUser(userId: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/User/block-user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBlockUser(_response);
        });
    }

    protected processBlockUser(response: AxiosResponse): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Unblocks the User given by the Id
     * @param userId The Id of the User being unblocked
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    unblockUsers(userId: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/unblock-users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnblockUsers(_response);
        });
    }

    protected processUnblockUsers(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Allows a User to save their searches
     * @param body (optional) 
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    saveSearch(body?: SavedSearchCreateDto | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/User/save-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSearch(_response);
        });
    }

    protected processSaveSearch(response: AxiosResponse): Promise<RentMyUserDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Removes a Saved Search from the User
     * @param savedSearchId The Id of the SavedSearch
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removeSavedSearch(savedSearchId: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/remove-saved-search/{savedSearchId}";
        if (savedSearchId === undefined || savedSearchId === null)
            throw new Error("The parameter 'savedSearchId' must be defined.");
        url_ = url_.replace("{savedSearchId}", encodeURIComponent("" + savedSearchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveSavedSearch(_response);
        });
    }

    protected processRemoveSavedSearch(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Adds an Item to the Users Watchlist
     * @param itemId The Id of the Item being Watched
     * @param watchEnd (optional) A DateTime of when the Watch Period will end is Nullable
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    watchItem(itemId: string, watchEnd?: Date | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/watch-item/{itemId}?";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (watchEnd === null)
            throw new Error("The parameter 'watchEnd' cannot be null.");
        else if (watchEnd !== undefined)
            url_ += "watchEnd=" + encodeURIComponent(watchEnd ? "" + watchEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWatchItem(_response);
        });
    }

    protected processWatchItem(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Removes an Item from the Users WatchList
     * @param itemId The Id of the Item being Watched
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    unwatchItem(itemId: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/unwatch-item/{itemId}";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnwatchItem(_response);
        });
    }

    protected processUnwatchItem(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Changes the Role of the User
     * @param role (optional) 
     * @return Returns if the User is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    changeRole(id: string, role?: RentMyRole | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/change-role?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeRole(_response);
        });
    }

    protected processChangeRole(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the User cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verification(body?: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/User/verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerification(_response);
        });
    }

    protected processVerification(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    verificationCheck(id?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/User/verification-check?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerificationCheck(_response);
        });
    }

    protected processVerificationCheck(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    passwordReset(id?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/password-reset?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPasswordReset(_response);
        });
    }

    protected processPasswordReset(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    reviews(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ReviewDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/reviews?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReviews(_response);
        });
    }

    protected processReviews(response: AxiosResponse): Promise<ReviewDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReviewDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ReviewDetailedDtoPaginationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReviewDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Disables an existing User
     * @return Success
     */
    delete30(id: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete30(_response);
        });
    }

    protected processDelete30(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate19(id: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate19(_response);
        });
    }

    protected processReactivate19(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Blocks a User from logging in on Auth0
     * @return Success
     */
    block(id: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/block";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBlock(_response);
        });
    }

    protected processBlock(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * disables, sets items to inactive, and suspends auth0 account for a user. Sends emails to user and admin.
     * @return Success
     */
    userDelete(id: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/userDelete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserDelete(_response);
        });
    }

    protected processUserDelete(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Unblocks a User on Auth0
     * @return Success
     */
    unblock(id: string, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/unblock";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnblock(_response);
        });
    }

    protected processUnblock(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a User
     * @param id (optional) 
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes22(id?: string | undefined, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/User/changes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges22(_response);
        });
    }

    protected processChanges22(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }

    /**
     * @param formFile (optional) 
     * @return Success
     */
    import(formFile?: FileParameter | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto[]> {
        let url_ = this.baseUrl + "/api/v1/User/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile === null || formFile === undefined)
            throw new Error("The parameter 'formFile' cannot be null.");
        else
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImport(_response);
        });
    }

    protected processImport(response: AxiosResponse): Promise<RentMyUserDetailedDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RentMyUserDetailedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RentMyUserDetailedDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto[]>(null as any);
    }

    /**
     * @return Success
     */
    checkOnboarding( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/check-onboarding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckOnboarding(_response);
        });
    }

    protected processCheckOnboarding(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    checkUserIntention( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/check-user-intention";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckUserIntention(_response);
        });
    }

    protected processCheckUserIntention(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getPhoneNumbers( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/get-phone-numbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPhoneNumbers(_response);
        });
    }

    protected processGetPhoneNumbers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    removeDuplicates( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/remove-duplicates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveDuplicates(_response);
        });
    }

    protected processRemoveDuplicates(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    generateSignalR( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/generateSignalR";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateSignalR(_response);
        });
    }

    protected processGenerateSignalR(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    flagUser(id: string, cancelToken?: CancelToken): Promise<RentMyUserSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/flagUser";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlagUser(_response);
        });
    }

    protected processFlagUser(response: AxiosResponse): Promise<RentMyUserSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserSimpleDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserSimpleDto>(null as any);
    }

    /**
     * @return Success
     */
    resolveFlaggedUser(id: string, cancelToken?: CancelToken): Promise<RentMyUserSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/resolveFlaggedUser";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolveFlaggedUser(_response);
        });
    }

    protected processResolveFlaggedUser(response: AxiosResponse): Promise<RentMyUserSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserSimpleDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserSimpleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPentestAccounts(body?: PenTestAccountCreateDto | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto[]> {
        let url_ = this.baseUrl + "/api/v1/User/create-pentest-accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePentestAccounts(_response);
        });
    }

    protected processCreatePentestAccounts(response: AxiosResponse): Promise<RentMyUserDetailedDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RentMyUserDetailedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RentMyUserDetailedDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto[]>(null as any);
    }

    /**
     * @param emailAddresses (optional) 
     * @return Success
     */
    createMailchimp(emailAddresses?: string[] | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/create-mailchimp?";
        if (emailAddresses === null)
            throw new Error("The parameter 'emailAddresses' cannot be null.");
        else if (emailAddresses !== undefined)
            emailAddresses && emailAddresses.forEach(item => { url_ += "emailAddresses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMailchimp(_response);
        });
    }

    protected processCreateMailchimp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    clearUser(id: string, name?: string | undefined, cancelToken?: CancelToken): Promise<RentMyUserDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}/clear-user?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearUser(_response);
        });
    }

    protected processClearUser(response: AxiosResponse): Promise<RentMyUserDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RentMyUserDetailedDto.fromJS(resultData200);
            return Promise.resolve<RentMyUserDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentMyUserDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    massEnableEmails( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/mass-enable-emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassEnableEmails(_response);
        });
    }

    protected processMassEnableEmails(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    giveFiveStarsToUnreviewed( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/give-five-stars-to-unreviewed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGiveFiveStarsToUnreviewed(_response);
        });
    }

    protected processGiveFiveStarsToUnreviewed(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    removeNameWhitespace( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/remove-name-whitespace";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveNameWhitespace(_response);
        });
    }

    protected processRemoveNameWhitespace(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    requestEmailVerification( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/User/request-email-verification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestEmailVerification(_response);
        });
    }

    protected processRequestEmailVerification(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VoucherClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets a Simple Voucher
     * @param id The Id of a Voucher
     * @return Returns if the Voucher is found and the User is Authorized appropriately
     */
    voucher(id: string, cancelToken?: CancelToken): Promise<VoucherSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVoucher(_response);
        });
    }

    protected processVoucher(response: AxiosResponse): Promise<VoucherSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherSimpleDto.fromJS(resultData200);
            return Promise.resolve<VoucherSimpleDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Voucher cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherSimpleDto>(null as any);
    }

    /**
     * Gets a Limited Voucher from its Code
     * @param code The Code of a Voucher
     * @return Returns if the Voucher is found and the User is Authorized appropriately
     */
    fromCode(code: string, cancelToken?: CancelToken): Promise<LimitedVoucherDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/fromCode/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFromCode(_response);
        });
    }

    protected processFromCode(response: AxiosResponse): Promise<LimitedVoucherDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LimitedVoucherDto.fromJS(resultData200);
            return Promise.resolve<LimitedVoucherDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Voucher cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LimitedVoucherDto>(null as any);
    }

    /**
     * Gets a Detailed Voucher
     * @param id The Id of a Voucher
     * @return Returns if the Voucher is found and the User is Authorized appropriately
     */
    detailed56(id: string, cancelToken?: CancelToken): Promise<VoucherDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed56(_response);
        });
    }

    protected processDetailed56(response: AxiosResponse): Promise<VoucherDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherDetailedDto.fromJS(resultData200);
            return Promise.resolve<VoucherDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Voucher cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherDetailedDto>(null as any);
    }

    /**
     * Gets all Vouchers in the Simple format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Accounts, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @param searchQuery (optional) Query the database.
     * @param orderby (optional) How should the results be ordered.
     * @return Returns if the Voucher is found and the User is Authorized appropriately
     */
    voucher2(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, searchQuery?: string | undefined, orderby?: VoucherOrderBy | undefined, cancelToken?: CancelToken): Promise<VoucherSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "Orderby=" + encodeURIComponent("" + orderby) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVoucher2(_response);
        });
    }

    protected processVoucher2(response: AxiosResponse): Promise<VoucherSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<VoucherSimpleDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Voucher cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Gets all Vouchers in the Detailed format
     * @param includeInactive (optional) Whether or not you want to Include Inactive Accounts, useful for Admins/Moderators
     * @param pageSize (optional) How much data you want to see on each page
     * @param page (optional) The page number you want to start from
     * @param searchQuery (optional) The search query you'd like to use
     * @param orderBy (optional) How you want to order the items returned
     * @return Returns if the Voucher is found and the User is Authorized appropriately
     */
    detailed57(includeInactive?: boolean | undefined, pageSize?: number | undefined, page?: number | undefined, searchQuery?: string | undefined, orderBy?: VoucherOrderBy | undefined, cancelToken?: CancelToken): Promise<VoucherDetailedDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/detailed?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (searchQuery === null)
            throw new Error("The parameter 'searchQuery' cannot be null.");
        else if (searchQuery !== undefined)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed57(_response);
        });
    }

    protected processDetailed57(response: AxiosResponse): Promise<VoucherDetailedDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherDetailedDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<VoucherDetailedDtoPaginationDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Returns if the request is valid but the Voucher cannot be found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherDetailedDtoPaginationDto>(null as any);
    }

    /**
     * Creates a new Voucher
     * @param body (optional) 
     * @return Returns if the Voucher is Created, also returns a DetailedDto of the newly created voucher
     */
    createPOST30(body?: VoucherCreateDto | undefined, cancelToken?: CancelToken): Promise<VoucherDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST30(_response);
        });
    }

    protected processCreatePOST30(response: AxiosResponse): Promise<VoucherDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherDetailedDto.fromJS(resultData200);
            return Promise.resolve<VoucherDetailedDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherDetailedDto>(null as any);
    }

    /**
     * Updates an existing Voucher
     * @param id The Id of the Voucher being Updated
     * @param body (optional) A Dictionairy of Changes to be made to the Voucher
     * @return Returns if the Voucher is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    update27(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<VoucherDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate27(_response);
        });
    }

    protected processUpdate27(response: AxiosResponse): Promise<VoucherDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<VoucherDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Assigns users to the voucher.
     * @param id The Id of the Voucher being Updated
     * @param body (optional) A list containing all assigned users
     * @return Returns if the Voucher is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addPUT2(id: string, body?: string[] | undefined, cancelToken?: CancelToken): Promise<VoucherDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/{id}/update/users/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPUT2(_response);
        });
    }

    protected processAddPUT2(response: AxiosResponse): Promise<VoucherDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<VoucherDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Unassignes users from the voucher.
     * @param id The Id of the Voucher being Updated
     * @param body (optional) A list containing all assigned users
     * @return Returns if the Voucher is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removePUT2(id: string, body?: string[] | undefined, cancelToken?: CancelToken): Promise<VoucherDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/{id}/update/users/remove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemovePUT2(_response);
        });
    }

    protected processRemovePUT2(response: AxiosResponse): Promise<VoucherDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<VoucherDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Assigns items to the voucher.
     * @param id The Id of the Voucher being Updated
     * @param body (optional) A list containing all assigned items
     * @return Returns if the Voucher is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    addPUT3(id: string, body?: string[] | undefined, cancelToken?: CancelToken): Promise<VoucherDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/{id}/update/items/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPUT3(_response);
        });
    }

    protected processAddPUT3(response: AxiosResponse): Promise<VoucherDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<VoucherDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * Unassignes items from the voucher.
     * @param id The Id of the Voucher being Updated
     * @param body (optional) A list containing all assigned items
     * @return Returns if the Voucher is Updated successfully, also returns a Detailed Dto of the newly updated object
     */
    removePUT3(id: string, body?: string[] | undefined, cancelToken?: CancelToken): Promise<VoucherDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/{id}/update/items/remove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemovePUT3(_response);
        });
    }

    protected processRemovePUT3(response: AxiosResponse): Promise<VoucherDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<VoucherDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Returns if there is an error within the request", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Returns if the request requires missing Authentication Credentials", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Returns if the Authentication is present but the User does not have Permission", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    redeem(voucherId: string, cancelToken?: CancelToken): Promise<VoucherRedemptionDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/{voucherId}/redeem";
        if (voucherId === undefined || voucherId === null)
            throw new Error("The parameter 'voucherId' must be defined.");
        url_ = url_.replace("{voucherId}", encodeURIComponent("" + voucherId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRedeem(_response);
        });
    }

    protected processRedeem(response: AxiosResponse): Promise<VoucherRedemptionDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherRedemptionDetailedDto.fromJS(resultData200);
            return Promise.resolve<VoucherRedemptionDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherRedemptionDetailedDto>(null as any);
    }

    /**
     * Disables an existing Voucher
     * @return Success
     */
    delete31(id: string, cancelToken?: CancelToken): Promise<VoucherDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete31(_response);
        });
    }

    protected processDelete31(response: AxiosResponse): Promise<VoucherDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherDetailedDto.fromJS(resultData200);
            return Promise.resolve<VoucherDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    reactivate20(id: string, cancelToken?: CancelToken): Promise<VoucherDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/Voucher/{id}/reactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivate20(_response);
        });
    }

    protected processReactivate20(response: AxiosResponse): Promise<VoucherDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VoucherDetailedDto.fromJS(resultData200);
            return Promise.resolve<VoucherDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VoucherDetailedDto>(null as any);
    }

    /**
     * Gets all Changes made to a Voucher
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    changes23(id: string, pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ChangeDto[]> {
        let url_ = this.baseUrl + "/api/v1/Voucher/{id}/changes?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChanges23(_response);
        });
    }

    protected processChanges23(response: AxiosResponse): Promise<ChangeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChangeDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    signup( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Voucher/signup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignup(_response);
        });
    }

    protected processSignup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    cleanup(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Voucher/{id}/cleanup";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCleanup(_response);
        });
    }

    protected processCleanup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WordFilterClient extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Filter through given filter request
     * @param body (optional) Text and Parameters to filter it by
     * @return Success
     */
    filter(body?: FilterTextRequest | undefined, cancelToken?: CancelToken): Promise<FilterReturn> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFilter(_response);
        });
    }

    protected processFilter(response: AxiosResponse): Promise<FilterReturn> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterReturn.fromJS(resultData200);
            return Promise.resolve<FilterReturn>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterReturn>(null as any);
    }

    /**
     * Get All filtered words
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    words(pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<FilteredWordSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/words?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWords(_response);
        });
    }

    protected processWords(response: AxiosResponse): Promise<FilteredWordSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredWordSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<FilteredWordSimpleDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredWordSimpleDtoPaginationDto>(null as any);
    }

    /**
     * Get a single filtered word by ID
     * @return Success
     */
    words2(id: string, cancelToken?: CancelToken): Promise<FilteredWordSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/words/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWords2(_response);
        });
    }

    protected processWords2(response: AxiosResponse): Promise<FilteredWordSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredWordSimpleDto.fromJS(resultData200);
            return Promise.resolve<FilteredWordSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredWordSimpleDto>(null as any);
    }

    /**
     * Get a single filtered word by ID in detailed format
     * @return Success
     */
    detailed58(id: string, cancelToken?: CancelToken): Promise<FilteredWordDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/words/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed58(_response);
        });
    }

    protected processDetailed58(response: AxiosResponse): Promise<FilteredWordDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredWordDetailedDto.fromJS(resultData200);
            return Promise.resolve<FilteredWordDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredWordDetailedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST31(body?: FilteredWordCreateDto | undefined, cancelToken?: CancelToken): Promise<FilteredWordDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/words/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST31(_response);
        });
    }

    protected processCreatePOST31(response: AxiosResponse): Promise<FilteredWordDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredWordDetailedDto.fromJS(resultData200);
            return Promise.resolve<FilteredWordDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredWordDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    removeDELETE(id: string, cancelToken?: CancelToken): Promise<FilteredWordDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/words/{id}/remove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveDELETE(_response);
        });
    }

    protected processRemoveDELETE(response: AxiosResponse): Promise<FilteredWordDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredWordDetailedDto.fromJS(resultData200);
            return Promise.resolve<FilteredWordDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredWordDetailedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update28(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<FilteredWordDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/words/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate28(_response);
        });
    }

    protected processUpdate28(response: AxiosResponse): Promise<FilteredWordDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredWordDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<FilteredWordDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredWordDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    excluded(pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<ExcludedWordsSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/excluded?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcluded(_response);
        });
    }

    protected processExcluded(response: AxiosResponse): Promise<ExcludedWordsSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExcludedWordsSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<ExcludedWordsSimpleDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExcludedWordsSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    excluded2(id: string, cancelToken?: CancelToken): Promise<ExcludedWordsSimpleDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/excluded/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExcluded2(_response);
        });
    }

    protected processExcluded2(response: AxiosResponse): Promise<ExcludedWordsSimpleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExcludedWordsSimpleDto.fromJS(resultData200);
            return Promise.resolve<ExcludedWordsSimpleDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExcludedWordsSimpleDto>(null as any);
    }

    /**
     * @return Success
     */
    detailed59(id: string, cancelToken?: CancelToken): Promise<ExcludedWordsDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/excluded/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed59(_response);
        });
    }

    protected processDetailed59(response: AxiosResponse): Promise<ExcludedWordsDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExcludedWordsDetailedDto.fromJS(resultData200);
            return Promise.resolve<ExcludedWordsDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExcludedWordsDetailedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST32(body?: ExcludedWordsCreateDto | undefined, cancelToken?: CancelToken): Promise<ExcludedWordsDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/excluded/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST32(_response);
        });
    }

    protected processCreatePOST32(response: AxiosResponse): Promise<ExcludedWordsDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExcludedWordsDetailedDto.fromJS(resultData200);
            return Promise.resolve<ExcludedWordsDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExcludedWordsDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    removeDELETE2(id: string, cancelToken?: CancelToken): Promise<ExcludedWordsDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/excluded/{id}/remove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveDELETE2(_response);
        });
    }

    protected processRemoveDELETE2(response: AxiosResponse): Promise<ExcludedWordsDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExcludedWordsDetailedDto.fromJS(resultData200);
            return Promise.resolve<ExcludedWordsDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExcludedWordsDetailedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update29(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<ExcludedWordsDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/excluded/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate29(_response);
        });
    }

    protected processUpdate29(response: AxiosResponse): Promise<ExcludedWordsDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExcludedWordsDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<ExcludedWordsDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExcludedWordsDetailedDtoUpdateResponseDto>(null as any);
    }

    /**
     * @param pageSize (optional) 
     * @param page (optional) 
     * @return Success
     */
    letters(pageSize?: number | undefined, page?: number | undefined, cancelToken?: CancelToken): Promise<FilteredWordLettersPublicSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/letters?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLetters(_response);
        });
    }

    protected processLetters(response: AxiosResponse): Promise<FilteredWordLettersPublicSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredWordLettersPublicSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<FilteredWordLettersPublicSimpleDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredWordLettersPublicSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    letters2(id: string, cancelToken?: CancelToken): Promise<FilteredWordLettersSimpleDtoPaginationDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/letters/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLetters2(_response);
        });
    }

    protected processLetters2(response: AxiosResponse): Promise<FilteredWordLettersSimpleDtoPaginationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredWordLettersSimpleDtoPaginationDto.fromJS(resultData200);
            return Promise.resolve<FilteredWordLettersSimpleDtoPaginationDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredWordLettersSimpleDtoPaginationDto>(null as any);
    }

    /**
     * @return Success
     */
    detailed60(id: string, cancelToken?: CancelToken): Promise<FilteredWordLettersDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/letters/{id}/detailed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetailed60(_response);
        });
    }

    protected processDetailed60(response: AxiosResponse): Promise<FilteredWordLettersDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredWordLettersDetailedDto.fromJS(resultData200);
            return Promise.resolve<FilteredWordLettersDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredWordLettersDetailedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPOST33(body?: FilteredWordLettersCreateDto | undefined, cancelToken?: CancelToken): Promise<FilteredWordLettersDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/letters/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePOST33(_response);
        });
    }

    protected processCreatePOST33(response: AxiosResponse): Promise<FilteredWordLettersDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredWordLettersDetailedDto.fromJS(resultData200);
            return Promise.resolve<FilteredWordLettersDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredWordLettersDetailedDto>(null as any);
    }

    /**
     * @return Success
     */
    removeDELETE3(id: string, cancelToken?: CancelToken): Promise<FilteredWordLettersDetailedDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/letters/{id}/remove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveDELETE3(_response);
        });
    }

    protected processRemoveDELETE3(response: AxiosResponse): Promise<FilteredWordLettersDetailedDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredWordLettersDetailedDto.fromJS(resultData200);
            return Promise.resolve<FilteredWordLettersDetailedDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredWordLettersDetailedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update30(id: string, body?: { [key: string]: string; } | undefined, cancelToken?: CancelToken): Promise<FilteredWordLettersDetailedDtoUpdateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/WordFilter/letters/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate30(_response);
        });
    }

    protected processUpdate30(response: AxiosResponse): Promise<FilteredWordLettersDetailedDtoUpdateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredWordLettersDetailedDtoUpdateResponseDto.fromJS(resultData200);
            return Promise.resolve<FilteredWordLettersDetailedDtoUpdateResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredWordLettersDetailedDtoUpdateResponseDto>(null as any);
    }
}

export class AcceptedTermsDto implements IAcceptedTermsDto {
    id!: string;
    user!: RentMyUserSimpleDto;
    terms!: TermsSimpleDto;

    constructor(data?: IAcceptedTermsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserSimpleDto(data.user) : <RentMyUserSimpleDto>this.user;
            this.terms = data.terms && !(<any>data.terms).toJSON ? new TermsSimpleDto(data.terms) : <TermsSimpleDto>this.terms;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? RentMyUserSimpleDto.fromJS(_data["user"]) : <any>undefined;
            this.terms = _data["terms"] ? TermsSimpleDto.fromJS(_data["terms"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AcceptedTermsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptedTermsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["terms"] = this.terms ? this.terms.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAcceptedTermsDto {
    id: string;
    user: IRentMyUserSimpleDto;
    terms: ITermsSimpleDto;
}

export class AcceptedTermsDtoPaginationDto implements IAcceptedTermsDtoPaginationDto {
    data!: AcceptedTermsDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IAcceptedTermsDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new AcceptedTermsDto(item) : <AcceptedTermsDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AcceptedTermsDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): AcceptedTermsDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptedTermsDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IAcceptedTermsDtoPaginationDto {
    data: IAcceptedTermsDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class AccountLinkDto implements IAccountLinkDto {
    url!: string | undefined;
    created!: Date;
    expiresAt!: Date;
    stripeResponse!: StripeResponse;

    constructor(data?: IAccountLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.stripeResponse = data.stripeResponse && !(<any>data.stripeResponse).toJSON ? new StripeResponse(data.stripeResponse) : <StripeResponse>this.stripeResponse;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.stripeResponse = _data["stripeResponse"] ? StripeResponse.fromJS(_data["stripeResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["stripeResponse"] = this.stripeResponse ? this.stripeResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccountLinkDto {
    url: string | undefined;
    created: Date;
    expiresAt: Date;
    stripeResponse: IStripeResponse;
}

export enum AccountType {
    Individual = "Individual",
    Business = "Business",
}

export class AgeGroupData implements IAgeGroupData {
    count!: number;
    stripeSignedUpCount!: number;

    constructor(data?: IAgeGroupData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.stripeSignedUpCount = _data["stripeSignedUpCount"];
        }
    }

    static fromJS(data: any): AgeGroupData {
        data = typeof data === 'object' ? data : {};
        let result = new AgeGroupData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["stripeSignedUpCount"] = this.stripeSignedUpCount;
        return data;
    }
}

export interface IAgeGroupData {
    count: number;
    stripeSignedUpCount: number;
}

export class Agreement implements IAgreement {
    renterAgreed!: boolean;
    buyerAgreed!: boolean;

    constructor(data?: IAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.renterAgreed = _data["renterAgreed"];
            this.buyerAgreed = _data["buyerAgreed"];
        }
    }

    static fromJS(data: any): Agreement {
        data = typeof data === 'object' ? data : {};
        let result = new Agreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["renterAgreed"] = this.renterAgreed;
        data["buyerAgreed"] = this.buyerAgreed;
        return data;
    }
}

export interface IAgreement {
    renterAgreed: boolean;
    buyerAgreed: boolean;
}

export enum Alignment {
    Left = "Left",
    Right = "Right",
    Top = "Top",
    Bottom = "Bottom",
    Center = "Center",
}

export class ApproximateLocation implements IApproximateLocation {
    readonly latitude!: number | undefined;
    readonly longitude!: number | undefined;
    readonly city!: string | undefined;
    readonly country!: string | undefined;
    readonly range!: number;

    constructor(data?: IApproximateLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).latitude = _data["latitude"];
            (<any>this).longitude = _data["longitude"];
            (<any>this).city = _data["city"];
            (<any>this).country = _data["country"];
            (<any>this).range = _data["range"];
        }
    }

    static fromJS(data: any): ApproximateLocation {
        data = typeof data === 'object' ? data : {};
        let result = new ApproximateLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["city"] = this.city;
        data["country"] = this.country;
        data["range"] = this.range;
        return data;
    }
}

export interface IApproximateLocation {
    latitude: number | undefined;
    longitude: number | undefined;
    city: string | undefined;
    country: string | undefined;
    range: number;
}

export class Aspect implements IAspect {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    category!: Category;
    forItem!: boolean;
    forProduct!: boolean;
    dataType!: string | undefined;
    maxLength!: number;
    selectionOnly!: boolean;
    required!: boolean;
    recommended!: boolean;
    multi!: boolean;
    exclusive!: boolean;
    values!: string[] | undefined;

    constructor(data?: IAspect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.category = data.category && !(<any>data.category).toJSON ? new Category(data.category) : <Category>this.category;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["Name"];
            this.category = _data["Category"] ? Category.fromJS(_data["Category"]) : <any>undefined;
            this.forItem = _data["ForItem"];
            this.forProduct = _data["ForProduct"];
            this.dataType = _data["DataType"];
            this.maxLength = _data["MaxLength"];
            this.selectionOnly = _data["SelectionOnly"];
            this.required = _data["Required"];
            this.recommended = _data["Recommended"];
            this.multi = _data["Multi"];
            this.exclusive = _data["exclusive"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): Aspect {
        data = typeof data === 'object' ? data : {};
        let result = new Aspect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["Name"] = this.name;
        data["Category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["ForItem"] = this.forItem;
        data["ForProduct"] = this.forProduct;
        data["DataType"] = this.dataType;
        data["MaxLength"] = this.maxLength;
        data["SelectionOnly"] = this.selectionOnly;
        data["Required"] = this.required;
        data["Recommended"] = this.recommended;
        data["Multi"] = this.multi;
        data["exclusive"] = this.exclusive;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IAspect {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    category: ICategory;
    forItem: boolean;
    forProduct: boolean;
    dataType: string | undefined;
    maxLength: number;
    selectionOnly: boolean;
    required: boolean;
    recommended: boolean;
    multi: boolean;
    exclusive: boolean;
    values: string[] | undefined;
}

export class AspectCreateDto implements IAspectCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    forItem!: boolean;
    forProduct!: boolean;
    dataType!: string | undefined;
    maxLength!: number;
    selectionOnly!: boolean;
    required!: boolean;
    recommended!: boolean;
    multi!: boolean;
    values!: string[] | undefined;
    exclusive!: boolean;

    constructor(data?: IAspectCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.forItem = _data["forItem"];
            this.forProduct = _data["forProduct"];
            this.dataType = _data["dataType"];
            this.maxLength = _data["maxLength"];
            this.selectionOnly = _data["selectionOnly"];
            this.required = _data["required"];
            this.recommended = _data["recommended"];
            this.multi = _data["multi"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            this.exclusive = _data["exclusive"];
        }
    }

    static fromJS(data: any): AspectCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AspectCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["forItem"] = this.forItem;
        data["forProduct"] = this.forProduct;
        data["dataType"] = this.dataType;
        data["maxLength"] = this.maxLength;
        data["selectionOnly"] = this.selectionOnly;
        data["required"] = this.required;
        data["recommended"] = this.recommended;
        data["multi"] = this.multi;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["exclusive"] = this.exclusive;
        return data;
    }
}

export interface IAspectCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    forItem: boolean;
    forProduct: boolean;
    dataType: string | undefined;
    maxLength: number;
    selectionOnly: boolean;
    required: boolean;
    recommended: boolean;
    multi: boolean;
    values: string[] | undefined;
    exclusive: boolean;
}

export class AspectDetailedDto implements IAspectDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    category!: CategorySimpleDto;
    forItem!: boolean;
    forProduct!: boolean;
    dataType!: string | undefined;
    maxLength!: number;
    selectionOnly!: boolean;
    required!: boolean;
    recommended!: boolean;
    multi!: boolean;
    values!: string[] | undefined;

    constructor(data?: IAspectDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.category = data.category && !(<any>data.category).toJSON ? new CategorySimpleDto(data.category) : <CategorySimpleDto>this.category;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.category = _data["category"] ? CategorySimpleDto.fromJS(_data["category"]) : <any>undefined;
            this.forItem = _data["forItem"];
            this.forProduct = _data["forProduct"];
            this.dataType = _data["dataType"];
            this.maxLength = _data["maxLength"];
            this.selectionOnly = _data["selectionOnly"];
            this.required = _data["required"];
            this.recommended = _data["recommended"];
            this.multi = _data["multi"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): AspectDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new AspectDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["forItem"] = this.forItem;
        data["forProduct"] = this.forProduct;
        data["dataType"] = this.dataType;
        data["maxLength"] = this.maxLength;
        data["selectionOnly"] = this.selectionOnly;
        data["required"] = this.required;
        data["recommended"] = this.recommended;
        data["multi"] = this.multi;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IAspectDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    category: ICategorySimpleDto;
    forItem: boolean;
    forProduct: boolean;
    dataType: string | undefined;
    maxLength: number;
    selectionOnly: boolean;
    required: boolean;
    recommended: boolean;
    multi: boolean;
    values: string[] | undefined;
}

export class AspectDetailedDtoUpdateResponseDto implements IAspectDetailedDtoUpdateResponseDto {
    data!: AspectDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IAspectDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new AspectDetailedDto(data.data) : <AspectDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AspectDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): AspectDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AspectDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IAspectDetailedDtoUpdateResponseDto {
    data: IAspectDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class AspectSimpleDto implements IAspectSimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    required!: boolean;
    recommended!: boolean;
    multi!: boolean;
    exclusive!: boolean;
    values!: string[] | undefined;

    constructor(data?: IAspectSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.required = _data["required"];
            this.recommended = _data["recommended"];
            this.multi = _data["multi"];
            this.exclusive = _data["exclusive"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): AspectSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AspectSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["required"] = this.required;
        data["recommended"] = this.recommended;
        data["multi"] = this.multi;
        data["exclusive"] = this.exclusive;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IAspectSimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    required: boolean;
    recommended: boolean;
    multi: boolean;
    exclusive: boolean;
    values: string[] | undefined;
}

export class AspectSimpleDtoPaginationDto implements IAspectSimpleDtoPaginationDto {
    data!: AspectSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IAspectSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new AspectSimpleDto(item) : <AspectSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AspectSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): AspectSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AspectSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IAspectSimpleDtoPaginationDto {
    data: IAspectSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class AvailabilityCreateDto implements IAvailabilityCreateDto {
    active!: boolean | undefined;
    dateTime!: Date;

    constructor(data?: IAvailabilityCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityCreateDto {
    active: boolean | undefined;
    dateTime: Date;
}

export class AvailabilityDetailedDto implements IAvailabilityDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    itemId!: string;
    dateTime!: Date;

    constructor(data?: IAvailabilityDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.itemId = _data["itemId"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["itemId"] = this.itemId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    itemId: string;
    dateTime: Date;
}

export class AvailabilitySimpleDto implements IAvailabilitySimpleDto {
    id!: string;
    active!: boolean;
    itemId!: string;
    dateTime!: Date;

    constructor(data?: IAvailabilitySimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.itemId = _data["itemId"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilitySimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilitySimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["itemId"] = this.itemId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAvailabilitySimpleDto {
    id: string;
    active: boolean;
    itemId: string;
    dateTime: Date;
}

export class BankAccountDto implements IBankAccountDto {
    id!: string | undefined;
    accountHolderName!: string | undefined;
    accountHolderType!: string | undefined;
    accountType!: string | undefined;
    country!: string | undefined;
    currency!: string | undefined;
    defaultForCurrency!: boolean | undefined;
    fingerprint!: string | undefined;
    last4!: string | undefined;
    status!: string | undefined;

    constructor(data?: IBankAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountHolderName = _data["accountHolderName"];
            this.accountHolderType = _data["accountHolderType"];
            this.accountType = _data["accountType"];
            this.country = _data["country"];
            this.currency = _data["currency"];
            this.defaultForCurrency = _data["defaultForCurrency"];
            this.fingerprint = _data["fingerprint"];
            this.last4 = _data["last4"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BankAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountHolderName"] = this.accountHolderName;
        data["accountHolderType"] = this.accountHolderType;
        data["accountType"] = this.accountType;
        data["country"] = this.country;
        data["currency"] = this.currency;
        data["defaultForCurrency"] = this.defaultForCurrency;
        data["fingerprint"] = this.fingerprint;
        data["last4"] = this.last4;
        data["status"] = this.status;
        return data;
    }
}

export interface IBankAccountDto {
    id: string | undefined;
    accountHolderName: string | undefined;
    accountHolderType: string | undefined;
    accountType: string | undefined;
    country: string | undefined;
    currency: string | undefined;
    defaultForCurrency: boolean | undefined;
    fingerprint: string | undefined;
    last4: string | undefined;
    status: string | undefined;
}

export class BannerImage implements IBannerImage {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    image!: Image;
    user!: RentMyUser;

    constructor(data?: IBannerImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.image = data.image && !(<any>data.image).toJSON ? new Image(data.image) : <Image>this.image;
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.image = _data["image"] ? Image.fromJS(_data["image"]) : <any>undefined;
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BannerImage {
        data = typeof data === 'object' ? data : {};
        let result = new BannerImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBannerImage {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    image: IImage;
    user: IRentMyUser;
}

export class BlockedUser implements IBlockedUser {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUser;
    userBlocked!: RentMyUser;

    constructor(data?: IBlockedUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
            this.userBlocked = data.userBlocked && !(<any>data.userBlocked).toJSON ? new RentMyUser(data.userBlocked) : <RentMyUser>this.userBlocked;
        }
        if (!data) {
            this.user = new RentMyUser();
            this.userBlocked = new RentMyUser();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : new RentMyUser();
            this.userBlocked = _data["userBlocked"] ? RentMyUser.fromJS(_data["userBlocked"]) : new RentMyUser();
        }
    }

    static fromJS(data: any): BlockedUser {
        data = typeof data === 'object' ? data : {};
        let result = new BlockedUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userBlocked"] = this.userBlocked ? this.userBlocked.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBlockedUser {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUser;
    userBlocked: IRentMyUser;
}

export class Booking implements IBooking {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    renter!: RentMyUser;
    sharer!: RentMyUser;
    item!: Item;
    paymentAmount!: number;
    serviceFeeAmount!: number;
    depositAmount!: number | undefined;
    discount!: number | undefined;
    currency!: CurrencyIsoCode;
    renterHandOverProposal!: HandOverProposal;
    buyerHandOverProposal!: HandOverProposal;
    acceptedHandOverProposal!: HandOverProposal;
    handOverAgreement!: Agreement;
    completionAgreement!: Agreement;
    bookingStatus!: BookingStatus;
    paymentStatus!: PaymentStatus;
    payoutStatus!: PayoutStatus;
    startingDate!: Date;
    endingDate!: Date;
    isHourly!: boolean;
    pickupImages!: Image[] | undefined;
    dropOffImages!: Image[] | undefined;
    paymentIntentId!: string | undefined;
    vouchers!: Voucher[] | undefined;
    insuranceBreakdown!: InsuranceBreakdown;
    stripeTransfers!: StripeTransfer[] | undefined;
    chargeId!: string | undefined;
    quotallPolicyReference!: string | undefined;
    hasClaim!: boolean;
    stripePayoutIds!: string[] | undefined;
    pdfTransactionId!: string | undefined;
    incrementer!: number;

    constructor(data?: IBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.renter = data.renter && !(<any>data.renter).toJSON ? new RentMyUser(data.renter) : <RentMyUser>this.renter;
            this.sharer = data.sharer && !(<any>data.sharer).toJSON ? new RentMyUser(data.sharer) : <RentMyUser>this.sharer;
            this.item = data.item && !(<any>data.item).toJSON ? new Item(data.item) : <Item>this.item;
            this.renterHandOverProposal = data.renterHandOverProposal && !(<any>data.renterHandOverProposal).toJSON ? new HandOverProposal(data.renterHandOverProposal) : <HandOverProposal>this.renterHandOverProposal;
            this.buyerHandOverProposal = data.buyerHandOverProposal && !(<any>data.buyerHandOverProposal).toJSON ? new HandOverProposal(data.buyerHandOverProposal) : <HandOverProposal>this.buyerHandOverProposal;
            this.acceptedHandOverProposal = data.acceptedHandOverProposal && !(<any>data.acceptedHandOverProposal).toJSON ? new HandOverProposal(data.acceptedHandOverProposal) : <HandOverProposal>this.acceptedHandOverProposal;
            this.handOverAgreement = data.handOverAgreement && !(<any>data.handOverAgreement).toJSON ? new Agreement(data.handOverAgreement) : <Agreement>this.handOverAgreement;
            this.completionAgreement = data.completionAgreement && !(<any>data.completionAgreement).toJSON ? new Agreement(data.completionAgreement) : <Agreement>this.completionAgreement;
            if (data.pickupImages) {
                this.pickupImages = [];
                for (let i = 0; i < data.pickupImages.length; i++) {
                    let item = data.pickupImages[i];
                    this.pickupImages[i] = item && !(<any>item).toJSON ? new Image(item) : <Image>item;
                }
            }
            if (data.dropOffImages) {
                this.dropOffImages = [];
                for (let i = 0; i < data.dropOffImages.length; i++) {
                    let item = data.dropOffImages[i];
                    this.dropOffImages[i] = item && !(<any>item).toJSON ? new Image(item) : <Image>item;
                }
            }
            if (data.vouchers) {
                this.vouchers = [];
                for (let i = 0; i < data.vouchers.length; i++) {
                    let item = data.vouchers[i];
                    this.vouchers[i] = item && !(<any>item).toJSON ? new Voucher(item) : <Voucher>item;
                }
            }
            this.insuranceBreakdown = data.insuranceBreakdown && !(<any>data.insuranceBreakdown).toJSON ? new InsuranceBreakdown(data.insuranceBreakdown) : <InsuranceBreakdown>this.insuranceBreakdown;
            if (data.stripeTransfers) {
                this.stripeTransfers = [];
                for (let i = 0; i < data.stripeTransfers.length; i++) {
                    let item = data.stripeTransfers[i];
                    this.stripeTransfers[i] = item && !(<any>item).toJSON ? new StripeTransfer(item) : <StripeTransfer>item;
                }
            }
        }
        if (!data) {
            this.renter = new RentMyUser();
            this.sharer = new RentMyUser();
            this.item = new Item();
            this.handOverAgreement = new Agreement();
            this.completionAgreement = new Agreement();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.renter = _data["renter"] ? RentMyUser.fromJS(_data["renter"]) : new RentMyUser();
            this.sharer = _data["sharer"] ? RentMyUser.fromJS(_data["sharer"]) : new RentMyUser();
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : new Item();
            this.paymentAmount = _data["paymentAmount"];
            this.serviceFeeAmount = _data["serviceFeeAmount"];
            this.depositAmount = _data["depositAmount"];
            this.discount = _data["discount"];
            this.currency = _data["currency"];
            this.renterHandOverProposal = _data["renterHandOverProposal"] ? HandOverProposal.fromJS(_data["renterHandOverProposal"]) : <any>undefined;
            this.buyerHandOverProposal = _data["buyerHandOverProposal"] ? HandOverProposal.fromJS(_data["buyerHandOverProposal"]) : <any>undefined;
            this.acceptedHandOverProposal = _data["acceptedHandOverProposal"] ? HandOverProposal.fromJS(_data["acceptedHandOverProposal"]) : <any>undefined;
            this.handOverAgreement = _data["handOverAgreement"] ? Agreement.fromJS(_data["handOverAgreement"]) : new Agreement();
            this.completionAgreement = _data["completionAgreement"] ? Agreement.fromJS(_data["completionAgreement"]) : new Agreement();
            this.bookingStatus = _data["bookingStatus"];
            this.paymentStatus = _data["paymentStatus"];
            this.payoutStatus = _data["payoutStatus"];
            this.startingDate = _data["startingDate"] ? new Date(_data["startingDate"].toString()) : <any>undefined;
            this.endingDate = _data["endingDate"] ? new Date(_data["endingDate"].toString()) : <any>undefined;
            this.isHourly = _data["isHourly"];
            if (Array.isArray(_data["pickupImages"])) {
                this.pickupImages = [] as any;
                for (let item of _data["pickupImages"])
                    this.pickupImages!.push(Image.fromJS(item));
            }
            if (Array.isArray(_data["dropOffImages"])) {
                this.dropOffImages = [] as any;
                for (let item of _data["dropOffImages"])
                    this.dropOffImages!.push(Image.fromJS(item));
            }
            this.paymentIntentId = _data["paymentIntentId"];
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["vouchers"])
                    this.vouchers!.push(Voucher.fromJS(item));
            }
            this.insuranceBreakdown = _data["insuranceBreakdown"] ? InsuranceBreakdown.fromJS(_data["insuranceBreakdown"]) : <any>undefined;
            if (Array.isArray(_data["stripeTransfers"])) {
                this.stripeTransfers = [] as any;
                for (let item of _data["stripeTransfers"])
                    this.stripeTransfers!.push(StripeTransfer.fromJS(item));
            }
            this.chargeId = _data["chargeId"];
            this.quotallPolicyReference = _data["quotallPolicyReference"];
            this.hasClaim = _data["hasClaim"];
            if (Array.isArray(_data["stripePayoutIds"])) {
                this.stripePayoutIds = [] as any;
                for (let item of _data["stripePayoutIds"])
                    this.stripePayoutIds!.push(item);
            }
            this.pdfTransactionId = _data["pdfTransactionId"];
            this.incrementer = _data["incrementer"];
        }
    }

    static fromJS(data: any): Booking {
        data = typeof data === 'object' ? data : {};
        let result = new Booking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["renter"] = this.renter ? this.renter.toJSON() : <any>undefined;
        data["sharer"] = this.sharer ? this.sharer.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["paymentAmount"] = this.paymentAmount;
        data["serviceFeeAmount"] = this.serviceFeeAmount;
        data["depositAmount"] = this.depositAmount;
        data["discount"] = this.discount;
        data["currency"] = this.currency;
        data["renterHandOverProposal"] = this.renterHandOverProposal ? this.renterHandOverProposal.toJSON() : <any>undefined;
        data["buyerHandOverProposal"] = this.buyerHandOverProposal ? this.buyerHandOverProposal.toJSON() : <any>undefined;
        data["acceptedHandOverProposal"] = this.acceptedHandOverProposal ? this.acceptedHandOverProposal.toJSON() : <any>undefined;
        data["handOverAgreement"] = this.handOverAgreement ? this.handOverAgreement.toJSON() : <any>undefined;
        data["completionAgreement"] = this.completionAgreement ? this.completionAgreement.toJSON() : <any>undefined;
        data["bookingStatus"] = this.bookingStatus;
        data["paymentStatus"] = this.paymentStatus;
        data["payoutStatus"] = this.payoutStatus;
        data["startingDate"] = this.startingDate ? this.startingDate.toISOString() : <any>undefined;
        data["endingDate"] = this.endingDate ? this.endingDate.toISOString() : <any>undefined;
        data["isHourly"] = this.isHourly;
        if (Array.isArray(this.pickupImages)) {
            data["pickupImages"] = [];
            for (let item of this.pickupImages)
                data["pickupImages"].push(item.toJSON());
        }
        if (Array.isArray(this.dropOffImages)) {
            data["dropOffImages"] = [];
            for (let item of this.dropOffImages)
                data["dropOffImages"].push(item.toJSON());
        }
        data["paymentIntentId"] = this.paymentIntentId;
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item.toJSON());
        }
        data["insuranceBreakdown"] = this.insuranceBreakdown ? this.insuranceBreakdown.toJSON() : <any>undefined;
        if (Array.isArray(this.stripeTransfers)) {
            data["stripeTransfers"] = [];
            for (let item of this.stripeTransfers)
                data["stripeTransfers"].push(item.toJSON());
        }
        data["chargeId"] = this.chargeId;
        data["quotallPolicyReference"] = this.quotallPolicyReference;
        data["hasClaim"] = this.hasClaim;
        if (Array.isArray(this.stripePayoutIds)) {
            data["stripePayoutIds"] = [];
            for (let item of this.stripePayoutIds)
                data["stripePayoutIds"].push(item);
        }
        data["pdfTransactionId"] = this.pdfTransactionId;
        data["incrementer"] = this.incrementer;
        return data;
    }
}

export interface IBooking {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    renter: IRentMyUser;
    sharer: IRentMyUser;
    item: IItem;
    paymentAmount: number;
    serviceFeeAmount: number;
    depositAmount: number | undefined;
    discount: number | undefined;
    currency: CurrencyIsoCode;
    renterHandOverProposal: IHandOverProposal;
    buyerHandOverProposal: IHandOverProposal;
    acceptedHandOverProposal: IHandOverProposal;
    handOverAgreement: IAgreement;
    completionAgreement: IAgreement;
    bookingStatus: BookingStatus;
    paymentStatus: PaymentStatus;
    payoutStatus: PayoutStatus;
    startingDate: Date;
    endingDate: Date;
    isHourly: boolean;
    pickupImages: IImage[] | undefined;
    dropOffImages: IImage[] | undefined;
    paymentIntentId: string | undefined;
    vouchers: IVoucher[] | undefined;
    insuranceBreakdown: IInsuranceBreakdown;
    stripeTransfers: IStripeTransfer[] | undefined;
    chargeId: string | undefined;
    quotallPolicyReference: string | undefined;
    hasClaim: boolean;
    stripePayoutIds: string[] | undefined;
    pdfTransactionId: string | undefined;
    incrementer: number;
}

export class BookingCreateDto implements IBookingCreateDto {
    active!: boolean | undefined;
    itemId!: string;
    startingDate!: Date;
    endingDate!: Date;
    isHourly!: boolean;
    currency!: CurrencyIsoCode;
    vouchers!: string[] | undefined;
    insurancePlanId!: string | undefined;
    referralCode!: string | undefined;

    constructor(data?: IBookingCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.itemId = _data["itemId"];
            this.startingDate = _data["startingDate"] ? new Date(_data["startingDate"].toString()) : <any>undefined;
            this.endingDate = _data["endingDate"] ? new Date(_data["endingDate"].toString()) : <any>undefined;
            this.isHourly = _data["isHourly"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["vouchers"])
                    this.vouchers!.push(item);
            }
            this.insurancePlanId = _data["insurancePlanId"];
            this.referralCode = _data["referralCode"];
        }
    }

    static fromJS(data: any): BookingCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["itemId"] = this.itemId;
        data["startingDate"] = this.startingDate ? this.startingDate.toISOString() : <any>undefined;
        data["endingDate"] = this.endingDate ? this.endingDate.toISOString() : <any>undefined;
        data["isHourly"] = this.isHourly;
        data["currency"] = this.currency;
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item);
        }
        data["insurancePlanId"] = this.insurancePlanId;
        data["referralCode"] = this.referralCode;
        return data;
    }
}

export interface IBookingCreateDto {
    active: boolean | undefined;
    itemId: string;
    startingDate: Date;
    endingDate: Date;
    isHourly: boolean;
    currency: CurrencyIsoCode;
    vouchers: string[] | undefined;
    insurancePlanId: string | undefined;
    referralCode: string | undefined;
}

export class BookingDetailedDto implements IBookingDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    renter!: RentMyUserPublicSimpleDto;
    sharer!: RentMyUserPublicSimpleDto;
    item!: ItemSimpleDto;
    paymentAmount!: number;
    serviceFeeAmount!: number;
    bookingStatus!: BookingStatus;
    paymentStatus!: PaymentStatus;
    payoutStatus!: PayoutStatus;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    endDateWithTurnAround!: Date | undefined;
    handOverAgreement!: Agreement;
    completionAgreement!: Agreement;
    renterHandOverProposal!: HandOverProposal;
    buyerHandOverProposal!: HandOverProposal;
    acceptedHandOverProposal!: HandOverProposal;
    isReviewed!: boolean;
    pickUpImages!: ImageSimpleDto[] | undefined;
    dropOffImages!: ImageSimpleDto[] | undefined;
    paymentIntentId!: string | undefined;
    insuranceBreakdown!: InsuranceBreakdown;
    discount!: number | undefined;
    totalAmount!: number;
    hasClaim!: boolean;
    quotallPolicyReference!: string | undefined;

    constructor(data?: IBookingDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.renter = data.renter && !(<any>data.renter).toJSON ? new RentMyUserPublicSimpleDto(data.renter) : <RentMyUserPublicSimpleDto>this.renter;
            this.sharer = data.sharer && !(<any>data.sharer).toJSON ? new RentMyUserPublicSimpleDto(data.sharer) : <RentMyUserPublicSimpleDto>this.sharer;
            this.item = data.item && !(<any>data.item).toJSON ? new ItemSimpleDto(data.item) : <ItemSimpleDto>this.item;
            this.handOverAgreement = data.handOverAgreement && !(<any>data.handOverAgreement).toJSON ? new Agreement(data.handOverAgreement) : <Agreement>this.handOverAgreement;
            this.completionAgreement = data.completionAgreement && !(<any>data.completionAgreement).toJSON ? new Agreement(data.completionAgreement) : <Agreement>this.completionAgreement;
            this.renterHandOverProposal = data.renterHandOverProposal && !(<any>data.renterHandOverProposal).toJSON ? new HandOverProposal(data.renterHandOverProposal) : <HandOverProposal>this.renterHandOverProposal;
            this.buyerHandOverProposal = data.buyerHandOverProposal && !(<any>data.buyerHandOverProposal).toJSON ? new HandOverProposal(data.buyerHandOverProposal) : <HandOverProposal>this.buyerHandOverProposal;
            this.acceptedHandOverProposal = data.acceptedHandOverProposal && !(<any>data.acceptedHandOverProposal).toJSON ? new HandOverProposal(data.acceptedHandOverProposal) : <HandOverProposal>this.acceptedHandOverProposal;
            if (data.pickUpImages) {
                this.pickUpImages = [];
                for (let i = 0; i < data.pickUpImages.length; i++) {
                    let item = data.pickUpImages[i];
                    this.pickUpImages[i] = item && !(<any>item).toJSON ? new ImageSimpleDto(item) : <ImageSimpleDto>item;
                }
            }
            if (data.dropOffImages) {
                this.dropOffImages = [];
                for (let i = 0; i < data.dropOffImages.length; i++) {
                    let item = data.dropOffImages[i];
                    this.dropOffImages[i] = item && !(<any>item).toJSON ? new ImageSimpleDto(item) : <ImageSimpleDto>item;
                }
            }
            this.insuranceBreakdown = data.insuranceBreakdown && !(<any>data.insuranceBreakdown).toJSON ? new InsuranceBreakdown(data.insuranceBreakdown) : <InsuranceBreakdown>this.insuranceBreakdown;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.renter = _data["renter"] ? RentMyUserPublicSimpleDto.fromJS(_data["renter"]) : <any>undefined;
            this.sharer = _data["sharer"] ? RentMyUserPublicSimpleDto.fromJS(_data["sharer"]) : <any>undefined;
            this.item = _data["item"] ? ItemSimpleDto.fromJS(_data["item"]) : <any>undefined;
            this.paymentAmount = _data["paymentAmount"];
            this.serviceFeeAmount = _data["serviceFeeAmount"];
            this.bookingStatus = _data["bookingStatus"];
            this.paymentStatus = _data["paymentStatus"];
            this.payoutStatus = _data["payoutStatus"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.endDateWithTurnAround = _data["endDateWithTurnAround"] ? new Date(_data["endDateWithTurnAround"].toString()) : <any>undefined;
            this.handOverAgreement = _data["handOverAgreement"] ? Agreement.fromJS(_data["handOverAgreement"]) : <any>undefined;
            this.completionAgreement = _data["completionAgreement"] ? Agreement.fromJS(_data["completionAgreement"]) : <any>undefined;
            this.renterHandOverProposal = _data["renterHandOverProposal"] ? HandOverProposal.fromJS(_data["renterHandOverProposal"]) : <any>undefined;
            this.buyerHandOverProposal = _data["buyerHandOverProposal"] ? HandOverProposal.fromJS(_data["buyerHandOverProposal"]) : <any>undefined;
            this.acceptedHandOverProposal = _data["acceptedHandOverProposal"] ? HandOverProposal.fromJS(_data["acceptedHandOverProposal"]) : <any>undefined;
            this.isReviewed = _data["isReviewed"];
            if (Array.isArray(_data["pickUpImages"])) {
                this.pickUpImages = [] as any;
                for (let item of _data["pickUpImages"])
                    this.pickUpImages!.push(ImageSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["dropOffImages"])) {
                this.dropOffImages = [] as any;
                for (let item of _data["dropOffImages"])
                    this.dropOffImages!.push(ImageSimpleDto.fromJS(item));
            }
            this.paymentIntentId = _data["paymentIntentId"];
            this.insuranceBreakdown = _data["insuranceBreakdown"] ? InsuranceBreakdown.fromJS(_data["insuranceBreakdown"]) : <any>undefined;
            this.discount = _data["discount"];
            this.totalAmount = _data["totalAmount"];
            this.hasClaim = _data["hasClaim"];
            this.quotallPolicyReference = _data["quotallPolicyReference"];
        }
    }

    static fromJS(data: any): BookingDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["renter"] = this.renter ? this.renter.toJSON() : <any>undefined;
        data["sharer"] = this.sharer ? this.sharer.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["paymentAmount"] = this.paymentAmount;
        data["serviceFeeAmount"] = this.serviceFeeAmount;
        data["bookingStatus"] = this.bookingStatus;
        data["paymentStatus"] = this.paymentStatus;
        data["payoutStatus"] = this.payoutStatus;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["endDateWithTurnAround"] = this.endDateWithTurnAround ? this.endDateWithTurnAround.toISOString() : <any>undefined;
        data["handOverAgreement"] = this.handOverAgreement ? this.handOverAgreement.toJSON() : <any>undefined;
        data["completionAgreement"] = this.completionAgreement ? this.completionAgreement.toJSON() : <any>undefined;
        data["renterHandOverProposal"] = this.renterHandOverProposal ? this.renterHandOverProposal.toJSON() : <any>undefined;
        data["buyerHandOverProposal"] = this.buyerHandOverProposal ? this.buyerHandOverProposal.toJSON() : <any>undefined;
        data["acceptedHandOverProposal"] = this.acceptedHandOverProposal ? this.acceptedHandOverProposal.toJSON() : <any>undefined;
        data["isReviewed"] = this.isReviewed;
        if (Array.isArray(this.pickUpImages)) {
            data["pickUpImages"] = [];
            for (let item of this.pickUpImages)
                data["pickUpImages"].push(item.toJSON());
        }
        if (Array.isArray(this.dropOffImages)) {
            data["dropOffImages"] = [];
            for (let item of this.dropOffImages)
                data["dropOffImages"].push(item.toJSON());
        }
        data["paymentIntentId"] = this.paymentIntentId;
        data["insuranceBreakdown"] = this.insuranceBreakdown ? this.insuranceBreakdown.toJSON() : <any>undefined;
        data["discount"] = this.discount;
        data["totalAmount"] = this.totalAmount;
        data["hasClaim"] = this.hasClaim;
        data["quotallPolicyReference"] = this.quotallPolicyReference;
        return data;
    }
}

export interface IBookingDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    renter: IRentMyUserPublicSimpleDto;
    sharer: IRentMyUserPublicSimpleDto;
    item: IItemSimpleDto;
    paymentAmount: number;
    serviceFeeAmount: number;
    bookingStatus: BookingStatus;
    paymentStatus: PaymentStatus;
    payoutStatus: PayoutStatus;
    startDate: Date | undefined;
    endDate: Date | undefined;
    endDateWithTurnAround: Date | undefined;
    handOverAgreement: IAgreement;
    completionAgreement: IAgreement;
    renterHandOverProposal: IHandOverProposal;
    buyerHandOverProposal: IHandOverProposal;
    acceptedHandOverProposal: IHandOverProposal;
    isReviewed: boolean;
    pickUpImages: IImageSimpleDto[] | undefined;
    dropOffImages: IImageSimpleDto[] | undefined;
    paymentIntentId: string | undefined;
    insuranceBreakdown: IInsuranceBreakdown;
    discount: number | undefined;
    totalAmount: number;
    hasClaim: boolean;
    quotallPolicyReference: string | undefined;
}

export class BookingDetailedDtoPaginationDto implements IBookingDetailedDtoPaginationDto {
    data!: BookingDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IBookingDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new BookingDetailedDto(item) : <BookingDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BookingDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): BookingDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IBookingDetailedDtoPaginationDto {
    data: IBookingDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class BookingDetailedDtoUpdateResponseDto implements IBookingDetailedDtoUpdateResponseDto {
    data!: BookingDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IBookingDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new BookingDetailedDto(data.data) : <BookingDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? BookingDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): BookingDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IBookingDetailedDtoUpdateResponseDto {
    data: IBookingDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export enum BookingOrderBy {
    Status = "Status",
    StartDate = "StartDate",
    EndDate = "EndDate",
    CreationDate = "CreationDate",
    ByRenter = "ByRenter",
    ByOwner = "ByOwner",
    Active = "Active",
}

export class BookingPricingDto implements IBookingPricingDto {
    paymentAmount!: number;
    serviceFeeAmount!: number;
    depositAmount!: number | undefined;
    discount!: number | undefined;
    currency!: CurrencyIsoCode;
    insuranceBreakdown!: InsuranceBreakdown;
    readonly netTotal!: number;
    readonly total!: number;
    redeemedVouchers!: VoucherRedemptionSimpleDto[] | undefined;
    unusedVouchers!: VoucherRedemptionSimpleDto[] | undefined;
    invalidVouchers!: VoucherRedemptionSimpleDto[] | undefined;
    responses!: string[] | undefined;

    constructor(data?: IBookingPricingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.insuranceBreakdown = data.insuranceBreakdown && !(<any>data.insuranceBreakdown).toJSON ? new InsuranceBreakdown(data.insuranceBreakdown) : <InsuranceBreakdown>this.insuranceBreakdown;
            if (data.redeemedVouchers) {
                this.redeemedVouchers = [];
                for (let i = 0; i < data.redeemedVouchers.length; i++) {
                    let item = data.redeemedVouchers[i];
                    this.redeemedVouchers[i] = item && !(<any>item).toJSON ? new VoucherRedemptionSimpleDto(item) : <VoucherRedemptionSimpleDto>item;
                }
            }
            if (data.unusedVouchers) {
                this.unusedVouchers = [];
                for (let i = 0; i < data.unusedVouchers.length; i++) {
                    let item = data.unusedVouchers[i];
                    this.unusedVouchers[i] = item && !(<any>item).toJSON ? new VoucherRedemptionSimpleDto(item) : <VoucherRedemptionSimpleDto>item;
                }
            }
            if (data.invalidVouchers) {
                this.invalidVouchers = [];
                for (let i = 0; i < data.invalidVouchers.length; i++) {
                    let item = data.invalidVouchers[i];
                    this.invalidVouchers[i] = item && !(<any>item).toJSON ? new VoucherRedemptionSimpleDto(item) : <VoucherRedemptionSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentAmount = _data["paymentAmount"];
            this.serviceFeeAmount = _data["serviceFeeAmount"];
            this.depositAmount = _data["depositAmount"];
            this.discount = _data["discount"];
            this.currency = _data["currency"];
            this.insuranceBreakdown = _data["insuranceBreakdown"] ? InsuranceBreakdown.fromJS(_data["insuranceBreakdown"]) : <any>undefined;
            (<any>this).netTotal = _data["netTotal"];
            (<any>this).total = _data["total"];
            if (Array.isArray(_data["redeemedVouchers"])) {
                this.redeemedVouchers = [] as any;
                for (let item of _data["redeemedVouchers"])
                    this.redeemedVouchers!.push(VoucherRedemptionSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["unusedVouchers"])) {
                this.unusedVouchers = [] as any;
                for (let item of _data["unusedVouchers"])
                    this.unusedVouchers!.push(VoucherRedemptionSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["invalidVouchers"])) {
                this.invalidVouchers = [] as any;
                for (let item of _data["invalidVouchers"])
                    this.invalidVouchers!.push(VoucherRedemptionSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(item);
            }
        }
    }

    static fromJS(data: any): BookingPricingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingPricingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentAmount"] = this.paymentAmount;
        data["serviceFeeAmount"] = this.serviceFeeAmount;
        data["depositAmount"] = this.depositAmount;
        data["discount"] = this.discount;
        data["currency"] = this.currency;
        data["insuranceBreakdown"] = this.insuranceBreakdown ? this.insuranceBreakdown.toJSON() : <any>undefined;
        data["netTotal"] = this.netTotal;
        data["total"] = this.total;
        if (Array.isArray(this.redeemedVouchers)) {
            data["redeemedVouchers"] = [];
            for (let item of this.redeemedVouchers)
                data["redeemedVouchers"].push(item.toJSON());
        }
        if (Array.isArray(this.unusedVouchers)) {
            data["unusedVouchers"] = [];
            for (let item of this.unusedVouchers)
                data["unusedVouchers"].push(item.toJSON());
        }
        if (Array.isArray(this.invalidVouchers)) {
            data["invalidVouchers"] = [];
            for (let item of this.invalidVouchers)
                data["invalidVouchers"].push(item.toJSON());
        }
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item);
        }
        return data;
    }
}

export interface IBookingPricingDto {
    paymentAmount: number;
    serviceFeeAmount: number;
    depositAmount: number | undefined;
    discount: number | undefined;
    currency: CurrencyIsoCode;
    insuranceBreakdown: IInsuranceBreakdown;
    netTotal: number;
    total: number;
    redeemedVouchers: IVoucherRedemptionSimpleDto[] | undefined;
    unusedVouchers: IVoucherRedemptionSimpleDto[] | undefined;
    invalidVouchers: IVoucherRedemptionSimpleDto[] | undefined;
    responses: string[] | undefined;
}

export class BookingSimpleDto implements IBookingSimpleDto {
    id!: string;
    active!: boolean;
    renter!: ImageableIdentifierDto;
    sharer!: ImageableIdentifierDto;
    item!: MultiImageableUrlIdentifierDto;
    paymentAmount!: number;
    serviceFeeAmount!: number;
    bookingStatus!: BookingStatus;
    paymentStatus!: PaymentStatus;
    payoutStatus!: PayoutStatus;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    endDateWithTurnAround!: Date | undefined;
    handOverAgreement!: Agreement;
    completionAgreement!: Agreement;
    renterHandOverProposal!: HandOverProposal;
    buyerHandOverProposal!: HandOverProposal;
    acceptedHandOverProposal!: HandOverProposal;
    isReviewed!: boolean;
    pickUpImages!: ImageDto[] | undefined;
    dropOffImages!: ImageDto[] | undefined;
    paymentIntentId!: string | undefined;
    insuranceBreakdown!: InsuranceBreakdown;
    discount!: number | undefined;
    totalAmount!: number;
    hasClaim!: boolean;

    constructor(data?: IBookingSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.renter = data.renter && !(<any>data.renter).toJSON ? new ImageableIdentifierDto(data.renter) : <ImageableIdentifierDto>this.renter;
            this.sharer = data.sharer && !(<any>data.sharer).toJSON ? new ImageableIdentifierDto(data.sharer) : <ImageableIdentifierDto>this.sharer;
            this.item = data.item && !(<any>data.item).toJSON ? new MultiImageableUrlIdentifierDto(data.item) : <MultiImageableUrlIdentifierDto>this.item;
            this.handOverAgreement = data.handOverAgreement && !(<any>data.handOverAgreement).toJSON ? new Agreement(data.handOverAgreement) : <Agreement>this.handOverAgreement;
            this.completionAgreement = data.completionAgreement && !(<any>data.completionAgreement).toJSON ? new Agreement(data.completionAgreement) : <Agreement>this.completionAgreement;
            this.renterHandOverProposal = data.renterHandOverProposal && !(<any>data.renterHandOverProposal).toJSON ? new HandOverProposal(data.renterHandOverProposal) : <HandOverProposal>this.renterHandOverProposal;
            this.buyerHandOverProposal = data.buyerHandOverProposal && !(<any>data.buyerHandOverProposal).toJSON ? new HandOverProposal(data.buyerHandOverProposal) : <HandOverProposal>this.buyerHandOverProposal;
            this.acceptedHandOverProposal = data.acceptedHandOverProposal && !(<any>data.acceptedHandOverProposal).toJSON ? new HandOverProposal(data.acceptedHandOverProposal) : <HandOverProposal>this.acceptedHandOverProposal;
            if (data.pickUpImages) {
                this.pickUpImages = [];
                for (let i = 0; i < data.pickUpImages.length; i++) {
                    let item = data.pickUpImages[i];
                    this.pickUpImages[i] = item && !(<any>item).toJSON ? new ImageDto(item) : <ImageDto>item;
                }
            }
            if (data.dropOffImages) {
                this.dropOffImages = [];
                for (let i = 0; i < data.dropOffImages.length; i++) {
                    let item = data.dropOffImages[i];
                    this.dropOffImages[i] = item && !(<any>item).toJSON ? new ImageDto(item) : <ImageDto>item;
                }
            }
            this.insuranceBreakdown = data.insuranceBreakdown && !(<any>data.insuranceBreakdown).toJSON ? new InsuranceBreakdown(data.insuranceBreakdown) : <InsuranceBreakdown>this.insuranceBreakdown;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.renter = _data["renter"] ? ImageableIdentifierDto.fromJS(_data["renter"]) : <any>undefined;
            this.sharer = _data["sharer"] ? ImageableIdentifierDto.fromJS(_data["sharer"]) : <any>undefined;
            this.item = _data["item"] ? MultiImageableUrlIdentifierDto.fromJS(_data["item"]) : <any>undefined;
            this.paymentAmount = _data["paymentAmount"];
            this.serviceFeeAmount = _data["serviceFeeAmount"];
            this.bookingStatus = _data["bookingStatus"];
            this.paymentStatus = _data["paymentStatus"];
            this.payoutStatus = _data["payoutStatus"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.endDateWithTurnAround = _data["endDateWithTurnAround"] ? new Date(_data["endDateWithTurnAround"].toString()) : <any>undefined;
            this.handOverAgreement = _data["handOverAgreement"] ? Agreement.fromJS(_data["handOverAgreement"]) : <any>undefined;
            this.completionAgreement = _data["completionAgreement"] ? Agreement.fromJS(_data["completionAgreement"]) : <any>undefined;
            this.renterHandOverProposal = _data["renterHandOverProposal"] ? HandOverProposal.fromJS(_data["renterHandOverProposal"]) : <any>undefined;
            this.buyerHandOverProposal = _data["buyerHandOverProposal"] ? HandOverProposal.fromJS(_data["buyerHandOverProposal"]) : <any>undefined;
            this.acceptedHandOverProposal = _data["acceptedHandOverProposal"] ? HandOverProposal.fromJS(_data["acceptedHandOverProposal"]) : <any>undefined;
            this.isReviewed = _data["isReviewed"];
            if (Array.isArray(_data["pickUpImages"])) {
                this.pickUpImages = [] as any;
                for (let item of _data["pickUpImages"])
                    this.pickUpImages!.push(ImageDto.fromJS(item));
            }
            if (Array.isArray(_data["dropOffImages"])) {
                this.dropOffImages = [] as any;
                for (let item of _data["dropOffImages"])
                    this.dropOffImages!.push(ImageDto.fromJS(item));
            }
            this.paymentIntentId = _data["paymentIntentId"];
            this.insuranceBreakdown = _data["insuranceBreakdown"] ? InsuranceBreakdown.fromJS(_data["insuranceBreakdown"]) : <any>undefined;
            this.discount = _data["discount"];
            this.totalAmount = _data["totalAmount"];
            this.hasClaim = _data["hasClaim"];
        }
    }

    static fromJS(data: any): BookingSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["renter"] = this.renter ? this.renter.toJSON() : <any>undefined;
        data["sharer"] = this.sharer ? this.sharer.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["paymentAmount"] = this.paymentAmount;
        data["serviceFeeAmount"] = this.serviceFeeAmount;
        data["bookingStatus"] = this.bookingStatus;
        data["paymentStatus"] = this.paymentStatus;
        data["payoutStatus"] = this.payoutStatus;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["endDateWithTurnAround"] = this.endDateWithTurnAround ? this.endDateWithTurnAround.toISOString() : <any>undefined;
        data["handOverAgreement"] = this.handOverAgreement ? this.handOverAgreement.toJSON() : <any>undefined;
        data["completionAgreement"] = this.completionAgreement ? this.completionAgreement.toJSON() : <any>undefined;
        data["renterHandOverProposal"] = this.renterHandOverProposal ? this.renterHandOverProposal.toJSON() : <any>undefined;
        data["buyerHandOverProposal"] = this.buyerHandOverProposal ? this.buyerHandOverProposal.toJSON() : <any>undefined;
        data["acceptedHandOverProposal"] = this.acceptedHandOverProposal ? this.acceptedHandOverProposal.toJSON() : <any>undefined;
        data["isReviewed"] = this.isReviewed;
        if (Array.isArray(this.pickUpImages)) {
            data["pickUpImages"] = [];
            for (let item of this.pickUpImages)
                data["pickUpImages"].push(item.toJSON());
        }
        if (Array.isArray(this.dropOffImages)) {
            data["dropOffImages"] = [];
            for (let item of this.dropOffImages)
                data["dropOffImages"].push(item.toJSON());
        }
        data["paymentIntentId"] = this.paymentIntentId;
        data["insuranceBreakdown"] = this.insuranceBreakdown ? this.insuranceBreakdown.toJSON() : <any>undefined;
        data["discount"] = this.discount;
        data["totalAmount"] = this.totalAmount;
        data["hasClaim"] = this.hasClaim;
        return data;
    }
}

export interface IBookingSimpleDto {
    id: string;
    active: boolean;
    renter: IImageableIdentifierDto;
    sharer: IImageableIdentifierDto;
    item: IMultiImageableUrlIdentifierDto;
    paymentAmount: number;
    serviceFeeAmount: number;
    bookingStatus: BookingStatus;
    paymentStatus: PaymentStatus;
    payoutStatus: PayoutStatus;
    startDate: Date | undefined;
    endDate: Date | undefined;
    endDateWithTurnAround: Date | undefined;
    handOverAgreement: IAgreement;
    completionAgreement: IAgreement;
    renterHandOverProposal: IHandOverProposal;
    buyerHandOverProposal: IHandOverProposal;
    acceptedHandOverProposal: IHandOverProposal;
    isReviewed: boolean;
    pickUpImages: IImageDto[] | undefined;
    dropOffImages: IImageDto[] | undefined;
    paymentIntentId: string | undefined;
    insuranceBreakdown: IInsuranceBreakdown;
    discount: number | undefined;
    totalAmount: number;
    hasClaim: boolean;
}

export class BookingSimpleDtoPaginationDto implements IBookingSimpleDtoPaginationDto {
    data!: BookingSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IBookingSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new BookingSimpleDto(item) : <BookingSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BookingSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): BookingSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IBookingSimpleDtoPaginationDto {
    data: IBookingSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum BookingStatus {
    Request = "Request",
    BookingAccepted = "BookingAccepted",
    Proposal = "Proposal",
    HandoverAccepted = "HandoverAccepted",
    AcceptBuyerProposal = "AcceptBuyerProposal",
    AcceptRenterProposal = "AcceptRenterProposal",
    Ongoing = "Ongoing",
    Completed = "Completed",
    Cancelled = "Cancelled",
    Disputed = "Disputed",
    Resolved = "Resolved",
    Rejected = "Rejected",
}

export enum CancellationPolicy {
    Flexible = "Flexible",
    Moderate = "Moderate",
    Strict = "Strict",
}

export class Category implements ICategory {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string;
    description!: string | undefined;
    items!: Item[] | undefined;
    children!: Category[] | undefined;
    parent!: Category;
    path!: string | undefined;
    shortName!: string | undefined;
    isCollection!: boolean;
    aspects!: Aspect[] | undefined;
    blacklistedAspects!: string[] | undefined;
    keywords!: string | undefined;
    insurancePlans!: InsurancePlan[] | undefined;
    quotallCategory!: QuotallCategory;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new Item(item) : <Item>item;
                }
            }
            if (data.children) {
                this.children = [];
                for (let i = 0; i < data.children.length; i++) {
                    let item = data.children[i];
                    this.children[i] = item && !(<any>item).toJSON ? new Category(item) : <Category>item;
                }
            }
            this.parent = data.parent && !(<any>data.parent).toJSON ? new Category(data.parent) : <Category>this.parent;
            if (data.aspects) {
                this.aspects = [];
                for (let i = 0; i < data.aspects.length; i++) {
                    let item = data.aspects[i];
                    this.aspects[i] = item && !(<any>item).toJSON ? new Aspect(item) : <Aspect>item;
                }
            }
            if (data.insurancePlans) {
                this.insurancePlans = [];
                for (let i = 0; i < data.insurancePlans.length; i++) {
                    let item = data.insurancePlans[i];
                    this.insurancePlans[i] = item && !(<any>item).toJSON ? new InsurancePlan(item) : <InsurancePlan>item;
                }
            }
            this.quotallCategory = data.quotallCategory && !(<any>data.quotallCategory).toJSON ? new QuotallCategory(data.quotallCategory) : <QuotallCategory>this.quotallCategory;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Item.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Category.fromJS(item));
            }
            this.parent = _data["parent"] ? Category.fromJS(_data["parent"]) : <any>undefined;
            this.path = _data["path"];
            this.shortName = _data["shortName"];
            this.isCollection = _data["isCollection"];
            if (Array.isArray(_data["Aspects"])) {
                this.aspects = [] as any;
                for (let item of _data["Aspects"])
                    this.aspects!.push(Aspect.fromJS(item));
            }
            if (Array.isArray(_data["blacklistedAspects"])) {
                this.blacklistedAspects = [] as any;
                for (let item of _data["blacklistedAspects"])
                    this.blacklistedAspects!.push(item);
            }
            this.keywords = _data["keywords"];
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans!.push(InsurancePlan.fromJS(item));
            }
            this.quotallCategory = _data["quotallCategory"] ? QuotallCategory.fromJS(_data["quotallCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["path"] = this.path;
        data["shortName"] = this.shortName;
        data["isCollection"] = this.isCollection;
        if (Array.isArray(this.aspects)) {
            data["Aspects"] = [];
            for (let item of this.aspects)
                data["Aspects"].push(item.toJSON());
        }
        if (Array.isArray(this.blacklistedAspects)) {
            data["blacklistedAspects"] = [];
            for (let item of this.blacklistedAspects)
                data["blacklistedAspects"].push(item);
        }
        data["keywords"] = this.keywords;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        data["quotallCategory"] = this.quotallCategory ? this.quotallCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICategory {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string;
    description: string | undefined;
    items: IItem[] | undefined;
    children: ICategory[] | undefined;
    parent: ICategory;
    path: string | undefined;
    shortName: string | undefined;
    isCollection: boolean;
    aspects: IAspect[] | undefined;
    blacklistedAspects: string[] | undefined;
    keywords: string | undefined;
    insurancePlans: IInsurancePlan[] | undefined;
    quotallCategory: IQuotallCategory;
}

export class CategoryAdminSearchDto implements ICategoryAdminSearchDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    path!: string | undefined;
    quotallCategoryName!: string | undefined;
    quotallCategoryCode!: string | undefined;
    childrenCount!: number;
    hasInsurance!: boolean;
    isCollection!: boolean;

    constructor(data?: ICategoryAdminSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.path = _data["path"];
            this.quotallCategoryName = _data["quotallCategoryName"];
            this.quotallCategoryCode = _data["quotallCategoryCode"];
            this.childrenCount = _data["childrenCount"];
            this.hasInsurance = _data["hasInsurance"];
            this.isCollection = _data["isCollection"];
        }
    }

    static fromJS(data: any): CategoryAdminSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryAdminSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["path"] = this.path;
        data["quotallCategoryName"] = this.quotallCategoryName;
        data["quotallCategoryCode"] = this.quotallCategoryCode;
        data["childrenCount"] = this.childrenCount;
        data["hasInsurance"] = this.hasInsurance;
        data["isCollection"] = this.isCollection;
        return data;
    }
}

export interface ICategoryAdminSearchDto {
    id: string;
    active: boolean;
    name: string | undefined;
    path: string | undefined;
    quotallCategoryName: string | undefined;
    quotallCategoryCode: string | undefined;
    childrenCount: number;
    hasInsurance: boolean;
    isCollection: boolean;
}

export class CategoryAdminSearchDtoPaginationDto implements ICategoryAdminSearchDtoPaginationDto {
    data!: CategoryAdminSearchDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ICategoryAdminSearchDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new CategoryAdminSearchDto(item) : <CategoryAdminSearchDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategoryAdminSearchDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): CategoryAdminSearchDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryAdminSearchDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ICategoryAdminSearchDtoPaginationDto {
    data: ICategoryAdminSearchDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class CategoryChildSimpleDto implements ICategoryChildSimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    description!: string | undefined;
    path!: string | undefined;
    shortName!: string | undefined;
    itemsCount!: number;
    isCollection!: boolean;
    childrenCount!: number;
    keywords!: string | undefined;
    insurancePlans!: NamedIdentifierDto[] | undefined;
    quotallCategory!: QuotallCategoryDto;
    children!: CategoryChildSimpleDto[] | undefined;

    constructor(data?: ICategoryChildSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.insurancePlans) {
                this.insurancePlans = [];
                for (let i = 0; i < data.insurancePlans.length; i++) {
                    let item = data.insurancePlans[i];
                    this.insurancePlans[i] = item && !(<any>item).toJSON ? new NamedIdentifierDto(item) : <NamedIdentifierDto>item;
                }
            }
            this.quotallCategory = data.quotallCategory && !(<any>data.quotallCategory).toJSON ? new QuotallCategoryDto(data.quotallCategory) : <QuotallCategoryDto>this.quotallCategory;
            if (data.children) {
                this.children = [];
                for (let i = 0; i < data.children.length; i++) {
                    let item = data.children[i];
                    this.children[i] = item && !(<any>item).toJSON ? new CategoryChildSimpleDto(item) : <CategoryChildSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.path = _data["path"];
            this.shortName = _data["shortName"];
            this.itemsCount = _data["itemsCount"];
            this.isCollection = _data["isCollection"];
            this.childrenCount = _data["childrenCount"];
            this.keywords = _data["keywords"];
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans!.push(NamedIdentifierDto.fromJS(item));
            }
            this.quotallCategory = _data["quotallCategory"] ? QuotallCategoryDto.fromJS(_data["quotallCategory"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(CategoryChildSimpleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryChildSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryChildSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["description"] = this.description;
        data["path"] = this.path;
        data["shortName"] = this.shortName;
        data["itemsCount"] = this.itemsCount;
        data["isCollection"] = this.isCollection;
        data["childrenCount"] = this.childrenCount;
        data["keywords"] = this.keywords;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        data["quotallCategory"] = this.quotallCategory ? this.quotallCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoryChildSimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    description: string | undefined;
    path: string | undefined;
    shortName: string | undefined;
    itemsCount: number;
    isCollection: boolean;
    childrenCount: number;
    keywords: string | undefined;
    insurancePlans: INamedIdentifierDto[] | undefined;
    quotallCategory: IQuotallCategoryDto;
    children: ICategoryChildSimpleDto[] | undefined;
}

export class CategoryCreateDto implements ICategoryCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    description!: string | undefined;
    shortName!: string | undefined;
    isCollection!: boolean;
    parentId!: string | undefined;
    insurancePlans!: string[] | undefined;

    constructor(data?: ICategoryCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.shortName = _data["shortName"];
            this.isCollection = _data["isCollection"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans!.push(item);
            }
        }
    }

    static fromJS(data: any): CategoryCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["description"] = this.description;
        data["shortName"] = this.shortName;
        data["isCollection"] = this.isCollection;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item);
        }
        return data;
    }
}

export interface ICategoryCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    description: string | undefined;
    shortName: string | undefined;
    isCollection: boolean;
    parentId: string | undefined;
    insurancePlans: string[] | undefined;
}

export class CategoryDetailedDto implements ICategoryDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    description!: string | undefined;
    path!: string | undefined;
    shortName!: string | undefined;
    itemsCount!: number;
    parent!: CategorySimpleDto;
    children!: CategoryChildSimpleDto[] | undefined;
    collections!: CategoryChildSimpleDto[] | undefined;
    blacklistedAspects!: string[] | undefined;
    isCollection!: boolean;
    keywords!: string | undefined;
    insurancePlans!: InsurancePlanDto[] | undefined;
    quotallCategory!: QuotallCategoryDto;

    constructor(data?: ICategoryDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.parent = data.parent && !(<any>data.parent).toJSON ? new CategorySimpleDto(data.parent) : <CategorySimpleDto>this.parent;
            if (data.children) {
                this.children = [];
                for (let i = 0; i < data.children.length; i++) {
                    let item = data.children[i];
                    this.children[i] = item && !(<any>item).toJSON ? new CategoryChildSimpleDto(item) : <CategoryChildSimpleDto>item;
                }
            }
            if (data.collections) {
                this.collections = [];
                for (let i = 0; i < data.collections.length; i++) {
                    let item = data.collections[i];
                    this.collections[i] = item && !(<any>item).toJSON ? new CategoryChildSimpleDto(item) : <CategoryChildSimpleDto>item;
                }
            }
            if (data.insurancePlans) {
                this.insurancePlans = [];
                for (let i = 0; i < data.insurancePlans.length; i++) {
                    let item = data.insurancePlans[i];
                    this.insurancePlans[i] = item && !(<any>item).toJSON ? new InsurancePlanDto(item) : <InsurancePlanDto>item;
                }
            }
            this.quotallCategory = data.quotallCategory && !(<any>data.quotallCategory).toJSON ? new QuotallCategoryDto(data.quotallCategory) : <QuotallCategoryDto>this.quotallCategory;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.path = _data["path"];
            this.shortName = _data["shortName"];
            this.itemsCount = _data["itemsCount"];
            this.parent = _data["parent"] ? CategorySimpleDto.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(CategoryChildSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["collections"])) {
                this.collections = [] as any;
                for (let item of _data["collections"])
                    this.collections!.push(CategoryChildSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["blacklistedAspects"])) {
                this.blacklistedAspects = [] as any;
                for (let item of _data["blacklistedAspects"])
                    this.blacklistedAspects!.push(item);
            }
            this.isCollection = _data["isCollection"];
            this.keywords = _data["keywords"];
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans!.push(InsurancePlanDto.fromJS(item));
            }
            this.quotallCategory = _data["quotallCategory"] ? QuotallCategoryDto.fromJS(_data["quotallCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CategoryDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["path"] = this.path;
        data["shortName"] = this.shortName;
        data["itemsCount"] = this.itemsCount;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        if (Array.isArray(this.collections)) {
            data["collections"] = [];
            for (let item of this.collections)
                data["collections"].push(item.toJSON());
        }
        if (Array.isArray(this.blacklistedAspects)) {
            data["blacklistedAspects"] = [];
            for (let item of this.blacklistedAspects)
                data["blacklistedAspects"].push(item);
        }
        data["isCollection"] = this.isCollection;
        data["keywords"] = this.keywords;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        data["quotallCategory"] = this.quotallCategory ? this.quotallCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICategoryDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    description: string | undefined;
    path: string | undefined;
    shortName: string | undefined;
    itemsCount: number;
    parent: ICategorySimpleDto;
    children: ICategoryChildSimpleDto[] | undefined;
    collections: ICategoryChildSimpleDto[] | undefined;
    blacklistedAspects: string[] | undefined;
    isCollection: boolean;
    keywords: string | undefined;
    insurancePlans: IInsurancePlanDto[] | undefined;
    quotallCategory: IQuotallCategoryDto;
}

export class CategoryDetailedDtoPaginationDto implements ICategoryDetailedDtoPaginationDto {
    data!: CategoryDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ICategoryDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new CategoryDetailedDto(item) : <CategoryDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategoryDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): CategoryDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ICategoryDetailedDtoPaginationDto {
    data: ICategoryDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class CategoryDetailedDtoUpdateResponseDto implements ICategoryDetailedDtoUpdateResponseDto {
    data!: CategoryDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: ICategoryDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new CategoryDetailedDto(data.data) : <CategoryDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CategoryDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): CategoryDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICategoryDetailedDtoUpdateResponseDto {
    data: ICategoryDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export enum CategoryExclusionType {
    SelectedOnly = "SelectedOnly",
    ParentsOnly = "ParentsOnly",
    ParentsAndSelected = "ParentsAndSelected",
}

export enum CategoryOrderBy {
    Relevance = "Relevance",
    Parents = "Parents",
    DownParents = "DownParents",
    Children = "Children",
    DownChildren = "DownChildren",
    Newest = "Newest",
    Alphabetically = "Alphabetically",
    AlphabeticallyLevelled = "AlphabeticallyLevelled",
}

export class CategoryResultsDto implements ICategoryResultsDto {
    id!: string;
    name!: string | undefined;
    shortName!: string | undefined;

    constructor(data?: ICategoryResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): CategoryResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface ICategoryResultsDto {
    id: string;
    name: string | undefined;
    shortName: string | undefined;
}

export class CategorySimpleDto implements ICategorySimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    description!: string | undefined;
    path!: string | undefined;
    shortName!: string | undefined;
    itemsCount!: number;
    isCollection!: boolean;
    childrenCount!: number;
    keywords!: string | undefined;
    insurancePlans!: NamedIdentifierDto[] | undefined;
    quotallCategory!: QuotallCategoryDto;

    constructor(data?: ICategorySimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.insurancePlans) {
                this.insurancePlans = [];
                for (let i = 0; i < data.insurancePlans.length; i++) {
                    let item = data.insurancePlans[i];
                    this.insurancePlans[i] = item && !(<any>item).toJSON ? new NamedIdentifierDto(item) : <NamedIdentifierDto>item;
                }
            }
            this.quotallCategory = data.quotallCategory && !(<any>data.quotallCategory).toJSON ? new QuotallCategoryDto(data.quotallCategory) : <QuotallCategoryDto>this.quotallCategory;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.path = _data["path"];
            this.shortName = _data["shortName"];
            this.itemsCount = _data["itemsCount"];
            this.isCollection = _data["isCollection"];
            this.childrenCount = _data["childrenCount"];
            this.keywords = _data["keywords"];
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans!.push(NamedIdentifierDto.fromJS(item));
            }
            this.quotallCategory = _data["quotallCategory"] ? QuotallCategoryDto.fromJS(_data["quotallCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CategorySimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategorySimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["description"] = this.description;
        data["path"] = this.path;
        data["shortName"] = this.shortName;
        data["itemsCount"] = this.itemsCount;
        data["isCollection"] = this.isCollection;
        data["childrenCount"] = this.childrenCount;
        data["keywords"] = this.keywords;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        data["quotallCategory"] = this.quotallCategory ? this.quotallCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICategorySimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    description: string | undefined;
    path: string | undefined;
    shortName: string | undefined;
    itemsCount: number;
    isCollection: boolean;
    childrenCount: number;
    keywords: string | undefined;
    insurancePlans: INamedIdentifierDto[] | undefined;
    quotallCategory: IQuotallCategoryDto;
}

export class CategorySimpleDtoPaginationDto implements ICategorySimpleDtoPaginationDto {
    data!: CategorySimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ICategorySimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new CategorySimpleDto(item) : <CategorySimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategorySimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): CategorySimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategorySimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ICategorySimpleDtoPaginationDto {
    data: ICategorySimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class CategoryWithAspectsDetailedDto implements ICategoryWithAspectsDetailedDto {
    id!: string;
    category!: CategoryDetailedDto;
    aspects!: AspectSimpleDto[] | undefined;
    ownedAspects!: AspectSimpleDto[] | undefined;
    inheritedAspects!: AspectSimpleDto[] | undefined;

    constructor(data?: ICategoryWithAspectsDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.category = data.category && !(<any>data.category).toJSON ? new CategoryDetailedDto(data.category) : <CategoryDetailedDto>this.category;
            if (data.aspects) {
                this.aspects = [];
                for (let i = 0; i < data.aspects.length; i++) {
                    let item = data.aspects[i];
                    this.aspects[i] = item && !(<any>item).toJSON ? new AspectSimpleDto(item) : <AspectSimpleDto>item;
                }
            }
            if (data.ownedAspects) {
                this.ownedAspects = [];
                for (let i = 0; i < data.ownedAspects.length; i++) {
                    let item = data.ownedAspects[i];
                    this.ownedAspects[i] = item && !(<any>item).toJSON ? new AspectSimpleDto(item) : <AspectSimpleDto>item;
                }
            }
            if (data.inheritedAspects) {
                this.inheritedAspects = [];
                for (let i = 0; i < data.inheritedAspects.length; i++) {
                    let item = data.inheritedAspects[i];
                    this.inheritedAspects[i] = item && !(<any>item).toJSON ? new AspectSimpleDto(item) : <AspectSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"] ? CategoryDetailedDto.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["aspects"])) {
                this.aspects = [] as any;
                for (let item of _data["aspects"])
                    this.aspects!.push(AspectSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["ownedAspects"])) {
                this.ownedAspects = [] as any;
                for (let item of _data["ownedAspects"])
                    this.ownedAspects!.push(AspectSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["inheritedAspects"])) {
                this.inheritedAspects = [] as any;
                for (let item of _data["inheritedAspects"])
                    this.inheritedAspects!.push(AspectSimpleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryWithAspectsDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryWithAspectsDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.aspects)) {
            data["aspects"] = [];
            for (let item of this.aspects)
                data["aspects"].push(item.toJSON());
        }
        if (Array.isArray(this.ownedAspects)) {
            data["ownedAspects"] = [];
            for (let item of this.ownedAspects)
                data["ownedAspects"].push(item.toJSON());
        }
        if (Array.isArray(this.inheritedAspects)) {
            data["inheritedAspects"] = [];
            for (let item of this.inheritedAspects)
                data["inheritedAspects"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoryWithAspectsDetailedDto {
    id: string;
    category: ICategoryDetailedDto;
    aspects: IAspectSimpleDto[] | undefined;
    ownedAspects: IAspectSimpleDto[] | undefined;
    inheritedAspects: IAspectSimpleDto[] | undefined;
}

export class CategoryWithAspectsSimpleDto implements ICategoryWithAspectsSimpleDto {
    id!: string;
    category!: CategorySimpleDto;
    aspects!: AspectSimpleDto[] | undefined;
    ownedAspects!: AspectSimpleDto[] | undefined;
    inheritedAspects!: AspectSimpleDto[] | undefined;

    constructor(data?: ICategoryWithAspectsSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.category = data.category && !(<any>data.category).toJSON ? new CategorySimpleDto(data.category) : <CategorySimpleDto>this.category;
            if (data.aspects) {
                this.aspects = [];
                for (let i = 0; i < data.aspects.length; i++) {
                    let item = data.aspects[i];
                    this.aspects[i] = item && !(<any>item).toJSON ? new AspectSimpleDto(item) : <AspectSimpleDto>item;
                }
            }
            if (data.ownedAspects) {
                this.ownedAspects = [];
                for (let i = 0; i < data.ownedAspects.length; i++) {
                    let item = data.ownedAspects[i];
                    this.ownedAspects[i] = item && !(<any>item).toJSON ? new AspectSimpleDto(item) : <AspectSimpleDto>item;
                }
            }
            if (data.inheritedAspects) {
                this.inheritedAspects = [];
                for (let i = 0; i < data.inheritedAspects.length; i++) {
                    let item = data.inheritedAspects[i];
                    this.inheritedAspects[i] = item && !(<any>item).toJSON ? new AspectSimpleDto(item) : <AspectSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"] ? CategorySimpleDto.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["aspects"])) {
                this.aspects = [] as any;
                for (let item of _data["aspects"])
                    this.aspects!.push(AspectSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["ownedAspects"])) {
                this.ownedAspects = [] as any;
                for (let item of _data["ownedAspects"])
                    this.ownedAspects!.push(AspectSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["inheritedAspects"])) {
                this.inheritedAspects = [] as any;
                for (let item of _data["inheritedAspects"])
                    this.inheritedAspects!.push(AspectSimpleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryWithAspectsSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryWithAspectsSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.aspects)) {
            data["aspects"] = [];
            for (let item of this.aspects)
                data["aspects"].push(item.toJSON());
        }
        if (Array.isArray(this.ownedAspects)) {
            data["ownedAspects"] = [];
            for (let item of this.ownedAspects)
                data["ownedAspects"].push(item.toJSON());
        }
        if (Array.isArray(this.inheritedAspects)) {
            data["inheritedAspects"] = [];
            for (let item of this.inheritedAspects)
                data["inheritedAspects"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICategoryWithAspectsSimpleDto {
    id: string;
    category: ICategorySimpleDto;
    aspects: IAspectSimpleDto[] | undefined;
    ownedAspects: IAspectSimpleDto[] | undefined;
    inheritedAspects: IAspectSimpleDto[] | undefined;
}

export class Change implements IChange {
    id!: string;
    objectType!: string;
    objectId!: string;
    dateTime!: Date;
    user!: RentMyUser;
    changeType!: ChangeType;
    property!: string | undefined;
    originalValue!: string | undefined;
    newValue!: string | undefined;

    constructor(data?: IChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
        }
        if (!data) {
            this.user = new RentMyUser();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : new RentMyUser();
            this.changeType = _data["changeType"];
            this.property = _data["property"];
            this.originalValue = _data["originalValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): Change {
        data = typeof data === 'object' ? data : {};
        let result = new Change();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["changeType"] = this.changeType;
        data["property"] = this.property;
        data["originalValue"] = this.originalValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IChange {
    id: string;
    objectType: string;
    objectId: string;
    dateTime: Date;
    user: IRentMyUser;
    changeType: ChangeType;
    property: string | undefined;
    originalValue: string | undefined;
    newValue: string | undefined;
}

export class ChangeDetailedDto implements IChangeDetailedDto {
    id!: string;
    objectType!: string | undefined;
    objectId!: string;
    changeType!: string | undefined;
    dateTime!: Date;
    user!: ImageableIdentifierDto;
    property!: string | undefined;
    originalValue!: string | undefined;
    newValue!: string | undefined;

    constructor(data?: IChangeDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new ImageableIdentifierDto(data.user) : <ImageableIdentifierDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.changeType = _data["changeType"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.user = _data["user"] ? ImageableIdentifierDto.fromJS(_data["user"]) : <any>undefined;
            this.property = _data["property"];
            this.originalValue = _data["originalValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): ChangeDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["changeType"] = this.changeType;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["property"] = this.property;
        data["originalValue"] = this.originalValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IChangeDetailedDto {
    id: string;
    objectType: string | undefined;
    objectId: string;
    changeType: string | undefined;
    dateTime: Date;
    user: IImageableIdentifierDto;
    property: string | undefined;
    originalValue: string | undefined;
    newValue: string | undefined;
}

export class ChangeDetailedDtoPaginationDto implements IChangeDetailedDtoPaginationDto {
    data!: ChangeDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IChangeDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ChangeDetailedDto(item) : <ChangeDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ChangeDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ChangeDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IChangeDetailedDtoPaginationDto {
    data: IChangeDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum ChangeDetailedSearchBy {
    Property = "Property",
    NewValue = "NewValue",
    OldValue = "OldValue",
    ObjectId = "ObjectId",
    ObjectType = "ObjectType",
}

export class ChangeDto implements IChangeDto {
    id!: string;
    changeType!: string | undefined;
    dateTime!: Date;
    user!: ImageableIdentifierDto;
    property!: string | undefined;
    originalValue!: string | undefined;
    newValue!: string | undefined;

    constructor(data?: IChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new ImageableIdentifierDto(data.user) : <ImageableIdentifierDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.changeType = _data["changeType"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.user = _data["user"] ? ImageableIdentifierDto.fromJS(_data["user"]) : <any>undefined;
            this.property = _data["property"];
            this.originalValue = _data["originalValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): ChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["changeType"] = this.changeType;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["property"] = this.property;
        data["originalValue"] = this.originalValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IChangeDto {
    id: string;
    changeType: string | undefined;
    dateTime: Date;
    user: IImageableIdentifierDto;
    property: string | undefined;
    originalValue: string | undefined;
    newValue: string | undefined;
}

export class ChangeDtoPaginationDto implements IChangeDtoPaginationDto {
    data!: ChangeDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IChangeDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ChangeDto(item) : <ChangeDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ChangeDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ChangeDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IChangeDtoPaginationDto {
    data: IChangeDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum ChangeOrderBy {
    Newest = "Newest",
    Oldest = "Oldest",
}

export enum ChangeSearchBy {
    Property = "Property",
    NewValue = "NewValue",
    OldValue = "OldValue",
}

export enum ChangeType {
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    Purge = "Purge",
    Reactivate = "Reactivate",
    SarGeneration = "SarGeneration",
}

export class CityUserCount implements ICityUserCount {
    city!: string | undefined;
    count!: number;

    constructor(data?: ICityUserCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CityUserCount {
        data = typeof data === 'object' ? data : {};
        let result = new CityUserCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["count"] = this.count;
        return data;
    }
}

export interface ICityUserCount {
    city: string | undefined;
    count: number;
}

export enum ClaimsOrderBy {
    Newest = "Newest",
    Oldest = "Oldest",
    Alphabetically = "Alphabetically",
    Value = "Value",
}

export class ClaimsStatsDto implements IClaimsStatsDto {
    totalClaims!: number;
    pendingClaims!: number;
    approvedClaims!: number;
    rejectedClaims!: number;
    amendedClaims!: number;
    lostClaims!: number;
    theftByRenterClaims!: number;
    theftByThirdPartyClaims!: number;
    damagedClaims!: number;
    destroyedClaims!: number;
    noClaimsClaims!: number;
    totalPaidOut!: number;
    averageClaim!: number;
    claimsDates!: Date;

    constructor(data?: IClaimsStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalClaims = _data["totalClaims"];
            this.pendingClaims = _data["pendingClaims"];
            this.approvedClaims = _data["approvedClaims"];
            this.rejectedClaims = _data["rejectedClaims"];
            this.amendedClaims = _data["amendedClaims"];
            this.lostClaims = _data["lostClaims"];
            this.theftByRenterClaims = _data["theftByRenterClaims"];
            this.theftByThirdPartyClaims = _data["theftByThirdPartyClaims"];
            this.damagedClaims = _data["damagedClaims"];
            this.destroyedClaims = _data["destroyedClaims"];
            this.noClaimsClaims = _data["noClaimsClaims"];
            this.totalPaidOut = _data["totalPaidOut"];
            this.averageClaim = _data["averageClaim"];
            this.claimsDates = _data["claimsDates"] ? new Date(_data["claimsDates"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClaimsStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalClaims"] = this.totalClaims;
        data["pendingClaims"] = this.pendingClaims;
        data["approvedClaims"] = this.approvedClaims;
        data["rejectedClaims"] = this.rejectedClaims;
        data["amendedClaims"] = this.amendedClaims;
        data["lostClaims"] = this.lostClaims;
        data["theftByRenterClaims"] = this.theftByRenterClaims;
        data["theftByThirdPartyClaims"] = this.theftByThirdPartyClaims;
        data["damagedClaims"] = this.damagedClaims;
        data["destroyedClaims"] = this.destroyedClaims;
        data["noClaimsClaims"] = this.noClaimsClaims;
        data["totalPaidOut"] = this.totalPaidOut;
        data["averageClaim"] = this.averageClaim;
        data["claimsDates"] = this.claimsDates ? this.claimsDates.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClaimsStatsDto {
    totalClaims: number;
    pendingClaims: number;
    approvedClaims: number;
    rejectedClaims: number;
    amendedClaims: number;
    lostClaims: number;
    theftByRenterClaims: number;
    theftByThirdPartyClaims: number;
    damagedClaims: number;
    destroyedClaims: number;
    noClaimsClaims: number;
    totalPaidOut: number;
    averageClaim: number;
    claimsDates: Date;
}

export class CommunityPageCreateDto implements ICommunityPageCreateDto {
    active!: boolean | undefined;
    userId!: string;
    content!: string | undefined;

    constructor(data?: ICommunityPageCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.userId = _data["userId"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CommunityPageCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunityPageCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["content"] = this.content;
        return data;
    }
}

export interface ICommunityPageCreateDto {
    active: boolean | undefined;
    userId: string;
    content: string | undefined;
}

export class CommunityPageDetailedDto implements ICommunityPageDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUserSimpleDto;
    content!: string | undefined;

    constructor(data?: ICommunityPageDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserSimpleDto(data.user) : <RentMyUserSimpleDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUserSimpleDto.fromJS(_data["user"]) : <any>undefined;
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CommunityPageDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunityPageDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["content"] = this.content;
        return data;
    }
}

export interface ICommunityPageDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUserSimpleDto;
    content: string | undefined;
}

export class CommunityPageDetailedDtoPaginationDto implements ICommunityPageDetailedDtoPaginationDto {
    data!: CommunityPageDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ICommunityPageDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new CommunityPageDetailedDto(item) : <CommunityPageDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CommunityPageDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): CommunityPageDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunityPageDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ICommunityPageDetailedDtoPaginationDto {
    data: ICommunityPageDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class CommunityPageDetailedDtoUpdateResponseDto implements ICommunityPageDetailedDtoUpdateResponseDto {
    data!: CommunityPageDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: ICommunityPageDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new CommunityPageDetailedDto(data.data) : <CommunityPageDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CommunityPageDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): CommunityPageDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunityPageDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICommunityPageDetailedDtoUpdateResponseDto {
    data: ICommunityPageDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class CommunityPageSimpleDto implements ICommunityPageSimpleDto {
    id!: string;
    active!: boolean;
    userId!: string;
    content!: string | undefined;

    constructor(data?: ICommunityPageSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.userId = _data["userId"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CommunityPageSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunityPageSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["content"] = this.content;
        return data;
    }
}

export interface ICommunityPageSimpleDto {
    id: string;
    active: boolean;
    userId: string;
    content: string | undefined;
}

export class CommunityPageSimpleDtoPaginationDto implements ICommunityPageSimpleDtoPaginationDto {
    data!: CommunityPageSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ICommunityPageSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new CommunityPageSimpleDto(item) : <CommunityPageSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CommunityPageSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): CommunityPageSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunityPageSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ICommunityPageSimpleDtoPaginationDto {
    data: ICommunityPageSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ContentAlignment implements IContentAlignment {
    desktop!: Alignment;
    mobile!: Alignment;

    constructor(data?: IContentAlignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktop = _data["desktop"];
            this.mobile = _data["mobile"];
        }
    }

    static fromJS(data: any): ContentAlignment {
        data = typeof data === 'object' ? data : {};
        let result = new ContentAlignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktop"] = this.desktop;
        data["mobile"] = this.mobile;
        return data;
    }
}

export interface IContentAlignment {
    desktop: Alignment;
    mobile: Alignment;
}

export class ConversationDto implements IConversationDto {
    id!: string;
    users!: RentMyUserPublicSimpleDto[] | undefined;
    messages!: MessageSimpleDto[] | undefined;
    lastMessage!: MessageSimpleDto;
    subject!: string | undefined;
    messageCount!: number;
    unreadMessages!: boolean;

    constructor(data?: IConversationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.users) {
                this.users = [];
                for (let i = 0; i < data.users.length; i++) {
                    let item = data.users[i];
                    this.users[i] = item && !(<any>item).toJSON ? new RentMyUserPublicSimpleDto(item) : <RentMyUserPublicSimpleDto>item;
                }
            }
            if (data.messages) {
                this.messages = [];
                for (let i = 0; i < data.messages.length; i++) {
                    let item = data.messages[i];
                    this.messages[i] = item && !(<any>item).toJSON ? new MessageSimpleDto(item) : <MessageSimpleDto>item;
                }
            }
            this.lastMessage = data.lastMessage && !(<any>data.lastMessage).toJSON ? new MessageSimpleDto(data.lastMessage) : <MessageSimpleDto>this.lastMessage;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(RentMyUserPublicSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MessageSimpleDto.fromJS(item));
            }
            this.lastMessage = _data["lastMessage"] ? MessageSimpleDto.fromJS(_data["lastMessage"]) : <any>undefined;
            this.subject = _data["subject"];
            this.messageCount = _data["messageCount"];
            this.unreadMessages = _data["unreadMessages"];
        }
    }

    static fromJS(data: any): ConversationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["lastMessage"] = this.lastMessage ? this.lastMessage.toJSON() : <any>undefined;
        data["subject"] = this.subject;
        data["messageCount"] = this.messageCount;
        data["unreadMessages"] = this.unreadMessages;
        return data;
    }
}

export interface IConversationDto {
    id: string;
    users: IRentMyUserPublicSimpleDto[] | undefined;
    messages: IMessageSimpleDto[] | undefined;
    lastMessage: IMessageSimpleDto;
    subject: string | undefined;
    messageCount: number;
    unreadMessages: boolean;
}

export class ConversationDtoPaginationDto implements IConversationDtoPaginationDto {
    data!: ConversationDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IConversationDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ConversationDto(item) : <ConversationDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConversationDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ConversationDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IConversationDtoPaginationDto {
    data: IConversationDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum ConversationOrderBy {
    Newest = "Newest",
    Oldest = "Oldest",
    Subject = "Subject",
}

export class Coordinate implements ICoordinate {
    x!: number;
    y!: number;
    z!: number;
    m!: number;
    coordinateValue!: Coordinate;
    readonly isValid!: boolean;

    constructor(data?: ICoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.coordinateValue = data.coordinateValue && !(<any>data.coordinateValue).toJSON ? new Coordinate(data.coordinateValue) : <Coordinate>this.coordinateValue;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
            this.m = _data["m"];
            this.coordinateValue = _data["coordinateValue"] ? Coordinate.fromJS(_data["coordinateValue"]) : <any>undefined;
            (<any>this).isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): Coordinate {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        data["m"] = this.m;
        data["coordinateValue"] = this.coordinateValue ? this.coordinateValue.toJSON() : <any>undefined;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface ICoordinate {
    x: number;
    y: number;
    z: number;
    m: number;
    coordinateValue: ICoordinate;
    isValid: boolean;
}

export class CoordinateEqualityComparer implements ICoordinateEqualityComparer {

    constructor(data?: ICoordinateEqualityComparer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CoordinateEqualityComparer {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateEqualityComparer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICoordinateEqualityComparer {
}

export class CoordinateSequence implements ICoordinateSequence {
    readonly dimension!: number;
    readonly measures!: number;
    readonly spatial!: number;
    ordinates!: Ordinates;
    readonly hasZ!: boolean;
    readonly hasM!: boolean;
    readonly zOrdinateIndex!: number;
    readonly mOrdinateIndex!: number;
    first!: Coordinate;
    last!: Coordinate;
    readonly count!: number;

    constructor(data?: ICoordinateSequence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.first = data.first && !(<any>data.first).toJSON ? new Coordinate(data.first) : <Coordinate>this.first;
            this.last = data.last && !(<any>data.last).toJSON ? new Coordinate(data.last) : <Coordinate>this.last;
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).dimension = _data["dimension"];
            (<any>this).measures = _data["measures"];
            (<any>this).spatial = _data["spatial"];
            this.ordinates = _data["ordinates"];
            (<any>this).hasZ = _data["hasZ"];
            (<any>this).hasM = _data["hasM"];
            (<any>this).zOrdinateIndex = _data["zOrdinateIndex"];
            (<any>this).mOrdinateIndex = _data["mOrdinateIndex"];
            this.first = _data["first"] ? Coordinate.fromJS(_data["first"]) : <any>undefined;
            this.last = _data["last"] ? Coordinate.fromJS(_data["last"]) : <any>undefined;
            (<any>this).count = _data["count"];
        }
    }

    static fromJS(data: any): CoordinateSequence {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateSequence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dimension"] = this.dimension;
        data["measures"] = this.measures;
        data["spatial"] = this.spatial;
        data["ordinates"] = this.ordinates;
        data["hasZ"] = this.hasZ;
        data["hasM"] = this.hasM;
        data["zOrdinateIndex"] = this.zOrdinateIndex;
        data["mOrdinateIndex"] = this.mOrdinateIndex;
        data["first"] = this.first ? this.first.toJSON() : <any>undefined;
        data["last"] = this.last ? this.last.toJSON() : <any>undefined;
        data["count"] = this.count;
        return data;
    }
}

export interface ICoordinateSequence {
    dimension: number;
    measures: number;
    spatial: number;
    ordinates: Ordinates;
    hasZ: boolean;
    hasM: boolean;
    zOrdinateIndex: number;
    mOrdinateIndex: number;
    first: ICoordinate;
    last: ICoordinate;
    count: number;
}

export class CoordinateSequenceFactory implements ICoordinateSequenceFactory {
    ordinates!: Ordinates;

    constructor(data?: ICoordinateSequenceFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinates = _data["ordinates"];
        }
    }

    static fromJS(data: any): CoordinateSequenceFactory {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateSequenceFactory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinates"] = this.ordinates;
        return data;
    }
}

export interface ICoordinateSequenceFactory {
    ordinates: Ordinates;
}

export class Coordinates implements ICoordinates {
    longitude!: number;
    latitude!: number;

    constructor(data?: ICoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
        }
    }

    static fromJS(data: any): Coordinates {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    }
}

export interface ICoordinates {
    longitude: number;
    latitude: number;
}

export class CourierCreateDto implements ICourierCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    courierType!: string | undefined;
    cost!: number;

    constructor(data?: ICourierCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.courierType = _data["courierType"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): CourierCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourierCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["courierType"] = this.courierType;
        data["cost"] = this.cost;
        return data;
    }
}

export interface ICourierCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    courierType: string | undefined;
    cost: number;
}

export class CourierDetailedDto implements ICourierDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    courierType!: string | undefined;
    cost!: number;

    constructor(data?: ICourierDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.courierType = _data["courierType"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): CourierDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourierDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["courierType"] = this.courierType;
        data["cost"] = this.cost;
        return data;
    }
}

export interface ICourierDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    courierType: string | undefined;
    cost: number;
}

export class CourierDetailedDtoPaginationDto implements ICourierDetailedDtoPaginationDto {
    data!: CourierDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ICourierDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new CourierDetailedDto(item) : <CourierDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CourierDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): CourierDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourierDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ICourierDetailedDtoPaginationDto {
    data: ICourierDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class CourierDetailedDtoUpdateResponseDto implements ICourierDetailedDtoUpdateResponseDto {
    data!: CourierDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: ICourierDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new CourierDetailedDto(data.data) : <CourierDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CourierDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): CourierDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourierDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ICourierDetailedDtoUpdateResponseDto {
    data: ICourierDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class CourierSimpleDto implements ICourierSimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    courierType!: string | undefined;
    cost!: number;

    constructor(data?: ICourierSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.courierType = _data["courierType"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): CourierSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourierSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["courierType"] = this.courierType;
        data["cost"] = this.cost;
        return data;
    }
}

export interface ICourierSimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    courierType: string | undefined;
    cost: number;
}

export class CourierSimpleDtoPaginationDto implements ICourierSimpleDtoPaginationDto {
    data!: CourierSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ICourierSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new CourierSimpleDto(item) : <CourierSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CourierSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): CourierSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CourierSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ICourierSimpleDtoPaginationDto {
    data: ICourierSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum CurrencyIsoCode {
    ALL = "ALL",
    DZD = "DZD",
    ARS = "ARS",
    AUD = "AUD",
    BSD = "BSD",
    BHD = "BHD",
    BDT = "BDT",
    AMD = "AMD",
    BBD = "BBD",
    BMD = "BMD",
    BTN = "BTN",
    BOB = "BOB",
    BWP = "BWP",
    BZD = "BZD",
    SBD = "SBD",
    BND = "BND",
    MMK = "MMK",
    BIF = "BIF",
    KHR = "KHR",
    CAD = "CAD",
    CVE = "CVE",
    KYD = "KYD",
    LKR = "LKR",
    CLP = "CLP",
    CNY = "CNY",
    COP = "COP",
    KMF = "KMF",
    CRC = "CRC",
    HRK = "HRK",
    CUP = "CUP",
    CZK = "CZK",
    DKK = "DKK",
    DOP = "DOP",
    SVC = "SVC",
    ETB = "ETB",
    ERN = "ERN",
    EEK = "EEK",
    FKP = "FKP",
    FJD = "FJD",
    DJF = "DJF",
    GMD = "GMD",
    GIP = "GIP",
    GTQ = "GTQ",
    GNF = "GNF",
    GYD = "GYD",
    HTG = "HTG",
    HNL = "HNL",
    HKD = "HKD",
    HUF = "HUF",
    ISK = "ISK",
    INR = "INR",
    IDR = "IDR",
    IRR = "IRR",
    IQD = "IQD",
    ILS = "ILS",
    JMD = "JMD",
    JPY = "JPY",
    KZT = "KZT",
    JOD = "JOD",
    KES = "KES",
    KPW = "KPW",
    KRW = "KRW",
    KWD = "KWD",
    KGS = "KGS",
    LAK = "LAK",
    LBP = "LBP",
    LSL = "LSL",
    LVL = "LVL",
    LRD = "LRD",
    LYD = "LYD",
    LTL = "LTL",
    MOP = "MOP",
    MWK = "MWK",
    MYR = "MYR",
    MVR = "MVR",
    MRO = "MRO",
    MUR = "MUR",
    MXN = "MXN",
    MNT = "MNT",
    MDL = "MDL",
    MAD = "MAD",
    OMR = "OMR",
    NAD = "NAD",
    NPR = "NPR",
    ANG = "ANG",
    AWG = "AWG",
    VUV = "VUV",
    NZD = "NZD",
    NIO = "NIO",
    NGN = "NGN",
    NOK = "NOK",
    PKR = "PKR",
    PAB = "PAB",
    PGK = "PGK",
    PYG = "PYG",
    PEN = "PEN",
    PHP = "PHP",
    QAR = "QAR",
    RUB = "RUB",
    RWF = "RWF",
    SHP = "SHP",
    STD = "STD",
    SAR = "SAR",
    SCR = "SCR",
    SLL = "SLL",
    SGD = "SGD",
    VND = "VND",
    SOS = "SOS",
    ZAR = "ZAR",
    SSP = "SSP",
    SZL = "SZL",
    SEK = "SEK",
    CHF = "CHF",
    SYP = "SYP",
    THB = "THB",
    TOP = "TOP",
    TTD = "TTD",
    AED = "AED",
    TND = "TND",
    UGX = "UGX",
    MKD = "MKD",
    EGP = "EGP",
    GBP = "GBP",
    TZS = "TZS",
    USD = "USD",
    UYU = "UYU",
    UZS = "UZS",
    WST = "WST",
    YER = "YER",
    ZMK = "ZMK",
    TWD = "TWD",
    UYW = "UYW",
    VES = "VES",
    MRU = "MRU",
    STN = "STN",
    CUC = "CUC",
    ZWL = "ZWL",
    BYN = "BYN",
    TMT = "TMT",
    GHS = "GHS",
    VEF = "VEF",
    SDG = "SDG",
    UYI = "UYI",
    RSD = "RSD",
    MZN = "MZN",
    AZN = "AZN",
    RON = "RON",
    CHE = "CHE",
    CHW = "CHW",
    TRY = "TRY",
    XAF = "XAF",
    XCD = "XCD",
    XOF = "XOF",
    XPF = "XPF",
    XBA = "XBA",
    XBB = "XBB",
    XBC = "XBC",
    XBD = "XBD",
    XAU = "XAU",
    XDR = "XDR",
    XAG = "XAG",
    XPT = "XPT",
    XTS = "XTS",
    XPD = "XPD",
    XUA = "XUA",
    ZMW = "ZMW",
    SRD = "SRD",
    MGA = "MGA",
    COU = "COU",
    AFN = "AFN",
    TJS = "TJS",
    AOA = "AOA",
    BYR = "BYR",
    BGN = "BGN",
    CDF = "CDF",
    BAM = "BAM",
    EUR = "EUR",
    MXV = "MXV",
    UAH = "UAH",
    GEL = "GEL",
    BOV = "BOV",
    PLN = "PLN",
    BRL = "BRL",
    CLF = "CLF",
    XSU = "XSU",
    USN = "USN",
    USS = "USS",
    XXX = "XXX",
}

export class DateRange implements IDateRange {
    start!: number;
    end!: number;

    constructor(data?: IDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"];
            this.end = _data["end"];
        }
    }

    static fromJS(data: any): DateRange {
        data = typeof data === 'object' ? data : {};
        let result = new DateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start;
        data["end"] = this.end;
        return data;
    }
}

export interface IDateRange {
    start: number;
    end: number;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export class DayOverride implements IDayOverride {
    day!: DayOfWeek;
    price!: Price;
    dailyDiscount!: number | undefined;
    hourlyDiscount!: number | undefined;

    constructor(data?: IDayOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.price = data.price && !(<any>data.price).toJSON ? new Price(data.price) : <Price>this.price;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.price = _data["price"] ? Price.fromJS(_data["price"]) : <any>undefined;
            this.dailyDiscount = _data["dailyDiscount"];
            this.hourlyDiscount = _data["hourlyDiscount"];
        }
    }

    static fromJS(data: any): DayOverride {
        data = typeof data === 'object' ? data : {};
        let result = new DayOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["dailyDiscount"] = this.dailyDiscount;
        data["hourlyDiscount"] = this.hourlyDiscount;
        return data;
    }
}

export interface IDayOverride {
    day: DayOfWeek;
    price: IPrice;
    dailyDiscount: number | undefined;
    hourlyDiscount: number | undefined;
}

export class DayPrice implements IDayPrice {
    daily!: number | undefined;
    hourly!: number | undefined;
    dailyServiceFee!: number | undefined;
    hourlyServiceFee!: number | undefined;
    hourlyStart!: number | undefined;
    hourlyEnd!: number | undefined;
    deposit!: number | undefined;
    currency!: CurrencyIsoCode;
    pricePeriodName!: string | undefined;

    constructor(data?: IDayPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.daily = _data["daily"];
            this.hourly = _data["hourly"];
            this.dailyServiceFee = _data["dailyServiceFee"];
            this.hourlyServiceFee = _data["hourlyServiceFee"];
            this.hourlyStart = _data["hourlyStart"];
            this.hourlyEnd = _data["hourlyEnd"];
            this.deposit = _data["deposit"];
            this.currency = _data["currency"];
            this.pricePeriodName = _data["pricePeriodName"];
        }
    }

    static fromJS(data: any): DayPrice {
        data = typeof data === 'object' ? data : {};
        let result = new DayPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daily"] = this.daily;
        data["hourly"] = this.hourly;
        data["dailyServiceFee"] = this.dailyServiceFee;
        data["hourlyServiceFee"] = this.hourlyServiceFee;
        data["hourlyStart"] = this.hourlyStart;
        data["hourlyEnd"] = this.hourlyEnd;
        data["deposit"] = this.deposit;
        data["currency"] = this.currency;
        data["pricePeriodName"] = this.pricePeriodName;
        return data;
    }
}

export interface IDayPrice {
    daily: number | undefined;
    hourly: number | undefined;
    dailyServiceFee: number | undefined;
    hourlyServiceFee: number | undefined;
    hourlyStart: number | undefined;
    hourlyEnd: number | undefined;
    deposit: number | undefined;
    currency: CurrencyIsoCode;
    pricePeriodName: string | undefined;
}

export class DeliveryCreateDto implements IDeliveryCreateDto {
    active!: boolean | undefined;
    bookingId!: string;
    courierId!: string;
    deliveryStatus!: number;

    constructor(data?: IDeliveryCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.bookingId = _data["bookingId"];
            this.courierId = _data["courierId"];
            this.deliveryStatus = _data["deliveryStatus"];
        }
    }

    static fromJS(data: any): DeliveryCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["bookingId"] = this.bookingId;
        data["courierId"] = this.courierId;
        data["deliveryStatus"] = this.deliveryStatus;
        return data;
    }
}

export interface IDeliveryCreateDto {
    active: boolean | undefined;
    bookingId: string;
    courierId: string;
    deliveryStatus: number;
}

export class DeliveryDetailedDto implements IDeliveryDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    booking!: BookingSimpleDto;
    courier!: CourierSimpleDto;
    deliveryStatus!: number;

    constructor(data?: IDeliveryDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.booking = data.booking && !(<any>data.booking).toJSON ? new BookingSimpleDto(data.booking) : <BookingSimpleDto>this.booking;
            this.courier = data.courier && !(<any>data.courier).toJSON ? new CourierSimpleDto(data.courier) : <CourierSimpleDto>this.courier;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.booking = _data["booking"] ? BookingSimpleDto.fromJS(_data["booking"]) : <any>undefined;
            this.courier = _data["courier"] ? CourierSimpleDto.fromJS(_data["courier"]) : <any>undefined;
            this.deliveryStatus = _data["deliveryStatus"];
        }
    }

    static fromJS(data: any): DeliveryDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["booking"] = this.booking ? this.booking.toJSON() : <any>undefined;
        data["courier"] = this.courier ? this.courier.toJSON() : <any>undefined;
        data["deliveryStatus"] = this.deliveryStatus;
        return data;
    }
}

export interface IDeliveryDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    booking: IBookingSimpleDto;
    courier: ICourierSimpleDto;
    deliveryStatus: number;
}

export class DeliveryDetailedDtoPaginationDto implements IDeliveryDetailedDtoPaginationDto {
    data!: DeliveryDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IDeliveryDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new DeliveryDetailedDto(item) : <DeliveryDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DeliveryDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): DeliveryDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IDeliveryDetailedDtoPaginationDto {
    data: IDeliveryDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class DeliveryDetailedDtoUpdateResponseDto implements IDeliveryDetailedDtoUpdateResponseDto {
    data!: DeliveryDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IDeliveryDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new DeliveryDetailedDto(data.data) : <DeliveryDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DeliveryDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): DeliveryDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IDeliveryDetailedDtoUpdateResponseDto {
    data: IDeliveryDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class DeliverySimpleDto implements IDeliverySimpleDto {
    id!: string;
    active!: boolean;
    bookingId!: string;
    courierId!: string;
    deliveryStatus!: number;

    constructor(data?: IDeliverySimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.bookingId = _data["bookingId"];
            this.courierId = _data["courierId"];
            this.deliveryStatus = _data["deliveryStatus"];
        }
    }

    static fromJS(data: any): DeliverySimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliverySimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["bookingId"] = this.bookingId;
        data["courierId"] = this.courierId;
        data["deliveryStatus"] = this.deliveryStatus;
        return data;
    }
}

export interface IDeliverySimpleDto {
    id: string;
    active: boolean;
    bookingId: string;
    courierId: string;
    deliveryStatus: number;
}

export class DeliverySimpleDtoPaginationDto implements IDeliverySimpleDtoPaginationDto {
    data!: DeliverySimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IDeliverySimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new DeliverySimpleDto(item) : <DeliverySimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DeliverySimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): DeliverySimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliverySimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IDeliverySimpleDtoPaginationDto {
    data: IDeliverySimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class DescribableIdentifierDto implements IDescribableIdentifierDto {
    id!: string;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: IDescribableIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DescribableIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new DescribableIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IDescribableIdentifierDto {
    id: string;
    name: string | undefined;
    description: string | undefined;
}

export enum Dimension {
    Point = "Point",
    Curve = "Curve",
    Surface = "Surface",
    Collapse = "Collapse",
    Dontcare = "Dontcare",
    True = "True",
    False = "False",
}

export class Discount implements IDiscount {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    owner!: RentMyUser;
    discountedUser!: RentMyUser;
    discountedAmount!: number;

    constructor(data?: IDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.owner = data.owner && !(<any>data.owner).toJSON ? new RentMyUser(data.owner) : <RentMyUser>this.owner;
            this.discountedUser = data.discountedUser && !(<any>data.discountedUser).toJSON ? new RentMyUser(data.discountedUser) : <RentMyUser>this.discountedUser;
        }
        if (!data) {
            this.owner = new RentMyUser();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.owner = _data["owner"] ? RentMyUser.fromJS(_data["owner"]) : new RentMyUser();
            this.discountedUser = _data["discountedUser"] ? RentMyUser.fromJS(_data["discountedUser"]) : <any>undefined;
            this.discountedAmount = _data["discountedAmount"];
        }
    }

    static fromJS(data: any): Discount {
        data = typeof data === 'object' ? data : {};
        let result = new Discount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["discountedUser"] = this.discountedUser ? this.discountedUser.toJSON() : <any>undefined;
        data["discountedAmount"] = this.discountedAmount;
        return data;
    }
}

export interface IDiscount {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    owner: IRentMyUser;
    discountedUser: IRentMyUser;
    discountedAmount: number;
}

export class DiscountCreateDto implements IDiscountCreateDto {
    active!: boolean | undefined;
    discountedUserId!: string;
    discountedAmount!: number;

    constructor(data?: IDiscountCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.discountedUserId = _data["discountedUserId"];
            this.discountedAmount = _data["discountedAmount"];
        }
    }

    static fromJS(data: any): DiscountCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["discountedUserId"] = this.discountedUserId;
        data["discountedAmount"] = this.discountedAmount;
        return data;
    }
}

export interface IDiscountCreateDto {
    active: boolean | undefined;
    discountedUserId: string;
    discountedAmount: number;
}

export class DiscountDetailedDto implements IDiscountDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    owner!: RentMyUserSimpleDto;
    discountedUser!: RentMyUserSimpleDto;
    discountedAmount!: number;

    constructor(data?: IDiscountDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.owner = data.owner && !(<any>data.owner).toJSON ? new RentMyUserSimpleDto(data.owner) : <RentMyUserSimpleDto>this.owner;
            this.discountedUser = data.discountedUser && !(<any>data.discountedUser).toJSON ? new RentMyUserSimpleDto(data.discountedUser) : <RentMyUserSimpleDto>this.discountedUser;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.owner = _data["owner"] ? RentMyUserSimpleDto.fromJS(_data["owner"]) : <any>undefined;
            this.discountedUser = _data["discountedUser"] ? RentMyUserSimpleDto.fromJS(_data["discountedUser"]) : <any>undefined;
            this.discountedAmount = _data["discountedAmount"];
        }
    }

    static fromJS(data: any): DiscountDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["discountedUser"] = this.discountedUser ? this.discountedUser.toJSON() : <any>undefined;
        data["discountedAmount"] = this.discountedAmount;
        return data;
    }
}

export interface IDiscountDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    owner: IRentMyUserSimpleDto;
    discountedUser: IRentMyUserSimpleDto;
    discountedAmount: number;
}

export class DiscountDetailedDtoPaginationDto implements IDiscountDetailedDtoPaginationDto {
    data!: DiscountDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IDiscountDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new DiscountDetailedDto(item) : <DiscountDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DiscountDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): DiscountDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IDiscountDetailedDtoPaginationDto {
    data: IDiscountDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class DiscountDetailedDtoUpdateResponseDto implements IDiscountDetailedDtoUpdateResponseDto {
    data!: DiscountDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IDiscountDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new DiscountDetailedDto(data.data) : <DiscountDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DiscountDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): DiscountDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IDiscountDetailedDtoUpdateResponseDto {
    data: IDiscountDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class DiscountSimpleDto implements IDiscountSimpleDto {
    id!: string;
    active!: boolean;
    ownerId!: string;
    discountedUserId!: string | undefined;
    discountedAmount!: number;

    constructor(data?: IDiscountSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.ownerId = _data["ownerId"];
            this.discountedUserId = _data["discountedUserId"];
            this.discountedAmount = _data["discountedAmount"];
        }
    }

    static fromJS(data: any): DiscountSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["ownerId"] = this.ownerId;
        data["discountedUserId"] = this.discountedUserId;
        data["discountedAmount"] = this.discountedAmount;
        return data;
    }
}

export interface IDiscountSimpleDto {
    id: string;
    active: boolean;
    ownerId: string;
    discountedUserId: string | undefined;
    discountedAmount: number;
}

export class DiscountSimpleDtoPaginationDto implements IDiscountSimpleDtoPaginationDto {
    data!: DiscountSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IDiscountSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new DiscountSimpleDto(item) : <DiscountSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DiscountSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): DiscountSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IDiscountSimpleDtoPaginationDto {
    data: IDiscountSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class DocumentDto implements IDocumentDto {
    id!: string;
    name!: string | undefined;
    dataType!: string | undefined;
    size!: number | undefined;
    path!: string | undefined;
    user!: NamedIdentifierDto;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new NamedIdentifierDto(data.user) : <NamedIdentifierDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.size = _data["size"];
            this.path = _data["path"];
            this.user = _data["user"] ? NamedIdentifierDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["size"] = this.size;
        data["path"] = this.path;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocumentDto {
    id: string;
    name: string | undefined;
    dataType: string | undefined;
    size: number | undefined;
    path: string | undefined;
    user: INamedIdentifierDto;
}

export class DocumentDtoPaginationDto implements IDocumentDtoPaginationDto {
    data!: DocumentDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IDocumentDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new DocumentDto(item) : <DocumentDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DocumentDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): DocumentDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IDocumentDtoPaginationDto {
    data: IDocumentDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class Envelope implements IEnvelope {
    readonly isNull!: boolean;
    readonly width!: number;
    readonly height!: number;
    readonly diameter!: number;
    readonly minX!: number;
    readonly maxX!: number;
    readonly minY!: number;
    readonly maxY!: number;
    readonly area!: number;
    readonly minExtent!: number;
    readonly maxExtent!: number;
    centre!: Coordinate;

    constructor(data?: IEnvelope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.centre = data.centre && !(<any>data.centre).toJSON ? new Coordinate(data.centre) : <Coordinate>this.centre;
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isNull = _data["isNull"];
            (<any>this).width = _data["width"];
            (<any>this).height = _data["height"];
            (<any>this).diameter = _data["diameter"];
            (<any>this).minX = _data["minX"];
            (<any>this).maxX = _data["maxX"];
            (<any>this).minY = _data["minY"];
            (<any>this).maxY = _data["maxY"];
            (<any>this).area = _data["area"];
            (<any>this).minExtent = _data["minExtent"];
            (<any>this).maxExtent = _data["maxExtent"];
            this.centre = _data["centre"] ? Coordinate.fromJS(_data["centre"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Envelope {
        data = typeof data === 'object' ? data : {};
        let result = new Envelope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNull"] = this.isNull;
        data["width"] = this.width;
        data["height"] = this.height;
        data["diameter"] = this.diameter;
        data["minX"] = this.minX;
        data["maxX"] = this.maxX;
        data["minY"] = this.minY;
        data["maxY"] = this.maxY;
        data["area"] = this.area;
        data["minExtent"] = this.minExtent;
        data["maxExtent"] = this.maxExtent;
        data["centre"] = this.centre ? this.centre.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEnvelope {
    isNull: boolean;
    width: number;
    height: number;
    diameter: number;
    minX: number;
    maxX: number;
    minY: number;
    maxY: number;
    area: number;
    minExtent: number;
    maxExtent: number;
    centre: ICoordinate;
}

export class ExcludedWordsCreateDto implements IExcludedWordsCreateDto {
    active!: boolean | undefined;
    word!: string | undefined;

    constructor(data?: IExcludedWordsCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.word = _data["word"];
        }
    }

    static fromJS(data: any): ExcludedWordsCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedWordsCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["word"] = this.word;
        return data;
    }
}

export interface IExcludedWordsCreateDto {
    active: boolean | undefined;
    word: string | undefined;
}

export class ExcludedWordsDetailedDto implements IExcludedWordsDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    word!: string | undefined;

    constructor(data?: IExcludedWordsDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.word = _data["word"];
        }
    }

    static fromJS(data: any): ExcludedWordsDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedWordsDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["word"] = this.word;
        return data;
    }
}

export interface IExcludedWordsDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    word: string | undefined;
}

export class ExcludedWordsDetailedDtoUpdateResponseDto implements IExcludedWordsDetailedDtoUpdateResponseDto {
    data!: ExcludedWordsDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IExcludedWordsDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new ExcludedWordsDetailedDto(data.data) : <ExcludedWordsDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ExcludedWordsDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): ExcludedWordsDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedWordsDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IExcludedWordsDetailedDtoUpdateResponseDto {
    data: IExcludedWordsDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class ExcludedWordsSimpleDto implements IExcludedWordsSimpleDto {
    id!: string;
    active!: boolean;
    word!: string | undefined;

    constructor(data?: IExcludedWordsSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.word = _data["word"];
        }
    }

    static fromJS(data: any): ExcludedWordsSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedWordsSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["word"] = this.word;
        return data;
    }
}

export interface IExcludedWordsSimpleDto {
    id: string;
    active: boolean;
    word: string | undefined;
}

export class ExcludedWordsSimpleDtoPaginationDto implements IExcludedWordsSimpleDtoPaginationDto {
    data!: ExcludedWordsSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IExcludedWordsSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ExcludedWordsSimpleDto(item) : <ExcludedWordsSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ExcludedWordsSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ExcludedWordsSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedWordsSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IExcludedWordsSimpleDtoPaginationDto {
    data: IExcludedWordsSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class FavouriteItem implements IFavouriteItem {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUser;
    item!: Item;

    constructor(data?: IFavouriteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
            this.item = data.item && !(<any>data.item).toJSON ? new Item(data.item) : <Item>this.item;
        }
        if (!data) {
            this.user = new RentMyUser();
            this.item = new Item();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : new RentMyUser();
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : new Item();
        }
    }

    static fromJS(data: any): FavouriteItem {
        data = typeof data === 'object' ? data : {};
        let result = new FavouriteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFavouriteItem {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUser;
    item: IItem;
}

export class FeaturedItemsCreateDto implements IFeaturedItemsCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    items!: string[] | undefined;

    constructor(data?: IFeaturedItemsCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
        }
    }

    static fromJS(data: any): FeaturedItemsCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeaturedItemsCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data;
    }
}

export interface IFeaturedItemsCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    items: string[] | undefined;
}

export class FeaturedItemsDto implements IFeaturedItemsDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    items!: ItemFeaturedDto[] | undefined;

    constructor(data?: IFeaturedItemsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new ItemFeaturedDto(item) : <ItemFeaturedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemFeaturedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeaturedItemsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeaturedItemsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFeaturedItemsDto {
    id: string;
    active: boolean;
    name: string | undefined;
    items: IItemFeaturedDto[] | undefined;
}

export class FeaturedItemsDtoPaginationDto implements IFeaturedItemsDtoPaginationDto {
    data!: FeaturedItemsDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IFeaturedItemsDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new FeaturedItemsDto(item) : <FeaturedItemsDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FeaturedItemsDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): FeaturedItemsDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeaturedItemsDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IFeaturedItemsDtoPaginationDto {
    data: IFeaturedItemsDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum FeaturedItemsOrderBy {
    Relevance = "Relevance",
    Newest = "Newest",
    Oldest = "Oldest",
}

export enum FilterParameters {
    Profanity = "Profanity",
    PersonalInformation = "PersonalInformation",
    Brands = "Brands",
}

export class FilterReturn implements IFilterReturn {
    profanity!: FilteredWordSimpleDto[] | undefined;
    personal!: FilteredWordSimpleDto[] | undefined;
    brand!: FilteredWordSimpleDto[] | undefined;
    newText!: string | undefined;
    oldText!: string | undefined;
    flagReasons!: string[] | undefined;

    constructor(data?: IFilterReturn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.profanity) {
                this.profanity = [];
                for (let i = 0; i < data.profanity.length; i++) {
                    let item = data.profanity[i];
                    this.profanity[i] = item && !(<any>item).toJSON ? new FilteredWordSimpleDto(item) : <FilteredWordSimpleDto>item;
                }
            }
            if (data.personal) {
                this.personal = [];
                for (let i = 0; i < data.personal.length; i++) {
                    let item = data.personal[i];
                    this.personal[i] = item && !(<any>item).toJSON ? new FilteredWordSimpleDto(item) : <FilteredWordSimpleDto>item;
                }
            }
            if (data.brand) {
                this.brand = [];
                for (let i = 0; i < data.brand.length; i++) {
                    let item = data.brand[i];
                    this.brand[i] = item && !(<any>item).toJSON ? new FilteredWordSimpleDto(item) : <FilteredWordSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["profanity"])) {
                this.profanity = [] as any;
                for (let item of _data["profanity"])
                    this.profanity!.push(FilteredWordSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["personal"])) {
                this.personal = [] as any;
                for (let item of _data["personal"])
                    this.personal!.push(FilteredWordSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["brand"])) {
                this.brand = [] as any;
                for (let item of _data["brand"])
                    this.brand!.push(FilteredWordSimpleDto.fromJS(item));
            }
            this.newText = _data["newText"];
            this.oldText = _data["oldText"];
            if (Array.isArray(_data["flagReasons"])) {
                this.flagReasons = [] as any;
                for (let item of _data["flagReasons"])
                    this.flagReasons!.push(item);
            }
        }
    }

    static fromJS(data: any): FilterReturn {
        data = typeof data === 'object' ? data : {};
        let result = new FilterReturn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profanity)) {
            data["profanity"] = [];
            for (let item of this.profanity)
                data["profanity"].push(item.toJSON());
        }
        if (Array.isArray(this.personal)) {
            data["personal"] = [];
            for (let item of this.personal)
                data["personal"].push(item.toJSON());
        }
        if (Array.isArray(this.brand)) {
            data["brand"] = [];
            for (let item of this.brand)
                data["brand"].push(item.toJSON());
        }
        data["newText"] = this.newText;
        data["oldText"] = this.oldText;
        if (Array.isArray(this.flagReasons)) {
            data["flagReasons"] = [];
            for (let item of this.flagReasons)
                data["flagReasons"].push(item);
        }
        return data;
    }
}

export interface IFilterReturn {
    profanity: IFilteredWordSimpleDto[] | undefined;
    personal: IFilteredWordSimpleDto[] | undefined;
    brand: IFilteredWordSimpleDto[] | undefined;
    newText: string | undefined;
    oldText: string | undefined;
    flagReasons: string[] | undefined;
}

export class FilterTextRequest implements IFilterTextRequest {
    text!: string | undefined;
    parameters!: FilterParameters[] | undefined;

    constructor(data?: IFilterTextRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(item);
            }
        }
    }

    static fromJS(data: any): FilterTextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterTextRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item);
        }
        return data;
    }
}

export interface IFilterTextRequest {
    text: string | undefined;
    parameters: FilterParameters[] | undefined;
}

export class FilteredWordCreateDto implements IFilteredWordCreateDto {
    active!: boolean | undefined;
    word!: string | undefined;
    priority!: FilteredWordPriority;
    type!: FilterParameters;

    constructor(data?: IFilteredWordCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.word = _data["word"];
            this.priority = _data["priority"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): FilteredWordCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredWordCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["word"] = this.word;
        data["priority"] = this.priority;
        data["type"] = this.type;
        return data;
    }
}

export interface IFilteredWordCreateDto {
    active: boolean | undefined;
    word: string | undefined;
    priority: FilteredWordPriority;
    type: FilterParameters;
}

export class FilteredWordDetailedDto implements IFilteredWordDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    word!: string | undefined;
    priority!: FilteredWordPriority;
    type!: FilterParameters;

    constructor(data?: IFilteredWordDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.word = _data["word"];
            this.priority = _data["priority"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): FilteredWordDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredWordDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["word"] = this.word;
        data["priority"] = this.priority;
        data["type"] = this.type;
        return data;
    }
}

export interface IFilteredWordDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    word: string | undefined;
    priority: FilteredWordPriority;
    type: FilterParameters;
}

export class FilteredWordDetailedDtoUpdateResponseDto implements IFilteredWordDetailedDtoUpdateResponseDto {
    data!: FilteredWordDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IFilteredWordDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new FilteredWordDetailedDto(data.data) : <FilteredWordDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilteredWordDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): FilteredWordDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredWordDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IFilteredWordDetailedDtoUpdateResponseDto {
    data: IFilteredWordDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class FilteredWordLettersCreateDto implements IFilteredWordLettersCreateDto {
    active!: boolean | undefined;
    letter!: string | undefined;
    replacement!: string | undefined;

    constructor(data?: IFilteredWordLettersCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.letter = _data["letter"];
            this.replacement = _data["replacement"];
        }
    }

    static fromJS(data: any): FilteredWordLettersCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredWordLettersCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["letter"] = this.letter;
        data["replacement"] = this.replacement;
        return data;
    }
}

export interface IFilteredWordLettersCreateDto {
    active: boolean | undefined;
    letter: string | undefined;
    replacement: string | undefined;
}

export class FilteredWordLettersDetailedDto implements IFilteredWordLettersDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    letter!: string | undefined;
    replacement!: string | undefined;

    constructor(data?: IFilteredWordLettersDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.letter = _data["letter"];
            this.replacement = _data["replacement"];
        }
    }

    static fromJS(data: any): FilteredWordLettersDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredWordLettersDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["letter"] = this.letter;
        data["replacement"] = this.replacement;
        return data;
    }
}

export interface IFilteredWordLettersDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    letter: string | undefined;
    replacement: string | undefined;
}

export class FilteredWordLettersDetailedDtoUpdateResponseDto implements IFilteredWordLettersDetailedDtoUpdateResponseDto {
    data!: FilteredWordLettersDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IFilteredWordLettersDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new FilteredWordLettersDetailedDto(data.data) : <FilteredWordLettersDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilteredWordLettersDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): FilteredWordLettersDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredWordLettersDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IFilteredWordLettersDetailedDtoUpdateResponseDto {
    data: IFilteredWordLettersDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class FilteredWordLettersPublicSimpleDto implements IFilteredWordLettersPublicSimpleDto {
    id!: string;
    active!: boolean;
    letter!: string | undefined;
    replacement!: string | undefined;

    constructor(data?: IFilteredWordLettersPublicSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.letter = _data["letter"];
            this.replacement = _data["replacement"];
        }
    }

    static fromJS(data: any): FilteredWordLettersPublicSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredWordLettersPublicSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["letter"] = this.letter;
        data["replacement"] = this.replacement;
        return data;
    }
}

export interface IFilteredWordLettersPublicSimpleDto {
    id: string;
    active: boolean;
    letter: string | undefined;
    replacement: string | undefined;
}

export class FilteredWordLettersPublicSimpleDtoPaginationDto implements IFilteredWordLettersPublicSimpleDtoPaginationDto {
    data!: FilteredWordLettersPublicSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IFilteredWordLettersPublicSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new FilteredWordLettersPublicSimpleDto(item) : <FilteredWordLettersPublicSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FilteredWordLettersPublicSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): FilteredWordLettersPublicSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredWordLettersPublicSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IFilteredWordLettersPublicSimpleDtoPaginationDto {
    data: IFilteredWordLettersPublicSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class FilteredWordLettersSimpleDto implements IFilteredWordLettersSimpleDto {
    id!: string;
    active!: boolean;
    letter!: string | undefined;
    replacement!: string | undefined;

    constructor(data?: IFilteredWordLettersSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.letter = _data["letter"];
            this.replacement = _data["replacement"];
        }
    }

    static fromJS(data: any): FilteredWordLettersSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredWordLettersSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["letter"] = this.letter;
        data["replacement"] = this.replacement;
        return data;
    }
}

export interface IFilteredWordLettersSimpleDto {
    id: string;
    active: boolean;
    letter: string | undefined;
    replacement: string | undefined;
}

export class FilteredWordLettersSimpleDtoPaginationDto implements IFilteredWordLettersSimpleDtoPaginationDto {
    data!: FilteredWordLettersSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IFilteredWordLettersSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new FilteredWordLettersSimpleDto(item) : <FilteredWordLettersSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FilteredWordLettersSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): FilteredWordLettersSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredWordLettersSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IFilteredWordLettersSimpleDtoPaginationDto {
    data: IFilteredWordLettersSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum FilteredWordPriority {
    RemoveWord = "RemoveWord",
    RemoveWordAndFlag = "RemoveWordAndFlag",
    DontSendAndFlag = "DontSendAndFlag",
    Flag = "Flag",
}

export class FilteredWordSimpleDto implements IFilteredWordSimpleDto {
    id!: string;
    active!: boolean;
    word!: string | undefined;
    priority!: FilteredWordPriority;
    type!: FilterParameters;

    constructor(data?: IFilteredWordSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.word = _data["word"];
            this.priority = _data["priority"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): FilteredWordSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredWordSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["word"] = this.word;
        data["priority"] = this.priority;
        data["type"] = this.type;
        return data;
    }
}

export interface IFilteredWordSimpleDto {
    id: string;
    active: boolean;
    word: string | undefined;
    priority: FilteredWordPriority;
    type: FilterParameters;
}

export class FilteredWordSimpleDtoPaginationDto implements IFilteredWordSimpleDtoPaginationDto {
    data!: FilteredWordSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IFilteredWordSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new FilteredWordSimpleDto(item) : <FilteredWordSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FilteredWordSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): FilteredWordSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredWordSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IFilteredWordSimpleDtoPaginationDto {
    data: IFilteredWordSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class FlaggedContentDto implements IFlaggedContentDto {
    id!: string;
    dateTime!: Date;
    property!: string | undefined;
    unfiltered!: string | undefined;
    filtered!: string | undefined;

    constructor(data?: IFlaggedContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.property = _data["property"];
            this.unfiltered = _data["unfiltered"];
            this.filtered = _data["filtered"];
        }
    }

    static fromJS(data: any): FlaggedContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlaggedContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["property"] = this.property;
        data["unfiltered"] = this.unfiltered;
        data["filtered"] = this.filtered;
        return data;
    }
}

export interface IFlaggedContentDto {
    id: string;
    dateTime: Date;
    property: string | undefined;
    unfiltered: string | undefined;
    filtered: string | undefined;
}

export class FlaggedItemDto implements IFlaggedItemDto {
    id!: string;
    flaggedContent!: { [key: string]: FlaggedContentDto; } | undefined;
    item!: ItemDto;

    constructor(data?: IFlaggedItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.flaggedContent) {
                this.flaggedContent = {};
                for (let key in data.flaggedContent) {
                    if (data.flaggedContent.hasOwnProperty(key)) {
                        let item = data.flaggedContent[key];
                        this.flaggedContent[key] = item && !(<any>item).toJSON ? new FlaggedContentDto(item) : <FlaggedContentDto>item;
                    }
                }
            }
            this.item = data.item && !(<any>data.item).toJSON ? new ItemDto(data.item) : <ItemDto>this.item;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (_data["flaggedContent"]) {
                this.flaggedContent = {} as any;
                for (let key in _data["flaggedContent"]) {
                    if (_data["flaggedContent"].hasOwnProperty(key))
                        (<any>this.flaggedContent)![key] = _data["flaggedContent"][key] ? FlaggedContentDto.fromJS(_data["flaggedContent"][key]) : new FlaggedContentDto();
                }
            }
            this.item = _data["item"] ? ItemDto.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlaggedItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlaggedItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.flaggedContent) {
            data["flaggedContent"] = {};
            for (let key in this.flaggedContent) {
                if (this.flaggedContent.hasOwnProperty(key))
                    (<any>data["flaggedContent"])[key] = this.flaggedContent[key] ? this.flaggedContent[key].toJSON() : <any>undefined;
            }
        }
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlaggedItemDto {
    id: string;
    flaggedContent: { [key: string]: IFlaggedContentDto; } | undefined;
    item: IItemDto;
}

export class FlaggedItemDtoPaginationDto implements IFlaggedItemDtoPaginationDto {
    data!: FlaggedItemDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IFlaggedItemDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new FlaggedItemDto(item) : <FlaggedItemDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FlaggedItemDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): FlaggedItemDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlaggedItemDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IFlaggedItemDtoPaginationDto {
    data: IFlaggedItemDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class FlaggedMessageDto implements IFlaggedMessageDto {
    id!: string;
    flaggedContent!: { [key: string]: FlaggedContentDto; } | undefined;
    message!: MessageDetailedDto;

    constructor(data?: IFlaggedMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.flaggedContent) {
                this.flaggedContent = {};
                for (let key in data.flaggedContent) {
                    if (data.flaggedContent.hasOwnProperty(key)) {
                        let item = data.flaggedContent[key];
                        this.flaggedContent[key] = item && !(<any>item).toJSON ? new FlaggedContentDto(item) : <FlaggedContentDto>item;
                    }
                }
            }
            this.message = data.message && !(<any>data.message).toJSON ? new MessageDetailedDto(data.message) : <MessageDetailedDto>this.message;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (_data["flaggedContent"]) {
                this.flaggedContent = {} as any;
                for (let key in _data["flaggedContent"]) {
                    if (_data["flaggedContent"].hasOwnProperty(key))
                        (<any>this.flaggedContent)![key] = _data["flaggedContent"][key] ? FlaggedContentDto.fromJS(_data["flaggedContent"][key]) : new FlaggedContentDto();
                }
            }
            this.message = _data["message"] ? MessageDetailedDto.fromJS(_data["message"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlaggedMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlaggedMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.flaggedContent) {
            data["flaggedContent"] = {};
            for (let key in this.flaggedContent) {
                if (this.flaggedContent.hasOwnProperty(key))
                    (<any>data["flaggedContent"])[key] = this.flaggedContent[key] ? this.flaggedContent[key].toJSON() : <any>undefined;
            }
        }
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlaggedMessageDto {
    id: string;
    flaggedContent: { [key: string]: IFlaggedContentDto; } | undefined;
    message: IMessageDetailedDto;
}

export class FlaggedMessageDtoPaginationDto implements IFlaggedMessageDtoPaginationDto {
    data!: FlaggedMessageDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IFlaggedMessageDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new FlaggedMessageDto(item) : <FlaggedMessageDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FlaggedMessageDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): FlaggedMessageDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlaggedMessageDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IFlaggedMessageDtoPaginationDto {
    data: IFlaggedMessageDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum FlaggedMessageOrderBy {
    Newest = "Newest",
    Oldest = "Oldest",
    Relevance = "Relevance",
}

export class FlaggedOverviewDto implements IFlaggedOverviewDto {
    flaggedMessages!: number;
    flaggedUsers!: number;
    flaggedImages!: number;
    flaggedVideos!: number;
    totalFlagged!: number;

    constructor(data?: IFlaggedOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flaggedMessages = _data["flaggedMessages"];
            this.flaggedUsers = _data["flaggedUsers"];
            this.flaggedImages = _data["flaggedImages"];
            this.flaggedVideos = _data["flaggedVideos"];
            this.totalFlagged = _data["totalFlagged"];
        }
    }

    static fromJS(data: any): FlaggedOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlaggedOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flaggedMessages"] = this.flaggedMessages;
        data["flaggedUsers"] = this.flaggedUsers;
        data["flaggedImages"] = this.flaggedImages;
        data["flaggedVideos"] = this.flaggedVideos;
        data["totalFlagged"] = this.totalFlagged;
        return data;
    }
}

export interface IFlaggedOverviewDto {
    flaggedMessages: number;
    flaggedUsers: number;
    flaggedImages: number;
    flaggedVideos: number;
    totalFlagged: number;
}

export class FollowedUser implements IFollowedUser {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUser;
    owner!: RentMyUser;

    constructor(data?: IFollowedUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
            this.owner = data.owner && !(<any>data.owner).toJSON ? new RentMyUser(data.owner) : <RentMyUser>this.owner;
        }
        if (!data) {
            this.user = new RentMyUser();
            this.owner = new RentMyUser();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : new RentMyUser();
            this.owner = _data["owner"] ? RentMyUser.fromJS(_data["owner"]) : new RentMyUser();
        }
    }

    static fromJS(data: any): FollowedUser {
        data = typeof data === 'object' ? data : {};
        let result = new FollowedUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFollowedUser {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUser;
    owner: IRentMyUser;
}

export class FontSize implements IFontSize {
    desktop!: string | undefined;
    mobile!: string | undefined;

    constructor(data?: IFontSize) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktop = _data["desktop"];
            this.mobile = _data["mobile"];
        }
    }

    static fromJS(data: any): FontSize {
        data = typeof data === 'object' ? data : {};
        let result = new FontSize();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktop"] = this.desktop;
        data["mobile"] = this.mobile;
        return data;
    }
}

export interface IFontSize {
    desktop: string | undefined;
    mobile: string | undefined;
}

export class ForumCommentCreateDto implements IForumCommentCreateDto {
    active!: boolean | undefined;
    postId!: string;
    content!: string | undefined;
    postTime!: Date;

    constructor(data?: IForumCommentCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.postId = _data["postId"];
            this.content = _data["content"];
            this.postTime = _data["postTime"] ? new Date(_data["postTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ForumCommentCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForumCommentCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["postId"] = this.postId;
        data["content"] = this.content;
        data["postTime"] = this.postTime ? this.postTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IForumCommentCreateDto {
    active: boolean | undefined;
    postId: string;
    content: string | undefined;
    postTime: Date;
}

export class ForumCommentSimpleDto implements IForumCommentSimpleDto {
    id!: string;
    active!: boolean;
    postId!: string;
    userId!: string;
    content!: string | undefined;
    postTime!: Date;

    constructor(data?: IForumCommentSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.postId = _data["postId"];
            this.userId = _data["userId"];
            this.content = _data["content"];
            this.postTime = _data["postTime"] ? new Date(_data["postTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ForumCommentSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForumCommentSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["postId"] = this.postId;
        data["userId"] = this.userId;
        data["content"] = this.content;
        data["postTime"] = this.postTime ? this.postTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IForumCommentSimpleDto {
    id: string;
    active: boolean;
    postId: string;
    userId: string;
    content: string | undefined;
    postTime: Date;
}

export class ForumPostCreateDto implements IForumPostCreateDto {
    active!: boolean | undefined;
    title!: string | undefined;
    description!: string | undefined;
    dateTime!: Date;

    constructor(data?: IForumPostCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ForumPostCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForumPostCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["title"] = this.title;
        data["description"] = this.description;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IForumPostCreateDto {
    active: boolean | undefined;
    title: string | undefined;
    description: string | undefined;
    dateTime: Date;
}

export class ForumPostDetailedDto implements IForumPostDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUserSimpleDto;
    title!: string | undefined;
    description!: string | undefined;
    postTime!: Date;
    comments!: ForumCommentSimpleDto[] | undefined;

    constructor(data?: IForumPostDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserSimpleDto(data.user) : <RentMyUserSimpleDto>this.user;
            if (data.comments) {
                this.comments = [];
                for (let i = 0; i < data.comments.length; i++) {
                    let item = data.comments[i];
                    this.comments[i] = item && !(<any>item).toJSON ? new ForumCommentSimpleDto(item) : <ForumCommentSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUserSimpleDto.fromJS(_data["user"]) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.postTime = _data["postTime"] ? new Date(_data["postTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(ForumCommentSimpleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ForumPostDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForumPostDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["postTime"] = this.postTime ? this.postTime.toISOString() : <any>undefined;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IForumPostDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUserSimpleDto;
    title: string | undefined;
    description: string | undefined;
    postTime: Date;
    comments: IForumCommentSimpleDto[] | undefined;
}

export class ForumPostDetailedDtoPaginationDto implements IForumPostDetailedDtoPaginationDto {
    data!: ForumPostDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IForumPostDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ForumPostDetailedDto(item) : <ForumPostDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ForumPostDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ForumPostDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForumPostDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IForumPostDetailedDtoPaginationDto {
    data: IForumPostDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ForumPostDetailedDtoUpdateResponseDto implements IForumPostDetailedDtoUpdateResponseDto {
    data!: ForumPostDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IForumPostDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new ForumPostDetailedDto(data.data) : <ForumPostDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ForumPostDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): ForumPostDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForumPostDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IForumPostDetailedDtoUpdateResponseDto {
    data: IForumPostDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class ForumPostSimpleDto implements IForumPostSimpleDto {
    id!: string;
    active!: boolean;
    userId!: string;
    title!: string | undefined;
    description!: string | undefined;
    postTime!: Date;
    commentIds!: string[] | undefined;

    constructor(data?: IForumPostSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.userId = _data["userId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.postTime = _data["postTime"] ? new Date(_data["postTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["commentIds"])) {
                this.commentIds = [] as any;
                for (let item of _data["commentIds"])
                    this.commentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ForumPostSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForumPostSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["postTime"] = this.postTime ? this.postTime.toISOString() : <any>undefined;
        if (Array.isArray(this.commentIds)) {
            data["commentIds"] = [];
            for (let item of this.commentIds)
                data["commentIds"].push(item);
        }
        return data;
    }
}

export interface IForumPostSimpleDto {
    id: string;
    active: boolean;
    userId: string;
    title: string | undefined;
    description: string | undefined;
    postTime: Date;
    commentIds: string[] | undefined;
}

export class ForumPostSimpleDtoPaginationDto implements IForumPostSimpleDtoPaginationDto {
    data!: ForumPostSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IForumPostSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ForumPostSimpleDto(item) : <ForumPostSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ForumPostSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ForumPostSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForumPostSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IForumPostSimpleDtoPaginationDto {
    data: IForumPostSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class Friend implements IFriend {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUser;
    userFriend!: RentMyUser;

    constructor(data?: IFriend) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
            this.userFriend = data.userFriend && !(<any>data.userFriend).toJSON ? new RentMyUser(data.userFriend) : <RentMyUser>this.userFriend;
        }
        if (!data) {
            this.user = new RentMyUser();
            this.userFriend = new RentMyUser();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : new RentMyUser();
            this.userFriend = _data["userFriend"] ? RentMyUser.fromJS(_data["userFriend"]) : new RentMyUser();
        }
    }

    static fromJS(data: any): Friend {
        data = typeof data === 'object' ? data : {};
        let result = new Friend();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userFriend"] = this.userFriend ? this.userFriend.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFriend {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUser;
    userFriend: IRentMyUser;
}

export class Gender implements IGender {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    nonBinary!: boolean;

    constructor(data?: IGender) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.nonBinary = _data["nonBinary"];
        }
    }

    static fromJS(data: any): Gender {
        data = typeof data === 'object' ? data : {};
        let result = new Gender();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["nonBinary"] = this.nonBinary;
        return data;
    }
}

export interface IGender {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    nonBinary: boolean;
}

export class GenderCreateDto implements IGenderCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    nonBinary!: boolean;

    constructor(data?: IGenderCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.nonBinary = _data["nonBinary"];
        }
    }

    static fromJS(data: any): GenderCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenderCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["nonBinary"] = this.nonBinary;
        return data;
    }
}

export interface IGenderCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    nonBinary: boolean;
}

export class GenderDetailedDto implements IGenderDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    nonBinary!: boolean;

    constructor(data?: IGenderDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.nonBinary = _data["nonBinary"];
        }
    }

    static fromJS(data: any): GenderDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenderDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["nonBinary"] = this.nonBinary;
        return data;
    }
}

export interface IGenderDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    nonBinary: boolean;
}

export class GenderDetailedDtoPaginationDto implements IGenderDetailedDtoPaginationDto {
    data!: GenderDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IGenderDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new GenderDetailedDto(item) : <GenderDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GenderDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): GenderDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenderDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IGenderDetailedDtoPaginationDto {
    data: IGenderDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class GenderDetailedDtoUpdateResponseDto implements IGenderDetailedDtoUpdateResponseDto {
    data!: GenderDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IGenderDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new GenderDetailedDto(data.data) : <GenderDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? GenderDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): GenderDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenderDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IGenderDetailedDtoUpdateResponseDto {
    data: IGenderDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export enum GenderOrderBy {
    Relevance = "Relevance",
    Alphabetically = "Alphabetically",
}

export class GenderSimpleDto implements IGenderSimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    nonBinary!: boolean;

    constructor(data?: IGenderSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.nonBinary = _data["nonBinary"];
        }
    }

    static fromJS(data: any): GenderSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenderSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["nonBinary"] = this.nonBinary;
        return data;
    }
}

export interface IGenderSimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    nonBinary: boolean;
}

export class GenderSimpleDtoPaginationDto implements IGenderSimpleDtoPaginationDto {
    data!: GenderSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IGenderSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new GenderSimpleDto(item) : <GenderSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GenderSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): GenderSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenderSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IGenderSimpleDtoPaginationDto {
    data: IGenderSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class Geometry implements IGeometry {
    factory!: GeometryFactory;
    userData!: any | undefined;
    srid!: number;
    readonly geometryType!: string | undefined;
    ogcGeometryType!: OgcGeometryType;
    precisionModel!: PrecisionModel;
    coordinate!: Coordinate;
    readonly coordinates!: Coordinate[] | undefined;
    readonly numPoints!: number;
    readonly numGeometries!: number;
    readonly isSimple!: boolean;
    readonly isValid!: boolean;
    readonly isEmpty!: boolean;
    readonly area!: number;
    readonly length!: number;
    centroid!: Point;
    interiorPoint!: Point;
    pointOnSurface!: Point;
    dimension!: Dimension;
    boundary!: Geometry;
    boundaryDimension!: Dimension;
    envelope!: Geometry;
    envelopeInternal!: Envelope;
    readonly isRectangle!: boolean;

    constructor(data?: IGeometry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.factory = data.factory && !(<any>data.factory).toJSON ? new GeometryFactory(data.factory) : <GeometryFactory>this.factory;
            this.precisionModel = data.precisionModel && !(<any>data.precisionModel).toJSON ? new PrecisionModel(data.precisionModel) : <PrecisionModel>this.precisionModel;
            this.coordinate = data.coordinate && !(<any>data.coordinate).toJSON ? new Coordinate(data.coordinate) : <Coordinate>this.coordinate;
            if (data.coordinates) {
                this.coordinates = [];
                for (let i = 0; i < data.coordinates.length; i++) {
                    let item = data.coordinates[i];
                    this.coordinates[i] = item && !(<any>item).toJSON ? new Coordinate(item) : <Coordinate>item;
                }
            }
            this.centroid = data.centroid && !(<any>data.centroid).toJSON ? new Point(data.centroid) : <Point>this.centroid;
            this.interiorPoint = data.interiorPoint && !(<any>data.interiorPoint).toJSON ? new Point(data.interiorPoint) : <Point>this.interiorPoint;
            this.pointOnSurface = data.pointOnSurface && !(<any>data.pointOnSurface).toJSON ? new Point(data.pointOnSurface) : <Point>this.pointOnSurface;
            this.boundary = data.boundary && !(<any>data.boundary).toJSON ? new Geometry(data.boundary) : <Geometry>this.boundary;
            this.envelope = data.envelope && !(<any>data.envelope).toJSON ? new Geometry(data.envelope) : <Geometry>this.envelope;
            this.envelopeInternal = data.envelopeInternal && !(<any>data.envelopeInternal).toJSON ? new Envelope(data.envelopeInternal) : <Envelope>this.envelopeInternal;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>undefined;
            this.userData = _data["userData"];
            this.srid = _data["srid"];
            (<any>this).geometryType = _data["geometryType"];
            this.ogcGeometryType = _data["ogcGeometryType"];
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            if (Array.isArray(_data["coordinates"])) {
                (<any>this).coordinates = [] as any;
                for (let item of _data["coordinates"])
                    (<any>this).coordinates!.push(Coordinate.fromJS(item));
            }
            (<any>this).numPoints = _data["numPoints"];
            (<any>this).numGeometries = _data["numGeometries"];
            (<any>this).isSimple = _data["isSimple"];
            (<any>this).isValid = _data["isValid"];
            (<any>this).isEmpty = _data["isEmpty"];
            (<any>this).area = _data["area"];
            (<any>this).length = _data["length"];
            this.centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>undefined;
            this.interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>undefined;
            this.pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>undefined;
            this.dimension = _data["dimension"];
            this.boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            this.boundaryDimension = _data["boundaryDimension"];
            this.envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>undefined;
            this.envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>undefined;
            (<any>this).isRectangle = _data["isRectangle"];
        }
    }

    static fromJS(data: any): Geometry {
        data = typeof data === 'object' ? data : {};
        let result = new Geometry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["userData"] = this.userData;
        data["srid"] = this.srid;
        data["geometryType"] = this.geometryType;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints;
        data["numGeometries"] = this.numGeometries;
        data["isSimple"] = this.isSimple;
        data["isValid"] = this.isValid;
        data["isEmpty"] = this.isEmpty;
        data["area"] = this.area;
        data["length"] = this.length;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>undefined;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>undefined;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>undefined;
        data["dimension"] = this.dimension;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["boundaryDimension"] = this.boundaryDimension;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>undefined;
        data["isRectangle"] = this.isRectangle;
        return data;
    }
}

export interface IGeometry {
    factory: IGeometryFactory;
    userData: any | undefined;
    srid: number;
    geometryType: string | undefined;
    ogcGeometryType: OgcGeometryType;
    precisionModel: IPrecisionModel;
    coordinate: ICoordinate;
    coordinates: ICoordinate[] | undefined;
    numPoints: number;
    numGeometries: number;
    isSimple: boolean;
    isValid: boolean;
    isEmpty: boolean;
    area: number;
    length: number;
    centroid: IPoint;
    interiorPoint: IPoint;
    pointOnSurface: IPoint;
    dimension: Dimension;
    boundary: IGeometry;
    boundaryDimension: Dimension;
    envelope: IGeometry;
    envelopeInternal: IEnvelope;
    isRectangle: boolean;
}

export class GeometryFactory implements IGeometryFactory {
    precisionModel!: PrecisionModel;
    coordinateSequenceFactory!: CoordinateSequenceFactory;
    readonly srid!: number;
    geometryServices!: NtsGeometryServices;

    constructor(data?: IGeometryFactory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.precisionModel = data.precisionModel && !(<any>data.precisionModel).toJSON ? new PrecisionModel(data.precisionModel) : <PrecisionModel>this.precisionModel;
            this.coordinateSequenceFactory = data.coordinateSequenceFactory && !(<any>data.coordinateSequenceFactory).toJSON ? new CoordinateSequenceFactory(data.coordinateSequenceFactory) : <CoordinateSequenceFactory>this.coordinateSequenceFactory;
            this.geometryServices = data.geometryServices && !(<any>data.geometryServices).toJSON ? new NtsGeometryServices(data.geometryServices) : <NtsGeometryServices>this.geometryServices;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            this.coordinateSequenceFactory = _data["coordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(_data["coordinateSequenceFactory"]) : <any>undefined;
            (<any>this).srid = _data["srid"];
            this.geometryServices = _data["geometryServices"] ? NtsGeometryServices.fromJS(_data["geometryServices"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeometryFactory {
        data = typeof data === 'object' ? data : {};
        let result = new GeometryFactory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["coordinateSequenceFactory"] = this.coordinateSequenceFactory ? this.coordinateSequenceFactory.toJSON() : <any>undefined;
        data["srid"] = this.srid;
        data["geometryServices"] = this.geometryServices ? this.geometryServices.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeometryFactory {
    precisionModel: IPrecisionModel;
    coordinateSequenceFactory: ICoordinateSequenceFactory;
    srid: number;
    geometryServices: INtsGeometryServices;
}

export class GeometryOverlay implements IGeometryOverlay {

    constructor(data?: IGeometryOverlay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GeometryOverlay {
        data = typeof data === 'object' ? data : {};
        let result = new GeometryOverlay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGeometryOverlay {
}

export class HandOverCreateDto implements IHandOverCreateDto {
    time!: Date;
    location!: Location;

    constructor(data?: IHandOverCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HandOverCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new HandOverCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHandOverCreateDto {
    time: Date;
    location: ILocation;
}

export class HandOverProposal implements IHandOverProposal {
    time!: Date;
    location!: Location;
    agreement!: Agreement;

    constructor(data?: IHandOverProposal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
            this.agreement = data.agreement && !(<any>data.agreement).toJSON ? new Agreement(data.agreement) : <Agreement>this.agreement;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.agreement = _data["agreement"] ? Agreement.fromJS(_data["agreement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HandOverProposal {
        data = typeof data === 'object' ? data : {};
        let result = new HandOverProposal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["agreement"] = this.agreement ? this.agreement.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHandOverProposal {
    time: Date;
    location: ILocation;
    agreement: IAgreement;
}

export class HttpContent implements IHttpContent {
    readonly headers!: StringStringIEnumerableKeyValuePair[] | undefined;

    constructor(data?: IHttpContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.headers) {
                this.headers = [];
                for (let i = 0; i < data.headers.length; i++) {
                    let item = data.headers[i];
                    this.headers[i] = item && !(<any>item).toJSON ? new StringStringIEnumerableKeyValuePair(item) : <StringStringIEnumerableKeyValuePair>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HttpContent {
        data = typeof data === 'object' ? data : {};
        let result = new HttpContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHttpContent {
    headers: IStringStringIEnumerableKeyValuePair[] | undefined;
}

export class HttpMethod implements IHttpMethod {
    method!: string | undefined;

    constructor(data?: IHttpMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"];
        }
    }

    static fromJS(data: any): HttpMethod {
        data = typeof data === 'object' ? data : {};
        let result = new HttpMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        return data;
    }
}

export interface IHttpMethod {
    method: string | undefined;
}

export class HttpRequestMessage implements IHttpRequestMessage {
    version!: Version;
    versionPolicy!: HttpVersionPolicy;
    content!: HttpContent;
    method!: HttpMethod;
    requestUri!: string | undefined;
    readonly headers!: StringStringIEnumerableKeyValuePair[] | undefined;
    readonly properties!: { [key: string]: any; } | undefined;
    readonly options!: { [key: string]: any; } | undefined;

    constructor(data?: IHttpRequestMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.version = data.version && !(<any>data.version).toJSON ? new Version(data.version) : <Version>this.version;
            this.content = data.content && !(<any>data.content).toJSON ? new HttpContent(data.content) : <HttpContent>this.content;
            this.method = data.method && !(<any>data.method).toJSON ? new HttpMethod(data.method) : <HttpMethod>this.method;
            if (data.headers) {
                this.headers = [];
                for (let i = 0; i < data.headers.length; i++) {
                    let item = data.headers[i];
                    this.headers[i] = item && !(<any>item).toJSON ? new StringStringIEnumerableKeyValuePair(item) : <StringStringIEnumerableKeyValuePair>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] ? Version.fromJS(_data["version"]) : <any>undefined;
            this.versionPolicy = _data["versionPolicy"];
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.method = _data["method"] ? HttpMethod.fromJS(_data["method"]) : <any>undefined;
            this.requestUri = _data["requestUri"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            if (_data["properties"]) {
                (<any>this).properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>(<any>this).properties)![key] = _data["properties"][key];
                }
            }
            if (_data["options"]) {
                (<any>this).options = {} as any;
                for (let key in _data["options"]) {
                    if (_data["options"].hasOwnProperty(key))
                        (<any>(<any>this).options)![key] = _data["options"][key];
                }
            }
        }
    }

    static fromJS(data: any): HttpRequestMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpRequestMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["versionPolicy"] = this.versionPolicy;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        data["requestUri"] = this.requestUri;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        if (this.options) {
            data["options"] = {};
            for (let key in this.options) {
                if (this.options.hasOwnProperty(key))
                    (<any>data["options"])[key] = (<any>this.options)[key];
            }
        }
        return data;
    }
}

export interface IHttpRequestMessage {
    version: IVersion;
    versionPolicy: HttpVersionPolicy;
    content: IHttpContent;
    method: IHttpMethod;
    requestUri: string | undefined;
    headers: IStringStringIEnumerableKeyValuePair[] | undefined;
    properties: { [key: string]: any; } | undefined;
    options: { [key: string]: any; } | undefined;
}

export class HttpResponseMessage implements IHttpResponseMessage {
    version!: Version;
    content!: HttpContent;
    statusCode!: HttpStatusCode;
    reasonPhrase!: string | undefined;
    readonly headers!: StringStringIEnumerableKeyValuePair[] | undefined;
    readonly trailingHeaders!: StringStringIEnumerableKeyValuePair[] | undefined;
    requestMessage!: HttpRequestMessage;
    readonly isSuccessStatusCode!: boolean;

    constructor(data?: IHttpResponseMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.version = data.version && !(<any>data.version).toJSON ? new Version(data.version) : <Version>this.version;
            this.content = data.content && !(<any>data.content).toJSON ? new HttpContent(data.content) : <HttpContent>this.content;
            if (data.headers) {
                this.headers = [];
                for (let i = 0; i < data.headers.length; i++) {
                    let item = data.headers[i];
                    this.headers[i] = item && !(<any>item).toJSON ? new StringStringIEnumerableKeyValuePair(item) : <StringStringIEnumerableKeyValuePair>item;
                }
            }
            if (data.trailingHeaders) {
                this.trailingHeaders = [];
                for (let i = 0; i < data.trailingHeaders.length; i++) {
                    let item = data.trailingHeaders[i];
                    this.trailingHeaders[i] = item && !(<any>item).toJSON ? new StringStringIEnumerableKeyValuePair(item) : <StringStringIEnumerableKeyValuePair>item;
                }
            }
            this.requestMessage = data.requestMessage && !(<any>data.requestMessage).toJSON ? new HttpRequestMessage(data.requestMessage) : <HttpRequestMessage>this.requestMessage;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] ? Version.fromJS(_data["version"]) : <any>undefined;
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            this.reasonPhrase = _data["reasonPhrase"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            if (Array.isArray(_data["trailingHeaders"])) {
                (<any>this).trailingHeaders = [] as any;
                for (let item of _data["trailingHeaders"])
                    (<any>this).trailingHeaders!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            this.requestMessage = _data["requestMessage"] ? HttpRequestMessage.fromJS(_data["requestMessage"]) : <any>undefined;
            (<any>this).isSuccessStatusCode = _data["isSuccessStatusCode"];
        }
    }

    static fromJS(data: any): HttpResponseMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpResponseMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["reasonPhrase"] = this.reasonPhrase;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (Array.isArray(this.trailingHeaders)) {
            data["trailingHeaders"] = [];
            for (let item of this.trailingHeaders)
                data["trailingHeaders"].push(item.toJSON());
        }
        data["requestMessage"] = this.requestMessage ? this.requestMessage.toJSON() : <any>undefined;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        return data;
    }
}

export interface IHttpResponseMessage {
    version: IVersion;
    content: IHttpContent;
    statusCode: HttpStatusCode;
    reasonPhrase: string | undefined;
    headers: IStringStringIEnumerableKeyValuePair[] | undefined;
    trailingHeaders: IStringStringIEnumerableKeyValuePair[] | undefined;
    requestMessage: IHttpRequestMessage;
    isSuccessStatusCode: boolean;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export enum HttpVersionPolicy {
    RequestVersionOrLower = "RequestVersionOrLower",
    RequestVersionOrHigher = "RequestVersionOrHigher",
    RequestVersionExact = "RequestVersionExact",
}

export class IBrowserFile implements IIBrowserFile {
    readonly name!: string | undefined;
    readonly lastModified!: Date;
    readonly size!: number;
    readonly contentType!: string | undefined;

    constructor(data?: IIBrowserFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            (<any>this).size = _data["size"];
            (<any>this).contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): IBrowserFile {
        data = typeof data === 'object' ? data : {};
        let result = new IBrowserFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["size"] = this.size;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IIBrowserFile {
    name: string | undefined;
    lastModified: Date;
    size: number;
    contentType: string | undefined;
}

export class Image implements IImage {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    dataType!: string | undefined;
    size!: number | undefined;
    path!: string | undefined;
    user!: RentMyUser;
    originalResolutionHeight!: number | undefined;
    originalResolutionWidth!: number | undefined;
    compressedPath!: string | undefined;
    compressedSize!: number | undefined;
    compressedResolutionHeight!: number | undefined;
    compressedResolutionWidth!: number | undefined;
    flagged!: boolean;
    metaData!: { [key: string]: string; } | undefined;

    constructor(data?: IImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.size = _data["size"];
            this.path = _data["path"];
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : <any>undefined;
            this.originalResolutionHeight = _data["originalResolutionHeight"];
            this.originalResolutionWidth = _data["originalResolutionWidth"];
            this.compressedPath = _data["compressedPath"];
            this.compressedSize = _data["compressedSize"];
            this.compressedResolutionHeight = _data["compressedResolutionHeight"];
            this.compressedResolutionWidth = _data["compressedResolutionWidth"];
            this.flagged = _data["flagged"];
            if (_data["metaData"]) {
                this.metaData = {} as any;
                for (let key in _data["metaData"]) {
                    if (_data["metaData"].hasOwnProperty(key))
                        (<any>this.metaData)![key] = _data["metaData"][key];
                }
            }
        }
    }

    static fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["size"] = this.size;
        data["path"] = this.path;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["originalResolutionHeight"] = this.originalResolutionHeight;
        data["originalResolutionWidth"] = this.originalResolutionWidth;
        data["compressedPath"] = this.compressedPath;
        data["compressedSize"] = this.compressedSize;
        data["compressedResolutionHeight"] = this.compressedResolutionHeight;
        data["compressedResolutionWidth"] = this.compressedResolutionWidth;
        data["flagged"] = this.flagged;
        if (this.metaData) {
            data["metaData"] = {};
            for (let key in this.metaData) {
                if (this.metaData.hasOwnProperty(key))
                    (<any>data["metaData"])[key] = (<any>this.metaData)[key];
            }
        }
        return data;
    }
}

export interface IImage {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    dataType: string | undefined;
    size: number | undefined;
    path: string | undefined;
    user: IRentMyUser;
    originalResolutionHeight: number | undefined;
    originalResolutionWidth: number | undefined;
    compressedPath: string | undefined;
    compressedSize: number | undefined;
    compressedResolutionHeight: number | undefined;
    compressedResolutionWidth: number | undefined;
    flagged: boolean;
    metaData: { [key: string]: string; } | undefined;
}

export class ImageDetailedDto implements IImageDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    dataType!: string | undefined;
    path!: string | undefined;
    size!: number | undefined;
    originalResolutionHeight!: number | undefined;
    originalResolutionWidth!: number | undefined;
    compressedPath!: string | undefined;
    compressedSize!: number | undefined;
    compressedResolutionHeight!: number | undefined;
    compressedResolutionWidth!: number | undefined;
    flagged!: boolean;
    metaData!: { [key: string]: string; } | undefined;
    user!: ImageableIdentifierDto;

    constructor(data?: IImageDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new ImageableIdentifierDto(data.user) : <ImageableIdentifierDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.path = _data["path"];
            this.size = _data["size"];
            this.originalResolutionHeight = _data["originalResolutionHeight"];
            this.originalResolutionWidth = _data["originalResolutionWidth"];
            this.compressedPath = _data["compressedPath"];
            this.compressedSize = _data["compressedSize"];
            this.compressedResolutionHeight = _data["compressedResolutionHeight"];
            this.compressedResolutionWidth = _data["compressedResolutionWidth"];
            this.flagged = _data["flagged"];
            if (_data["metaData"]) {
                this.metaData = {} as any;
                for (let key in _data["metaData"]) {
                    if (_data["metaData"].hasOwnProperty(key))
                        (<any>this.metaData)![key] = _data["metaData"][key];
                }
            }
            this.user = _data["user"] ? ImageableIdentifierDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ImageDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["path"] = this.path;
        data["size"] = this.size;
        data["originalResolutionHeight"] = this.originalResolutionHeight;
        data["originalResolutionWidth"] = this.originalResolutionWidth;
        data["compressedPath"] = this.compressedPath;
        data["compressedSize"] = this.compressedSize;
        data["compressedResolutionHeight"] = this.compressedResolutionHeight;
        data["compressedResolutionWidth"] = this.compressedResolutionWidth;
        data["flagged"] = this.flagged;
        if (this.metaData) {
            data["metaData"] = {};
            for (let key in this.metaData) {
                if (this.metaData.hasOwnProperty(key))
                    (<any>data["metaData"])[key] = (<any>this.metaData)[key];
            }
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImageDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    dataType: string | undefined;
    path: string | undefined;
    size: number | undefined;
    originalResolutionHeight: number | undefined;
    originalResolutionWidth: number | undefined;
    compressedPath: string | undefined;
    compressedSize: number | undefined;
    compressedResolutionHeight: number | undefined;
    compressedResolutionWidth: number | undefined;
    flagged: boolean;
    metaData: { [key: string]: string; } | undefined;
    user: IImageableIdentifierDto;
}

export class ImageDetailedDtoPaginationDto implements IImageDetailedDtoPaginationDto {
    data!: ImageDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IImageDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ImageDetailedDto(item) : <ImageDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ImageDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ImageDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IImageDetailedDtoPaginationDto {
    data: IImageDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ImageDto implements IImageDto {
    id!: string;
    name!: string | undefined;
    dataType!: string | undefined;
    size!: number | undefined;
    path!: string | undefined;
    user!: NamedIdentifierDto;
    originalResolutionHeight!: number | undefined;
    originalResolutionWidth!: number | undefined;
    compressedPath!: string | undefined;
    compressedSize!: number | undefined;
    compressedResolutionHeight!: number | undefined;
    compressedResolutionWidth!: number | undefined;
    metaData!: { [key: string]: string; } | undefined;
    flagged!: boolean;

    constructor(data?: IImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new NamedIdentifierDto(data.user) : <NamedIdentifierDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.size = _data["size"];
            this.path = _data["path"];
            this.user = _data["user"] ? NamedIdentifierDto.fromJS(_data["user"]) : <any>undefined;
            this.originalResolutionHeight = _data["originalResolutionHeight"];
            this.originalResolutionWidth = _data["originalResolutionWidth"];
            this.compressedPath = _data["compressedPath"];
            this.compressedSize = _data["compressedSize"];
            this.compressedResolutionHeight = _data["compressedResolutionHeight"];
            this.compressedResolutionWidth = _data["compressedResolutionWidth"];
            if (_data["metaData"]) {
                this.metaData = {} as any;
                for (let key in _data["metaData"]) {
                    if (_data["metaData"].hasOwnProperty(key))
                        (<any>this.metaData)![key] = _data["metaData"][key];
                }
            }
            this.flagged = _data["flagged"];
        }
    }

    static fromJS(data: any): ImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["size"] = this.size;
        data["path"] = this.path;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["originalResolutionHeight"] = this.originalResolutionHeight;
        data["originalResolutionWidth"] = this.originalResolutionWidth;
        data["compressedPath"] = this.compressedPath;
        data["compressedSize"] = this.compressedSize;
        data["compressedResolutionHeight"] = this.compressedResolutionHeight;
        data["compressedResolutionWidth"] = this.compressedResolutionWidth;
        if (this.metaData) {
            data["metaData"] = {};
            for (let key in this.metaData) {
                if (this.metaData.hasOwnProperty(key))
                    (<any>data["metaData"])[key] = (<any>this.metaData)[key];
            }
        }
        data["flagged"] = this.flagged;
        return data;
    }
}

export interface IImageDto {
    id: string;
    name: string | undefined;
    dataType: string | undefined;
    size: number | undefined;
    path: string | undefined;
    user: INamedIdentifierDto;
    originalResolutionHeight: number | undefined;
    originalResolutionWidth: number | undefined;
    compressedPath: string | undefined;
    compressedSize: number | undefined;
    compressedResolutionHeight: number | undefined;
    compressedResolutionWidth: number | undefined;
    metaData: { [key: string]: string; } | undefined;
    flagged: boolean;
}

export enum ImageOrderBy {
    Relevance = "Relevance",
    Newest = "Newest",
    Oldest = "Oldest",
    Size = "Size",
}

export class ImageSimpleDto implements IImageSimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    dataType!: string | undefined;
    path!: string | undefined;
    size!: number | undefined;
    originalResolutionHeight!: number | undefined;
    originalResolutionWidth!: number | undefined;
    compressedPath!: string | undefined;
    compressedSize!: number | undefined;
    compressedResolutionHeight!: number | undefined;
    compressedResolutionWidth!: number | undefined;
    flagged!: boolean;
    metaData!: { [key: string]: string; } | undefined;
    user!: NamedIdentifierDto;

    constructor(data?: IImageSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new NamedIdentifierDto(data.user) : <NamedIdentifierDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.path = _data["path"];
            this.size = _data["size"];
            this.originalResolutionHeight = _data["originalResolutionHeight"];
            this.originalResolutionWidth = _data["originalResolutionWidth"];
            this.compressedPath = _data["compressedPath"];
            this.compressedSize = _data["compressedSize"];
            this.compressedResolutionHeight = _data["compressedResolutionHeight"];
            this.compressedResolutionWidth = _data["compressedResolutionWidth"];
            this.flagged = _data["flagged"];
            if (_data["metaData"]) {
                this.metaData = {} as any;
                for (let key in _data["metaData"]) {
                    if (_data["metaData"].hasOwnProperty(key))
                        (<any>this.metaData)![key] = _data["metaData"][key];
                }
            }
            this.user = _data["user"] ? NamedIdentifierDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ImageSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["path"] = this.path;
        data["size"] = this.size;
        data["originalResolutionHeight"] = this.originalResolutionHeight;
        data["originalResolutionWidth"] = this.originalResolutionWidth;
        data["compressedPath"] = this.compressedPath;
        data["compressedSize"] = this.compressedSize;
        data["compressedResolutionHeight"] = this.compressedResolutionHeight;
        data["compressedResolutionWidth"] = this.compressedResolutionWidth;
        data["flagged"] = this.flagged;
        if (this.metaData) {
            data["metaData"] = {};
            for (let key in this.metaData) {
                if (this.metaData.hasOwnProperty(key))
                    (<any>data["metaData"])[key] = (<any>this.metaData)[key];
            }
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImageSimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    dataType: string | undefined;
    path: string | undefined;
    size: number | undefined;
    originalResolutionHeight: number | undefined;
    originalResolutionWidth: number | undefined;
    compressedPath: string | undefined;
    compressedSize: number | undefined;
    compressedResolutionHeight: number | undefined;
    compressedResolutionWidth: number | undefined;
    flagged: boolean;
    metaData: { [key: string]: string; } | undefined;
    user: INamedIdentifierDto;
}

export class ImageSimpleDtoPaginationDto implements IImageSimpleDtoPaginationDto {
    data!: ImageSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IImageSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ImageSimpleDto(item) : <ImageSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ImageSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ImageSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IImageSimpleDtoPaginationDto {
    data: IImageSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ImageableIdentifierDto implements IImageableIdentifierDto {
    id!: string;
    name!: string | undefined;
    image!: ImageDto;

    constructor(data?: IImageableIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.image = data.image && !(<any>data.image).toJSON ? new ImageDto(data.image) : <ImageDto>this.image;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ImageableIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageableIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImageableIdentifierDto {
    id: string;
    name: string | undefined;
    image: IImageDto;
}

export class InsuranceBreakdown implements IInsuranceBreakdown {
    insurancePlan!: NamedIdentifierDto;
    insuranceCompany!: ImageableIdentifierDto;
    activePremium!: number;
    fromPremium!: number;
    dailyRate!: number;
    additionalDailyPremium!: number;
    netPremium!: number;
    iptAmount!: number;
    rentalPremium!: number;

    constructor(data?: IInsuranceBreakdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.insurancePlan = data.insurancePlan && !(<any>data.insurancePlan).toJSON ? new NamedIdentifierDto(data.insurancePlan) : <NamedIdentifierDto>this.insurancePlan;
            this.insuranceCompany = data.insuranceCompany && !(<any>data.insuranceCompany).toJSON ? new ImageableIdentifierDto(data.insuranceCompany) : <ImageableIdentifierDto>this.insuranceCompany;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insurancePlan = _data["insurancePlan"] ? NamedIdentifierDto.fromJS(_data["insurancePlan"]) : <any>undefined;
            this.insuranceCompany = _data["insuranceCompany"] ? ImageableIdentifierDto.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.activePremium = _data["activePremium"];
            this.fromPremium = _data["fromPremium"];
            this.dailyRate = _data["dailyRate"];
            this.additionalDailyPremium = _data["additionalDailyPremium"];
            this.netPremium = _data["netPremium"];
            this.iptAmount = _data["iptAmount"];
            this.rentalPremium = _data["rentalPremium"];
        }
    }

    static fromJS(data: any): InsuranceBreakdown {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceBreakdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insurancePlan"] = this.insurancePlan ? this.insurancePlan.toJSON() : <any>undefined;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["activePremium"] = this.activePremium;
        data["fromPremium"] = this.fromPremium;
        data["dailyRate"] = this.dailyRate;
        data["additionalDailyPremium"] = this.additionalDailyPremium;
        data["netPremium"] = this.netPremium;
        data["iptAmount"] = this.iptAmount;
        data["rentalPremium"] = this.rentalPremium;
        return data;
    }
}

export interface IInsuranceBreakdown {
    insurancePlan: INamedIdentifierDto;
    insuranceCompany: IImageableIdentifierDto;
    activePremium: number;
    fromPremium: number;
    dailyRate: number;
    additionalDailyPremium: number;
    netPremium: number;
    iptAmount: number;
    rentalPremium: number;
}

export class InsuranceCompany implements IInsuranceCompany {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    image!: Image;
    insurancePlans!: InsurancePlan[] | undefined;
    location!: Location;
    stripeAccountId!: string | undefined;

    constructor(data?: IInsuranceCompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.image = data.image && !(<any>data.image).toJSON ? new Image(data.image) : <Image>this.image;
            if (data.insurancePlans) {
                this.insurancePlans = [];
                for (let i = 0; i < data.insurancePlans.length; i++) {
                    let item = data.insurancePlans[i];
                    this.insurancePlans[i] = item && !(<any>item).toJSON ? new InsurancePlan(item) : <InsurancePlan>item;
                }
            }
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.image = _data["image"] ? Image.fromJS(_data["image"]) : <any>undefined;
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans!.push(InsurancePlan.fromJS(item));
            }
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.stripeAccountId = _data["stripeAccountId"];
        }
    }

    static fromJS(data: any): InsuranceCompany {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompany();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["stripeAccountId"] = this.stripeAccountId;
        return data;
    }
}

export interface IInsuranceCompany {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    image: IImage;
    insurancePlans: IInsurancePlan[] | undefined;
    location: ILocation;
    stripeAccountId: string | undefined;
}

export class InsuranceCompanyCreateDto implements IInsuranceCompanyCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    imageId!: string | undefined;
    location!: Location;
    stripeAccountId!: string | undefined;

    constructor(data?: IInsuranceCompanyCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.imageId = _data["imageId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.stripeAccountId = _data["stripeAccountId"];
        }
    }

    static fromJS(data: any): InsuranceCompanyCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["imageId"] = this.imageId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["stripeAccountId"] = this.stripeAccountId;
        return data;
    }
}

export interface IInsuranceCompanyCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    imageId: string | undefined;
    location: ILocation;
    stripeAccountId: string | undefined;
}

export class InsuranceCompanyDto implements IInsuranceCompanyDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    image!: ImageDto;
    insurancePlans!: InsurancePlanDto[] | undefined;
    location!: Location;
    stripeAccountId!: string | undefined;

    constructor(data?: IInsuranceCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.image = data.image && !(<any>data.image).toJSON ? new ImageDto(data.image) : <ImageDto>this.image;
            if (data.insurancePlans) {
                this.insurancePlans = [];
                for (let i = 0; i < data.insurancePlans.length; i++) {
                    let item = data.insurancePlans[i];
                    this.insurancePlans[i] = item && !(<any>item).toJSON ? new InsurancePlanDto(item) : <InsurancePlanDto>item;
                }
            }
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans!.push(InsurancePlanDto.fromJS(item));
            }
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.stripeAccountId = _data["stripeAccountId"];
        }
    }

    static fromJS(data: any): InsuranceCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["stripeAccountId"] = this.stripeAccountId;
        return data;
    }
}

export interface IInsuranceCompanyDto {
    id: string;
    active: boolean;
    name: string | undefined;
    image: IImageDto;
    insurancePlans: IInsurancePlanDto[] | undefined;
    location: ILocation;
    stripeAccountId: string | undefined;
}

export class InsuranceCompanyDtoPaginationDto implements IInsuranceCompanyDtoPaginationDto {
    data!: InsuranceCompanyDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IInsuranceCompanyDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new InsuranceCompanyDto(item) : <InsuranceCompanyDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InsuranceCompanyDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): InsuranceCompanyDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IInsuranceCompanyDtoPaginationDto {
    data: IInsuranceCompanyDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class InsuranceCompanyDtoUpdateResponseDto implements IInsuranceCompanyDtoUpdateResponseDto {
    data!: InsuranceCompanyDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IInsuranceCompanyDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new InsuranceCompanyDto(data.data) : <InsuranceCompanyDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? InsuranceCompanyDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): InsuranceCompanyDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCompanyDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IInsuranceCompanyDtoUpdateResponseDto {
    data: IInsuranceCompanyDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class InsurancePlan implements IInsurancePlan {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    sharerName!: string | undefined;
    insuranceCompany!: InsuranceCompany;
    baseRate!: number;
    ipt!: number | undefined;
    minimumPremium!: number | undefined;
    categories!: Category[] | undefined;
    items!: Item[] | undefined;
    itemValueLowerLimit!: number | undefined;
    itemValueUpperLimit!: number | undefined;

    constructor(data?: IInsurancePlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.insuranceCompany = data.insuranceCompany && !(<any>data.insuranceCompany).toJSON ? new InsuranceCompany(data.insuranceCompany) : <InsuranceCompany>this.insuranceCompany;
            if (data.categories) {
                this.categories = [];
                for (let i = 0; i < data.categories.length; i++) {
                    let item = data.categories[i];
                    this.categories[i] = item && !(<any>item).toJSON ? new Category(item) : <Category>item;
                }
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new Item(item) : <Item>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.sharerName = _data["sharerName"];
            this.insuranceCompany = _data["insuranceCompany"] ? InsuranceCompany.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.baseRate = _data["baseRate"];
            this.ipt = _data["ipt"];
            this.minimumPremium = _data["minimumPremium"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(Category.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Item.fromJS(item));
            }
            this.itemValueLowerLimit = _data["itemValueLowerLimit"];
            this.itemValueUpperLimit = _data["itemValueUpperLimit"];
        }
    }

    static fromJS(data: any): InsurancePlan {
        data = typeof data === 'object' ? data : {};
        let result = new InsurancePlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["sharerName"] = this.sharerName;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["baseRate"] = this.baseRate;
        data["ipt"] = this.ipt;
        data["minimumPremium"] = this.minimumPremium;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["itemValueLowerLimit"] = this.itemValueLowerLimit;
        data["itemValueUpperLimit"] = this.itemValueUpperLimit;
        return data;
    }
}

export interface IInsurancePlan {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    sharerName: string | undefined;
    insuranceCompany: IInsuranceCompany;
    baseRate: number;
    ipt: number | undefined;
    minimumPremium: number | undefined;
    categories: ICategory[] | undefined;
    items: IItem[] | undefined;
    itemValueLowerLimit: number | undefined;
    itemValueUpperLimit: number | undefined;
}

export class InsurancePlanCreateDto implements IInsurancePlanCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    sharerName!: string | undefined;
    insuranceCompanyId!: string;
    baseRate!: number;
    ipt!: number | undefined;
    minimumPremium!: number | undefined;
    itemValueLowerLimit!: number | undefined;
    itemValueUpperLimit!: number | undefined;

    constructor(data?: IInsurancePlanCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.sharerName = _data["sharerName"];
            this.insuranceCompanyId = _data["insuranceCompanyId"];
            this.baseRate = _data["baseRate"];
            this.ipt = _data["ipt"];
            this.minimumPremium = _data["minimumPremium"];
            this.itemValueLowerLimit = _data["itemValueLowerLimit"];
            this.itemValueUpperLimit = _data["itemValueUpperLimit"];
        }
    }

    static fromJS(data: any): InsurancePlanCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsurancePlanCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["sharerName"] = this.sharerName;
        data["insuranceCompanyId"] = this.insuranceCompanyId;
        data["baseRate"] = this.baseRate;
        data["ipt"] = this.ipt;
        data["minimumPremium"] = this.minimumPremium;
        data["itemValueLowerLimit"] = this.itemValueLowerLimit;
        data["itemValueUpperLimit"] = this.itemValueUpperLimit;
        return data;
    }
}

export interface IInsurancePlanCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    sharerName: string | undefined;
    insuranceCompanyId: string;
    baseRate: number;
    ipt: number | undefined;
    minimumPremium: number | undefined;
    itemValueLowerLimit: number | undefined;
    itemValueUpperLimit: number | undefined;
}

export class InsurancePlanDto implements IInsurancePlanDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    sharerName!: string | undefined;
    insuranceCompany!: ImageableIdentifierDto;
    baseRate!: number;
    ipt!: number | undefined;
    minimumPremium!: number | undefined;
    readonly insurancePlanLowerLimit!: number | undefined;
    readonly insurancePlanUpperLimit!: number | undefined;
    itemValueLowerLimit!: number | undefined;
    itemValueUpperLimit!: number | undefined;

    constructor(data?: IInsurancePlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.insuranceCompany = data.insuranceCompany && !(<any>data.insuranceCompany).toJSON ? new ImageableIdentifierDto(data.insuranceCompany) : <ImageableIdentifierDto>this.insuranceCompany;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.sharerName = _data["sharerName"];
            this.insuranceCompany = _data["insuranceCompany"] ? ImageableIdentifierDto.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.baseRate = _data["baseRate"];
            this.ipt = _data["ipt"];
            this.minimumPremium = _data["minimumPremium"];
            (<any>this).insurancePlanLowerLimit = _data["insurancePlanLowerLimit"];
            (<any>this).insurancePlanUpperLimit = _data["insurancePlanUpperLimit"];
            this.itemValueLowerLimit = _data["itemValueLowerLimit"];
            this.itemValueUpperLimit = _data["itemValueUpperLimit"];
        }
    }

    static fromJS(data: any): InsurancePlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsurancePlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["sharerName"] = this.sharerName;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["baseRate"] = this.baseRate;
        data["ipt"] = this.ipt;
        data["minimumPremium"] = this.minimumPremium;
        data["insurancePlanLowerLimit"] = this.insurancePlanLowerLimit;
        data["insurancePlanUpperLimit"] = this.insurancePlanUpperLimit;
        data["itemValueLowerLimit"] = this.itemValueLowerLimit;
        data["itemValueUpperLimit"] = this.itemValueUpperLimit;
        return data;
    }
}

export interface IInsurancePlanDto {
    id: string;
    active: boolean;
    name: string | undefined;
    sharerName: string | undefined;
    insuranceCompany: IImageableIdentifierDto;
    baseRate: number;
    ipt: number | undefined;
    minimumPremium: number | undefined;
    insurancePlanLowerLimit: number | undefined;
    insurancePlanUpperLimit: number | undefined;
    itemValueLowerLimit: number | undefined;
    itemValueUpperLimit: number | undefined;
}

export class InsurancePlanDtoPaginationDto implements IInsurancePlanDtoPaginationDto {
    data!: InsurancePlanDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IInsurancePlanDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new InsurancePlanDto(item) : <InsurancePlanDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InsurancePlanDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): InsurancePlanDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsurancePlanDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IInsurancePlanDtoPaginationDto {
    data: IInsurancePlanDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class InsurancePlanDtoUpdateResponseDto implements IInsurancePlanDtoUpdateResponseDto {
    data!: InsurancePlanDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IInsurancePlanDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new InsurancePlanDto(data.data) : <InsurancePlanDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? InsurancePlanDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): InsurancePlanDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsurancePlanDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IInsurancePlanDtoUpdateResponseDto {
    data: IInsurancePlanDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class InsurancePrice implements IInsurancePrice {
    insurancePlan!: NamedIdentifierDto;
    insuranceCompany!: ImageableIdentifierDto;
    activePremium!: number;
    fromPremium!: number;
    dailyRate!: number;

    constructor(data?: IInsurancePrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.insurancePlan = data.insurancePlan && !(<any>data.insurancePlan).toJSON ? new NamedIdentifierDto(data.insurancePlan) : <NamedIdentifierDto>this.insurancePlan;
            this.insuranceCompany = data.insuranceCompany && !(<any>data.insuranceCompany).toJSON ? new ImageableIdentifierDto(data.insuranceCompany) : <ImageableIdentifierDto>this.insuranceCompany;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insurancePlan = _data["insurancePlan"] ? NamedIdentifierDto.fromJS(_data["insurancePlan"]) : <any>undefined;
            this.insuranceCompany = _data["insuranceCompany"] ? ImageableIdentifierDto.fromJS(_data["insuranceCompany"]) : <any>undefined;
            this.activePremium = _data["activePremium"];
            this.fromPremium = _data["fromPremium"];
            this.dailyRate = _data["dailyRate"];
        }
    }

    static fromJS(data: any): InsurancePrice {
        data = typeof data === 'object' ? data : {};
        let result = new InsurancePrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insurancePlan"] = this.insurancePlan ? this.insurancePlan.toJSON() : <any>undefined;
        data["insuranceCompany"] = this.insuranceCompany ? this.insuranceCompany.toJSON() : <any>undefined;
        data["activePremium"] = this.activePremium;
        data["fromPremium"] = this.fromPremium;
        data["dailyRate"] = this.dailyRate;
        return data;
    }
}

export interface IInsurancePrice {
    insurancePlan: INamedIdentifierDto;
    insuranceCompany: IImageableIdentifierDto;
    activePremium: number;
    fromPremium: number;
    dailyRate: number;
}

export class Item implements IItem {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUser;
    name!: string;
    description!: string | undefined;
    quantity!: number;
    bookings!: Booking[] | undefined;
    pricePeriods!: PricePeriod[] | undefined;
    averageDailyPrice!: number | undefined;
    cheapestDailyPrice!: number | undefined;
    highestDailyPrice!: number | undefined;
    originalValue!: number | undefined;
    itemValue!: number | undefined;
    purchaseDate!: Date | undefined;
    receipt!: boolean;
    requiresTraining!: boolean;
    requiresPpe!: boolean;
    isPublished!: boolean;
    isSuspended!: boolean;
    instantBooking!: boolean;
    flagged!: boolean;
    extensionLimitDays!: number | undefined;
    extensionLimitHours!: number | undefined;
    minimumHandoverImages!: number | undefined;
    overallAverage!: number | undefined;
    communicationAverage!: number | undefined;
    pickUpAverage!: number | undefined;
    dropOffAverage!: number | undefined;
    accuracyAverage!: number | undefined;
    qualityAverage!: number | undefined;
    valueAverage!: number | undefined;
    reviewCount!: number;
    cancellationPolicy!: CancellationPolicy;
    aspects!: { [key: string]: string[]; } | undefined;
    categories!: Category[] | undefined;
    collections!: Category[] | undefined;
    locations!: Location[] | undefined;
    offers!: Offer[] | undefined;
    linkedItems!: LinkedItem[] | undefined;
    images!: Image[] | undefined;
    videos!: Video[] | undefined;
    tenant!: Tenant;
    externalLink!: string | undefined;
    externalId!: string | undefined;
    externalSource!: string | undefined;
    externalInsurance!: boolean;
    viewCount!: number;
    insurancePlans!: InsurancePlan[] | undefined;
    requireInsurance!: boolean;
    geoPoint!: Point;
    url!: string | undefined;
    isRequest!: boolean;

    constructor(data?: IItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
            if (data.bookings) {
                this.bookings = [];
                for (let i = 0; i < data.bookings.length; i++) {
                    let item = data.bookings[i];
                    this.bookings[i] = item && !(<any>item).toJSON ? new Booking(item) : <Booking>item;
                }
            }
            if (data.pricePeriods) {
                this.pricePeriods = [];
                for (let i = 0; i < data.pricePeriods.length; i++) {
                    let item = data.pricePeriods[i];
                    this.pricePeriods[i] = item && !(<any>item).toJSON ? new PricePeriod(item) : <PricePeriod>item;
                }
            }
            if (data.categories) {
                this.categories = [];
                for (let i = 0; i < data.categories.length; i++) {
                    let item = data.categories[i];
                    this.categories[i] = item && !(<any>item).toJSON ? new Category(item) : <Category>item;
                }
            }
            if (data.collections) {
                this.collections = [];
                for (let i = 0; i < data.collections.length; i++) {
                    let item = data.collections[i];
                    this.collections[i] = item && !(<any>item).toJSON ? new Category(item) : <Category>item;
                }
            }
            if (data.locations) {
                this.locations = [];
                for (let i = 0; i < data.locations.length; i++) {
                    let item = data.locations[i];
                    this.locations[i] = item && !(<any>item).toJSON ? new Location(item) : <Location>item;
                }
            }
            if (data.offers) {
                this.offers = [];
                for (let i = 0; i < data.offers.length; i++) {
                    let item = data.offers[i];
                    this.offers[i] = item && !(<any>item).toJSON ? new Offer(item) : <Offer>item;
                }
            }
            if (data.linkedItems) {
                this.linkedItems = [];
                for (let i = 0; i < data.linkedItems.length; i++) {
                    let item = data.linkedItems[i];
                    this.linkedItems[i] = item && !(<any>item).toJSON ? new LinkedItem(item) : <LinkedItem>item;
                }
            }
            if (data.images) {
                this.images = [];
                for (let i = 0; i < data.images.length; i++) {
                    let item = data.images[i];
                    this.images[i] = item && !(<any>item).toJSON ? new Image(item) : <Image>item;
                }
            }
            if (data.videos) {
                this.videos = [];
                for (let i = 0; i < data.videos.length; i++) {
                    let item = data.videos[i];
                    this.videos[i] = item && !(<any>item).toJSON ? new Video(item) : <Video>item;
                }
            }
            this.tenant = data.tenant && !(<any>data.tenant).toJSON ? new Tenant(data.tenant) : <Tenant>this.tenant;
            if (data.insurancePlans) {
                this.insurancePlans = [];
                for (let i = 0; i < data.insurancePlans.length; i++) {
                    let item = data.insurancePlans[i];
                    this.insurancePlans[i] = item && !(<any>item).toJSON ? new InsurancePlan(item) : <InsurancePlan>item;
                }
            }
            this.geoPoint = data.geoPoint && !(<any>data.geoPoint).toJSON ? new Point(data.geoPoint) : <Point>this.geoPoint;
        }
        if (!data) {
            this.user = new RentMyUser();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : new RentMyUser();
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(Booking.fromJS(item));
            }
            if (Array.isArray(_data["pricePeriods"])) {
                this.pricePeriods = [] as any;
                for (let item of _data["pricePeriods"])
                    this.pricePeriods!.push(PricePeriod.fromJS(item));
            }
            this.averageDailyPrice = _data["averageDailyPrice"];
            this.cheapestDailyPrice = _data["cheapestDailyPrice"];
            this.highestDailyPrice = _data["highestDailyPrice"];
            this.originalValue = _data["originalValue"];
            this.itemValue = _data["itemValue"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.receipt = _data["receipt"];
            this.requiresTraining = _data["requiresTraining"];
            this.requiresPpe = _data["requiresPpe"];
            this.isPublished = _data["isPublished"];
            this.isSuspended = _data["isSuspended"];
            this.instantBooking = _data["instantBooking"];
            this.flagged = _data["flagged"];
            this.extensionLimitDays = _data["extensionLimitDays"];
            this.extensionLimitHours = _data["extensionLimitHours"];
            this.minimumHandoverImages = _data["minimumHandoverImages"];
            this.overallAverage = _data["overallAverage"];
            this.communicationAverage = _data["communicationAverage"];
            this.pickUpAverage = _data["pickUpAverage"];
            this.dropOffAverage = _data["dropOffAverage"];
            this.accuracyAverage = _data["accuracyAverage"];
            this.qualityAverage = _data["qualityAverage"];
            this.valueAverage = _data["valueAverage"];
            this.reviewCount = _data["reviewCount"];
            this.cancellationPolicy = _data["cancellationPolicy"];
            if (_data["aspects"]) {
                this.aspects = {} as any;
                for (let key in _data["aspects"]) {
                    if (_data["aspects"].hasOwnProperty(key))
                        (<any>this.aspects)![key] = _data["aspects"][key];
                }
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(Category.fromJS(item));
            }
            if (Array.isArray(_data["collections"])) {
                this.collections = [] as any;
                for (let item of _data["collections"])
                    this.collections!.push(Category.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["offers"])) {
                this.offers = [] as any;
                for (let item of _data["offers"])
                    this.offers!.push(Offer.fromJS(item));
            }
            if (Array.isArray(_data["linkedItems"])) {
                this.linkedItems = [] as any;
                for (let item of _data["linkedItems"])
                    this.linkedItems!.push(LinkedItem.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(Image.fromJS(item));
            }
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(Video.fromJS(item));
            }
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.externalLink = _data["externalLink"];
            this.externalId = _data["externalId"];
            this.externalSource = _data["externalSource"];
            this.externalInsurance = _data["externalInsurance"];
            this.viewCount = _data["viewCount"];
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans!.push(InsurancePlan.fromJS(item));
            }
            this.requireInsurance = _data["requireInsurance"];
            this.geoPoint = _data["geoPoint"] ? Point.fromJS(_data["geoPoint"]) : <any>undefined;
            this.url = _data["url"];
            this.isRequest = _data["isRequest"];
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item.toJSON());
        }
        if (Array.isArray(this.pricePeriods)) {
            data["pricePeriods"] = [];
            for (let item of this.pricePeriods)
                data["pricePeriods"].push(item.toJSON());
        }
        data["averageDailyPrice"] = this.averageDailyPrice;
        data["cheapestDailyPrice"] = this.cheapestDailyPrice;
        data["highestDailyPrice"] = this.highestDailyPrice;
        data["originalValue"] = this.originalValue;
        data["itemValue"] = this.itemValue;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["receipt"] = this.receipt;
        data["requiresTraining"] = this.requiresTraining;
        data["requiresPpe"] = this.requiresPpe;
        data["isPublished"] = this.isPublished;
        data["isSuspended"] = this.isSuspended;
        data["instantBooking"] = this.instantBooking;
        data["flagged"] = this.flagged;
        data["extensionLimitDays"] = this.extensionLimitDays;
        data["extensionLimitHours"] = this.extensionLimitHours;
        data["minimumHandoverImages"] = this.minimumHandoverImages;
        data["overallAverage"] = this.overallAverage;
        data["communicationAverage"] = this.communicationAverage;
        data["pickUpAverage"] = this.pickUpAverage;
        data["dropOffAverage"] = this.dropOffAverage;
        data["accuracyAverage"] = this.accuracyAverage;
        data["qualityAverage"] = this.qualityAverage;
        data["valueAverage"] = this.valueAverage;
        data["reviewCount"] = this.reviewCount;
        data["cancellationPolicy"] = this.cancellationPolicy;
        if (this.aspects) {
            data["aspects"] = {};
            for (let key in this.aspects) {
                if (this.aspects.hasOwnProperty(key))
                    (<any>data["aspects"])[key] = (<any>this.aspects)[key];
            }
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.collections)) {
            data["collections"] = [];
            for (let item of this.collections)
                data["collections"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.offers)) {
            data["offers"] = [];
            for (let item of this.offers)
                data["offers"].push(item.toJSON());
        }
        if (Array.isArray(this.linkedItems)) {
            data["linkedItems"] = [];
            for (let item of this.linkedItems)
                data["linkedItems"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["externalLink"] = this.externalLink;
        data["externalId"] = this.externalId;
        data["externalSource"] = this.externalSource;
        data["externalInsurance"] = this.externalInsurance;
        data["viewCount"] = this.viewCount;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        data["requireInsurance"] = this.requireInsurance;
        data["geoPoint"] = this.geoPoint ? this.geoPoint.toJSON() : <any>undefined;
        data["url"] = this.url;
        data["isRequest"] = this.isRequest;
        return data;
    }
}

export interface IItem {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUser;
    name: string;
    description: string | undefined;
    quantity: number;
    bookings: IBooking[] | undefined;
    pricePeriods: IPricePeriod[] | undefined;
    averageDailyPrice: number | undefined;
    cheapestDailyPrice: number | undefined;
    highestDailyPrice: number | undefined;
    originalValue: number | undefined;
    itemValue: number | undefined;
    purchaseDate: Date | undefined;
    receipt: boolean;
    requiresTraining: boolean;
    requiresPpe: boolean;
    isPublished: boolean;
    isSuspended: boolean;
    instantBooking: boolean;
    flagged: boolean;
    extensionLimitDays: number | undefined;
    extensionLimitHours: number | undefined;
    minimumHandoverImages: number | undefined;
    overallAverage: number | undefined;
    communicationAverage: number | undefined;
    pickUpAverage: number | undefined;
    dropOffAverage: number | undefined;
    accuracyAverage: number | undefined;
    qualityAverage: number | undefined;
    valueAverage: number | undefined;
    reviewCount: number;
    cancellationPolicy: CancellationPolicy;
    aspects: { [key: string]: string[]; } | undefined;
    categories: ICategory[] | undefined;
    collections: ICategory[] | undefined;
    locations: ILocation[] | undefined;
    offers: IOffer[] | undefined;
    linkedItems: ILinkedItem[] | undefined;
    images: IImage[] | undefined;
    videos: IVideo[] | undefined;
    tenant: ITenant;
    externalLink: string | undefined;
    externalId: string | undefined;
    externalSource: string | undefined;
    externalInsurance: boolean;
    viewCount: number;
    insurancePlans: IInsurancePlan[] | undefined;
    requireInsurance: boolean;
    geoPoint: IPoint;
    url: string | undefined;
    isRequest: boolean;
}

export class ItemAdminSearchDto implements IItemAdminSearchDto {
    id!: string;
    active!: boolean;
    itemName!: string | undefined;
    image!: ImageDto;
    isPublished!: boolean;
    instantBooking!: boolean;
    city!: string | undefined;
    cheapestPrice!: string | undefined;
    owner!: ImageableIdentifierDto;

    constructor(data?: IItemAdminSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.image = data.image && !(<any>data.image).toJSON ? new ImageDto(data.image) : <ImageDto>this.image;
            this.owner = data.owner && !(<any>data.owner).toJSON ? new ImageableIdentifierDto(data.owner) : <ImageableIdentifierDto>this.owner;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.itemName = _data["itemName"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            this.isPublished = _data["isPublished"];
            this.instantBooking = _data["instantBooking"];
            this.city = _data["city"];
            this.cheapestPrice = _data["cheapestPrice"];
            this.owner = _data["owner"] ? ImageableIdentifierDto.fromJS(_data["owner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemAdminSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemAdminSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["itemName"] = this.itemName;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["isPublished"] = this.isPublished;
        data["instantBooking"] = this.instantBooking;
        data["city"] = this.city;
        data["cheapestPrice"] = this.cheapestPrice;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItemAdminSearchDto {
    id: string;
    active: boolean;
    itemName: string | undefined;
    image: IImageDto;
    isPublished: boolean;
    instantBooking: boolean;
    city: string | undefined;
    cheapestPrice: string | undefined;
    owner: IImageableIdentifierDto;
}

export class ItemAdminSearchDtoPaginationDto implements IItemAdminSearchDtoPaginationDto {
    data!: ItemAdminSearchDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IItemAdminSearchDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ItemAdminSearchDto(item) : <ItemAdminSearchDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ItemAdminSearchDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ItemAdminSearchDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemAdminSearchDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IItemAdminSearchDtoPaginationDto {
    data: IItemAdminSearchDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ItemCreateDto implements IItemCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    description!: string | undefined;
    quantity!: number;
    pricePeriods!: PricePeriod[] | undefined;
    originalValue!: number | undefined;
    itemValue!: number | undefined;
    purchaseDate!: Date | undefined;
    receipt!: boolean;
    minimumHandOverImages!: number | undefined;
    extensionLimitDays!: number | undefined;
    extensionLimitHours!: number | undefined;
    cancellationPolicy!: CancellationPolicy;
    categoryIds!: string[] | undefined;
    collectionIds!: string[] | undefined;
    aspects!: { [key: string]: string[]; } | undefined;
    locations!: Location[] | undefined;
    imageIds!: string[] | undefined;
    videoIds!: string[] | undefined;
    instantBooking!: boolean;
    isPublished!: boolean;
    tenantId!: string | undefined;
    insurancePlanIds!: string[] | undefined;
    requireInsurance!: boolean;
    isRequest!: boolean;

    constructor(data?: IItemCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.pricePeriods) {
                this.pricePeriods = [];
                for (let i = 0; i < data.pricePeriods.length; i++) {
                    let item = data.pricePeriods[i];
                    this.pricePeriods[i] = item && !(<any>item).toJSON ? new PricePeriod(item) : <PricePeriod>item;
                }
            }
            if (data.locations) {
                this.locations = [];
                for (let i = 0; i < data.locations.length; i++) {
                    let item = data.locations[i];
                    this.locations[i] = item && !(<any>item).toJSON ? new Location(item) : <Location>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            if (Array.isArray(_data["pricePeriods"])) {
                this.pricePeriods = [] as any;
                for (let item of _data["pricePeriods"])
                    this.pricePeriods!.push(PricePeriod.fromJS(item));
            }
            this.originalValue = _data["originalValue"];
            this.itemValue = _data["itemValue"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.receipt = _data["receipt"];
            this.minimumHandOverImages = _data["minimumHandOverImages"];
            this.extensionLimitDays = _data["extensionLimitDays"];
            this.extensionLimitHours = _data["extensionLimitHours"];
            this.cancellationPolicy = _data["cancellationPolicy"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            if (Array.isArray(_data["collectionIds"])) {
                this.collectionIds = [] as any;
                for (let item of _data["collectionIds"])
                    this.collectionIds!.push(item);
            }
            if (_data["aspects"]) {
                this.aspects = {} as any;
                for (let key in _data["aspects"]) {
                    if (_data["aspects"].hasOwnProperty(key))
                        (<any>this.aspects)![key] = _data["aspects"][key];
                }
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["imageIds"])) {
                this.imageIds = [] as any;
                for (let item of _data["imageIds"])
                    this.imageIds!.push(item);
            }
            if (Array.isArray(_data["videoIds"])) {
                this.videoIds = [] as any;
                for (let item of _data["videoIds"])
                    this.videoIds!.push(item);
            }
            this.instantBooking = _data["instantBooking"];
            this.isPublished = _data["isPublished"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["insurancePlanIds"])) {
                this.insurancePlanIds = [] as any;
                for (let item of _data["insurancePlanIds"])
                    this.insurancePlanIds!.push(item);
            }
            this.requireInsurance = _data["requireInsurance"];
            this.isRequest = _data["isRequest"];
        }
    }

    static fromJS(data: any): ItemCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        if (Array.isArray(this.pricePeriods)) {
            data["pricePeriods"] = [];
            for (let item of this.pricePeriods)
                data["pricePeriods"].push(item.toJSON());
        }
        data["originalValue"] = this.originalValue;
        data["itemValue"] = this.itemValue;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["receipt"] = this.receipt;
        data["minimumHandOverImages"] = this.minimumHandOverImages;
        data["extensionLimitDays"] = this.extensionLimitDays;
        data["extensionLimitHours"] = this.extensionLimitHours;
        data["cancellationPolicy"] = this.cancellationPolicy;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        if (Array.isArray(this.collectionIds)) {
            data["collectionIds"] = [];
            for (let item of this.collectionIds)
                data["collectionIds"].push(item);
        }
        if (this.aspects) {
            data["aspects"] = {};
            for (let key in this.aspects) {
                if (this.aspects.hasOwnProperty(key))
                    (<any>data["aspects"])[key] = (<any>this.aspects)[key];
            }
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.imageIds)) {
            data["imageIds"] = [];
            for (let item of this.imageIds)
                data["imageIds"].push(item);
        }
        if (Array.isArray(this.videoIds)) {
            data["videoIds"] = [];
            for (let item of this.videoIds)
                data["videoIds"].push(item);
        }
        data["instantBooking"] = this.instantBooking;
        data["isPublished"] = this.isPublished;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.insurancePlanIds)) {
            data["insurancePlanIds"] = [];
            for (let item of this.insurancePlanIds)
                data["insurancePlanIds"].push(item);
        }
        data["requireInsurance"] = this.requireInsurance;
        data["isRequest"] = this.isRequest;
        return data;
    }
}

export interface IItemCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    pricePeriods: IPricePeriod[] | undefined;
    originalValue: number | undefined;
    itemValue: number | undefined;
    purchaseDate: Date | undefined;
    receipt: boolean;
    minimumHandOverImages: number | undefined;
    extensionLimitDays: number | undefined;
    extensionLimitHours: number | undefined;
    cancellationPolicy: CancellationPolicy;
    categoryIds: string[] | undefined;
    collectionIds: string[] | undefined;
    aspects: { [key: string]: string[]; } | undefined;
    locations: ILocation[] | undefined;
    imageIds: string[] | undefined;
    videoIds: string[] | undefined;
    instantBooking: boolean;
    isPublished: boolean;
    tenantId: string | undefined;
    insurancePlanIds: string[] | undefined;
    requireInsurance: boolean;
    isRequest: boolean;
}

export class ItemDto implements IItemDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUserSimpleDto;
    name!: string | undefined;
    description!: string | undefined;
    quantity!: number;
    priceInfo!: PriceInfo;
    originalValue!: number | undefined;
    itemValue!: number | undefined;
    purchaseDate!: Date | undefined;
    receipt!: boolean;
    requiresTraining!: boolean;
    requiresPpe!: boolean;
    isPublished!: boolean;
    isActive!: boolean;
    instantBooking!: boolean;
    extensionLimitDays!: number | undefined;
    extensionLimitHours!: number | undefined;
    minimumHandOverImages!: number | undefined;
    cancellationPolicy!: CancellationPolicy;
    overallAverage!: number | undefined;
    communicationAverage!: number | undefined;
    pickUpAverage!: number | undefined;
    dropOffAverage!: number | undefined;
    accuracyAverage!: number | undefined;
    qualityAverage!: number | undefined;
    valueAverage!: number | undefined;
    reviewCount!: number;
    categories!: CategoryAdminSearchDto[] | undefined;
    collections!: CategoryAdminSearchDto[] | undefined;
    aspects!: { [key: string]: string[]; } | undefined;
    location!: Location;
    offers!: OfferSimpleDto[] | undefined;
    linkedItems!: ItemSimpleDto[] | undefined;
    images!: ImageDto[] | undefined;
    videos!: VideoDto[] | undefined;
    viewCount!: number;
    tenant!: TenantSimpleDto;
    insurancePlans!: InsurancePlanDto[] | undefined;
    insurancePrices!: InsurancePrice[] | undefined;
    requireInsurance!: boolean;
    flagged!: boolean;
    externalLink!: string | undefined;
    externalInsurance!: boolean;
    url!: string | undefined;
    bookingCount!: number;

    constructor(data?: IItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserSimpleDto(data.user) : <RentMyUserSimpleDto>this.user;
            this.priceInfo = data.priceInfo && !(<any>data.priceInfo).toJSON ? new PriceInfo(data.priceInfo) : <PriceInfo>this.priceInfo;
            if (data.categories) {
                this.categories = [];
                for (let i = 0; i < data.categories.length; i++) {
                    let item = data.categories[i];
                    this.categories[i] = item && !(<any>item).toJSON ? new CategoryAdminSearchDto(item) : <CategoryAdminSearchDto>item;
                }
            }
            if (data.collections) {
                this.collections = [];
                for (let i = 0; i < data.collections.length; i++) {
                    let item = data.collections[i];
                    this.collections[i] = item && !(<any>item).toJSON ? new CategoryAdminSearchDto(item) : <CategoryAdminSearchDto>item;
                }
            }
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
            if (data.offers) {
                this.offers = [];
                for (let i = 0; i < data.offers.length; i++) {
                    let item = data.offers[i];
                    this.offers[i] = item && !(<any>item).toJSON ? new OfferSimpleDto(item) : <OfferSimpleDto>item;
                }
            }
            if (data.linkedItems) {
                this.linkedItems = [];
                for (let i = 0; i < data.linkedItems.length; i++) {
                    let item = data.linkedItems[i];
                    this.linkedItems[i] = item && !(<any>item).toJSON ? new ItemSimpleDto(item) : <ItemSimpleDto>item;
                }
            }
            if (data.images) {
                this.images = [];
                for (let i = 0; i < data.images.length; i++) {
                    let item = data.images[i];
                    this.images[i] = item && !(<any>item).toJSON ? new ImageDto(item) : <ImageDto>item;
                }
            }
            if (data.videos) {
                this.videos = [];
                for (let i = 0; i < data.videos.length; i++) {
                    let item = data.videos[i];
                    this.videos[i] = item && !(<any>item).toJSON ? new VideoDto(item) : <VideoDto>item;
                }
            }
            this.tenant = data.tenant && !(<any>data.tenant).toJSON ? new TenantSimpleDto(data.tenant) : <TenantSimpleDto>this.tenant;
            if (data.insurancePlans) {
                this.insurancePlans = [];
                for (let i = 0; i < data.insurancePlans.length; i++) {
                    let item = data.insurancePlans[i];
                    this.insurancePlans[i] = item && !(<any>item).toJSON ? new InsurancePlanDto(item) : <InsurancePlanDto>item;
                }
            }
            if (data.insurancePrices) {
                this.insurancePrices = [];
                for (let i = 0; i < data.insurancePrices.length; i++) {
                    let item = data.insurancePrices[i];
                    this.insurancePrices[i] = item && !(<any>item).toJSON ? new InsurancePrice(item) : <InsurancePrice>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUserSimpleDto.fromJS(_data["user"]) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.priceInfo = _data["priceInfo"] ? PriceInfo.fromJS(_data["priceInfo"]) : <any>undefined;
            this.originalValue = _data["originalValue"];
            this.itemValue = _data["itemValue"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.receipt = _data["receipt"];
            this.requiresTraining = _data["requiresTraining"];
            this.requiresPpe = _data["requiresPpe"];
            this.isPublished = _data["isPublished"];
            this.isActive = _data["isActive"];
            this.instantBooking = _data["instantBooking"];
            this.extensionLimitDays = _data["extensionLimitDays"];
            this.extensionLimitHours = _data["extensionLimitHours"];
            this.minimumHandOverImages = _data["minimumHandOverImages"];
            this.cancellationPolicy = _data["cancellationPolicy"];
            this.overallAverage = _data["overallAverage"];
            this.communicationAverage = _data["communicationAverage"];
            this.pickUpAverage = _data["pickUpAverage"];
            this.dropOffAverage = _data["dropOffAverage"];
            this.accuracyAverage = _data["accuracyAverage"];
            this.qualityAverage = _data["qualityAverage"];
            this.valueAverage = _data["valueAverage"];
            this.reviewCount = _data["reviewCount"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoryAdminSearchDto.fromJS(item));
            }
            if (Array.isArray(_data["collections"])) {
                this.collections = [] as any;
                for (let item of _data["collections"])
                    this.collections!.push(CategoryAdminSearchDto.fromJS(item));
            }
            if (_data["aspects"]) {
                this.aspects = {} as any;
                for (let key in _data["aspects"]) {
                    if (_data["aspects"].hasOwnProperty(key))
                        (<any>this.aspects)![key] = _data["aspects"][key];
                }
            }
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["offers"])) {
                this.offers = [] as any;
                for (let item of _data["offers"])
                    this.offers!.push(OfferSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["linkedItems"])) {
                this.linkedItems = [] as any;
                for (let item of _data["linkedItems"])
                    this.linkedItems!.push(ItemSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(VideoDto.fromJS(item));
            }
            this.viewCount = _data["viewCount"];
            this.tenant = _data["tenant"] ? TenantSimpleDto.fromJS(_data["tenant"]) : <any>undefined;
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans!.push(InsurancePlanDto.fromJS(item));
            }
            if (Array.isArray(_data["insurancePrices"])) {
                this.insurancePrices = [] as any;
                for (let item of _data["insurancePrices"])
                    this.insurancePrices!.push(InsurancePrice.fromJS(item));
            }
            this.requireInsurance = _data["requireInsurance"];
            this.flagged = _data["flagged"];
            this.externalLink = _data["externalLink"];
            this.externalInsurance = _data["externalInsurance"];
            this.url = _data["url"];
            this.bookingCount = _data["bookingCount"];
        }
    }

    static fromJS(data: any): ItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["priceInfo"] = this.priceInfo ? this.priceInfo.toJSON() : <any>undefined;
        data["originalValue"] = this.originalValue;
        data["itemValue"] = this.itemValue;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["receipt"] = this.receipt;
        data["requiresTraining"] = this.requiresTraining;
        data["requiresPpe"] = this.requiresPpe;
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["instantBooking"] = this.instantBooking;
        data["extensionLimitDays"] = this.extensionLimitDays;
        data["extensionLimitHours"] = this.extensionLimitHours;
        data["minimumHandOverImages"] = this.minimumHandOverImages;
        data["cancellationPolicy"] = this.cancellationPolicy;
        data["overallAverage"] = this.overallAverage;
        data["communicationAverage"] = this.communicationAverage;
        data["pickUpAverage"] = this.pickUpAverage;
        data["dropOffAverage"] = this.dropOffAverage;
        data["accuracyAverage"] = this.accuracyAverage;
        data["qualityAverage"] = this.qualityAverage;
        data["valueAverage"] = this.valueAverage;
        data["reviewCount"] = this.reviewCount;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.collections)) {
            data["collections"] = [];
            for (let item of this.collections)
                data["collections"].push(item.toJSON());
        }
        if (this.aspects) {
            data["aspects"] = {};
            for (let key in this.aspects) {
                if (this.aspects.hasOwnProperty(key))
                    (<any>data["aspects"])[key] = (<any>this.aspects)[key];
            }
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.offers)) {
            data["offers"] = [];
            for (let item of this.offers)
                data["offers"].push(item.toJSON());
        }
        if (Array.isArray(this.linkedItems)) {
            data["linkedItems"] = [];
            for (let item of this.linkedItems)
                data["linkedItems"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        data["viewCount"] = this.viewCount;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.insurancePrices)) {
            data["insurancePrices"] = [];
            for (let item of this.insurancePrices)
                data["insurancePrices"].push(item.toJSON());
        }
        data["requireInsurance"] = this.requireInsurance;
        data["flagged"] = this.flagged;
        data["externalLink"] = this.externalLink;
        data["externalInsurance"] = this.externalInsurance;
        data["url"] = this.url;
        data["bookingCount"] = this.bookingCount;
        return data;
    }
}

export interface IItemDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUserSimpleDto;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    priceInfo: IPriceInfo;
    originalValue: number | undefined;
    itemValue: number | undefined;
    purchaseDate: Date | undefined;
    receipt: boolean;
    requiresTraining: boolean;
    requiresPpe: boolean;
    isPublished: boolean;
    isActive: boolean;
    instantBooking: boolean;
    extensionLimitDays: number | undefined;
    extensionLimitHours: number | undefined;
    minimumHandOverImages: number | undefined;
    cancellationPolicy: CancellationPolicy;
    overallAverage: number | undefined;
    communicationAverage: number | undefined;
    pickUpAverage: number | undefined;
    dropOffAverage: number | undefined;
    accuracyAverage: number | undefined;
    qualityAverage: number | undefined;
    valueAverage: number | undefined;
    reviewCount: number;
    categories: ICategoryAdminSearchDto[] | undefined;
    collections: ICategoryAdminSearchDto[] | undefined;
    aspects: { [key: string]: string[]; } | undefined;
    location: ILocation;
    offers: IOfferSimpleDto[] | undefined;
    linkedItems: IItemSimpleDto[] | undefined;
    images: IImageDto[] | undefined;
    videos: IVideoDto[] | undefined;
    viewCount: number;
    tenant: ITenantSimpleDto;
    insurancePlans: IInsurancePlanDto[] | undefined;
    insurancePrices: IInsurancePrice[] | undefined;
    requireInsurance: boolean;
    flagged: boolean;
    externalLink: string | undefined;
    externalInsurance: boolean;
    url: string | undefined;
    bookingCount: number;
}

export class ItemDtoPaginationDto implements IItemDtoPaginationDto {
    data!: ItemDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IItemDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ItemDto(item) : <ItemDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ItemDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ItemDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IItemDtoPaginationDto {
    data: IItemDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ItemDtoUpdateResponseDto implements IItemDtoUpdateResponseDto {
    data!: ItemDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IItemDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new ItemDto(data.data) : <ItemDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ItemDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): ItemDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IItemDtoUpdateResponseDto {
    data: IItemDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class ItemFeaturedDto implements IItemFeaturedDto {
    id!: string;
    active!: boolean;
    dailyPrice!: number | undefined;
    name!: string | undefined;
    image!: ImageDto;
    user!: ImageableIdentifierDto;
    location!: string | undefined;
    reviewScore!: number | undefined;
    reviewCount!: number;

    constructor(data?: IItemFeaturedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.image = data.image && !(<any>data.image).toJSON ? new ImageDto(data.image) : <ImageDto>this.image;
            this.user = data.user && !(<any>data.user).toJSON ? new ImageableIdentifierDto(data.user) : <ImageableIdentifierDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.dailyPrice = _data["dailyPrice"];
            this.name = _data["name"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            this.user = _data["user"] ? ImageableIdentifierDto.fromJS(_data["user"]) : <any>undefined;
            this.location = _data["location"];
            this.reviewScore = _data["reviewScore"];
            this.reviewCount = _data["reviewCount"];
        }
    }

    static fromJS(data: any): ItemFeaturedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemFeaturedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["dailyPrice"] = this.dailyPrice;
        data["name"] = this.name;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["reviewScore"] = this.reviewScore;
        data["reviewCount"] = this.reviewCount;
        return data;
    }
}

export interface IItemFeaturedDto {
    id: string;
    active: boolean;
    dailyPrice: number | undefined;
    name: string | undefined;
    image: IImageDto;
    user: IImageableIdentifierDto;
    location: string | undefined;
    reviewScore: number | undefined;
    reviewCount: number;
}

export enum ItemOrderBy {
    Relevance = "Relevance",
    DailyPrice = "DailyPrice",
    DownDailyPrice = "DownDailyPrice",
    HourlyPrice = "HourlyPrice",
    DownHourlyPrice = "DownHourlyPrice",
    Distance = "Distance",
    Rating = "Rating",
    Newest = "Newest",
    Oldest = "Oldest",
    Alphabetically = "Alphabetically",
    DownAlphabetically = "DownAlphabetically",
    TopBooked = "TopBooked",
}

export class ItemPublicDto implements IItemPublicDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUserPublicSimpleDto;
    name!: string | undefined;
    description!: string | undefined;
    quantity!: number;
    priceInfo!: PriceInfo;
    originalValue!: number | undefined;
    itemValue!: number | undefined;
    purchaseDate!: Date | undefined;
    receipt!: boolean;
    requiresTraining!: boolean;
    requiresPpe!: boolean;
    isPublished!: boolean;
    isActive!: boolean;
    instantBooking!: boolean;
    extensionLimitDays!: number | undefined;
    extensionLimitHours!: number | undefined;
    minimumHandOverImages!: number | undefined;
    cancellationPolicy!: CancellationPolicy;
    overallAverage!: number | undefined;
    communicationAverage!: number | undefined;
    pickUpAverage!: number | undefined;
    dropOffAverage!: number | undefined;
    accuracyAverage!: number | undefined;
    qualityAverage!: number | undefined;
    valueAverage!: number | undefined;
    reviewCount!: number;
    categories!: CategorySimpleDto[] | undefined;
    collections!: CategorySimpleDto[] | undefined;
    aspects!: { [key: string]: string[]; } | undefined;
    approximateLocation!: ApproximateLocation;
    offers!: OfferSimpleDto[] | undefined;
    linkedItems!: ItemSimpleDto[] | undefined;
    images!: ImageDto[] | undefined;
    videos!: VideoDto[] | undefined;
    tenant!: TenantSimpleDto;
    insurancePlans!: InsurancePlanDto[] | undefined;
    insurancePrices!: InsurancePrice[] | undefined;
    cheapestInsurance!: InsuranceBreakdown;
    requireInsurance!: boolean;
    externalLink!: string | undefined;
    externalInsurance!: boolean;
    url!: string | undefined;
    flagged!: boolean | undefined;

    constructor(data?: IItemPublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserPublicSimpleDto(data.user) : <RentMyUserPublicSimpleDto>this.user;
            this.priceInfo = data.priceInfo && !(<any>data.priceInfo).toJSON ? new PriceInfo(data.priceInfo) : <PriceInfo>this.priceInfo;
            if (data.categories) {
                this.categories = [];
                for (let i = 0; i < data.categories.length; i++) {
                    let item = data.categories[i];
                    this.categories[i] = item && !(<any>item).toJSON ? new CategorySimpleDto(item) : <CategorySimpleDto>item;
                }
            }
            if (data.collections) {
                this.collections = [];
                for (let i = 0; i < data.collections.length; i++) {
                    let item = data.collections[i];
                    this.collections[i] = item && !(<any>item).toJSON ? new CategorySimpleDto(item) : <CategorySimpleDto>item;
                }
            }
            this.approximateLocation = data.approximateLocation && !(<any>data.approximateLocation).toJSON ? new ApproximateLocation(data.approximateLocation) : <ApproximateLocation>this.approximateLocation;
            if (data.offers) {
                this.offers = [];
                for (let i = 0; i < data.offers.length; i++) {
                    let item = data.offers[i];
                    this.offers[i] = item && !(<any>item).toJSON ? new OfferSimpleDto(item) : <OfferSimpleDto>item;
                }
            }
            if (data.linkedItems) {
                this.linkedItems = [];
                for (let i = 0; i < data.linkedItems.length; i++) {
                    let item = data.linkedItems[i];
                    this.linkedItems[i] = item && !(<any>item).toJSON ? new ItemSimpleDto(item) : <ItemSimpleDto>item;
                }
            }
            if (data.images) {
                this.images = [];
                for (let i = 0; i < data.images.length; i++) {
                    let item = data.images[i];
                    this.images[i] = item && !(<any>item).toJSON ? new ImageDto(item) : <ImageDto>item;
                }
            }
            if (data.videos) {
                this.videos = [];
                for (let i = 0; i < data.videos.length; i++) {
                    let item = data.videos[i];
                    this.videos[i] = item && !(<any>item).toJSON ? new VideoDto(item) : <VideoDto>item;
                }
            }
            this.tenant = data.tenant && !(<any>data.tenant).toJSON ? new TenantSimpleDto(data.tenant) : <TenantSimpleDto>this.tenant;
            if (data.insurancePlans) {
                this.insurancePlans = [];
                for (let i = 0; i < data.insurancePlans.length; i++) {
                    let item = data.insurancePlans[i];
                    this.insurancePlans[i] = item && !(<any>item).toJSON ? new InsurancePlanDto(item) : <InsurancePlanDto>item;
                }
            }
            if (data.insurancePrices) {
                this.insurancePrices = [];
                for (let i = 0; i < data.insurancePrices.length; i++) {
                    let item = data.insurancePrices[i];
                    this.insurancePrices[i] = item && !(<any>item).toJSON ? new InsurancePrice(item) : <InsurancePrice>item;
                }
            }
            this.cheapestInsurance = data.cheapestInsurance && !(<any>data.cheapestInsurance).toJSON ? new InsuranceBreakdown(data.cheapestInsurance) : <InsuranceBreakdown>this.cheapestInsurance;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUserPublicSimpleDto.fromJS(_data["user"]) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.priceInfo = _data["priceInfo"] ? PriceInfo.fromJS(_data["priceInfo"]) : <any>undefined;
            this.originalValue = _data["originalValue"];
            this.itemValue = _data["itemValue"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.receipt = _data["receipt"];
            this.requiresTraining = _data["requiresTraining"];
            this.requiresPpe = _data["requiresPpe"];
            this.isPublished = _data["isPublished"];
            this.isActive = _data["isActive"];
            this.instantBooking = _data["instantBooking"];
            this.extensionLimitDays = _data["extensionLimitDays"];
            this.extensionLimitHours = _data["extensionLimitHours"];
            this.minimumHandOverImages = _data["minimumHandOverImages"];
            this.cancellationPolicy = _data["cancellationPolicy"];
            this.overallAverage = _data["overallAverage"];
            this.communicationAverage = _data["communicationAverage"];
            this.pickUpAverage = _data["pickUpAverage"];
            this.dropOffAverage = _data["dropOffAverage"];
            this.accuracyAverage = _data["accuracyAverage"];
            this.qualityAverage = _data["qualityAverage"];
            this.valueAverage = _data["valueAverage"];
            this.reviewCount = _data["reviewCount"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategorySimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["collections"])) {
                this.collections = [] as any;
                for (let item of _data["collections"])
                    this.collections!.push(CategorySimpleDto.fromJS(item));
            }
            if (_data["aspects"]) {
                this.aspects = {} as any;
                for (let key in _data["aspects"]) {
                    if (_data["aspects"].hasOwnProperty(key))
                        (<any>this.aspects)![key] = _data["aspects"][key];
                }
            }
            this.approximateLocation = _data["approximateLocation"] ? ApproximateLocation.fromJS(_data["approximateLocation"]) : <any>undefined;
            if (Array.isArray(_data["offers"])) {
                this.offers = [] as any;
                for (let item of _data["offers"])
                    this.offers!.push(OfferSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["linkedItems"])) {
                this.linkedItems = [] as any;
                for (let item of _data["linkedItems"])
                    this.linkedItems!.push(ItemSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(VideoDto.fromJS(item));
            }
            this.tenant = _data["tenant"] ? TenantSimpleDto.fromJS(_data["tenant"]) : <any>undefined;
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans!.push(InsurancePlanDto.fromJS(item));
            }
            if (Array.isArray(_data["insurancePrices"])) {
                this.insurancePrices = [] as any;
                for (let item of _data["insurancePrices"])
                    this.insurancePrices!.push(InsurancePrice.fromJS(item));
            }
            this.cheapestInsurance = _data["cheapestInsurance"] ? InsuranceBreakdown.fromJS(_data["cheapestInsurance"]) : <any>undefined;
            this.requireInsurance = _data["requireInsurance"];
            this.externalLink = _data["externalLink"];
            this.externalInsurance = _data["externalInsurance"];
            this.url = _data["url"];
            this.flagged = _data["flagged"];
        }
    }

    static fromJS(data: any): ItemPublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemPublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["priceInfo"] = this.priceInfo ? this.priceInfo.toJSON() : <any>undefined;
        data["originalValue"] = this.originalValue;
        data["itemValue"] = this.itemValue;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["receipt"] = this.receipt;
        data["requiresTraining"] = this.requiresTraining;
        data["requiresPpe"] = this.requiresPpe;
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["instantBooking"] = this.instantBooking;
        data["extensionLimitDays"] = this.extensionLimitDays;
        data["extensionLimitHours"] = this.extensionLimitHours;
        data["minimumHandOverImages"] = this.minimumHandOverImages;
        data["cancellationPolicy"] = this.cancellationPolicy;
        data["overallAverage"] = this.overallAverage;
        data["communicationAverage"] = this.communicationAverage;
        data["pickUpAverage"] = this.pickUpAverage;
        data["dropOffAverage"] = this.dropOffAverage;
        data["accuracyAverage"] = this.accuracyAverage;
        data["qualityAverage"] = this.qualityAverage;
        data["valueAverage"] = this.valueAverage;
        data["reviewCount"] = this.reviewCount;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.collections)) {
            data["collections"] = [];
            for (let item of this.collections)
                data["collections"].push(item.toJSON());
        }
        if (this.aspects) {
            data["aspects"] = {};
            for (let key in this.aspects) {
                if (this.aspects.hasOwnProperty(key))
                    (<any>data["aspects"])[key] = (<any>this.aspects)[key];
            }
        }
        data["approximateLocation"] = this.approximateLocation ? this.approximateLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.offers)) {
            data["offers"] = [];
            for (let item of this.offers)
                data["offers"].push(item.toJSON());
        }
        if (Array.isArray(this.linkedItems)) {
            data["linkedItems"] = [];
            for (let item of this.linkedItems)
                data["linkedItems"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.insurancePrices)) {
            data["insurancePrices"] = [];
            for (let item of this.insurancePrices)
                data["insurancePrices"].push(item.toJSON());
        }
        data["cheapestInsurance"] = this.cheapestInsurance ? this.cheapestInsurance.toJSON() : <any>undefined;
        data["requireInsurance"] = this.requireInsurance;
        data["externalLink"] = this.externalLink;
        data["externalInsurance"] = this.externalInsurance;
        data["url"] = this.url;
        data["flagged"] = this.flagged;
        return data;
    }
}

export interface IItemPublicDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUserPublicSimpleDto;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    priceInfo: IPriceInfo;
    originalValue: number | undefined;
    itemValue: number | undefined;
    purchaseDate: Date | undefined;
    receipt: boolean;
    requiresTraining: boolean;
    requiresPpe: boolean;
    isPublished: boolean;
    isActive: boolean;
    instantBooking: boolean;
    extensionLimitDays: number | undefined;
    extensionLimitHours: number | undefined;
    minimumHandOverImages: number | undefined;
    cancellationPolicy: CancellationPolicy;
    overallAverage: number | undefined;
    communicationAverage: number | undefined;
    pickUpAverage: number | undefined;
    dropOffAverage: number | undefined;
    accuracyAverage: number | undefined;
    qualityAverage: number | undefined;
    valueAverage: number | undefined;
    reviewCount: number;
    categories: ICategorySimpleDto[] | undefined;
    collections: ICategorySimpleDto[] | undefined;
    aspects: { [key: string]: string[]; } | undefined;
    approximateLocation: IApproximateLocation;
    offers: IOfferSimpleDto[] | undefined;
    linkedItems: IItemSimpleDto[] | undefined;
    images: IImageDto[] | undefined;
    videos: IVideoDto[] | undefined;
    tenant: ITenantSimpleDto;
    insurancePlans: IInsurancePlanDto[] | undefined;
    insurancePrices: IInsurancePrice[] | undefined;
    cheapestInsurance: IInsuranceBreakdown;
    requireInsurance: boolean;
    externalLink: string | undefined;
    externalInsurance: boolean;
    url: string | undefined;
    flagged: boolean | undefined;
}

export class ItemPublicDtoPaginationDto implements IItemPublicDtoPaginationDto {
    data!: ItemPublicDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IItemPublicDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ItemPublicDto(item) : <ItemPublicDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ItemPublicDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ItemPublicDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemPublicDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IItemPublicDtoPaginationDto {
    data: IItemPublicDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ItemPublicSimpleDto implements IItemPublicSimpleDto {
    id!: string;
    active!: boolean;
    userId!: ImageableIdentifierDto;
    name!: string | undefined;
    description!: string | undefined;
    quantity!: number;
    prices!: { [key: string]: DayPrice; } | undefined;
    originalValue!: number | undefined;
    itemValue!: number | undefined;
    purchaseDate!: Date | undefined;
    receipt!: boolean;
    requiresTraining!: boolean;
    requiresPpe!: boolean;
    isPublished!: boolean;
    instantBooking!: boolean;
    extensionLimitDays!: number | undefined;
    extensionLimitHours!: number | undefined;
    minimumHandOverImages!: number | undefined;
    cancellationPolicy!: CancellationPolicy;
    overallAverage!: number | undefined;
    communicationAverage!: number | undefined;
    pickUpAverage!: number | undefined;
    dropOffAverage!: number | undefined;
    accuracyAverage!: number | undefined;
    qualityAverage!: number | undefined;
    valueAverage!: number | undefined;
    reviewCount!: number;
    categoryIds!: DescribableIdentifierDto[] | undefined;
    collectionIds!: DescribableIdentifierDto[] | undefined;
    aspects!: { [key: string]: string[]; } | undefined;
    insuranceIds!: string[] | undefined;
    approximateLocations!: ApproximateLocation;
    offerIds!: string[] | undefined;
    linkedItemIds!: string[] | undefined;
    images!: ImageDto[] | undefined;
    videos!: VideoDto[] | undefined;
    tenant!: TenantSimpleDto;
    externalLink!: string | undefined;
    isRequest!: boolean;

    constructor(data?: IItemPublicSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.userId = data.userId && !(<any>data.userId).toJSON ? new ImageableIdentifierDto(data.userId) : <ImageableIdentifierDto>this.userId;
            if (data.prices) {
                this.prices = {};
                for (let key in data.prices) {
                    if (data.prices.hasOwnProperty(key)) {
                        let item = data.prices[key];
                        this.prices[key] = item && !(<any>item).toJSON ? new DayPrice(item) : <DayPrice>item;
                    }
                }
            }
            if (data.categoryIds) {
                this.categoryIds = [];
                for (let i = 0; i < data.categoryIds.length; i++) {
                    let item = data.categoryIds[i];
                    this.categoryIds[i] = item && !(<any>item).toJSON ? new DescribableIdentifierDto(item) : <DescribableIdentifierDto>item;
                }
            }
            if (data.collectionIds) {
                this.collectionIds = [];
                for (let i = 0; i < data.collectionIds.length; i++) {
                    let item = data.collectionIds[i];
                    this.collectionIds[i] = item && !(<any>item).toJSON ? new DescribableIdentifierDto(item) : <DescribableIdentifierDto>item;
                }
            }
            this.approximateLocations = data.approximateLocations && !(<any>data.approximateLocations).toJSON ? new ApproximateLocation(data.approximateLocations) : <ApproximateLocation>this.approximateLocations;
            if (data.images) {
                this.images = [];
                for (let i = 0; i < data.images.length; i++) {
                    let item = data.images[i];
                    this.images[i] = item && !(<any>item).toJSON ? new ImageDto(item) : <ImageDto>item;
                }
            }
            if (data.videos) {
                this.videos = [];
                for (let i = 0; i < data.videos.length; i++) {
                    let item = data.videos[i];
                    this.videos[i] = item && !(<any>item).toJSON ? new VideoDto(item) : <VideoDto>item;
                }
            }
            this.tenant = data.tenant && !(<any>data.tenant).toJSON ? new TenantSimpleDto(data.tenant) : <TenantSimpleDto>this.tenant;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.userId = _data["userId"] ? ImageableIdentifierDto.fromJS(_data["userId"]) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            if (_data["prices"]) {
                this.prices = {} as any;
                for (let key in _data["prices"]) {
                    if (_data["prices"].hasOwnProperty(key))
                        (<any>this.prices)![key] = _data["prices"][key] ? DayPrice.fromJS(_data["prices"][key]) : new DayPrice();
                }
            }
            this.originalValue = _data["originalValue"];
            this.itemValue = _data["itemValue"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.receipt = _data["receipt"];
            this.requiresTraining = _data["requiresTraining"];
            this.requiresPpe = _data["requiresPpe"];
            this.isPublished = _data["isPublished"];
            this.instantBooking = _data["instantBooking"];
            this.extensionLimitDays = _data["extensionLimitDays"];
            this.extensionLimitHours = _data["extensionLimitHours"];
            this.minimumHandOverImages = _data["minimumHandOverImages"];
            this.cancellationPolicy = _data["cancellationPolicy"];
            this.overallAverage = _data["overallAverage"];
            this.communicationAverage = _data["communicationAverage"];
            this.pickUpAverage = _data["pickUpAverage"];
            this.dropOffAverage = _data["dropOffAverage"];
            this.accuracyAverage = _data["accuracyAverage"];
            this.qualityAverage = _data["qualityAverage"];
            this.valueAverage = _data["valueAverage"];
            this.reviewCount = _data["reviewCount"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(DescribableIdentifierDto.fromJS(item));
            }
            if (Array.isArray(_data["collectionIds"])) {
                this.collectionIds = [] as any;
                for (let item of _data["collectionIds"])
                    this.collectionIds!.push(DescribableIdentifierDto.fromJS(item));
            }
            if (_data["aspects"]) {
                this.aspects = {} as any;
                for (let key in _data["aspects"]) {
                    if (_data["aspects"].hasOwnProperty(key))
                        (<any>this.aspects)![key] = _data["aspects"][key];
                }
            }
            if (Array.isArray(_data["insuranceIds"])) {
                this.insuranceIds = [] as any;
                for (let item of _data["insuranceIds"])
                    this.insuranceIds!.push(item);
            }
            this.approximateLocations = _data["approximateLocations"] ? ApproximateLocation.fromJS(_data["approximateLocations"]) : <any>undefined;
            if (Array.isArray(_data["offerIds"])) {
                this.offerIds = [] as any;
                for (let item of _data["offerIds"])
                    this.offerIds!.push(item);
            }
            if (Array.isArray(_data["linkedItemIds"])) {
                this.linkedItemIds = [] as any;
                for (let item of _data["linkedItemIds"])
                    this.linkedItemIds!.push(item);
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(VideoDto.fromJS(item));
            }
            this.tenant = _data["tenant"] ? TenantSimpleDto.fromJS(_data["tenant"]) : <any>undefined;
            this.externalLink = _data["externalLink"];
            this.isRequest = _data["isRequest"];
        }
    }

    static fromJS(data: any): ItemPublicSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemPublicSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["userId"] = this.userId ? this.userId.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        if (this.prices) {
            data["prices"] = {};
            for (let key in this.prices) {
                if (this.prices.hasOwnProperty(key))
                    (<any>data["prices"])[key] = this.prices[key] ? this.prices[key].toJSON() : <any>undefined;
            }
        }
        data["originalValue"] = this.originalValue;
        data["itemValue"] = this.itemValue;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["receipt"] = this.receipt;
        data["requiresTraining"] = this.requiresTraining;
        data["requiresPpe"] = this.requiresPpe;
        data["isPublished"] = this.isPublished;
        data["instantBooking"] = this.instantBooking;
        data["extensionLimitDays"] = this.extensionLimitDays;
        data["extensionLimitHours"] = this.extensionLimitHours;
        data["minimumHandOverImages"] = this.minimumHandOverImages;
        data["cancellationPolicy"] = this.cancellationPolicy;
        data["overallAverage"] = this.overallAverage;
        data["communicationAverage"] = this.communicationAverage;
        data["pickUpAverage"] = this.pickUpAverage;
        data["dropOffAverage"] = this.dropOffAverage;
        data["accuracyAverage"] = this.accuracyAverage;
        data["qualityAverage"] = this.qualityAverage;
        data["valueAverage"] = this.valueAverage;
        data["reviewCount"] = this.reviewCount;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item.toJSON());
        }
        if (Array.isArray(this.collectionIds)) {
            data["collectionIds"] = [];
            for (let item of this.collectionIds)
                data["collectionIds"].push(item.toJSON());
        }
        if (this.aspects) {
            data["aspects"] = {};
            for (let key in this.aspects) {
                if (this.aspects.hasOwnProperty(key))
                    (<any>data["aspects"])[key] = (<any>this.aspects)[key];
            }
        }
        if (Array.isArray(this.insuranceIds)) {
            data["insuranceIds"] = [];
            for (let item of this.insuranceIds)
                data["insuranceIds"].push(item);
        }
        data["approximateLocations"] = this.approximateLocations ? this.approximateLocations.toJSON() : <any>undefined;
        if (Array.isArray(this.offerIds)) {
            data["offerIds"] = [];
            for (let item of this.offerIds)
                data["offerIds"].push(item);
        }
        if (Array.isArray(this.linkedItemIds)) {
            data["linkedItemIds"] = [];
            for (let item of this.linkedItemIds)
                data["linkedItemIds"].push(item);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["externalLink"] = this.externalLink;
        data["isRequest"] = this.isRequest;
        return data;
    }
}

export interface IItemPublicSimpleDto {
    id: string;
    active: boolean;
    userId: IImageableIdentifierDto;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    prices: { [key: string]: IDayPrice; } | undefined;
    originalValue: number | undefined;
    itemValue: number | undefined;
    purchaseDate: Date | undefined;
    receipt: boolean;
    requiresTraining: boolean;
    requiresPpe: boolean;
    isPublished: boolean;
    instantBooking: boolean;
    extensionLimitDays: number | undefined;
    extensionLimitHours: number | undefined;
    minimumHandOverImages: number | undefined;
    cancellationPolicy: CancellationPolicy;
    overallAverage: number | undefined;
    communicationAverage: number | undefined;
    pickUpAverage: number | undefined;
    dropOffAverage: number | undefined;
    accuracyAverage: number | undefined;
    qualityAverage: number | undefined;
    valueAverage: number | undefined;
    reviewCount: number;
    categoryIds: IDescribableIdentifierDto[] | undefined;
    collectionIds: IDescribableIdentifierDto[] | undefined;
    aspects: { [key: string]: string[]; } | undefined;
    insuranceIds: string[] | undefined;
    approximateLocations: IApproximateLocation;
    offerIds: string[] | undefined;
    linkedItemIds: string[] | undefined;
    images: IImageDto[] | undefined;
    videos: IVideoDto[] | undefined;
    tenant: ITenantSimpleDto;
    externalLink: string | undefined;
    isRequest: boolean;
}

export class ItemSearchDto implements IItemSearchDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    itemName!: string | undefined;
    image!: ImageDto;
    dayRate!: number | undefined;
    ownerName!: string | undefined;
    ownerProfilePicture!: ImageDto;
    ownerId!: string;
    locationName!: string | undefined;
    rating!: number | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    url!: string | undefined;
    external!: boolean;
    reviewCount!: number;

    constructor(data?: IItemSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.image = data.image && !(<any>data.image).toJSON ? new ImageDto(data.image) : <ImageDto>this.image;
            this.ownerProfilePicture = data.ownerProfilePicture && !(<any>data.ownerProfilePicture).toJSON ? new ImageDto(data.ownerProfilePicture) : <ImageDto>this.ownerProfilePicture;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.itemName = _data["itemName"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            this.dayRate = _data["dayRate"];
            this.ownerName = _data["ownerName"];
            this.ownerProfilePicture = _data["ownerProfilePicture"] ? ImageDto.fromJS(_data["ownerProfilePicture"]) : <any>undefined;
            this.ownerId = _data["ownerId"];
            this.locationName = _data["locationName"];
            this.rating = _data["rating"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.url = _data["url"];
            this.external = _data["external"];
            this.reviewCount = _data["reviewCount"];
        }
    }

    static fromJS(data: any): ItemSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["itemName"] = this.itemName;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["dayRate"] = this.dayRate;
        data["ownerName"] = this.ownerName;
        data["ownerProfilePicture"] = this.ownerProfilePicture ? this.ownerProfilePicture.toJSON() : <any>undefined;
        data["ownerId"] = this.ownerId;
        data["locationName"] = this.locationName;
        data["rating"] = this.rating;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["url"] = this.url;
        data["external"] = this.external;
        data["reviewCount"] = this.reviewCount;
        return data;
    }
}

export interface IItemSearchDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    itemName: string | undefined;
    image: IImageDto;
    dayRate: number | undefined;
    ownerName: string | undefined;
    ownerProfilePicture: IImageDto;
    ownerId: string;
    locationName: string | undefined;
    rating: number | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    url: string | undefined;
    external: boolean;
    reviewCount: number;
}

export class ItemSearchDtoPaginationDto implements IItemSearchDtoPaginationDto {
    data!: ItemSearchDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IItemSearchDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ItemSearchDto(item) : <ItemSearchDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ItemSearchDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ItemSearchDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemSearchDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IItemSearchDtoPaginationDto {
    data: IItemSearchDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ItemSearchResultDto implements IItemSearchResultDto {
    logs!: string[] | undefined;
    paginatedData!: ItemSearchDtoPaginationDto;
    topLevelCategories!: CategoryResultsDto[] | undefined;

    constructor(data?: IItemSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.paginatedData = data.paginatedData && !(<any>data.paginatedData).toJSON ? new ItemSearchDtoPaginationDto(data.paginatedData) : <ItemSearchDtoPaginationDto>this.paginatedData;
            if (data.topLevelCategories) {
                this.topLevelCategories = [];
                for (let i = 0; i < data.topLevelCategories.length; i++) {
                    let item = data.topLevelCategories[i];
                    this.topLevelCategories[i] = item && !(<any>item).toJSON ? new CategoryResultsDto(item) : <CategoryResultsDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(item);
            }
            this.paginatedData = _data["paginatedData"] ? ItemSearchDtoPaginationDto.fromJS(_data["paginatedData"]) : <any>undefined;
            if (Array.isArray(_data["topLevelCategories"])) {
                this.topLevelCategories = [] as any;
                for (let item of _data["topLevelCategories"])
                    this.topLevelCategories!.push(CategoryResultsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ItemSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item);
        }
        data["paginatedData"] = this.paginatedData ? this.paginatedData.toJSON() : <any>undefined;
        if (Array.isArray(this.topLevelCategories)) {
            data["topLevelCategories"] = [];
            for (let item of this.topLevelCategories)
                data["topLevelCategories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IItemSearchResultDto {
    logs: string[] | undefined;
    paginatedData: IItemSearchDtoPaginationDto;
    topLevelCategories: ICategoryResultsDto[] | undefined;
}

export class ItemSimpleDto implements IItemSimpleDto {
    id!: string;
    active!: boolean;
    user!: ImageableIdentifierDto;
    name!: string | undefined;
    description!: string | undefined;
    quantity!: number;
    prices!: { [key: string]: DayPrice; } | undefined;
    originalValue!: number | undefined;
    itemValue!: number | undefined;
    purchaseDate!: Date | undefined;
    receipt!: boolean;
    requiresTraining!: boolean;
    requiresPpe!: boolean;
    isPublished!: boolean;
    instantBooking!: boolean;
    extensionLimitDays!: number | undefined;
    extensionLimitHours!: number | undefined;
    minimumHandOverImages!: number | undefined;
    cancellationPolicy!: CancellationPolicy;
    overallAverage!: number | undefined;
    communicationAverage!: number | undefined;
    pickUpAverage!: number | undefined;
    dropOffAverage!: number | undefined;
    accuracyAverage!: number | undefined;
    qualityAverage!: number | undefined;
    valueAverage!: number | undefined;
    reviewCount!: number;
    categories!: DescribableIdentifierDto[] | undefined;
    collectionIds!: DescribableIdentifierDto[] | undefined;
    aspects!: { [key: string]: string[]; } | undefined;
    insuranceIds!: string[] | undefined;
    location!: Location;
    offerIds!: string[] | undefined;
    linkedItemIds!: string[] | undefined;
    images!: ImageDto[] | undefined;
    videos!: VideoDto[] | undefined;
    viewCount!: number;
    tenant!: TenantSimpleDto;
    flagged!: boolean;
    externalLink!: string | undefined;
    url!: string | undefined;
    isRequest!: boolean;

    constructor(data?: IItemSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new ImageableIdentifierDto(data.user) : <ImageableIdentifierDto>this.user;
            if (data.prices) {
                this.prices = {};
                for (let key in data.prices) {
                    if (data.prices.hasOwnProperty(key)) {
                        let item = data.prices[key];
                        this.prices[key] = item && !(<any>item).toJSON ? new DayPrice(item) : <DayPrice>item;
                    }
                }
            }
            if (data.categories) {
                this.categories = [];
                for (let i = 0; i < data.categories.length; i++) {
                    let item = data.categories[i];
                    this.categories[i] = item && !(<any>item).toJSON ? new DescribableIdentifierDto(item) : <DescribableIdentifierDto>item;
                }
            }
            if (data.collectionIds) {
                this.collectionIds = [];
                for (let i = 0; i < data.collectionIds.length; i++) {
                    let item = data.collectionIds[i];
                    this.collectionIds[i] = item && !(<any>item).toJSON ? new DescribableIdentifierDto(item) : <DescribableIdentifierDto>item;
                }
            }
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
            if (data.images) {
                this.images = [];
                for (let i = 0; i < data.images.length; i++) {
                    let item = data.images[i];
                    this.images[i] = item && !(<any>item).toJSON ? new ImageDto(item) : <ImageDto>item;
                }
            }
            if (data.videos) {
                this.videos = [];
                for (let i = 0; i < data.videos.length; i++) {
                    let item = data.videos[i];
                    this.videos[i] = item && !(<any>item).toJSON ? new VideoDto(item) : <VideoDto>item;
                }
            }
            this.tenant = data.tenant && !(<any>data.tenant).toJSON ? new TenantSimpleDto(data.tenant) : <TenantSimpleDto>this.tenant;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.user = _data["user"] ? ImageableIdentifierDto.fromJS(_data["user"]) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            if (_data["prices"]) {
                this.prices = {} as any;
                for (let key in _data["prices"]) {
                    if (_data["prices"].hasOwnProperty(key))
                        (<any>this.prices)![key] = _data["prices"][key] ? DayPrice.fromJS(_data["prices"][key]) : new DayPrice();
                }
            }
            this.originalValue = _data["originalValue"];
            this.itemValue = _data["itemValue"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.receipt = _data["receipt"];
            this.requiresTraining = _data["requiresTraining"];
            this.requiresPpe = _data["requiresPpe"];
            this.isPublished = _data["isPublished"];
            this.instantBooking = _data["instantBooking"];
            this.extensionLimitDays = _data["extensionLimitDays"];
            this.extensionLimitHours = _data["extensionLimitHours"];
            this.minimumHandOverImages = _data["minimumHandOverImages"];
            this.cancellationPolicy = _data["cancellationPolicy"];
            this.overallAverage = _data["overallAverage"];
            this.communicationAverage = _data["communicationAverage"];
            this.pickUpAverage = _data["pickUpAverage"];
            this.dropOffAverage = _data["dropOffAverage"];
            this.accuracyAverage = _data["accuracyAverage"];
            this.qualityAverage = _data["qualityAverage"];
            this.valueAverage = _data["valueAverage"];
            this.reviewCount = _data["reviewCount"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(DescribableIdentifierDto.fromJS(item));
            }
            if (Array.isArray(_data["collectionIds"])) {
                this.collectionIds = [] as any;
                for (let item of _data["collectionIds"])
                    this.collectionIds!.push(DescribableIdentifierDto.fromJS(item));
            }
            if (_data["aspects"]) {
                this.aspects = {} as any;
                for (let key in _data["aspects"]) {
                    if (_data["aspects"].hasOwnProperty(key))
                        (<any>this.aspects)![key] = _data["aspects"][key];
                }
            }
            if (Array.isArray(_data["insuranceIds"])) {
                this.insuranceIds = [] as any;
                for (let item of _data["insuranceIds"])
                    this.insuranceIds!.push(item);
            }
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["offerIds"])) {
                this.offerIds = [] as any;
                for (let item of _data["offerIds"])
                    this.offerIds!.push(item);
            }
            if (Array.isArray(_data["linkedItemIds"])) {
                this.linkedItemIds = [] as any;
                for (let item of _data["linkedItemIds"])
                    this.linkedItemIds!.push(item);
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(VideoDto.fromJS(item));
            }
            this.viewCount = _data["viewCount"];
            this.tenant = _data["tenant"] ? TenantSimpleDto.fromJS(_data["tenant"]) : <any>undefined;
            this.flagged = _data["flagged"];
            this.externalLink = _data["externalLink"];
            this.url = _data["url"];
            this.isRequest = _data["isRequest"];
        }
    }

    static fromJS(data: any): ItemSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        if (this.prices) {
            data["prices"] = {};
            for (let key in this.prices) {
                if (this.prices.hasOwnProperty(key))
                    (<any>data["prices"])[key] = this.prices[key] ? this.prices[key].toJSON() : <any>undefined;
            }
        }
        data["originalValue"] = this.originalValue;
        data["itemValue"] = this.itemValue;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["receipt"] = this.receipt;
        data["requiresTraining"] = this.requiresTraining;
        data["requiresPpe"] = this.requiresPpe;
        data["isPublished"] = this.isPublished;
        data["instantBooking"] = this.instantBooking;
        data["extensionLimitDays"] = this.extensionLimitDays;
        data["extensionLimitHours"] = this.extensionLimitHours;
        data["minimumHandOverImages"] = this.minimumHandOverImages;
        data["cancellationPolicy"] = this.cancellationPolicy;
        data["overallAverage"] = this.overallAverage;
        data["communicationAverage"] = this.communicationAverage;
        data["pickUpAverage"] = this.pickUpAverage;
        data["dropOffAverage"] = this.dropOffAverage;
        data["accuracyAverage"] = this.accuracyAverage;
        data["qualityAverage"] = this.qualityAverage;
        data["valueAverage"] = this.valueAverage;
        data["reviewCount"] = this.reviewCount;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.collectionIds)) {
            data["collectionIds"] = [];
            for (let item of this.collectionIds)
                data["collectionIds"].push(item.toJSON());
        }
        if (this.aspects) {
            data["aspects"] = {};
            for (let key in this.aspects) {
                if (this.aspects.hasOwnProperty(key))
                    (<any>data["aspects"])[key] = (<any>this.aspects)[key];
            }
        }
        if (Array.isArray(this.insuranceIds)) {
            data["insuranceIds"] = [];
            for (let item of this.insuranceIds)
                data["insuranceIds"].push(item);
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.offerIds)) {
            data["offerIds"] = [];
            for (let item of this.offerIds)
                data["offerIds"].push(item);
        }
        if (Array.isArray(this.linkedItemIds)) {
            data["linkedItemIds"] = [];
            for (let item of this.linkedItemIds)
                data["linkedItemIds"].push(item);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        data["viewCount"] = this.viewCount;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["flagged"] = this.flagged;
        data["externalLink"] = this.externalLink;
        data["url"] = this.url;
        data["isRequest"] = this.isRequest;
        return data;
    }
}

export interface IItemSimpleDto {
    id: string;
    active: boolean;
    user: IImageableIdentifierDto;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    prices: { [key: string]: IDayPrice; } | undefined;
    originalValue: number | undefined;
    itemValue: number | undefined;
    purchaseDate: Date | undefined;
    receipt: boolean;
    requiresTraining: boolean;
    requiresPpe: boolean;
    isPublished: boolean;
    instantBooking: boolean;
    extensionLimitDays: number | undefined;
    extensionLimitHours: number | undefined;
    minimumHandOverImages: number | undefined;
    cancellationPolicy: CancellationPolicy;
    overallAverage: number | undefined;
    communicationAverage: number | undefined;
    pickUpAverage: number | undefined;
    dropOffAverage: number | undefined;
    accuracyAverage: number | undefined;
    qualityAverage: number | undefined;
    valueAverage: number | undefined;
    reviewCount: number;
    categories: IDescribableIdentifierDto[] | undefined;
    collectionIds: IDescribableIdentifierDto[] | undefined;
    aspects: { [key: string]: string[]; } | undefined;
    insuranceIds: string[] | undefined;
    location: ILocation;
    offerIds: string[] | undefined;
    linkedItemIds: string[] | undefined;
    images: IImageDto[] | undefined;
    videos: IVideoDto[] | undefined;
    viewCount: number;
    tenant: ITenantSimpleDto;
    flagged: boolean;
    externalLink: string | undefined;
    url: string | undefined;
    isRequest: boolean;
}

export class ItemViewDto implements IItemViewDto {
    id!: string;
    itemName!: string | undefined;
    description!: string | undefined;
    image!: ImageDto;
    priceInfo!: PriceInfo;
    reviews!: ReviewViewDto;
    ownerName!: string | undefined;
    ownerProfilePicture!: ImageDto;
    otherItems!: OtherItemsViewDto[] | undefined;
    approximateLocations!: ApproximateLocation[] | undefined;
    insurancePlans!: InsurancePlanDto[] | undefined;
    upcomingBookings!: UpcomingBookingsDto;
    externalLink!: string | undefined;

    constructor(data?: IItemViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.image = data.image && !(<any>data.image).toJSON ? new ImageDto(data.image) : <ImageDto>this.image;
            this.priceInfo = data.priceInfo && !(<any>data.priceInfo).toJSON ? new PriceInfo(data.priceInfo) : <PriceInfo>this.priceInfo;
            this.reviews = data.reviews && !(<any>data.reviews).toJSON ? new ReviewViewDto(data.reviews) : <ReviewViewDto>this.reviews;
            this.ownerProfilePicture = data.ownerProfilePicture && !(<any>data.ownerProfilePicture).toJSON ? new ImageDto(data.ownerProfilePicture) : <ImageDto>this.ownerProfilePicture;
            if (data.otherItems) {
                this.otherItems = [];
                for (let i = 0; i < data.otherItems.length; i++) {
                    let item = data.otherItems[i];
                    this.otherItems[i] = item && !(<any>item).toJSON ? new OtherItemsViewDto(item) : <OtherItemsViewDto>item;
                }
            }
            if (data.approximateLocations) {
                this.approximateLocations = [];
                for (let i = 0; i < data.approximateLocations.length; i++) {
                    let item = data.approximateLocations[i];
                    this.approximateLocations[i] = item && !(<any>item).toJSON ? new ApproximateLocation(item) : <ApproximateLocation>item;
                }
            }
            if (data.insurancePlans) {
                this.insurancePlans = [];
                for (let i = 0; i < data.insurancePlans.length; i++) {
                    let item = data.insurancePlans[i];
                    this.insurancePlans[i] = item && !(<any>item).toJSON ? new InsurancePlanDto(item) : <InsurancePlanDto>item;
                }
            }
            this.upcomingBookings = data.upcomingBookings && !(<any>data.upcomingBookings).toJSON ? new UpcomingBookingsDto(data.upcomingBookings) : <UpcomingBookingsDto>this.upcomingBookings;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemName = _data["itemName"];
            this.description = _data["description"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            this.priceInfo = _data["priceInfo"] ? PriceInfo.fromJS(_data["priceInfo"]) : <any>undefined;
            this.reviews = _data["reviews"] ? ReviewViewDto.fromJS(_data["reviews"]) : <any>undefined;
            this.ownerName = _data["ownerName"];
            this.ownerProfilePicture = _data["ownerProfilePicture"] ? ImageDto.fromJS(_data["ownerProfilePicture"]) : <any>undefined;
            if (Array.isArray(_data["otherItems"])) {
                this.otherItems = [] as any;
                for (let item of _data["otherItems"])
                    this.otherItems!.push(OtherItemsViewDto.fromJS(item));
            }
            if (Array.isArray(_data["approximateLocations"])) {
                this.approximateLocations = [] as any;
                for (let item of _data["approximateLocations"])
                    this.approximateLocations!.push(ApproximateLocation.fromJS(item));
            }
            if (Array.isArray(_data["insurancePlans"])) {
                this.insurancePlans = [] as any;
                for (let item of _data["insurancePlans"])
                    this.insurancePlans!.push(InsurancePlanDto.fromJS(item));
            }
            this.upcomingBookings = _data["upcomingBookings"] ? UpcomingBookingsDto.fromJS(_data["upcomingBookings"]) : <any>undefined;
            this.externalLink = _data["externalLink"];
        }
    }

    static fromJS(data: any): ItemViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemName"] = this.itemName;
        data["description"] = this.description;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["priceInfo"] = this.priceInfo ? this.priceInfo.toJSON() : <any>undefined;
        data["reviews"] = this.reviews ? this.reviews.toJSON() : <any>undefined;
        data["ownerName"] = this.ownerName;
        data["ownerProfilePicture"] = this.ownerProfilePicture ? this.ownerProfilePicture.toJSON() : <any>undefined;
        if (Array.isArray(this.otherItems)) {
            data["otherItems"] = [];
            for (let item of this.otherItems)
                data["otherItems"].push(item.toJSON());
        }
        if (Array.isArray(this.approximateLocations)) {
            data["approximateLocations"] = [];
            for (let item of this.approximateLocations)
                data["approximateLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.insurancePlans)) {
            data["insurancePlans"] = [];
            for (let item of this.insurancePlans)
                data["insurancePlans"].push(item.toJSON());
        }
        data["upcomingBookings"] = this.upcomingBookings ? this.upcomingBookings.toJSON() : <any>undefined;
        data["externalLink"] = this.externalLink;
        return data;
    }
}

export interface IItemViewDto {
    id: string;
    itemName: string | undefined;
    description: string | undefined;
    image: IImageDto;
    priceInfo: IPriceInfo;
    reviews: IReviewViewDto;
    ownerName: string | undefined;
    ownerProfilePicture: IImageDto;
    otherItems: IOtherItemsViewDto[] | undefined;
    approximateLocations: IApproximateLocation[] | undefined;
    insurancePlans: IInsurancePlanDto[] | undefined;
    upcomingBookings: IUpcomingBookingsDto;
    externalLink: string | undefined;
}

export class LimitedVoucherDto implements ILimitedVoucherDto {
    code!: string | undefined;
    id!: string;

    constructor(data?: ILimitedVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LimitedVoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new LimitedVoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface ILimitedVoucherDto {
    code: string | undefined;
    id: string;
}

export class LinkedItem implements ILinkedItem {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    item!: Item;
    itemLink!: Item;

    constructor(data?: ILinkedItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.item = data.item && !(<any>data.item).toJSON ? new Item(data.item) : <Item>this.item;
            this.itemLink = data.itemLink && !(<any>data.itemLink).toJSON ? new Item(data.itemLink) : <Item>this.itemLink;
        }
        if (!data) {
            this.item = new Item();
            this.itemLink = new Item();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : new Item();
            this.itemLink = _data["itemLink"] ? Item.fromJS(_data["itemLink"]) : new Item();
        }
    }

    static fromJS(data: any): LinkedItem {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["itemLink"] = this.itemLink ? this.itemLink.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILinkedItem {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    item: IItem;
    itemLink: IItem;
}

export class ListingsAnalyticsDto implements IListingsAnalyticsDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    totalListingPrice!: number | undefined;
    totalReplacementPrice!: number | undefined;
    queryTimePrice!: number | undefined;
    items!: ItemSimpleDto[] | undefined;
    queryDate!: Date | undefined;
    queryParameters!: { [key: string]: string; } | undefined;

    constructor(data?: IListingsAnalyticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new ItemSimpleDto(item) : <ItemSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.totalListingPrice = _data["totalListingPrice"];
            this.totalReplacementPrice = _data["totalReplacementPrice"];
            this.queryTimePrice = _data["queryTimePrice"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemSimpleDto.fromJS(item));
            }
            this.queryDate = _data["queryDate"] ? new Date(_data["queryDate"].toString()) : <any>undefined;
            if (_data["queryParameters"]) {
                this.queryParameters = {} as any;
                for (let key in _data["queryParameters"]) {
                    if (_data["queryParameters"].hasOwnProperty(key))
                        (<any>this.queryParameters)![key] = _data["queryParameters"][key];
                }
            }
        }
    }

    static fromJS(data: any): ListingsAnalyticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListingsAnalyticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["totalListingPrice"] = this.totalListingPrice;
        data["totalReplacementPrice"] = this.totalReplacementPrice;
        data["queryTimePrice"] = this.queryTimePrice;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["queryDate"] = this.queryDate ? this.queryDate.toISOString() : <any>undefined;
        if (this.queryParameters) {
            data["queryParameters"] = {};
            for (let key in this.queryParameters) {
                if (this.queryParameters.hasOwnProperty(key))
                    (<any>data["queryParameters"])[key] = (<any>this.queryParameters)[key];
            }
        }
        return data;
    }
}

export interface IListingsAnalyticsDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    totalListingPrice: number | undefined;
    totalReplacementPrice: number | undefined;
    queryTimePrice: number | undefined;
    items: IItemSimpleDto[] | undefined;
    queryDate: Date | undefined;
    queryParameters: { [key: string]: string; } | undefined;
}

export class Location implements ILocation {
    name!: string | undefined;
    addressLine1!: string | undefined;
    addressLine2!: string | undefined;
    addressLine3!: string | undefined;
    city!: string | undefined;
    county!: string | undefined;
    country!: string | undefined;
    postcode!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.country = _data["country"];
            this.postcode = _data["postcode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["city"] = this.city;
        data["county"] = this.county;
        data["country"] = this.country;
        data["postcode"] = this.postcode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface ILocation {
    name: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    addressLine3: string | undefined;
    city: string | undefined;
    county: string | undefined;
    country: string | undefined;
    postcode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
}

export class LocationPageCreateDto implements ILocationPageCreateDto {
    active!: boolean | undefined;
    browserTitle!: string | undefined;
    pageTitle!: string | undefined;
    pageTitleAlignment!: ContentAlignment;
    pageTitleFontSize!: FontSize;
    imageId!: string | undefined;
    metaDescription!: string | undefined;
    description!: string | undefined;
    descriptionAlignment!: ContentAlignment;
    descriptionFontSize!: FontSize;
    smallText!: string | undefined;
    smallTextAlignment!: ContentAlignment;
    smallTextFontSize!: FontSize;
    longText!: string | undefined;
    categoryId!: string | undefined;
    similarCategoriesIds!: string[] | undefined;
    location!: SeoLocation;
    breadcrumbs!: SeoBreadcrumb[] | undefined;
    url!: string | undefined;

    constructor(data?: ILocationPageCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.pageTitleAlignment = data.pageTitleAlignment && !(<any>data.pageTitleAlignment).toJSON ? new ContentAlignment(data.pageTitleAlignment) : <ContentAlignment>this.pageTitleAlignment;
            this.pageTitleFontSize = data.pageTitleFontSize && !(<any>data.pageTitleFontSize).toJSON ? new FontSize(data.pageTitleFontSize) : <FontSize>this.pageTitleFontSize;
            this.descriptionAlignment = data.descriptionAlignment && !(<any>data.descriptionAlignment).toJSON ? new ContentAlignment(data.descriptionAlignment) : <ContentAlignment>this.descriptionAlignment;
            this.descriptionFontSize = data.descriptionFontSize && !(<any>data.descriptionFontSize).toJSON ? new FontSize(data.descriptionFontSize) : <FontSize>this.descriptionFontSize;
            this.smallTextAlignment = data.smallTextAlignment && !(<any>data.smallTextAlignment).toJSON ? new ContentAlignment(data.smallTextAlignment) : <ContentAlignment>this.smallTextAlignment;
            this.smallTextFontSize = data.smallTextFontSize && !(<any>data.smallTextFontSize).toJSON ? new FontSize(data.smallTextFontSize) : <FontSize>this.smallTextFontSize;
            this.location = data.location && !(<any>data.location).toJSON ? new SeoLocation(data.location) : <SeoLocation>this.location;
            if (data.breadcrumbs) {
                this.breadcrumbs = [];
                for (let i = 0; i < data.breadcrumbs.length; i++) {
                    let item = data.breadcrumbs[i];
                    this.breadcrumbs[i] = item && !(<any>item).toJSON ? new SeoBreadcrumb(item) : <SeoBreadcrumb>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.browserTitle = _data["browserTitle"];
            this.pageTitle = _data["pageTitle"];
            this.pageTitleAlignment = _data["pageTitleAlignment"] ? ContentAlignment.fromJS(_data["pageTitleAlignment"]) : <any>undefined;
            this.pageTitleFontSize = _data["pageTitleFontSize"] ? FontSize.fromJS(_data["pageTitleFontSize"]) : <any>undefined;
            this.imageId = _data["imageId"];
            this.metaDescription = _data["metaDescription"];
            this.description = _data["description"];
            this.descriptionAlignment = _data["descriptionAlignment"] ? ContentAlignment.fromJS(_data["descriptionAlignment"]) : <any>undefined;
            this.descriptionFontSize = _data["descriptionFontSize"] ? FontSize.fromJS(_data["descriptionFontSize"]) : <any>undefined;
            this.smallText = _data["smallText"];
            this.smallTextAlignment = _data["smallTextAlignment"] ? ContentAlignment.fromJS(_data["smallTextAlignment"]) : <any>undefined;
            this.smallTextFontSize = _data["smallTextFontSize"] ? FontSize.fromJS(_data["smallTextFontSize"]) : <any>undefined;
            this.longText = _data["longText"];
            this.categoryId = _data["categoryId"];
            if (Array.isArray(_data["similarCategoriesIds"])) {
                this.similarCategoriesIds = [] as any;
                for (let item of _data["similarCategoriesIds"])
                    this.similarCategoriesIds!.push(item);
            }
            this.location = _data["location"] ? SeoLocation.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["breadcrumbs"])) {
                this.breadcrumbs = [] as any;
                for (let item of _data["breadcrumbs"])
                    this.breadcrumbs!.push(SeoBreadcrumb.fromJS(item));
            }
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): LocationPageCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPageCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["browserTitle"] = this.browserTitle;
        data["pageTitle"] = this.pageTitle;
        data["pageTitleAlignment"] = this.pageTitleAlignment ? this.pageTitleAlignment.toJSON() : <any>undefined;
        data["pageTitleFontSize"] = this.pageTitleFontSize ? this.pageTitleFontSize.toJSON() : <any>undefined;
        data["imageId"] = this.imageId;
        data["metaDescription"] = this.metaDescription;
        data["description"] = this.description;
        data["descriptionAlignment"] = this.descriptionAlignment ? this.descriptionAlignment.toJSON() : <any>undefined;
        data["descriptionFontSize"] = this.descriptionFontSize ? this.descriptionFontSize.toJSON() : <any>undefined;
        data["smallText"] = this.smallText;
        data["smallTextAlignment"] = this.smallTextAlignment ? this.smallTextAlignment.toJSON() : <any>undefined;
        data["smallTextFontSize"] = this.smallTextFontSize ? this.smallTextFontSize.toJSON() : <any>undefined;
        data["longText"] = this.longText;
        data["categoryId"] = this.categoryId;
        if (Array.isArray(this.similarCategoriesIds)) {
            data["similarCategoriesIds"] = [];
            for (let item of this.similarCategoriesIds)
                data["similarCategoriesIds"].push(item);
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.breadcrumbs)) {
            data["breadcrumbs"] = [];
            for (let item of this.breadcrumbs)
                data["breadcrumbs"].push(item.toJSON());
        }
        data["url"] = this.url;
        return data;
    }
}

export interface ILocationPageCreateDto {
    active: boolean | undefined;
    browserTitle: string | undefined;
    pageTitle: string | undefined;
    pageTitleAlignment: IContentAlignment;
    pageTitleFontSize: IFontSize;
    imageId: string | undefined;
    metaDescription: string | undefined;
    description: string | undefined;
    descriptionAlignment: IContentAlignment;
    descriptionFontSize: IFontSize;
    smallText: string | undefined;
    smallTextAlignment: IContentAlignment;
    smallTextFontSize: IFontSize;
    longText: string | undefined;
    categoryId: string | undefined;
    similarCategoriesIds: string[] | undefined;
    location: ISeoLocation;
    breadcrumbs: ISeoBreadcrumb[] | undefined;
    url: string | undefined;
}

export class LocationPageDetailedDto implements ILocationPageDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    browserTitle!: string | undefined;
    pageTitle!: string | undefined;
    pageTitleAlignment!: ContentAlignment;
    pageTitleFontSize!: FontSize;
    image!: ImageDto;
    metaDescription!: string | undefined;
    description!: string | undefined;
    descriptionAlignment!: ContentAlignment;
    descriptionFontSize!: FontSize;
    smallText!: string | undefined;
    smallTextAlignment!: ContentAlignment;
    smallTextFontSize!: FontSize;
    longText!: string | undefined;
    category!: CategoryDetailedDto;
    similarCategories!: CategoryDetailedDto[] | undefined;
    location!: SeoLocation;
    breadcrumbs!: SeoBreadcrumb[] | undefined;
    url!: string | undefined;

    constructor(data?: ILocationPageDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.pageTitleAlignment = data.pageTitleAlignment && !(<any>data.pageTitleAlignment).toJSON ? new ContentAlignment(data.pageTitleAlignment) : <ContentAlignment>this.pageTitleAlignment;
            this.pageTitleFontSize = data.pageTitleFontSize && !(<any>data.pageTitleFontSize).toJSON ? new FontSize(data.pageTitleFontSize) : <FontSize>this.pageTitleFontSize;
            this.image = data.image && !(<any>data.image).toJSON ? new ImageDto(data.image) : <ImageDto>this.image;
            this.descriptionAlignment = data.descriptionAlignment && !(<any>data.descriptionAlignment).toJSON ? new ContentAlignment(data.descriptionAlignment) : <ContentAlignment>this.descriptionAlignment;
            this.descriptionFontSize = data.descriptionFontSize && !(<any>data.descriptionFontSize).toJSON ? new FontSize(data.descriptionFontSize) : <FontSize>this.descriptionFontSize;
            this.smallTextAlignment = data.smallTextAlignment && !(<any>data.smallTextAlignment).toJSON ? new ContentAlignment(data.smallTextAlignment) : <ContentAlignment>this.smallTextAlignment;
            this.smallTextFontSize = data.smallTextFontSize && !(<any>data.smallTextFontSize).toJSON ? new FontSize(data.smallTextFontSize) : <FontSize>this.smallTextFontSize;
            this.category = data.category && !(<any>data.category).toJSON ? new CategoryDetailedDto(data.category) : <CategoryDetailedDto>this.category;
            if (data.similarCategories) {
                this.similarCategories = [];
                for (let i = 0; i < data.similarCategories.length; i++) {
                    let item = data.similarCategories[i];
                    this.similarCategories[i] = item && !(<any>item).toJSON ? new CategoryDetailedDto(item) : <CategoryDetailedDto>item;
                }
            }
            this.location = data.location && !(<any>data.location).toJSON ? new SeoLocation(data.location) : <SeoLocation>this.location;
            if (data.breadcrumbs) {
                this.breadcrumbs = [];
                for (let i = 0; i < data.breadcrumbs.length; i++) {
                    let item = data.breadcrumbs[i];
                    this.breadcrumbs[i] = item && !(<any>item).toJSON ? new SeoBreadcrumb(item) : <SeoBreadcrumb>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.browserTitle = _data["browserTitle"];
            this.pageTitle = _data["pageTitle"];
            this.pageTitleAlignment = _data["pageTitleAlignment"] ? ContentAlignment.fromJS(_data["pageTitleAlignment"]) : <any>undefined;
            this.pageTitleFontSize = _data["pageTitleFontSize"] ? FontSize.fromJS(_data["pageTitleFontSize"]) : <any>undefined;
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            this.metaDescription = _data["metaDescription"];
            this.description = _data["description"];
            this.descriptionAlignment = _data["descriptionAlignment"] ? ContentAlignment.fromJS(_data["descriptionAlignment"]) : <any>undefined;
            this.descriptionFontSize = _data["descriptionFontSize"] ? FontSize.fromJS(_data["descriptionFontSize"]) : <any>undefined;
            this.smallText = _data["smallText"];
            this.smallTextAlignment = _data["smallTextAlignment"] ? ContentAlignment.fromJS(_data["smallTextAlignment"]) : <any>undefined;
            this.smallTextFontSize = _data["smallTextFontSize"] ? FontSize.fromJS(_data["smallTextFontSize"]) : <any>undefined;
            this.longText = _data["longText"];
            this.category = _data["category"] ? CategoryDetailedDto.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["similarCategories"])) {
                this.similarCategories = [] as any;
                for (let item of _data["similarCategories"])
                    this.similarCategories!.push(CategoryDetailedDto.fromJS(item));
            }
            this.location = _data["location"] ? SeoLocation.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["breadcrumbs"])) {
                this.breadcrumbs = [] as any;
                for (let item of _data["breadcrumbs"])
                    this.breadcrumbs!.push(SeoBreadcrumb.fromJS(item));
            }
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): LocationPageDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPageDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["browserTitle"] = this.browserTitle;
        data["pageTitle"] = this.pageTitle;
        data["pageTitleAlignment"] = this.pageTitleAlignment ? this.pageTitleAlignment.toJSON() : <any>undefined;
        data["pageTitleFontSize"] = this.pageTitleFontSize ? this.pageTitleFontSize.toJSON() : <any>undefined;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["metaDescription"] = this.metaDescription;
        data["description"] = this.description;
        data["descriptionAlignment"] = this.descriptionAlignment ? this.descriptionAlignment.toJSON() : <any>undefined;
        data["descriptionFontSize"] = this.descriptionFontSize ? this.descriptionFontSize.toJSON() : <any>undefined;
        data["smallText"] = this.smallText;
        data["smallTextAlignment"] = this.smallTextAlignment ? this.smallTextAlignment.toJSON() : <any>undefined;
        data["smallTextFontSize"] = this.smallTextFontSize ? this.smallTextFontSize.toJSON() : <any>undefined;
        data["longText"] = this.longText;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.similarCategories)) {
            data["similarCategories"] = [];
            for (let item of this.similarCategories)
                data["similarCategories"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.breadcrumbs)) {
            data["breadcrumbs"] = [];
            for (let item of this.breadcrumbs)
                data["breadcrumbs"].push(item.toJSON());
        }
        data["url"] = this.url;
        return data;
    }
}

export interface ILocationPageDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    browserTitle: string | undefined;
    pageTitle: string | undefined;
    pageTitleAlignment: IContentAlignment;
    pageTitleFontSize: IFontSize;
    image: IImageDto;
    metaDescription: string | undefined;
    description: string | undefined;
    descriptionAlignment: IContentAlignment;
    descriptionFontSize: IFontSize;
    smallText: string | undefined;
    smallTextAlignment: IContentAlignment;
    smallTextFontSize: IFontSize;
    longText: string | undefined;
    category: ICategoryDetailedDto;
    similarCategories: ICategoryDetailedDto[] | undefined;
    location: ISeoLocation;
    breadcrumbs: ISeoBreadcrumb[] | undefined;
    url: string | undefined;
}

export class LocationPageDetailedDtoPaginationDto implements ILocationPageDetailedDtoPaginationDto {
    data!: LocationPageDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ILocationPageDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new LocationPageDetailedDto(item) : <LocationPageDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LocationPageDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): LocationPageDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPageDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ILocationPageDetailedDtoPaginationDto {
    data: ILocationPageDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class LocationPageDetailedDtoUpdateResponseDto implements ILocationPageDetailedDtoUpdateResponseDto {
    data!: LocationPageDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: ILocationPageDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new LocationPageDetailedDto(data.data) : <LocationPageDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? LocationPageDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): LocationPageDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPageDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ILocationPageDetailedDtoUpdateResponseDto {
    data: ILocationPageDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class LocationPageResultsDto implements ILocationPageResultsDto {
    id!: string;
    locationPage!: LocationPageSimpleDto;
    items!: ItemPublicSimpleDto[] | undefined;
    reviews!: ReviewSimpleDto[] | undefined;

    constructor(data?: ILocationPageResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.locationPage = data.locationPage && !(<any>data.locationPage).toJSON ? new LocationPageSimpleDto(data.locationPage) : <LocationPageSimpleDto>this.locationPage;
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new ItemPublicSimpleDto(item) : <ItemPublicSimpleDto>item;
                }
            }
            if (data.reviews) {
                this.reviews = [];
                for (let i = 0; i < data.reviews.length; i++) {
                    let item = data.reviews[i];
                    this.reviews[i] = item && !(<any>item).toJSON ? new ReviewSimpleDto(item) : <ReviewSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationPage = _data["locationPage"] ? LocationPageSimpleDto.fromJS(_data["locationPage"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemPublicSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["reviews"])) {
                this.reviews = [] as any;
                for (let item of _data["reviews"])
                    this.reviews!.push(ReviewSimpleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocationPageResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPageResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationPage"] = this.locationPage ? this.locationPage.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.reviews)) {
            data["reviews"] = [];
            for (let item of this.reviews)
                data["reviews"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationPageResultsDto {
    id: string;
    locationPage: ILocationPageSimpleDto;
    items: IItemPublicSimpleDto[] | undefined;
    reviews: IReviewSimpleDto[] | undefined;
}

export class LocationPageSimpleDto implements ILocationPageSimpleDto {
    id!: string;
    active!: boolean;
    browserTitle!: string | undefined;
    pageTitle!: string | undefined;
    pageTitleAlignment!: ContentAlignment;
    pageTitleFontSize!: FontSize;
    image!: ImageDto;
    metaDescription!: string | undefined;
    description!: string | undefined;
    descriptionAlignment!: ContentAlignment;
    descriptionFontSize!: FontSize;
    smallText!: string | undefined;
    smallTextAlignment!: ContentAlignment;
    smallTextFontSize!: FontSize;
    longText!: string | undefined;
    category!: CategoryDetailedDto;
    similarCategories!: CategoryDetailedDto[] | undefined;
    location!: SeoLocation;
    breadcrumbs!: SeoBreadcrumb[] | undefined;
    url!: string | undefined;

    constructor(data?: ILocationPageSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.pageTitleAlignment = data.pageTitleAlignment && !(<any>data.pageTitleAlignment).toJSON ? new ContentAlignment(data.pageTitleAlignment) : <ContentAlignment>this.pageTitleAlignment;
            this.pageTitleFontSize = data.pageTitleFontSize && !(<any>data.pageTitleFontSize).toJSON ? new FontSize(data.pageTitleFontSize) : <FontSize>this.pageTitleFontSize;
            this.image = data.image && !(<any>data.image).toJSON ? new ImageDto(data.image) : <ImageDto>this.image;
            this.descriptionAlignment = data.descriptionAlignment && !(<any>data.descriptionAlignment).toJSON ? new ContentAlignment(data.descriptionAlignment) : <ContentAlignment>this.descriptionAlignment;
            this.descriptionFontSize = data.descriptionFontSize && !(<any>data.descriptionFontSize).toJSON ? new FontSize(data.descriptionFontSize) : <FontSize>this.descriptionFontSize;
            this.smallTextAlignment = data.smallTextAlignment && !(<any>data.smallTextAlignment).toJSON ? new ContentAlignment(data.smallTextAlignment) : <ContentAlignment>this.smallTextAlignment;
            this.smallTextFontSize = data.smallTextFontSize && !(<any>data.smallTextFontSize).toJSON ? new FontSize(data.smallTextFontSize) : <FontSize>this.smallTextFontSize;
            this.category = data.category && !(<any>data.category).toJSON ? new CategoryDetailedDto(data.category) : <CategoryDetailedDto>this.category;
            if (data.similarCategories) {
                this.similarCategories = [];
                for (let i = 0; i < data.similarCategories.length; i++) {
                    let item = data.similarCategories[i];
                    this.similarCategories[i] = item && !(<any>item).toJSON ? new CategoryDetailedDto(item) : <CategoryDetailedDto>item;
                }
            }
            this.location = data.location && !(<any>data.location).toJSON ? new SeoLocation(data.location) : <SeoLocation>this.location;
            if (data.breadcrumbs) {
                this.breadcrumbs = [];
                for (let i = 0; i < data.breadcrumbs.length; i++) {
                    let item = data.breadcrumbs[i];
                    this.breadcrumbs[i] = item && !(<any>item).toJSON ? new SeoBreadcrumb(item) : <SeoBreadcrumb>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.browserTitle = _data["browserTitle"];
            this.pageTitle = _data["pageTitle"];
            this.pageTitleAlignment = _data["pageTitleAlignment"] ? ContentAlignment.fromJS(_data["pageTitleAlignment"]) : <any>undefined;
            this.pageTitleFontSize = _data["pageTitleFontSize"] ? FontSize.fromJS(_data["pageTitleFontSize"]) : <any>undefined;
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            this.metaDescription = _data["metaDescription"];
            this.description = _data["description"];
            this.descriptionAlignment = _data["descriptionAlignment"] ? ContentAlignment.fromJS(_data["descriptionAlignment"]) : <any>undefined;
            this.descriptionFontSize = _data["descriptionFontSize"] ? FontSize.fromJS(_data["descriptionFontSize"]) : <any>undefined;
            this.smallText = _data["smallText"];
            this.smallTextAlignment = _data["smallTextAlignment"] ? ContentAlignment.fromJS(_data["smallTextAlignment"]) : <any>undefined;
            this.smallTextFontSize = _data["smallTextFontSize"] ? FontSize.fromJS(_data["smallTextFontSize"]) : <any>undefined;
            this.longText = _data["longText"];
            this.category = _data["category"] ? CategoryDetailedDto.fromJS(_data["category"]) : <any>undefined;
            if (Array.isArray(_data["similarCategories"])) {
                this.similarCategories = [] as any;
                for (let item of _data["similarCategories"])
                    this.similarCategories!.push(CategoryDetailedDto.fromJS(item));
            }
            this.location = _data["location"] ? SeoLocation.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["breadcrumbs"])) {
                this.breadcrumbs = [] as any;
                for (let item of _data["breadcrumbs"])
                    this.breadcrumbs!.push(SeoBreadcrumb.fromJS(item));
            }
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): LocationPageSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPageSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["browserTitle"] = this.browserTitle;
        data["pageTitle"] = this.pageTitle;
        data["pageTitleAlignment"] = this.pageTitleAlignment ? this.pageTitleAlignment.toJSON() : <any>undefined;
        data["pageTitleFontSize"] = this.pageTitleFontSize ? this.pageTitleFontSize.toJSON() : <any>undefined;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["metaDescription"] = this.metaDescription;
        data["description"] = this.description;
        data["descriptionAlignment"] = this.descriptionAlignment ? this.descriptionAlignment.toJSON() : <any>undefined;
        data["descriptionFontSize"] = this.descriptionFontSize ? this.descriptionFontSize.toJSON() : <any>undefined;
        data["smallText"] = this.smallText;
        data["smallTextAlignment"] = this.smallTextAlignment ? this.smallTextAlignment.toJSON() : <any>undefined;
        data["smallTextFontSize"] = this.smallTextFontSize ? this.smallTextFontSize.toJSON() : <any>undefined;
        data["longText"] = this.longText;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (Array.isArray(this.similarCategories)) {
            data["similarCategories"] = [];
            for (let item of this.similarCategories)
                data["similarCategories"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.breadcrumbs)) {
            data["breadcrumbs"] = [];
            for (let item of this.breadcrumbs)
                data["breadcrumbs"].push(item.toJSON());
        }
        data["url"] = this.url;
        return data;
    }
}

export interface ILocationPageSimpleDto {
    id: string;
    active: boolean;
    browserTitle: string | undefined;
    pageTitle: string | undefined;
    pageTitleAlignment: IContentAlignment;
    pageTitleFontSize: IFontSize;
    image: IImageDto;
    metaDescription: string | undefined;
    description: string | undefined;
    descriptionAlignment: IContentAlignment;
    descriptionFontSize: IFontSize;
    smallText: string | undefined;
    smallTextAlignment: IContentAlignment;
    smallTextFontSize: IFontSize;
    longText: string | undefined;
    category: ICategoryDetailedDto;
    similarCategories: ICategoryDetailedDto[] | undefined;
    location: ISeoLocation;
    breadcrumbs: ISeoBreadcrumb[] | undefined;
    url: string | undefined;
}

export class LocationPageSimpleDtoPaginationDto implements ILocationPageSimpleDtoPaginationDto {
    data!: LocationPageSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ILocationPageSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new LocationPageSimpleDto(item) : <LocationPageSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LocationPageSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): LocationPageSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationPageSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ILocationPageSimpleDtoPaginationDto {
    data: ILocationPageSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum LossView {
    All = "All",
    Lost = "Lost",
    Stolen = "Stolen",
    Theft = "Theft",
    Damaged = "Damaged",
    Destroyed = "Destroyed",
    None = "None",
}

export class MessageCreateDto implements IMessageCreateDto {
    active!: boolean | undefined;
    recipient!: string;
    subject!: string | undefined;
    content!: string | undefined;

    constructor(data?: IMessageCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.recipient = _data["recipient"];
            this.subject = _data["subject"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): MessageCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["recipient"] = this.recipient;
        data["subject"] = this.subject;
        data["content"] = this.content;
        return data;
    }
}

export interface IMessageCreateDto {
    active: boolean | undefined;
    recipient: string;
    subject: string | undefined;
    content: string | undefined;
}

export class MessageDetailedDto implements IMessageDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    sender!: RentMyUserSimpleDto;
    recipient!: RentMyUserSimpleDto;
    subject!: string | undefined;
    content!: string | undefined;
    dateSent!: Date;
    dateReceived!: Date | undefined;
    dateRead!: Date | undefined;
    flagged!: boolean;

    constructor(data?: IMessageDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.sender = data.sender && !(<any>data.sender).toJSON ? new RentMyUserSimpleDto(data.sender) : <RentMyUserSimpleDto>this.sender;
            this.recipient = data.recipient && !(<any>data.recipient).toJSON ? new RentMyUserSimpleDto(data.recipient) : <RentMyUserSimpleDto>this.recipient;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.sender = _data["sender"] ? RentMyUserSimpleDto.fromJS(_data["sender"]) : <any>undefined;
            this.recipient = _data["recipient"] ? RentMyUserSimpleDto.fromJS(_data["recipient"]) : <any>undefined;
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.dateSent = _data["dateSent"] ? new Date(_data["dateSent"].toString()) : <any>undefined;
            this.dateReceived = _data["dateReceived"] ? new Date(_data["dateReceived"].toString()) : <any>undefined;
            this.dateRead = _data["dateRead"] ? new Date(_data["dateRead"].toString()) : <any>undefined;
            this.flagged = _data["flagged"];
        }
    }

    static fromJS(data: any): MessageDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["sender"] = this.sender ? this.sender.toJSON() : <any>undefined;
        data["recipient"] = this.recipient ? this.recipient.toJSON() : <any>undefined;
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["dateSent"] = this.dateSent ? this.dateSent.toISOString() : <any>undefined;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        data["dateRead"] = this.dateRead ? this.dateRead.toISOString() : <any>undefined;
        data["flagged"] = this.flagged;
        return data;
    }
}

export interface IMessageDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    sender: IRentMyUserSimpleDto;
    recipient: IRentMyUserSimpleDto;
    subject: string | undefined;
    content: string | undefined;
    dateSent: Date;
    dateReceived: Date | undefined;
    dateRead: Date | undefined;
    flagged: boolean;
}

export class MessageDetailedDtoPaginationDto implements IMessageDetailedDtoPaginationDto {
    data!: MessageDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IMessageDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new MessageDetailedDto(item) : <MessageDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MessageDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): MessageDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IMessageDetailedDtoPaginationDto {
    data: IMessageDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class MessageDetailedDtoUpdateResponseDto implements IMessageDetailedDtoUpdateResponseDto {
    data!: MessageDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IMessageDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new MessageDetailedDto(data.data) : <MessageDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? MessageDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): MessageDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IMessageDetailedDtoUpdateResponseDto {
    data: IMessageDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class MessageSimpleDto implements IMessageSimpleDto {
    id!: string;
    active!: boolean;
    sender!: ImageableIdentifierDto;
    recipient!: ImageableIdentifierDto;
    subject!: string | undefined;
    content!: string | undefined;
    dateSent!: Date;
    dateReceived!: Date | undefined;
    dateRead!: Date | undefined;
    flagged!: boolean;

    constructor(data?: IMessageSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.sender = data.sender && !(<any>data.sender).toJSON ? new ImageableIdentifierDto(data.sender) : <ImageableIdentifierDto>this.sender;
            this.recipient = data.recipient && !(<any>data.recipient).toJSON ? new ImageableIdentifierDto(data.recipient) : <ImageableIdentifierDto>this.recipient;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.sender = _data["sender"] ? ImageableIdentifierDto.fromJS(_data["sender"]) : <any>undefined;
            this.recipient = _data["recipient"] ? ImageableIdentifierDto.fromJS(_data["recipient"]) : <any>undefined;
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.dateSent = _data["dateSent"] ? new Date(_data["dateSent"].toString()) : <any>undefined;
            this.dateReceived = _data["dateReceived"] ? new Date(_data["dateReceived"].toString()) : <any>undefined;
            this.dateRead = _data["dateRead"] ? new Date(_data["dateRead"].toString()) : <any>undefined;
            this.flagged = _data["flagged"];
        }
    }

    static fromJS(data: any): MessageSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["sender"] = this.sender ? this.sender.toJSON() : <any>undefined;
        data["recipient"] = this.recipient ? this.recipient.toJSON() : <any>undefined;
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["dateSent"] = this.dateSent ? this.dateSent.toISOString() : <any>undefined;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        data["dateRead"] = this.dateRead ? this.dateRead.toISOString() : <any>undefined;
        data["flagged"] = this.flagged;
        return data;
    }
}

export interface IMessageSimpleDto {
    id: string;
    active: boolean;
    sender: IImageableIdentifierDto;
    recipient: IImageableIdentifierDto;
    subject: string | undefined;
    content: string | undefined;
    dateSent: Date;
    dateReceived: Date | undefined;
    dateRead: Date | undefined;
    flagged: boolean;
}

export class MessageSimpleDtoPaginationDto implements IMessageSimpleDtoPaginationDto {
    data!: MessageSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IMessageSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new MessageSimpleDto(item) : <MessageSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MessageSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): MessageSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IMessageSimpleDtoPaginationDto {
    data: IMessageSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class MicroshopCreateDto implements IMicroshopCreateDto {
    active!: boolean | undefined;
    userId!: string;
    name!: string | undefined;
    details!: string | undefined;
    website!: string | undefined;
    icon!: string | undefined;

    constructor(data?: IMicroshopCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.details = _data["details"];
            this.website = _data["website"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): MicroshopCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new MicroshopCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["details"] = this.details;
        data["website"] = this.website;
        data["icon"] = this.icon;
        return data;
    }
}

export interface IMicroshopCreateDto {
    active: boolean | undefined;
    userId: string;
    name: string | undefined;
    details: string | undefined;
    website: string | undefined;
    icon: string | undefined;
}

export class MicroshopDetailedDto implements IMicroshopDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUserSimpleDto;
    name!: string | undefined;
    details!: string | undefined;
    website!: string | undefined;
    icon!: string | undefined;
    items!: ItemSimpleDto[] | undefined;

    constructor(data?: IMicroshopDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserSimpleDto(data.user) : <RentMyUserSimpleDto>this.user;
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new ItemSimpleDto(item) : <ItemSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUserSimpleDto.fromJS(_data["user"]) : <any>undefined;
            this.name = _data["name"];
            this.details = _data["details"];
            this.website = _data["website"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemSimpleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MicroshopDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new MicroshopDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["details"] = this.details;
        data["website"] = this.website;
        data["icon"] = this.icon;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMicroshopDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUserSimpleDto;
    name: string | undefined;
    details: string | undefined;
    website: string | undefined;
    icon: string | undefined;
    items: IItemSimpleDto[] | undefined;
}

export class MicroshopDetailedDtoPaginationDto implements IMicroshopDetailedDtoPaginationDto {
    data!: MicroshopDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IMicroshopDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new MicroshopDetailedDto(item) : <MicroshopDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MicroshopDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): MicroshopDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MicroshopDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IMicroshopDetailedDtoPaginationDto {
    data: IMicroshopDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class MicroshopDetailedDtoUpdateResponseDto implements IMicroshopDetailedDtoUpdateResponseDto {
    data!: MicroshopDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IMicroshopDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new MicroshopDetailedDto(data.data) : <MicroshopDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? MicroshopDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): MicroshopDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MicroshopDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IMicroshopDetailedDtoUpdateResponseDto {
    data: IMicroshopDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class MicroshopSimpleDto implements IMicroshopSimpleDto {
    id!: string;
    active!: boolean;
    userId!: string;
    name!: string | undefined;
    details!: string | undefined;
    website!: string | undefined;
    icon!: string | undefined;
    readonly items!: string[] | undefined;

    constructor(data?: IMicroshopSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.details = _data["details"];
            this.website = _data["website"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(item);
            }
        }
    }

    static fromJS(data: any): MicroshopSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MicroshopSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["details"] = this.details;
        data["website"] = this.website;
        data["icon"] = this.icon;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data;
    }
}

export interface IMicroshopSimpleDto {
    id: string;
    active: boolean;
    userId: string;
    name: string | undefined;
    details: string | undefined;
    website: string | undefined;
    icon: string | undefined;
    items: string[] | undefined;
}

export class MicroshopSimpleDtoPaginationDto implements IMicroshopSimpleDtoPaginationDto {
    data!: MicroshopSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IMicroshopSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new MicroshopSimpleDto(item) : <MicroshopSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MicroshopSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): MicroshopSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MicroshopSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IMicroshopSimpleDtoPaginationDto {
    data: IMicroshopSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum MultiAspectSearchMode {
    And = "And",
    Or = "Or",
}

export class MultiBooking implements IMultiBooking {
    amount!: number;
    discount!: number;

    constructor(data?: IMultiBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.discount = _data["discount"];
        }
    }

    static fromJS(data: any): MultiBooking {
        data = typeof data === 'object' ? data : {};
        let result = new MultiBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["discount"] = this.discount;
        return data;
    }
}

export interface IMultiBooking {
    amount: number;
    discount: number;
}

export class MultiImageableIdentifierDto implements IMultiImageableIdentifierDto {
    id!: string;
    name!: string | undefined;
    images!: ImageDto[] | undefined;

    constructor(data?: IMultiImageableIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.images) {
                this.images = [];
                for (let i = 0; i < data.images.length; i++) {
                    let item = data.images[i];
                    this.images[i] = item && !(<any>item).toJSON ? new ImageDto(item) : <ImageDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultiImageableIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiImageableIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMultiImageableIdentifierDto {
    id: string;
    name: string | undefined;
    images: IImageDto[] | undefined;
}

export class MultiImageableUrlIdentifierDto implements IMultiImageableUrlIdentifierDto {
    id!: string;
    name!: string | undefined;
    images!: ImageDto[] | undefined;
    url!: string | undefined;

    constructor(data?: IMultiImageableUrlIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.images) {
                this.images = [];
                for (let i = 0; i < data.images.length; i++) {
                    let item = data.images[i];
                    this.images[i] = item && !(<any>item).toJSON ? new ImageDto(item) : <ImageDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): MultiImageableUrlIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiImageableUrlIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["url"] = this.url;
        return data;
    }
}

export interface IMultiImageableUrlIdentifierDto {
    id: string;
    name: string | undefined;
    images: IImageDto[] | undefined;
    url: string | undefined;
}

export class NamedIdentifierDto implements INamedIdentifierDto {
    id!: string;
    name!: string | undefined;

    constructor(data?: INamedIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): NamedIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new NamedIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface INamedIdentifierDto {
    id: string;
    name: string | undefined;
}

export class NtsGeometryServices implements INtsGeometryServices {
    geometryOverlay!: GeometryOverlay;
    coordinateEqualityComparer!: CoordinateEqualityComparer;
    readonly defaultSRID!: number;
    defaultCoordinateSequenceFactory!: CoordinateSequenceFactory;
    defaultPrecisionModel!: PrecisionModel;

    constructor(data?: INtsGeometryServices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.geometryOverlay = data.geometryOverlay && !(<any>data.geometryOverlay).toJSON ? new GeometryOverlay(data.geometryOverlay) : <GeometryOverlay>this.geometryOverlay;
            this.coordinateEqualityComparer = data.coordinateEqualityComparer && !(<any>data.coordinateEqualityComparer).toJSON ? new CoordinateEqualityComparer(data.coordinateEqualityComparer) : <CoordinateEqualityComparer>this.coordinateEqualityComparer;
            this.defaultCoordinateSequenceFactory = data.defaultCoordinateSequenceFactory && !(<any>data.defaultCoordinateSequenceFactory).toJSON ? new CoordinateSequenceFactory(data.defaultCoordinateSequenceFactory) : <CoordinateSequenceFactory>this.defaultCoordinateSequenceFactory;
            this.defaultPrecisionModel = data.defaultPrecisionModel && !(<any>data.defaultPrecisionModel).toJSON ? new PrecisionModel(data.defaultPrecisionModel) : <PrecisionModel>this.defaultPrecisionModel;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geometryOverlay = _data["geometryOverlay"] ? GeometryOverlay.fromJS(_data["geometryOverlay"]) : <any>undefined;
            this.coordinateEqualityComparer = _data["coordinateEqualityComparer"] ? CoordinateEqualityComparer.fromJS(_data["coordinateEqualityComparer"]) : <any>undefined;
            (<any>this).defaultSRID = _data["defaultSRID"];
            this.defaultCoordinateSequenceFactory = _data["defaultCoordinateSequenceFactory"] ? CoordinateSequenceFactory.fromJS(_data["defaultCoordinateSequenceFactory"]) : <any>undefined;
            this.defaultPrecisionModel = _data["defaultPrecisionModel"] ? PrecisionModel.fromJS(_data["defaultPrecisionModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NtsGeometryServices {
        data = typeof data === 'object' ? data : {};
        let result = new NtsGeometryServices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geometryOverlay"] = this.geometryOverlay ? this.geometryOverlay.toJSON() : <any>undefined;
        data["coordinateEqualityComparer"] = this.coordinateEqualityComparer ? this.coordinateEqualityComparer.toJSON() : <any>undefined;
        data["defaultSRID"] = this.defaultSRID;
        data["defaultCoordinateSequenceFactory"] = this.defaultCoordinateSequenceFactory ? this.defaultCoordinateSequenceFactory.toJSON() : <any>undefined;
        data["defaultPrecisionModel"] = this.defaultPrecisionModel ? this.defaultPrecisionModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface INtsGeometryServices {
    geometryOverlay: IGeometryOverlay;
    coordinateEqualityComparer: ICoordinateEqualityComparer;
    defaultSRID: number;
    defaultCoordinateSequenceFactory: ICoordinateSequenceFactory;
    defaultPrecisionModel: IPrecisionModel;
}

export class Offer implements IOffer {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string;
    description!: string;
    dealPercentage!: number;
    items!: Item[];

    constructor(data?: IOffer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new Item(item) : <Item>item;
                }
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.dealPercentage = _data["dealPercentage"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Offer {
        data = typeof data === 'object' ? data : {};
        let result = new Offer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dealPercentage"] = this.dealPercentage;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOffer {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string;
    description: string;
    dealPercentage: number;
    items: IItem[];
}

export class OfferCreateDto implements IOfferCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    description!: string | undefined;
    dealPercentage!: number;
    itemIds!: string[] | undefined;

    constructor(data?: IOfferCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dealPercentage = _data["dealPercentage"];
            if (Array.isArray(_data["itemIds"])) {
                this.itemIds = [] as any;
                for (let item of _data["itemIds"])
                    this.itemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): OfferCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dealPercentage"] = this.dealPercentage;
        if (Array.isArray(this.itemIds)) {
            data["itemIds"] = [];
            for (let item of this.itemIds)
                data["itemIds"].push(item);
        }
        return data;
    }
}

export interface IOfferCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    description: string | undefined;
    dealPercentage: number;
    itemIds: string[] | undefined;
}

export class OfferDetailedDto implements IOfferDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    description!: string | undefined;
    dealPercentage!: number;
    items!: ItemSimpleDto[] | undefined;

    constructor(data?: IOfferDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new ItemSimpleDto(item) : <ItemSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.dealPercentage = _data["dealPercentage"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemSimpleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfferDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dealPercentage"] = this.dealPercentage;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOfferDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    description: string | undefined;
    dealPercentage: number;
    items: IItemSimpleDto[] | undefined;
}

export class OfferDetailedDtoPaginationDto implements IOfferDetailedDtoPaginationDto {
    data!: OfferDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IOfferDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new OfferDetailedDto(item) : <OfferDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OfferDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): OfferDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IOfferDetailedDtoPaginationDto {
    data: IOfferDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class OfferDetailedDtoUpdateResponseDto implements IOfferDetailedDtoUpdateResponseDto {
    data!: OfferDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IOfferDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new OfferDetailedDto(data.data) : <OfferDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? OfferDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): OfferDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IOfferDetailedDtoUpdateResponseDto {
    data: IOfferDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class OfferSimpleDto implements IOfferSimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    description!: string | undefined;
    dealPercentage!: number;
    itemIds!: string[] | undefined;

    constructor(data?: IOfferSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dealPercentage = _data["dealPercentage"];
            if (Array.isArray(_data["itemIds"])) {
                this.itemIds = [] as any;
                for (let item of _data["itemIds"])
                    this.itemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): OfferSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dealPercentage"] = this.dealPercentage;
        if (Array.isArray(this.itemIds)) {
            data["itemIds"] = [];
            for (let item of this.itemIds)
                data["itemIds"].push(item);
        }
        return data;
    }
}

export interface IOfferSimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    description: string | undefined;
    dealPercentage: number;
    itemIds: string[] | undefined;
}

export class OfferSimpleDtoPaginationDto implements IOfferSimpleDtoPaginationDto {
    data!: OfferSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IOfferSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new OfferSimpleDto(item) : <OfferSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OfferSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): OfferSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IOfferSimpleDtoPaginationDto {
    data: IOfferSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum OgcGeometryType {
    Point = "Point",
    LineString = "LineString",
    Polygon = "Polygon",
    MultiPoint = "MultiPoint",
    MultiLineString = "MultiLineString",
    MultiPolygon = "MultiPolygon",
    GeometryCollection = "GeometryCollection",
    CircularString = "CircularString",
    CompoundCurve = "CompoundCurve",
    CurvePolygon = "CurvePolygon",
    MultiCurve = "MultiCurve",
    MultiSurface = "MultiSurface",
    Curve = "Curve",
    Surface = "Surface",
    PolyhedralSurface = "PolyhedralSurface",
    TIN = "TIN",
}

export enum Ordinates {
    None = "None",
    X = "X",
    Y = "Y",
    XY = "XY",
    Z = "Z",
    XYZ = "XYZ",
    Spatial4 = "Spatial4",
    Spatial5 = "Spatial5",
    Spatial6 = "Spatial6",
    Spatial7 = "Spatial7",
    Spatial8 = "Spatial8",
    Spatial9 = "Spatial9",
    Spatial10 = "Spatial10",
    Spatial11 = "Spatial11",
    Spatial12 = "Spatial12",
    Spatial13 = "Spatial13",
    Spatial14 = "Spatial14",
    Spatial15 = "Spatial15",
    Spatial16 = "Spatial16",
    AllSpatialOrdinates = "AllSpatialOrdinates",
    M = "M",
    XYM = "XYM",
    XYZM = "XYZM",
    Measure2 = "Measure2",
    Measure3 = "Measure3",
    Measure4 = "Measure4",
    Measure5 = "Measure5",
    Measure6 = "Measure6",
    Measure7 = "Measure7",
    Measure8 = "Measure8",
    Measure9 = "Measure9",
    Measure10 = "Measure10",
    Measure11 = "Measure11",
    Measure12 = "Measure12",
    Measure13 = "Measure13",
    Measure14 = "Measure14",
    Measure15 = "Measure15",
    Measure16 = "Measure16",
    AllMeasureOrdinates = "AllMeasureOrdinates",
    AllOrdinates = "AllOrdinates",
}

export class OtherItemsViewDto implements IOtherItemsViewDto {
    id!: string;
    name!: string | undefined;
    compressedImage!: ImageDto;
    averageReviewScore!: number | undefined;
    dayRate!: number | undefined;

    constructor(data?: IOtherItemsViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.compressedImage = data.compressedImage && !(<any>data.compressedImage).toJSON ? new ImageDto(data.compressedImage) : <ImageDto>this.compressedImage;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.compressedImage = _data["compressedImage"] ? ImageDto.fromJS(_data["compressedImage"]) : <any>undefined;
            this.averageReviewScore = _data["averageReviewScore"];
            this.dayRate = _data["dayRate"];
        }
    }

    static fromJS(data: any): OtherItemsViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherItemsViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["compressedImage"] = this.compressedImage ? this.compressedImage.toJSON() : <any>undefined;
        data["averageReviewScore"] = this.averageReviewScore;
        data["dayRate"] = this.dayRate;
        return data;
    }
}

export interface IOtherItemsViewDto {
    id: string;
    name: string | undefined;
    compressedImage: IImageDto;
    averageReviewScore: number | undefined;
    dayRate: number | undefined;
}

export enum OutcomeView {
    All = "All",
    Agreed = "Agreed",
    Declined = "Declined",
    Pending = "Pending",
    Amended = "Amended",
}

export enum PaymentStatus {
    Unauthorised = "Unauthorised",
    Authorised = "Authorised",
    ProcessingCapture = "ProcessingCapture",
    Captured = "Captured",
    Failed = "Failed",
    ProcessingRefund = "ProcessingRefund",
    Refunded = "Refunded",
    PartialRefunded = "PartialRefunded",
}

export enum PayoutStatus {
    NotStarted = "NotStarted",
    Processing = "Processing",
    Succeeded = "Succeeded",
    Failed = "Failed",
}

export class PenTestAccountCreateDto implements IPenTestAccountCreateDto {
    emailAddress!: string | undefined;
    firstName!: string | undefined;
    roles!: RentMyRole[] | undefined;
    password!: string | undefined;
    userRoleAmount!: number;

    constructor(data?: IPenTestAccountCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.password = _data["password"];
            this.userRoleAmount = _data["userRoleAmount"];
        }
    }

    static fromJS(data: any): PenTestAccountCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PenTestAccountCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["password"] = this.password;
        data["userRoleAmount"] = this.userRoleAmount;
        return data;
    }
}

export interface IPenTestAccountCreateDto {
    emailAddress: string | undefined;
    firstName: string | undefined;
    roles: RentMyRole[] | undefined;
    password: string | undefined;
    userRoleAmount: number;
}

export class Point implements IPoint {
    factory!: GeometryFactory;
    userData!: any | undefined;
    srid!: number;
    precisionModel!: PrecisionModel;
    readonly numGeometries!: number;
    readonly isSimple!: boolean;
    readonly isValid!: boolean;
    readonly area!: number;
    readonly length!: number;
    centroid!: Point;
    interiorPoint!: Point;
    pointOnSurface!: Point;
    envelope!: Geometry;
    envelopeInternal!: Envelope;
    readonly isRectangle!: boolean;
    coordinateSequence!: CoordinateSequence;
    readonly coordinates!: Coordinate[] | undefined;
    readonly numPoints!: number;
    readonly isEmpty!: boolean;
    dimension!: Dimension;
    boundaryDimension!: Dimension;
    x!: number;
    y!: number;
    coordinate!: Coordinate;
    readonly geometryType!: string | undefined;
    ogcGeometryType!: OgcGeometryType;
    boundary!: Geometry;
    z!: number;
    m!: number;

    constructor(data?: IPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.factory = data.factory && !(<any>data.factory).toJSON ? new GeometryFactory(data.factory) : <GeometryFactory>this.factory;
            this.precisionModel = data.precisionModel && !(<any>data.precisionModel).toJSON ? new PrecisionModel(data.precisionModel) : <PrecisionModel>this.precisionModel;
            this.centroid = data.centroid && !(<any>data.centroid).toJSON ? new Point(data.centroid) : <Point>this.centroid;
            this.interiorPoint = data.interiorPoint && !(<any>data.interiorPoint).toJSON ? new Point(data.interiorPoint) : <Point>this.interiorPoint;
            this.pointOnSurface = data.pointOnSurface && !(<any>data.pointOnSurface).toJSON ? new Point(data.pointOnSurface) : <Point>this.pointOnSurface;
            this.envelope = data.envelope && !(<any>data.envelope).toJSON ? new Geometry(data.envelope) : <Geometry>this.envelope;
            this.envelopeInternal = data.envelopeInternal && !(<any>data.envelopeInternal).toJSON ? new Envelope(data.envelopeInternal) : <Envelope>this.envelopeInternal;
            this.coordinateSequence = data.coordinateSequence && !(<any>data.coordinateSequence).toJSON ? new CoordinateSequence(data.coordinateSequence) : <CoordinateSequence>this.coordinateSequence;
            if (data.coordinates) {
                this.coordinates = [];
                for (let i = 0; i < data.coordinates.length; i++) {
                    let item = data.coordinates[i];
                    this.coordinates[i] = item && !(<any>item).toJSON ? new Coordinate(item) : <Coordinate>item;
                }
            }
            this.coordinate = data.coordinate && !(<any>data.coordinate).toJSON ? new Coordinate(data.coordinate) : <Coordinate>this.coordinate;
            this.boundary = data.boundary && !(<any>data.boundary).toJSON ? new Geometry(data.boundary) : <Geometry>this.boundary;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factory = _data["factory"] ? GeometryFactory.fromJS(_data["factory"]) : <any>undefined;
            this.userData = _data["userData"];
            this.srid = _data["srid"];
            this.precisionModel = _data["precisionModel"] ? PrecisionModel.fromJS(_data["precisionModel"]) : <any>undefined;
            (<any>this).numGeometries = _data["numGeometries"];
            (<any>this).isSimple = _data["isSimple"];
            (<any>this).isValid = _data["isValid"];
            (<any>this).area = _data["area"];
            (<any>this).length = _data["length"];
            this.centroid = _data["centroid"] ? Point.fromJS(_data["centroid"]) : <any>undefined;
            this.interiorPoint = _data["interiorPoint"] ? Point.fromJS(_data["interiorPoint"]) : <any>undefined;
            this.pointOnSurface = _data["pointOnSurface"] ? Point.fromJS(_data["pointOnSurface"]) : <any>undefined;
            this.envelope = _data["envelope"] ? Geometry.fromJS(_data["envelope"]) : <any>undefined;
            this.envelopeInternal = _data["envelopeInternal"] ? Envelope.fromJS(_data["envelopeInternal"]) : <any>undefined;
            (<any>this).isRectangle = _data["isRectangle"];
            this.coordinateSequence = _data["coordinateSequence"] ? CoordinateSequence.fromJS(_data["coordinateSequence"]) : <any>undefined;
            if (Array.isArray(_data["coordinates"])) {
                (<any>this).coordinates = [] as any;
                for (let item of _data["coordinates"])
                    (<any>this).coordinates!.push(Coordinate.fromJS(item));
            }
            (<any>this).numPoints = _data["numPoints"];
            (<any>this).isEmpty = _data["isEmpty"];
            this.dimension = _data["dimension"];
            this.boundaryDimension = _data["boundaryDimension"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.coordinate = _data["coordinate"] ? Coordinate.fromJS(_data["coordinate"]) : <any>undefined;
            (<any>this).geometryType = _data["geometryType"];
            this.ogcGeometryType = _data["ogcGeometryType"];
            this.boundary = _data["boundary"] ? Geometry.fromJS(_data["boundary"]) : <any>undefined;
            this.z = _data["z"];
            this.m = _data["m"];
        }
    }

    static fromJS(data: any): Point {
        data = typeof data === 'object' ? data : {};
        let result = new Point();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["userData"] = this.userData;
        data["srid"] = this.srid;
        data["precisionModel"] = this.precisionModel ? this.precisionModel.toJSON() : <any>undefined;
        data["numGeometries"] = this.numGeometries;
        data["isSimple"] = this.isSimple;
        data["isValid"] = this.isValid;
        data["area"] = this.area;
        data["length"] = this.length;
        data["centroid"] = this.centroid ? this.centroid.toJSON() : <any>undefined;
        data["interiorPoint"] = this.interiorPoint ? this.interiorPoint.toJSON() : <any>undefined;
        data["pointOnSurface"] = this.pointOnSurface ? this.pointOnSurface.toJSON() : <any>undefined;
        data["envelope"] = this.envelope ? this.envelope.toJSON() : <any>undefined;
        data["envelopeInternal"] = this.envelopeInternal ? this.envelopeInternal.toJSON() : <any>undefined;
        data["isRectangle"] = this.isRectangle;
        data["coordinateSequence"] = this.coordinateSequence ? this.coordinateSequence.toJSON() : <any>undefined;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item.toJSON());
        }
        data["numPoints"] = this.numPoints;
        data["isEmpty"] = this.isEmpty;
        data["dimension"] = this.dimension;
        data["boundaryDimension"] = this.boundaryDimension;
        data["x"] = this.x;
        data["y"] = this.y;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : <any>undefined;
        data["geometryType"] = this.geometryType;
        data["ogcGeometryType"] = this.ogcGeometryType;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>undefined;
        data["z"] = this.z;
        data["m"] = this.m;
        return data;
    }
}

export interface IPoint {
    factory: IGeometryFactory;
    userData: any | undefined;
    srid: number;
    precisionModel: IPrecisionModel;
    numGeometries: number;
    isSimple: boolean;
    isValid: boolean;
    area: number;
    length: number;
    centroid: IPoint;
    interiorPoint: IPoint;
    pointOnSurface: IPoint;
    envelope: IGeometry;
    envelopeInternal: IEnvelope;
    isRectangle: boolean;
    coordinateSequence: ICoordinateSequence;
    coordinates: ICoordinate[] | undefined;
    numPoints: number;
    isEmpty: boolean;
    dimension: Dimension;
    boundaryDimension: Dimension;
    x: number;
    y: number;
    coordinate: ICoordinate;
    geometryType: string | undefined;
    ogcGeometryType: OgcGeometryType;
    boundary: IGeometry;
    z: number;
    m: number;
}

export class PrecisionModel implements IPrecisionModel {
    readonly isFloating!: boolean;
    readonly maximumSignificantDigits!: number;
    scale!: number;
    readonly gridSize!: number;
    precisionModelType!: PrecisionModels;

    constructor(data?: IPrecisionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isFloating = _data["isFloating"];
            (<any>this).maximumSignificantDigits = _data["maximumSignificantDigits"];
            this.scale = _data["scale"];
            (<any>this).gridSize = _data["gridSize"];
            this.precisionModelType = _data["precisionModelType"];
        }
    }

    static fromJS(data: any): PrecisionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrecisionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFloating"] = this.isFloating;
        data["maximumSignificantDigits"] = this.maximumSignificantDigits;
        data["scale"] = this.scale;
        data["gridSize"] = this.gridSize;
        data["precisionModelType"] = this.precisionModelType;
        return data;
    }
}

export interface IPrecisionModel {
    isFloating: boolean;
    maximumSignificantDigits: number;
    scale: number;
    gridSize: number;
    precisionModelType: PrecisionModels;
}

export enum PrecisionModels {
    Floating = "Floating",
    FloatingSingle = "FloatingSingle",
    Fixed = "Fixed",
}

export class Price implements IPrice {
    daily!: number | undefined;
    hourly!: number | undefined;
    dailyServiceFee!: number | undefined;
    hourlyServiceFee!: number | undefined;
    hourlyStart!: number | undefined;
    hourlyEnd!: number | undefined;
    deposit!: number | undefined;
    currency!: CurrencyIsoCode;

    constructor(data?: IPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.daily = _data["daily"];
            this.hourly = _data["hourly"];
            this.dailyServiceFee = _data["dailyServiceFee"];
            this.hourlyServiceFee = _data["hourlyServiceFee"];
            this.hourlyStart = _data["hourlyStart"];
            this.hourlyEnd = _data["hourlyEnd"];
            this.deposit = _data["deposit"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): Price {
        data = typeof data === 'object' ? data : {};
        let result = new Price();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daily"] = this.daily;
        data["hourly"] = this.hourly;
        data["dailyServiceFee"] = this.dailyServiceFee;
        data["hourlyServiceFee"] = this.hourlyServiceFee;
        data["hourlyStart"] = this.hourlyStart;
        data["hourlyEnd"] = this.hourlyEnd;
        data["deposit"] = this.deposit;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IPrice {
    daily: number | undefined;
    hourly: number | undefined;
    dailyServiceFee: number | undefined;
    hourlyServiceFee: number | undefined;
    hourlyStart: number | undefined;
    hourlyEnd: number | undefined;
    deposit: number | undefined;
    currency: CurrencyIsoCode;
}

export class PriceInfo implements IPriceInfo {
    periods!: PricePeriod[] | undefined;
    days!: { [key: string]: DayPrice; } | undefined;
    averageDailyPrice!: number | undefined;
    cheapestDailyPrice!: number | undefined;
    highestDailyPrice!: number | undefined;

    constructor(data?: IPriceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.periods) {
                this.periods = [];
                for (let i = 0; i < data.periods.length; i++) {
                    let item = data.periods[i];
                    this.periods[i] = item && !(<any>item).toJSON ? new PricePeriod(item) : <PricePeriod>item;
                }
            }
            if (data.days) {
                this.days = {};
                for (let key in data.days) {
                    if (data.days.hasOwnProperty(key)) {
                        let item = data.days[key];
                        this.days[key] = item && !(<any>item).toJSON ? new DayPrice(item) : <DayPrice>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(PricePeriod.fromJS(item));
            }
            if (_data["days"]) {
                this.days = {} as any;
                for (let key in _data["days"]) {
                    if (_data["days"].hasOwnProperty(key))
                        (<any>this.days)![key] = _data["days"][key] ? DayPrice.fromJS(_data["days"][key]) : new DayPrice();
                }
            }
            this.averageDailyPrice = _data["averageDailyPrice"];
            this.cheapestDailyPrice = _data["cheapestDailyPrice"];
            this.highestDailyPrice = _data["highestDailyPrice"];
        }
    }

    static fromJS(data: any): PriceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PriceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item.toJSON());
        }
        if (this.days) {
            data["days"] = {};
            for (let key in this.days) {
                if (this.days.hasOwnProperty(key))
                    (<any>data["days"])[key] = this.days[key] ? this.days[key].toJSON() : <any>undefined;
            }
        }
        data["averageDailyPrice"] = this.averageDailyPrice;
        data["cheapestDailyPrice"] = this.cheapestDailyPrice;
        data["highestDailyPrice"] = this.highestDailyPrice;
        return data;
    }
}

export interface IPriceInfo {
    periods: IPricePeriod[] | undefined;
    days: { [key: string]: IDayPrice; } | undefined;
    averageDailyPrice: number | undefined;
    cheapestDailyPrice: number | undefined;
    highestDailyPrice: number | undefined;
}

export class PricePeriod implements IPricePeriod {
    id!: string;
    name!: string | undefined;
    price!: Price;
    minimumBookingDays!: number | undefined;
    maximumBookingDays!: number | undefined;
    minimumBookingHours!: number | undefined;
    maximumBookingHours!: number | undefined;
    dailyTurnaroundTime!: number | undefined;
    hourlyTurnaroundTime!: number | undefined;
    pickUpTime!: number | undefined;
    dropOffTime!: number | undefined;
    dateRanges!: DateRange[] | undefined;
    dayOverrides!: DayOverride[] | undefined;
    dailyMultiBookings!: MultiBooking[] | undefined;
    hourlyMultiBookings!: MultiBooking[] | undefined;

    constructor(data?: IPricePeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.price = data.price && !(<any>data.price).toJSON ? new Price(data.price) : <Price>this.price;
            if (data.dateRanges) {
                this.dateRanges = [];
                for (let i = 0; i < data.dateRanges.length; i++) {
                    let item = data.dateRanges[i];
                    this.dateRanges[i] = item && !(<any>item).toJSON ? new DateRange(item) : <DateRange>item;
                }
            }
            if (data.dayOverrides) {
                this.dayOverrides = [];
                for (let i = 0; i < data.dayOverrides.length; i++) {
                    let item = data.dayOverrides[i];
                    this.dayOverrides[i] = item && !(<any>item).toJSON ? new DayOverride(item) : <DayOverride>item;
                }
            }
            if (data.dailyMultiBookings) {
                this.dailyMultiBookings = [];
                for (let i = 0; i < data.dailyMultiBookings.length; i++) {
                    let item = data.dailyMultiBookings[i];
                    this.dailyMultiBookings[i] = item && !(<any>item).toJSON ? new MultiBooking(item) : <MultiBooking>item;
                }
            }
            if (data.hourlyMultiBookings) {
                this.hourlyMultiBookings = [];
                for (let i = 0; i < data.hourlyMultiBookings.length; i++) {
                    let item = data.hourlyMultiBookings[i];
                    this.hourlyMultiBookings[i] = item && !(<any>item).toJSON ? new MultiBooking(item) : <MultiBooking>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"] ? Price.fromJS(_data["price"]) : <any>undefined;
            this.minimumBookingDays = _data["minimumBookingDays"];
            this.maximumBookingDays = _data["maximumBookingDays"];
            this.minimumBookingHours = _data["minimumBookingHours"];
            this.maximumBookingHours = _data["maximumBookingHours"];
            this.dailyTurnaroundTime = _data["dailyTurnaroundTime"];
            this.hourlyTurnaroundTime = _data["hourlyTurnaroundTime"];
            this.pickUpTime = _data["pickUpTime"];
            this.dropOffTime = _data["dropOffTime"];
            if (Array.isArray(_data["dateRanges"])) {
                this.dateRanges = [] as any;
                for (let item of _data["dateRanges"])
                    this.dateRanges!.push(DateRange.fromJS(item));
            }
            if (Array.isArray(_data["dayOverrides"])) {
                this.dayOverrides = [] as any;
                for (let item of _data["dayOverrides"])
                    this.dayOverrides!.push(DayOverride.fromJS(item));
            }
            if (Array.isArray(_data["dailyMultiBookings"])) {
                this.dailyMultiBookings = [] as any;
                for (let item of _data["dailyMultiBookings"])
                    this.dailyMultiBookings!.push(MultiBooking.fromJS(item));
            }
            if (Array.isArray(_data["hourlyMultiBookings"])) {
                this.hourlyMultiBookings = [] as any;
                for (let item of _data["hourlyMultiBookings"])
                    this.hourlyMultiBookings!.push(MultiBooking.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PricePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new PricePeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["minimumBookingDays"] = this.minimumBookingDays;
        data["maximumBookingDays"] = this.maximumBookingDays;
        data["minimumBookingHours"] = this.minimumBookingHours;
        data["maximumBookingHours"] = this.maximumBookingHours;
        data["dailyTurnaroundTime"] = this.dailyTurnaroundTime;
        data["hourlyTurnaroundTime"] = this.hourlyTurnaroundTime;
        data["pickUpTime"] = this.pickUpTime;
        data["dropOffTime"] = this.dropOffTime;
        if (Array.isArray(this.dateRanges)) {
            data["dateRanges"] = [];
            for (let item of this.dateRanges)
                data["dateRanges"].push(item.toJSON());
        }
        if (Array.isArray(this.dayOverrides)) {
            data["dayOverrides"] = [];
            for (let item of this.dayOverrides)
                data["dayOverrides"].push(item.toJSON());
        }
        if (Array.isArray(this.dailyMultiBookings)) {
            data["dailyMultiBookings"] = [];
            for (let item of this.dailyMultiBookings)
                data["dailyMultiBookings"].push(item.toJSON());
        }
        if (Array.isArray(this.hourlyMultiBookings)) {
            data["hourlyMultiBookings"] = [];
            for (let item of this.hourlyMultiBookings)
                data["hourlyMultiBookings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPricePeriod {
    id: string;
    name: string | undefined;
    price: IPrice;
    minimumBookingDays: number | undefined;
    maximumBookingDays: number | undefined;
    minimumBookingHours: number | undefined;
    maximumBookingHours: number | undefined;
    dailyTurnaroundTime: number | undefined;
    hourlyTurnaroundTime: number | undefined;
    pickUpTime: number | undefined;
    dropOffTime: number | undefined;
    dateRanges: IDateRange[] | undefined;
    dayOverrides: IDayOverride[] | undefined;
    dailyMultiBookings: IMultiBooking[] | undefined;
    hourlyMultiBookings: IMultiBooking[] | undefined;
}

export class PropertyResult implements IPropertyResult {
    success!: boolean;
    message!: string | undefined;

    constructor(data?: IPropertyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PropertyResult {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IPropertyResult {
    success: boolean;
    message: string | undefined;
}

export class QuotallCategory implements IQuotallCategory {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    code!: string | undefined;
    categories!: Category[] | undefined;

    constructor(data?: IQuotallCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.categories) {
                this.categories = [];
                for (let i = 0; i < data.categories.length; i++) {
                    let item = data.categories[i];
                    this.categories[i] = item && !(<any>item).toJSON ? new Category(item) : <Category>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.code = _data["code"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(Category.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuotallCategory {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["code"] = this.code;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuotallCategory {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    code: string | undefined;
    categories: ICategory[] | undefined;
}

export class QuotallCategoryCreateDto implements IQuotallCategoryCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IQuotallCategoryCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): QuotallCategoryCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallCategoryCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IQuotallCategoryCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    code: string | undefined;
}

export class QuotallCategoryDto implements IQuotallCategoryDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IQuotallCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): QuotallCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IQuotallCategoryDto {
    id: string;
    active: boolean;
    name: string | undefined;
    code: string | undefined;
}

export class QuotallCategoryDtoPaginationDto implements IQuotallCategoryDtoPaginationDto {
    data!: QuotallCategoryDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IQuotallCategoryDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new QuotallCategoryDto(item) : <QuotallCategoryDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuotallCategoryDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): QuotallCategoryDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallCategoryDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IQuotallCategoryDtoPaginationDto {
    data: IQuotallCategoryDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class QuotallCategoryDtoUpdateResponseDto implements IQuotallCategoryDtoUpdateResponseDto {
    data!: QuotallCategoryDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IQuotallCategoryDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new QuotallCategoryDto(data.data) : <QuotallCategoryDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? QuotallCategoryDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): QuotallCategoryDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallCategoryDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IQuotallCategoryDtoUpdateResponseDto {
    data: IQuotallCategoryDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class QuotallClaimCreateDto implements IQuotallClaimCreateDto {
    active!: boolean | undefined;
    bookingId!: string;
    description!: string | undefined;
    lossDate!: Date;
    lossTypeId!: string;
    images!: string[] | undefined;
    videos!: string[] | undefined;
    documents!: string[] | undefined;
    value!: number | undefined;

    constructor(data?: IQuotallClaimCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.bookingId = _data["bookingId"];
            this.description = _data["description"];
            this.lossDate = _data["lossDate"] ? new Date(_data["lossDate"].toString()) : <any>undefined;
            this.lossTypeId = _data["lossTypeId"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(item);
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(item);
            }
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): QuotallClaimCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallClaimCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["bookingId"] = this.bookingId;
        data["description"] = this.description;
        data["lossDate"] = this.lossDate ? this.lossDate.toISOString() : <any>undefined;
        data["lossTypeId"] = this.lossTypeId;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item);
        }
        data["value"] = this.value;
        return data;
    }
}

export interface IQuotallClaimCreateDto {
    active: boolean | undefined;
    bookingId: string;
    description: string | undefined;
    lossDate: Date;
    lossTypeId: string;
    images: string[] | undefined;
    videos: string[] | undefined;
    documents: string[] | undefined;
    value: number | undefined;
}

export class QuotallClaimDto implements IQuotallClaimDto {
    id!: string;
    active!: boolean;
    booking!: BookingSimpleDto;
    user!: RentMyUserSimpleDto;
    value!: number | undefined;
    documents!: boolean;
    description!: string | undefined;
    lossNotifiedDate!: Date | undefined;
    lossDate!: Date | undefined;
    quotallLossType!: QuotallLossTypeDto;
    quotallOutcomeType!: QuotallOutcomeTypeDto;
    dateOutcomeDetermined!: Date | undefined;
    claimImages!: ImageDto[] | undefined;
    claimVideos!: VideoDto[] | undefined;
    claimDocuments!: DocumentDto[] | undefined;
    amendedValue!: number | undefined;
    amendedNotes!: string | undefined;

    constructor(data?: IQuotallClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.booking = data.booking && !(<any>data.booking).toJSON ? new BookingSimpleDto(data.booking) : <BookingSimpleDto>this.booking;
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserSimpleDto(data.user) : <RentMyUserSimpleDto>this.user;
            this.quotallLossType = data.quotallLossType && !(<any>data.quotallLossType).toJSON ? new QuotallLossTypeDto(data.quotallLossType) : <QuotallLossTypeDto>this.quotallLossType;
            this.quotallOutcomeType = data.quotallOutcomeType && !(<any>data.quotallOutcomeType).toJSON ? new QuotallOutcomeTypeDto(data.quotallOutcomeType) : <QuotallOutcomeTypeDto>this.quotallOutcomeType;
            if (data.claimImages) {
                this.claimImages = [];
                for (let i = 0; i < data.claimImages.length; i++) {
                    let item = data.claimImages[i];
                    this.claimImages[i] = item && !(<any>item).toJSON ? new ImageDto(item) : <ImageDto>item;
                }
            }
            if (data.claimVideos) {
                this.claimVideos = [];
                for (let i = 0; i < data.claimVideos.length; i++) {
                    let item = data.claimVideos[i];
                    this.claimVideos[i] = item && !(<any>item).toJSON ? new VideoDto(item) : <VideoDto>item;
                }
            }
            if (data.claimDocuments) {
                this.claimDocuments = [];
                for (let i = 0; i < data.claimDocuments.length; i++) {
                    let item = data.claimDocuments[i];
                    this.claimDocuments[i] = item && !(<any>item).toJSON ? new DocumentDto(item) : <DocumentDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.booking = _data["booking"] ? BookingSimpleDto.fromJS(_data["booking"]) : <any>undefined;
            this.user = _data["user"] ? RentMyUserSimpleDto.fromJS(_data["user"]) : <any>undefined;
            this.value = _data["value"];
            this.documents = _data["documents"];
            this.description = _data["description"];
            this.lossNotifiedDate = _data["lossNotifiedDate"] ? new Date(_data["lossNotifiedDate"].toString()) : <any>undefined;
            this.lossDate = _data["lossDate"] ? new Date(_data["lossDate"].toString()) : <any>undefined;
            this.quotallLossType = _data["quotallLossType"] ? QuotallLossTypeDto.fromJS(_data["quotallLossType"]) : <any>undefined;
            this.quotallOutcomeType = _data["quotallOutcomeType"] ? QuotallOutcomeTypeDto.fromJS(_data["quotallOutcomeType"]) : <any>undefined;
            this.dateOutcomeDetermined = _data["dateOutcomeDetermined"] ? new Date(_data["dateOutcomeDetermined"].toString()) : <any>undefined;
            if (Array.isArray(_data["claimImages"])) {
                this.claimImages = [] as any;
                for (let item of _data["claimImages"])
                    this.claimImages!.push(ImageDto.fromJS(item));
            }
            if (Array.isArray(_data["claimVideos"])) {
                this.claimVideos = [] as any;
                for (let item of _data["claimVideos"])
                    this.claimVideos!.push(VideoDto.fromJS(item));
            }
            if (Array.isArray(_data["claimDocuments"])) {
                this.claimDocuments = [] as any;
                for (let item of _data["claimDocuments"])
                    this.claimDocuments!.push(DocumentDto.fromJS(item));
            }
            this.amendedValue = _data["amendedValue"];
            this.amendedNotes = _data["amendedNotes"];
        }
    }

    static fromJS(data: any): QuotallClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["booking"] = this.booking ? this.booking.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["value"] = this.value;
        data["documents"] = this.documents;
        data["description"] = this.description;
        data["lossNotifiedDate"] = this.lossNotifiedDate ? this.lossNotifiedDate.toISOString() : <any>undefined;
        data["lossDate"] = this.lossDate ? this.lossDate.toISOString() : <any>undefined;
        data["quotallLossType"] = this.quotallLossType ? this.quotallLossType.toJSON() : <any>undefined;
        data["quotallOutcomeType"] = this.quotallOutcomeType ? this.quotallOutcomeType.toJSON() : <any>undefined;
        data["dateOutcomeDetermined"] = this.dateOutcomeDetermined ? this.dateOutcomeDetermined.toISOString() : <any>undefined;
        if (Array.isArray(this.claimImages)) {
            data["claimImages"] = [];
            for (let item of this.claimImages)
                data["claimImages"].push(item.toJSON());
        }
        if (Array.isArray(this.claimVideos)) {
            data["claimVideos"] = [];
            for (let item of this.claimVideos)
                data["claimVideos"].push(item.toJSON());
        }
        if (Array.isArray(this.claimDocuments)) {
            data["claimDocuments"] = [];
            for (let item of this.claimDocuments)
                data["claimDocuments"].push(item.toJSON());
        }
        data["amendedValue"] = this.amendedValue;
        data["amendedNotes"] = this.amendedNotes;
        return data;
    }
}

export interface IQuotallClaimDto {
    id: string;
    active: boolean;
    booking: IBookingSimpleDto;
    user: IRentMyUserSimpleDto;
    value: number | undefined;
    documents: boolean;
    description: string | undefined;
    lossNotifiedDate: Date | undefined;
    lossDate: Date | undefined;
    quotallLossType: IQuotallLossTypeDto;
    quotallOutcomeType: IQuotallOutcomeTypeDto;
    dateOutcomeDetermined: Date | undefined;
    claimImages: IImageDto[] | undefined;
    claimVideos: IVideoDto[] | undefined;
    claimDocuments: IDocumentDto[] | undefined;
    amendedValue: number | undefined;
    amendedNotes: string | undefined;
}

export class QuotallClaimDtoPaginationDto implements IQuotallClaimDtoPaginationDto {
    data!: QuotallClaimDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IQuotallClaimDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new QuotallClaimDto(item) : <QuotallClaimDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuotallClaimDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): QuotallClaimDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallClaimDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IQuotallClaimDtoPaginationDto {
    data: IQuotallClaimDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class QuotallClaimDtoUpdateResponseDto implements IQuotallClaimDtoUpdateResponseDto {
    data!: QuotallClaimDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IQuotallClaimDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new QuotallClaimDto(data.data) : <QuotallClaimDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? QuotallClaimDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): QuotallClaimDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallClaimDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IQuotallClaimDtoUpdateResponseDto {
    data: IQuotallClaimDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class QuotallLossTypeCreateDto implements IQuotallLossTypeCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IQuotallLossTypeCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): QuotallLossTypeCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallLossTypeCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IQuotallLossTypeCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    code: string | undefined;
}

export class QuotallLossTypeDto implements IQuotallLossTypeDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    code!: string | undefined;

    constructor(data?: IQuotallLossTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): QuotallLossTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallLossTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IQuotallLossTypeDto {
    id: string;
    active: boolean;
    name: string | undefined;
    code: string | undefined;
}

export class QuotallLossTypeDtoPaginationDto implements IQuotallLossTypeDtoPaginationDto {
    data!: QuotallLossTypeDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IQuotallLossTypeDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new QuotallLossTypeDto(item) : <QuotallLossTypeDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuotallLossTypeDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): QuotallLossTypeDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallLossTypeDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IQuotallLossTypeDtoPaginationDto {
    data: IQuotallLossTypeDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class QuotallLossTypeDtoUpdateResponseDto implements IQuotallLossTypeDtoUpdateResponseDto {
    data!: QuotallLossTypeDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IQuotallLossTypeDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new QuotallLossTypeDto(data.data) : <QuotallLossTypeDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? QuotallLossTypeDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): QuotallLossTypeDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallLossTypeDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IQuotallLossTypeDtoUpdateResponseDto {
    data: IQuotallLossTypeDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export enum QuotallOrderBy {
    Relevance = "Relevance",
    Alphabetically = "Alphabetically",
}

export class QuotallOutcomeTypeCreateDto implements IQuotallOutcomeTypeCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    code!: string | undefined;
    payout!: boolean;

    constructor(data?: IQuotallOutcomeTypeCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.payout = _data["payout"];
        }
    }

    static fromJS(data: any): QuotallOutcomeTypeCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallOutcomeTypeCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["code"] = this.code;
        data["payout"] = this.payout;
        return data;
    }
}

export interface IQuotallOutcomeTypeCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    code: string | undefined;
    payout: boolean;
}

export class QuotallOutcomeTypeDto implements IQuotallOutcomeTypeDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    code!: string | undefined;
    payout!: boolean;

    constructor(data?: IQuotallOutcomeTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.payout = _data["payout"];
        }
    }

    static fromJS(data: any): QuotallOutcomeTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallOutcomeTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["code"] = this.code;
        data["payout"] = this.payout;
        return data;
    }
}

export interface IQuotallOutcomeTypeDto {
    id: string;
    active: boolean;
    name: string | undefined;
    code: string | undefined;
    payout: boolean;
}

export class QuotallOutcomeTypeDtoPaginationDto implements IQuotallOutcomeTypeDtoPaginationDto {
    data!: QuotallOutcomeTypeDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IQuotallOutcomeTypeDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new QuotallOutcomeTypeDto(item) : <QuotallOutcomeTypeDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(QuotallOutcomeTypeDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): QuotallOutcomeTypeDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallOutcomeTypeDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IQuotallOutcomeTypeDtoPaginationDto {
    data: IQuotallOutcomeTypeDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class QuotallOutcomeTypeDtoUpdateResponseDto implements IQuotallOutcomeTypeDtoUpdateResponseDto {
    data!: QuotallOutcomeTypeDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IQuotallOutcomeTypeDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new QuotallOutcomeTypeDto(data.data) : <QuotallOutcomeTypeDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? QuotallOutcomeTypeDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): QuotallOutcomeTypeDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotallOutcomeTypeDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IQuotallOutcomeTypeDtoUpdateResponseDto {
    data: IQuotallOutcomeTypeDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class Referral implements IReferral {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUser;
    referredUsers!: RentMyUser[];
    code!: string;
    discount!: number;
    userId!: string;

    constructor(data?: IReferral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
            if (data.referredUsers) {
                this.referredUsers = [];
                for (let i = 0; i < data.referredUsers.length; i++) {
                    let item = data.referredUsers[i];
                    this.referredUsers[i] = item && !(<any>item).toJSON ? new RentMyUser(item) : <RentMyUser>item;
                }
            }
        }
        if (!data) {
            this.user = new RentMyUser();
            this.referredUsers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : new RentMyUser();
            if (Array.isArray(_data["referredUsers"])) {
                this.referredUsers = [] as any;
                for (let item of _data["referredUsers"])
                    this.referredUsers!.push(RentMyUser.fromJS(item));
            }
            this.code = _data["code"];
            this.discount = _data["discount"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): Referral {
        data = typeof data === 'object' ? data : {};
        let result = new Referral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.referredUsers)) {
            data["referredUsers"] = [];
            for (let item of this.referredUsers)
                data["referredUsers"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["discount"] = this.discount;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IReferral {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUser;
    referredUsers: IRentMyUser[];
    code: string;
    discount: number;
    userId: string;
}

export class ReferralDetailedDto implements IReferralDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: ImageableIdentifierDto;
    referredUsers!: RentMyUserSimpleDto[] | undefined;
    code!: string | undefined;

    constructor(data?: IReferralDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new ImageableIdentifierDto(data.user) : <ImageableIdentifierDto>this.user;
            if (data.referredUsers) {
                this.referredUsers = [];
                for (let i = 0; i < data.referredUsers.length; i++) {
                    let item = data.referredUsers[i];
                    this.referredUsers[i] = item && !(<any>item).toJSON ? new RentMyUserSimpleDto(item) : <RentMyUserSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? ImageableIdentifierDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["referredUsers"])) {
                this.referredUsers = [] as any;
                for (let item of _data["referredUsers"])
                    this.referredUsers!.push(RentMyUserSimpleDto.fromJS(item));
            }
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ReferralDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.referredUsers)) {
            data["referredUsers"] = [];
            for (let item of this.referredUsers)
                data["referredUsers"].push(item.toJSON());
        }
        data["code"] = this.code;
        return data;
    }
}

export interface IReferralDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IImageableIdentifierDto;
    referredUsers: IRentMyUserSimpleDto[] | undefined;
    code: string | undefined;
}

export class ReferralDetailedDtoPaginationDto implements IReferralDetailedDtoPaginationDto {
    data!: ReferralDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IReferralDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ReferralDetailedDto(item) : <ReferralDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReferralDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ReferralDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IReferralDetailedDtoPaginationDto {
    data: IReferralDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum ReferralOrderBy {
    Count = "Count",
    User = "User",
}

export class ReferralSimpleDto implements IReferralSimpleDto {
    id!: string;
    active!: boolean;
    user!: ImageableIdentifierDto;
    referredUsers!: ImageableIdentifierDto[] | undefined;
    code!: string | undefined;

    constructor(data?: IReferralSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new ImageableIdentifierDto(data.user) : <ImageableIdentifierDto>this.user;
            if (data.referredUsers) {
                this.referredUsers = [];
                for (let i = 0; i < data.referredUsers.length; i++) {
                    let item = data.referredUsers[i];
                    this.referredUsers[i] = item && !(<any>item).toJSON ? new ImageableIdentifierDto(item) : <ImageableIdentifierDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.user = _data["user"] ? ImageableIdentifierDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["referredUsers"])) {
                this.referredUsers = [] as any;
                for (let item of _data["referredUsers"])
                    this.referredUsers!.push(ImageableIdentifierDto.fromJS(item));
            }
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ReferralSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.referredUsers)) {
            data["referredUsers"] = [];
            for (let item of this.referredUsers)
                data["referredUsers"].push(item.toJSON());
        }
        data["code"] = this.code;
        return data;
    }
}

export interface IReferralSimpleDto {
    id: string;
    active: boolean;
    user: IImageableIdentifierDto;
    referredUsers: IImageableIdentifierDto[] | undefined;
    code: string | undefined;
}

export class ReferralSimpleDtoPaginationDto implements IReferralSimpleDtoPaginationDto {
    data!: ReferralSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IReferralSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ReferralSimpleDto(item) : <ReferralSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReferralSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ReferralSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IReferralSimpleDtoPaginationDto {
    data: IReferralSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum RentMyRole {
    SuperAdmin = "SuperAdmin",
    OperationalAdmin = "OperationalAdmin",
    OperationalSupport = "OperationalSupport",
    FeetOnTheStreet = "FeetOnTheStreet",
    CommunitySupport = "CommunitySupport",
    MarketingAdmin = "MarketingAdmin",
    MarketingSupport = "MarketingSupport",
    InsightAdmin = "InsightAdmin",
    InsightSupport = "InsightSupport",
    SaasAdmin = "SaasAdmin",
    SaasSupport = "SaasSupport",
    ClaimsManager = "ClaimsManager",
    User = "User",
    MicroshopOwner = "MicroshopOwner",
    BusinessOwner = "BusinessOwner",
}

export class RentMyUser implements IRentMyUser {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string;
    firstName!: string | undefined;
    lastName!: string | undefined;
    auth0UserId!: string | undefined;
    phoneNumber!: string | undefined;
    aboutMe!: string | undefined;
    emailAddress!: string;
    birthdate!: Date | undefined;
    joinedDate!: Date;
    profileImage!: Image;
    bannerImage!: BannerImage;
    gender!: Gender;
    isBusiness!: boolean;
    moderators!: RentMyUser[] | undefined;
    nationalityCountry!: string | undefined;
    location!: Location;
    favouriteLocations!: Location[] | undefined;
    favouriteItems!: FavouriteItem[] | undefined;
    followedUsers!: FollowedUser[] | undefined;
    followerCount!: number;
    followingCount!: number;
    friends!: Friend[] | undefined;
    referral!: Referral;
    blockedUsers!: BlockedUser[] | undefined;
    savedSearches!: SavedSearch[] | undefined;
    watchedItems!: WatchedItem[] | undefined;
    vouchersRedeemed!: VoucherRedemption[] | undefined;
    discounts!: Discount[] | undefined;
    images!: Image[] | undefined;
    videos!: Video[] | undefined;
    reviewOverallAverage!: number | undefined;
    reviewCommunicationAverage!: number | undefined;
    reviewPickUpAverage!: number | undefined;
    reviewDropOffAverage!: number | undefined;
    reviewAccuracyAverage!: number | undefined;
    reviewQualityAverage!: number | undefined;
    reviewValueAverage!: number | undefined;
    reviewCount!: number;
    reviewsMadeCount!: number;
    isSuspended!: boolean;
    isVerified!: boolean;
    verificationStatus!: string | undefined;
    receiveEmailsNotifications!: boolean;
    receivePhoneNotifications!: boolean;
    receiveTextNotifications!: boolean;
    receiveWhatsappNotifications!: boolean;
    receivePostNotifications!: boolean;
    website!: string | undefined;
    instagramUserName!: string | undefined;
    instagramUrl!: string | undefined;
    facebookUserName!: string | undefined;
    facebookUrl!: string | undefined;
    twitterUserName!: string | undefined;
    twitterUrl!: string | undefined;
    youtubeUserName!: string | undefined;
    youtubeUrl!: string | undefined;
    stripeAccountId!: string | undefined;
    stripeCustomerId!: string | undefined;
    stripeExternalAccounts!: string[] | undefined;
    stripeVerificationSessionId!: string | undefined;
    stripeOnboarded!: boolean;
    role!: RentMyRole;
    signalRId!: string | undefined;
    intention!: UserIntention;
    flagged!: boolean;
    tenant!: Tenant;
    excludeFromAnalytics!: boolean;
    lastIP!: string | undefined;
    hasBeenReferred!: boolean;
    dateConsentGiven!: Date | undefined;
    dateConsentRequested!: Date | undefined;

    constructor(data?: IRentMyUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.profileImage = data.profileImage && !(<any>data.profileImage).toJSON ? new Image(data.profileImage) : <Image>this.profileImage;
            this.bannerImage = data.bannerImage && !(<any>data.bannerImage).toJSON ? new BannerImage(data.bannerImage) : <BannerImage>this.bannerImage;
            this.gender = data.gender && !(<any>data.gender).toJSON ? new Gender(data.gender) : <Gender>this.gender;
            if (data.moderators) {
                this.moderators = [];
                for (let i = 0; i < data.moderators.length; i++) {
                    let item = data.moderators[i];
                    this.moderators[i] = item && !(<any>item).toJSON ? new RentMyUser(item) : <RentMyUser>item;
                }
            }
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
            if (data.favouriteLocations) {
                this.favouriteLocations = [];
                for (let i = 0; i < data.favouriteLocations.length; i++) {
                    let item = data.favouriteLocations[i];
                    this.favouriteLocations[i] = item && !(<any>item).toJSON ? new Location(item) : <Location>item;
                }
            }
            if (data.favouriteItems) {
                this.favouriteItems = [];
                for (let i = 0; i < data.favouriteItems.length; i++) {
                    let item = data.favouriteItems[i];
                    this.favouriteItems[i] = item && !(<any>item).toJSON ? new FavouriteItem(item) : <FavouriteItem>item;
                }
            }
            if (data.followedUsers) {
                this.followedUsers = [];
                for (let i = 0; i < data.followedUsers.length; i++) {
                    let item = data.followedUsers[i];
                    this.followedUsers[i] = item && !(<any>item).toJSON ? new FollowedUser(item) : <FollowedUser>item;
                }
            }
            if (data.friends) {
                this.friends = [];
                for (let i = 0; i < data.friends.length; i++) {
                    let item = data.friends[i];
                    this.friends[i] = item && !(<any>item).toJSON ? new Friend(item) : <Friend>item;
                }
            }
            this.referral = data.referral && !(<any>data.referral).toJSON ? new Referral(data.referral) : <Referral>this.referral;
            if (data.blockedUsers) {
                this.blockedUsers = [];
                for (let i = 0; i < data.blockedUsers.length; i++) {
                    let item = data.blockedUsers[i];
                    this.blockedUsers[i] = item && !(<any>item).toJSON ? new BlockedUser(item) : <BlockedUser>item;
                }
            }
            if (data.savedSearches) {
                this.savedSearches = [];
                for (let i = 0; i < data.savedSearches.length; i++) {
                    let item = data.savedSearches[i];
                    this.savedSearches[i] = item && !(<any>item).toJSON ? new SavedSearch(item) : <SavedSearch>item;
                }
            }
            if (data.watchedItems) {
                this.watchedItems = [];
                for (let i = 0; i < data.watchedItems.length; i++) {
                    let item = data.watchedItems[i];
                    this.watchedItems[i] = item && !(<any>item).toJSON ? new WatchedItem(item) : <WatchedItem>item;
                }
            }
            if (data.vouchersRedeemed) {
                this.vouchersRedeemed = [];
                for (let i = 0; i < data.vouchersRedeemed.length; i++) {
                    let item = data.vouchersRedeemed[i];
                    this.vouchersRedeemed[i] = item && !(<any>item).toJSON ? new VoucherRedemption(item) : <VoucherRedemption>item;
                }
            }
            if (data.discounts) {
                this.discounts = [];
                for (let i = 0; i < data.discounts.length; i++) {
                    let item = data.discounts[i];
                    this.discounts[i] = item && !(<any>item).toJSON ? new Discount(item) : <Discount>item;
                }
            }
            if (data.images) {
                this.images = [];
                for (let i = 0; i < data.images.length; i++) {
                    let item = data.images[i];
                    this.images[i] = item && !(<any>item).toJSON ? new Image(item) : <Image>item;
                }
            }
            if (data.videos) {
                this.videos = [];
                for (let i = 0; i < data.videos.length; i++) {
                    let item = data.videos[i];
                    this.videos[i] = item && !(<any>item).toJSON ? new Video(item) : <Video>item;
                }
            }
            this.tenant = data.tenant && !(<any>data.tenant).toJSON ? new Tenant(data.tenant) : <Tenant>this.tenant;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.auth0UserId = _data["auth0UserId"];
            this.phoneNumber = _data["phoneNumber"];
            this.aboutMe = _data["aboutMe"];
            this.emailAddress = _data["emailAddress"];
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : <any>undefined;
            this.joinedDate = _data["joinedDate"] ? new Date(_data["joinedDate"].toString()) : <any>undefined;
            this.profileImage = _data["profileImage"] ? Image.fromJS(_data["profileImage"]) : <any>undefined;
            this.bannerImage = _data["bannerImage"] ? BannerImage.fromJS(_data["bannerImage"]) : <any>undefined;
            this.gender = _data["gender"] ? Gender.fromJS(_data["gender"]) : <any>undefined;
            this.isBusiness = _data["isBusiness"];
            if (Array.isArray(_data["moderators"])) {
                this.moderators = [] as any;
                for (let item of _data["moderators"])
                    this.moderators!.push(RentMyUser.fromJS(item));
            }
            this.nationalityCountry = _data["nationalityCountry"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["favouriteLocations"])) {
                this.favouriteLocations = [] as any;
                for (let item of _data["favouriteLocations"])
                    this.favouriteLocations!.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["favouriteItems"])) {
                this.favouriteItems = [] as any;
                for (let item of _data["favouriteItems"])
                    this.favouriteItems!.push(FavouriteItem.fromJS(item));
            }
            if (Array.isArray(_data["followedUsers"])) {
                this.followedUsers = [] as any;
                for (let item of _data["followedUsers"])
                    this.followedUsers!.push(FollowedUser.fromJS(item));
            }
            this.followerCount = _data["followerCount"];
            this.followingCount = _data["followingCount"];
            if (Array.isArray(_data["friends"])) {
                this.friends = [] as any;
                for (let item of _data["friends"])
                    this.friends!.push(Friend.fromJS(item));
            }
            this.referral = _data["referral"] ? Referral.fromJS(_data["referral"]) : <any>undefined;
            if (Array.isArray(_data["blockedUsers"])) {
                this.blockedUsers = [] as any;
                for (let item of _data["blockedUsers"])
                    this.blockedUsers!.push(BlockedUser.fromJS(item));
            }
            if (Array.isArray(_data["savedSearches"])) {
                this.savedSearches = [] as any;
                for (let item of _data["savedSearches"])
                    this.savedSearches!.push(SavedSearch.fromJS(item));
            }
            if (Array.isArray(_data["watchedItems"])) {
                this.watchedItems = [] as any;
                for (let item of _data["watchedItems"])
                    this.watchedItems!.push(WatchedItem.fromJS(item));
            }
            if (Array.isArray(_data["vouchersRedeemed"])) {
                this.vouchersRedeemed = [] as any;
                for (let item of _data["vouchersRedeemed"])
                    this.vouchersRedeemed!.push(VoucherRedemption.fromJS(item));
            }
            if (Array.isArray(_data["discounts"])) {
                this.discounts = [] as any;
                for (let item of _data["discounts"])
                    this.discounts!.push(Discount.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(Image.fromJS(item));
            }
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(Video.fromJS(item));
            }
            this.reviewOverallAverage = _data["reviewOverallAverage"];
            this.reviewCommunicationAverage = _data["reviewCommunicationAverage"];
            this.reviewPickUpAverage = _data["reviewPickUpAverage"];
            this.reviewDropOffAverage = _data["reviewDropOffAverage"];
            this.reviewAccuracyAverage = _data["reviewAccuracyAverage"];
            this.reviewQualityAverage = _data["reviewQualityAverage"];
            this.reviewValueAverage = _data["reviewValueAverage"];
            this.reviewCount = _data["reviewCount"];
            this.reviewsMadeCount = _data["reviewsMadeCount"];
            this.isSuspended = _data["isSuspended"];
            this.isVerified = _data["isVerified"];
            this.verificationStatus = _data["verificationStatus"];
            this.receiveEmailsNotifications = _data["receiveEmailsNotifications"];
            this.receivePhoneNotifications = _data["receivePhoneNotifications"];
            this.receiveTextNotifications = _data["receiveTextNotifications"];
            this.receiveWhatsappNotifications = _data["receiveWhatsappNotifications"];
            this.receivePostNotifications = _data["receivePostNotifications"];
            this.website = _data["website"];
            this.instagramUserName = _data["instagramUserName"];
            this.instagramUrl = _data["instagramUrl"];
            this.facebookUserName = _data["facebookUserName"];
            this.facebookUrl = _data["facebookUrl"];
            this.twitterUserName = _data["twitterUserName"];
            this.twitterUrl = _data["twitterUrl"];
            this.youtubeUserName = _data["youtubeUserName"];
            this.youtubeUrl = _data["youtubeUrl"];
            this.stripeAccountId = _data["stripeAccountId"];
            this.stripeCustomerId = _data["stripeCustomerId"];
            if (Array.isArray(_data["stripeExternalAccounts"])) {
                this.stripeExternalAccounts = [] as any;
                for (let item of _data["stripeExternalAccounts"])
                    this.stripeExternalAccounts!.push(item);
            }
            this.stripeVerificationSessionId = _data["stripeVerificationSessionId"];
            this.stripeOnboarded = _data["stripeOnboarded"];
            this.role = _data["role"];
            this.signalRId = _data["signalRId"];
            this.intention = _data["intention"];
            this.flagged = _data["flagged"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.excludeFromAnalytics = _data["excludeFromAnalytics"];
            this.lastIP = _data["lastIP"];
            this.hasBeenReferred = _data["hasBeenReferred"];
            this.dateConsentGiven = _data["dateConsentGiven"] ? new Date(_data["dateConsentGiven"].toString()) : <any>undefined;
            this.dateConsentRequested = _data["dateConsentRequested"] ? new Date(_data["dateConsentRequested"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RentMyUser {
        data = typeof data === 'object' ? data : {};
        let result = new RentMyUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["auth0UserId"] = this.auth0UserId;
        data["phoneNumber"] = this.phoneNumber;
        data["aboutMe"] = this.aboutMe;
        data["emailAddress"] = this.emailAddress;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["joinedDate"] = this.joinedDate ? this.joinedDate.toISOString() : <any>undefined;
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>undefined;
        data["bannerImage"] = this.bannerImage ? this.bannerImage.toJSON() : <any>undefined;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["isBusiness"] = this.isBusiness;
        if (Array.isArray(this.moderators)) {
            data["moderators"] = [];
            for (let item of this.moderators)
                data["moderators"].push(item.toJSON());
        }
        data["nationalityCountry"] = this.nationalityCountry;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.favouriteLocations)) {
            data["favouriteLocations"] = [];
            for (let item of this.favouriteLocations)
                data["favouriteLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.favouriteItems)) {
            data["favouriteItems"] = [];
            for (let item of this.favouriteItems)
                data["favouriteItems"].push(item.toJSON());
        }
        if (Array.isArray(this.followedUsers)) {
            data["followedUsers"] = [];
            for (let item of this.followedUsers)
                data["followedUsers"].push(item.toJSON());
        }
        data["followerCount"] = this.followerCount;
        data["followingCount"] = this.followingCount;
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        data["referral"] = this.referral ? this.referral.toJSON() : <any>undefined;
        if (Array.isArray(this.blockedUsers)) {
            data["blockedUsers"] = [];
            for (let item of this.blockedUsers)
                data["blockedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.savedSearches)) {
            data["savedSearches"] = [];
            for (let item of this.savedSearches)
                data["savedSearches"].push(item.toJSON());
        }
        if (Array.isArray(this.watchedItems)) {
            data["watchedItems"] = [];
            for (let item of this.watchedItems)
                data["watchedItems"].push(item.toJSON());
        }
        if (Array.isArray(this.vouchersRedeemed)) {
            data["vouchersRedeemed"] = [];
            for (let item of this.vouchersRedeemed)
                data["vouchersRedeemed"].push(item.toJSON());
        }
        if (Array.isArray(this.discounts)) {
            data["discounts"] = [];
            for (let item of this.discounts)
                data["discounts"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        data["reviewOverallAverage"] = this.reviewOverallAverage;
        data["reviewCommunicationAverage"] = this.reviewCommunicationAverage;
        data["reviewPickUpAverage"] = this.reviewPickUpAverage;
        data["reviewDropOffAverage"] = this.reviewDropOffAverage;
        data["reviewAccuracyAverage"] = this.reviewAccuracyAverage;
        data["reviewQualityAverage"] = this.reviewQualityAverage;
        data["reviewValueAverage"] = this.reviewValueAverage;
        data["reviewCount"] = this.reviewCount;
        data["reviewsMadeCount"] = this.reviewsMadeCount;
        data["isSuspended"] = this.isSuspended;
        data["isVerified"] = this.isVerified;
        data["verificationStatus"] = this.verificationStatus;
        data["receiveEmailsNotifications"] = this.receiveEmailsNotifications;
        data["receivePhoneNotifications"] = this.receivePhoneNotifications;
        data["receiveTextNotifications"] = this.receiveTextNotifications;
        data["receiveWhatsappNotifications"] = this.receiveWhatsappNotifications;
        data["receivePostNotifications"] = this.receivePostNotifications;
        data["website"] = this.website;
        data["instagramUserName"] = this.instagramUserName;
        data["instagramUrl"] = this.instagramUrl;
        data["facebookUserName"] = this.facebookUserName;
        data["facebookUrl"] = this.facebookUrl;
        data["twitterUserName"] = this.twitterUserName;
        data["twitterUrl"] = this.twitterUrl;
        data["youtubeUserName"] = this.youtubeUserName;
        data["youtubeUrl"] = this.youtubeUrl;
        data["stripeAccountId"] = this.stripeAccountId;
        data["stripeCustomerId"] = this.stripeCustomerId;
        if (Array.isArray(this.stripeExternalAccounts)) {
            data["stripeExternalAccounts"] = [];
            for (let item of this.stripeExternalAccounts)
                data["stripeExternalAccounts"].push(item);
        }
        data["stripeVerificationSessionId"] = this.stripeVerificationSessionId;
        data["stripeOnboarded"] = this.stripeOnboarded;
        data["role"] = this.role;
        data["signalRId"] = this.signalRId;
        data["intention"] = this.intention;
        data["flagged"] = this.flagged;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["excludeFromAnalytics"] = this.excludeFromAnalytics;
        data["lastIP"] = this.lastIP;
        data["hasBeenReferred"] = this.hasBeenReferred;
        data["dateConsentGiven"] = this.dateConsentGiven ? this.dateConsentGiven.toISOString() : <any>undefined;
        data["dateConsentRequested"] = this.dateConsentRequested ? this.dateConsentRequested.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRentMyUser {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string;
    firstName: string | undefined;
    lastName: string | undefined;
    auth0UserId: string | undefined;
    phoneNumber: string | undefined;
    aboutMe: string | undefined;
    emailAddress: string;
    birthdate: Date | undefined;
    joinedDate: Date;
    profileImage: IImage;
    bannerImage: IBannerImage;
    gender: IGender;
    isBusiness: boolean;
    moderators: IRentMyUser[] | undefined;
    nationalityCountry: string | undefined;
    location: ILocation;
    favouriteLocations: ILocation[] | undefined;
    favouriteItems: IFavouriteItem[] | undefined;
    followedUsers: IFollowedUser[] | undefined;
    followerCount: number;
    followingCount: number;
    friends: IFriend[] | undefined;
    referral: IReferral;
    blockedUsers: IBlockedUser[] | undefined;
    savedSearches: ISavedSearch[] | undefined;
    watchedItems: IWatchedItem[] | undefined;
    vouchersRedeemed: IVoucherRedemption[] | undefined;
    discounts: IDiscount[] | undefined;
    images: IImage[] | undefined;
    videos: IVideo[] | undefined;
    reviewOverallAverage: number | undefined;
    reviewCommunicationAverage: number | undefined;
    reviewPickUpAverage: number | undefined;
    reviewDropOffAverage: number | undefined;
    reviewAccuracyAverage: number | undefined;
    reviewQualityAverage: number | undefined;
    reviewValueAverage: number | undefined;
    reviewCount: number;
    reviewsMadeCount: number;
    isSuspended: boolean;
    isVerified: boolean;
    verificationStatus: string | undefined;
    receiveEmailsNotifications: boolean;
    receivePhoneNotifications: boolean;
    receiveTextNotifications: boolean;
    receiveWhatsappNotifications: boolean;
    receivePostNotifications: boolean;
    website: string | undefined;
    instagramUserName: string | undefined;
    instagramUrl: string | undefined;
    facebookUserName: string | undefined;
    facebookUrl: string | undefined;
    twitterUserName: string | undefined;
    twitterUrl: string | undefined;
    youtubeUserName: string | undefined;
    youtubeUrl: string | undefined;
    stripeAccountId: string | undefined;
    stripeCustomerId: string | undefined;
    stripeExternalAccounts: string[] | undefined;
    stripeVerificationSessionId: string | undefined;
    stripeOnboarded: boolean;
    role: RentMyRole;
    signalRId: string | undefined;
    intention: UserIntention;
    flagged: boolean;
    tenant: ITenant;
    excludeFromAnalytics: boolean;
    lastIP: string | undefined;
    hasBeenReferred: boolean;
    dateConsentGiven: Date | undefined;
    dateConsentRequested: Date | undefined;
}

export class RentMyUserDetailedDto implements IRentMyUserDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    phoneNumber!: string | undefined;
    aboutMe!: string | undefined;
    joinedDate!: Date;
    birthdate!: Date | undefined;
    profileImage!: ImageDto;
    bannerImage!: ImageDto;
    emailAddress!: string | undefined;
    gender!: string | undefined;
    nationalityCountry!: string | undefined;
    location!: Location;
    followingCount!: number | undefined;
    followerCount!: number | undefined;
    favouriteLocations!: Location[] | undefined;
    favouriteItems!: ItemSimpleDto[] | undefined;
    followedUsers!: RentMyUserSimpleDto[] | undefined;
    friends!: RentMyUserSimpleDto[] | undefined;
    blockedUsers!: RentMyUserSimpleDto[] | undefined;
    savedSearches!: SavedSearchSimpleDto[] | undefined;
    watchedItems!: WatchedItemSimpleDto[] | undefined;
    vouchersRedeemed!: VoucherRedemptionSimpleDto[] | undefined;
    discounts!: DiscountSimpleDto[] | undefined;
    reviewOverallAverage!: number | undefined;
    reviewCommunicationAverage!: number | undefined;
    reviewPickUpAverage!: number | undefined;
    reviewDropOffAverage!: number | undefined;
    reviewAccuracyAverage!: number | undefined;
    reviewQualityAverage!: number | undefined;
    reviewValueAverage!: number | undefined;
    reviewCount!: number;
    reviewsMadeCount!: number;
    isVerified!: boolean;
    receiveEmailsNotifications!: boolean;
    receivePhoneNotifications!: boolean;
    receiveTextNotifications!: boolean;
    receivePostNotifications!: boolean;
    receiveWhatsappNotifications!: boolean;
    website!: string | undefined;
    instagramUserName!: string | undefined;
    instagramUrl!: string | undefined;
    facebookUserName!: string | undefined;
    facebookUrl!: string | undefined;
    twitterUserName!: string | undefined;
    twitterUrl!: string | undefined;
    youtubeUserName!: string | undefined;
    youtubeUrl!: string | undefined;
    role!: RentMyRole;
    stripeId!: string | undefined;
    stripeCustomerId!: string | undefined;
    auth0Id!: string | undefined;
    canBeSharer!: boolean;
    stripeOnboarded!: boolean;
    signalRId!: string | undefined;
    referral!: ReferralSimpleDto;
    referredUsers!: RentMyUserPublicSimpleDto[] | undefined;
    flagged!: boolean;
    intention!: UserIntention;
    stripeVerificationSessionId!: string | undefined;
    isBusiness!: boolean;
    isSuspended!: boolean;
    tenant!: TenantSimpleDto;
    lastIP!: string | undefined;
    hasBeenReferred!: boolean;

    constructor(data?: IRentMyUserDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.profileImage = data.profileImage && !(<any>data.profileImage).toJSON ? new ImageDto(data.profileImage) : <ImageDto>this.profileImage;
            this.bannerImage = data.bannerImage && !(<any>data.bannerImage).toJSON ? new ImageDto(data.bannerImage) : <ImageDto>this.bannerImage;
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
            if (data.favouriteLocations) {
                this.favouriteLocations = [];
                for (let i = 0; i < data.favouriteLocations.length; i++) {
                    let item = data.favouriteLocations[i];
                    this.favouriteLocations[i] = item && !(<any>item).toJSON ? new Location(item) : <Location>item;
                }
            }
            if (data.favouriteItems) {
                this.favouriteItems = [];
                for (let i = 0; i < data.favouriteItems.length; i++) {
                    let item = data.favouriteItems[i];
                    this.favouriteItems[i] = item && !(<any>item).toJSON ? new ItemSimpleDto(item) : <ItemSimpleDto>item;
                }
            }
            if (data.followedUsers) {
                this.followedUsers = [];
                for (let i = 0; i < data.followedUsers.length; i++) {
                    let item = data.followedUsers[i];
                    this.followedUsers[i] = item && !(<any>item).toJSON ? new RentMyUserSimpleDto(item) : <RentMyUserSimpleDto>item;
                }
            }
            if (data.friends) {
                this.friends = [];
                for (let i = 0; i < data.friends.length; i++) {
                    let item = data.friends[i];
                    this.friends[i] = item && !(<any>item).toJSON ? new RentMyUserSimpleDto(item) : <RentMyUserSimpleDto>item;
                }
            }
            if (data.blockedUsers) {
                this.blockedUsers = [];
                for (let i = 0; i < data.blockedUsers.length; i++) {
                    let item = data.blockedUsers[i];
                    this.blockedUsers[i] = item && !(<any>item).toJSON ? new RentMyUserSimpleDto(item) : <RentMyUserSimpleDto>item;
                }
            }
            if (data.savedSearches) {
                this.savedSearches = [];
                for (let i = 0; i < data.savedSearches.length; i++) {
                    let item = data.savedSearches[i];
                    this.savedSearches[i] = item && !(<any>item).toJSON ? new SavedSearchSimpleDto(item) : <SavedSearchSimpleDto>item;
                }
            }
            if (data.watchedItems) {
                this.watchedItems = [];
                for (let i = 0; i < data.watchedItems.length; i++) {
                    let item = data.watchedItems[i];
                    this.watchedItems[i] = item && !(<any>item).toJSON ? new WatchedItemSimpleDto(item) : <WatchedItemSimpleDto>item;
                }
            }
            if (data.vouchersRedeemed) {
                this.vouchersRedeemed = [];
                for (let i = 0; i < data.vouchersRedeemed.length; i++) {
                    let item = data.vouchersRedeemed[i];
                    this.vouchersRedeemed[i] = item && !(<any>item).toJSON ? new VoucherRedemptionSimpleDto(item) : <VoucherRedemptionSimpleDto>item;
                }
            }
            if (data.discounts) {
                this.discounts = [];
                for (let i = 0; i < data.discounts.length; i++) {
                    let item = data.discounts[i];
                    this.discounts[i] = item && !(<any>item).toJSON ? new DiscountSimpleDto(item) : <DiscountSimpleDto>item;
                }
            }
            this.referral = data.referral && !(<any>data.referral).toJSON ? new ReferralSimpleDto(data.referral) : <ReferralSimpleDto>this.referral;
            if (data.referredUsers) {
                this.referredUsers = [];
                for (let i = 0; i < data.referredUsers.length; i++) {
                    let item = data.referredUsers[i];
                    this.referredUsers[i] = item && !(<any>item).toJSON ? new RentMyUserPublicSimpleDto(item) : <RentMyUserPublicSimpleDto>item;
                }
            }
            this.tenant = data.tenant && !(<any>data.tenant).toJSON ? new TenantSimpleDto(data.tenant) : <TenantSimpleDto>this.tenant;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.aboutMe = _data["aboutMe"];
            this.joinedDate = _data["joinedDate"] ? new Date(_data["joinedDate"].toString()) : <any>undefined;
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : <any>undefined;
            this.profileImage = _data["profileImage"] ? ImageDto.fromJS(_data["profileImage"]) : <any>undefined;
            this.bannerImage = _data["bannerImage"] ? ImageDto.fromJS(_data["bannerImage"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.gender = _data["gender"];
            this.nationalityCountry = _data["nationalityCountry"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.followingCount = _data["followingCount"];
            this.followerCount = _data["followerCount"];
            if (Array.isArray(_data["favouriteLocations"])) {
                this.favouriteLocations = [] as any;
                for (let item of _data["favouriteLocations"])
                    this.favouriteLocations!.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["favouriteItems"])) {
                this.favouriteItems = [] as any;
                for (let item of _data["favouriteItems"])
                    this.favouriteItems!.push(ItemSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["followedUsers"])) {
                this.followedUsers = [] as any;
                for (let item of _data["followedUsers"])
                    this.followedUsers!.push(RentMyUserSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["friends"])) {
                this.friends = [] as any;
                for (let item of _data["friends"])
                    this.friends!.push(RentMyUserSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["blockedUsers"])) {
                this.blockedUsers = [] as any;
                for (let item of _data["blockedUsers"])
                    this.blockedUsers!.push(RentMyUserSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["savedSearches"])) {
                this.savedSearches = [] as any;
                for (let item of _data["savedSearches"])
                    this.savedSearches!.push(SavedSearchSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["watchedItems"])) {
                this.watchedItems = [] as any;
                for (let item of _data["watchedItems"])
                    this.watchedItems!.push(WatchedItemSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["vouchersRedeemed"])) {
                this.vouchersRedeemed = [] as any;
                for (let item of _data["vouchersRedeemed"])
                    this.vouchersRedeemed!.push(VoucherRedemptionSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["discounts"])) {
                this.discounts = [] as any;
                for (let item of _data["discounts"])
                    this.discounts!.push(DiscountSimpleDto.fromJS(item));
            }
            this.reviewOverallAverage = _data["reviewOverallAverage"];
            this.reviewCommunicationAverage = _data["reviewCommunicationAverage"];
            this.reviewPickUpAverage = _data["reviewPickUpAverage"];
            this.reviewDropOffAverage = _data["reviewDropOffAverage"];
            this.reviewAccuracyAverage = _data["reviewAccuracyAverage"];
            this.reviewQualityAverage = _data["reviewQualityAverage"];
            this.reviewValueAverage = _data["reviewValueAverage"];
            this.reviewCount = _data["reviewCount"];
            this.reviewsMadeCount = _data["reviewsMadeCount"];
            this.isVerified = _data["isVerified"];
            this.receiveEmailsNotifications = _data["receiveEmailsNotifications"];
            this.receivePhoneNotifications = _data["receivePhoneNotifications"];
            this.receiveTextNotifications = _data["receiveTextNotifications"];
            this.receivePostNotifications = _data["receivePostNotifications"];
            this.receiveWhatsappNotifications = _data["receiveWhatsappNotifications"];
            this.website = _data["website"];
            this.instagramUserName = _data["instagramUserName"];
            this.instagramUrl = _data["instagramUrl"];
            this.facebookUserName = _data["facebookUserName"];
            this.facebookUrl = _data["facebookUrl"];
            this.twitterUserName = _data["twitterUserName"];
            this.twitterUrl = _data["twitterUrl"];
            this.youtubeUserName = _data["youtubeUserName"];
            this.youtubeUrl = _data["youtubeUrl"];
            this.role = _data["role"];
            this.stripeId = _data["stripeId"];
            this.stripeCustomerId = _data["stripeCustomerId"];
            this.auth0Id = _data["auth0Id"];
            this.canBeSharer = _data["canBeSharer"];
            this.stripeOnboarded = _data["stripeOnboarded"];
            this.signalRId = _data["signalRId"];
            this.referral = _data["referral"] ? ReferralSimpleDto.fromJS(_data["referral"]) : <any>undefined;
            if (Array.isArray(_data["referredUsers"])) {
                this.referredUsers = [] as any;
                for (let item of _data["referredUsers"])
                    this.referredUsers!.push(RentMyUserPublicSimpleDto.fromJS(item));
            }
            this.flagged = _data["flagged"];
            this.intention = _data["intention"];
            this.stripeVerificationSessionId = _data["stripeVerificationSessionId"];
            this.isBusiness = _data["isBusiness"];
            this.isSuspended = _data["isSuspended"];
            this.tenant = _data["tenant"] ? TenantSimpleDto.fromJS(_data["tenant"]) : <any>undefined;
            this.lastIP = _data["lastIP"];
            this.hasBeenReferred = _data["hasBeenReferred"];
        }
    }

    static fromJS(data: any): RentMyUserDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentMyUserDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["aboutMe"] = this.aboutMe;
        data["joinedDate"] = this.joinedDate ? this.joinedDate.toISOString() : <any>undefined;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>undefined;
        data["bannerImage"] = this.bannerImage ? this.bannerImage.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["gender"] = this.gender;
        data["nationalityCountry"] = this.nationalityCountry;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["followingCount"] = this.followingCount;
        data["followerCount"] = this.followerCount;
        if (Array.isArray(this.favouriteLocations)) {
            data["favouriteLocations"] = [];
            for (let item of this.favouriteLocations)
                data["favouriteLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.favouriteItems)) {
            data["favouriteItems"] = [];
            for (let item of this.favouriteItems)
                data["favouriteItems"].push(item.toJSON());
        }
        if (Array.isArray(this.followedUsers)) {
            data["followedUsers"] = [];
            for (let item of this.followedUsers)
                data["followedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        if (Array.isArray(this.blockedUsers)) {
            data["blockedUsers"] = [];
            for (let item of this.blockedUsers)
                data["blockedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.savedSearches)) {
            data["savedSearches"] = [];
            for (let item of this.savedSearches)
                data["savedSearches"].push(item.toJSON());
        }
        if (Array.isArray(this.watchedItems)) {
            data["watchedItems"] = [];
            for (let item of this.watchedItems)
                data["watchedItems"].push(item.toJSON());
        }
        if (Array.isArray(this.vouchersRedeemed)) {
            data["vouchersRedeemed"] = [];
            for (let item of this.vouchersRedeemed)
                data["vouchersRedeemed"].push(item.toJSON());
        }
        if (Array.isArray(this.discounts)) {
            data["discounts"] = [];
            for (let item of this.discounts)
                data["discounts"].push(item.toJSON());
        }
        data["reviewOverallAverage"] = this.reviewOverallAverage;
        data["reviewCommunicationAverage"] = this.reviewCommunicationAverage;
        data["reviewPickUpAverage"] = this.reviewPickUpAverage;
        data["reviewDropOffAverage"] = this.reviewDropOffAverage;
        data["reviewAccuracyAverage"] = this.reviewAccuracyAverage;
        data["reviewQualityAverage"] = this.reviewQualityAverage;
        data["reviewValueAverage"] = this.reviewValueAverage;
        data["reviewCount"] = this.reviewCount;
        data["reviewsMadeCount"] = this.reviewsMadeCount;
        data["isVerified"] = this.isVerified;
        data["receiveEmailsNotifications"] = this.receiveEmailsNotifications;
        data["receivePhoneNotifications"] = this.receivePhoneNotifications;
        data["receiveTextNotifications"] = this.receiveTextNotifications;
        data["receivePostNotifications"] = this.receivePostNotifications;
        data["receiveWhatsappNotifications"] = this.receiveWhatsappNotifications;
        data["website"] = this.website;
        data["instagramUserName"] = this.instagramUserName;
        data["instagramUrl"] = this.instagramUrl;
        data["facebookUserName"] = this.facebookUserName;
        data["facebookUrl"] = this.facebookUrl;
        data["twitterUserName"] = this.twitterUserName;
        data["twitterUrl"] = this.twitterUrl;
        data["youtubeUserName"] = this.youtubeUserName;
        data["youtubeUrl"] = this.youtubeUrl;
        data["role"] = this.role;
        data["stripeId"] = this.stripeId;
        data["stripeCustomerId"] = this.stripeCustomerId;
        data["auth0Id"] = this.auth0Id;
        data["canBeSharer"] = this.canBeSharer;
        data["stripeOnboarded"] = this.stripeOnboarded;
        data["signalRId"] = this.signalRId;
        data["referral"] = this.referral ? this.referral.toJSON() : <any>undefined;
        if (Array.isArray(this.referredUsers)) {
            data["referredUsers"] = [];
            for (let item of this.referredUsers)
                data["referredUsers"].push(item.toJSON());
        }
        data["flagged"] = this.flagged;
        data["intention"] = this.intention;
        data["stripeVerificationSessionId"] = this.stripeVerificationSessionId;
        data["isBusiness"] = this.isBusiness;
        data["isSuspended"] = this.isSuspended;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["lastIP"] = this.lastIP;
        data["hasBeenReferred"] = this.hasBeenReferred;
        return data;
    }
}

export interface IRentMyUserDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    aboutMe: string | undefined;
    joinedDate: Date;
    birthdate: Date | undefined;
    profileImage: IImageDto;
    bannerImage: IImageDto;
    emailAddress: string | undefined;
    gender: string | undefined;
    nationalityCountry: string | undefined;
    location: ILocation;
    followingCount: number | undefined;
    followerCount: number | undefined;
    favouriteLocations: ILocation[] | undefined;
    favouriteItems: IItemSimpleDto[] | undefined;
    followedUsers: IRentMyUserSimpleDto[] | undefined;
    friends: IRentMyUserSimpleDto[] | undefined;
    blockedUsers: IRentMyUserSimpleDto[] | undefined;
    savedSearches: ISavedSearchSimpleDto[] | undefined;
    watchedItems: IWatchedItemSimpleDto[] | undefined;
    vouchersRedeemed: IVoucherRedemptionSimpleDto[] | undefined;
    discounts: IDiscountSimpleDto[] | undefined;
    reviewOverallAverage: number | undefined;
    reviewCommunicationAverage: number | undefined;
    reviewPickUpAverage: number | undefined;
    reviewDropOffAverage: number | undefined;
    reviewAccuracyAverage: number | undefined;
    reviewQualityAverage: number | undefined;
    reviewValueAverage: number | undefined;
    reviewCount: number;
    reviewsMadeCount: number;
    isVerified: boolean;
    receiveEmailsNotifications: boolean;
    receivePhoneNotifications: boolean;
    receiveTextNotifications: boolean;
    receivePostNotifications: boolean;
    receiveWhatsappNotifications: boolean;
    website: string | undefined;
    instagramUserName: string | undefined;
    instagramUrl: string | undefined;
    facebookUserName: string | undefined;
    facebookUrl: string | undefined;
    twitterUserName: string | undefined;
    twitterUrl: string | undefined;
    youtubeUserName: string | undefined;
    youtubeUrl: string | undefined;
    role: RentMyRole;
    stripeId: string | undefined;
    stripeCustomerId: string | undefined;
    auth0Id: string | undefined;
    canBeSharer: boolean;
    stripeOnboarded: boolean;
    signalRId: string | undefined;
    referral: IReferralSimpleDto;
    referredUsers: IRentMyUserPublicSimpleDto[] | undefined;
    flagged: boolean;
    intention: UserIntention;
    stripeVerificationSessionId: string | undefined;
    isBusiness: boolean;
    isSuspended: boolean;
    tenant: ITenantSimpleDto;
    lastIP: string | undefined;
    hasBeenReferred: boolean;
}

export class RentMyUserDetailedDtoPaginationDto implements IRentMyUserDetailedDtoPaginationDto {
    data!: RentMyUserDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IRentMyUserDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new RentMyUserDetailedDto(item) : <RentMyUserDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RentMyUserDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): RentMyUserDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentMyUserDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IRentMyUserDetailedDtoPaginationDto {
    data: IRentMyUserDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class RentMyUserDetailedDtoUpdateResponseDto implements IRentMyUserDetailedDtoUpdateResponseDto {
    data!: RentMyUserDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IRentMyUserDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new RentMyUserDetailedDto(data.data) : <RentMyUserDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RentMyUserDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): RentMyUserDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentMyUserDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IRentMyUserDetailedDtoUpdateResponseDto {
    data: IRentMyUserDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class RentMyUserPublicDetailedDto implements IRentMyUserPublicDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    aboutMe!: string | undefined;
    joinedDate!: Date;
    profileImage!: ImageDto;
    bannerImage!: ImageDto;
    approximateLocation!: ApproximateLocation;
    followedUsers!: RentMyUserSimpleDto[] | undefined;
    followingCount!: number | undefined;
    followerCount!: number | undefined;
    reviewOverallAverage!: number | undefined;
    reviewCommunicationAverage!: number | undefined;
    reviewPickUpAverage!: number | undefined;
    reviewDropOffAverage!: number | undefined;
    reviewAccuracyAverage!: number | undefined;
    reviewQualityAverage!: number | undefined;
    reviewValueAverage!: number | undefined;
    reviewCount!: number;
    isVerified!: boolean;
    website!: string | undefined;
    instagramUserName!: string | undefined;
    instagramUrl!: string | undefined;
    facebookUserName!: string | undefined;
    facebookUrl!: string | undefined;
    twitterUserName!: string | undefined;
    twitterUrl!: string | undefined;
    youtubeUserName!: string | undefined;
    youtubeUrl!: string | undefined;
    canBeSharer!: boolean;
    stripeOnboarded!: boolean;
    referralCode!: string | undefined;
    role!: RentMyRole;
    intention!: UserIntention;
    isBusiness!: boolean;
    isSuspended!: boolean;
    flagged!: boolean;
    hasBeenReferred!: boolean;
    tenant!: TenantSimpleDto;

    constructor(data?: IRentMyUserPublicDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.profileImage = data.profileImage && !(<any>data.profileImage).toJSON ? new ImageDto(data.profileImage) : <ImageDto>this.profileImage;
            this.bannerImage = data.bannerImage && !(<any>data.bannerImage).toJSON ? new ImageDto(data.bannerImage) : <ImageDto>this.bannerImage;
            this.approximateLocation = data.approximateLocation && !(<any>data.approximateLocation).toJSON ? new ApproximateLocation(data.approximateLocation) : <ApproximateLocation>this.approximateLocation;
            if (data.followedUsers) {
                this.followedUsers = [];
                for (let i = 0; i < data.followedUsers.length; i++) {
                    let item = data.followedUsers[i];
                    this.followedUsers[i] = item && !(<any>item).toJSON ? new RentMyUserSimpleDto(item) : <RentMyUserSimpleDto>item;
                }
            }
            this.tenant = data.tenant && !(<any>data.tenant).toJSON ? new TenantSimpleDto(data.tenant) : <TenantSimpleDto>this.tenant;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.aboutMe = _data["aboutMe"];
            this.joinedDate = _data["joinedDate"] ? new Date(_data["joinedDate"].toString()) : <any>undefined;
            this.profileImage = _data["profileImage"] ? ImageDto.fromJS(_data["profileImage"]) : <any>undefined;
            this.bannerImage = _data["bannerImage"] ? ImageDto.fromJS(_data["bannerImage"]) : <any>undefined;
            this.approximateLocation = _data["approximateLocation"] ? ApproximateLocation.fromJS(_data["approximateLocation"]) : <any>undefined;
            if (Array.isArray(_data["followedUsers"])) {
                this.followedUsers = [] as any;
                for (let item of _data["followedUsers"])
                    this.followedUsers!.push(RentMyUserSimpleDto.fromJS(item));
            }
            this.followingCount = _data["followingCount"];
            this.followerCount = _data["followerCount"];
            this.reviewOverallAverage = _data["reviewOverallAverage"];
            this.reviewCommunicationAverage = _data["reviewCommunicationAverage"];
            this.reviewPickUpAverage = _data["reviewPickUpAverage"];
            this.reviewDropOffAverage = _data["reviewDropOffAverage"];
            this.reviewAccuracyAverage = _data["reviewAccuracyAverage"];
            this.reviewQualityAverage = _data["reviewQualityAverage"];
            this.reviewValueAverage = _data["reviewValueAverage"];
            this.reviewCount = _data["reviewCount"];
            this.isVerified = _data["isVerified"];
            this.website = _data["website"];
            this.instagramUserName = _data["instagramUserName"];
            this.instagramUrl = _data["instagramUrl"];
            this.facebookUserName = _data["facebookUserName"];
            this.facebookUrl = _data["facebookUrl"];
            this.twitterUserName = _data["twitterUserName"];
            this.twitterUrl = _data["twitterUrl"];
            this.youtubeUserName = _data["youtubeUserName"];
            this.youtubeUrl = _data["youtubeUrl"];
            this.canBeSharer = _data["canBeSharer"];
            this.stripeOnboarded = _data["stripeOnboarded"];
            this.referralCode = _data["referralCode"];
            this.role = _data["role"];
            this.intention = _data["intention"];
            this.isBusiness = _data["isBusiness"];
            this.isSuspended = _data["isSuspended"];
            this.flagged = _data["flagged"];
            this.hasBeenReferred = _data["hasBeenReferred"];
            this.tenant = _data["tenant"] ? TenantSimpleDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RentMyUserPublicDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentMyUserPublicDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["aboutMe"] = this.aboutMe;
        data["joinedDate"] = this.joinedDate ? this.joinedDate.toISOString() : <any>undefined;
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>undefined;
        data["bannerImage"] = this.bannerImage ? this.bannerImage.toJSON() : <any>undefined;
        data["approximateLocation"] = this.approximateLocation ? this.approximateLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.followedUsers)) {
            data["followedUsers"] = [];
            for (let item of this.followedUsers)
                data["followedUsers"].push(item.toJSON());
        }
        data["followingCount"] = this.followingCount;
        data["followerCount"] = this.followerCount;
        data["reviewOverallAverage"] = this.reviewOverallAverage;
        data["reviewCommunicationAverage"] = this.reviewCommunicationAverage;
        data["reviewPickUpAverage"] = this.reviewPickUpAverage;
        data["reviewDropOffAverage"] = this.reviewDropOffAverage;
        data["reviewAccuracyAverage"] = this.reviewAccuracyAverage;
        data["reviewQualityAverage"] = this.reviewQualityAverage;
        data["reviewValueAverage"] = this.reviewValueAverage;
        data["reviewCount"] = this.reviewCount;
        data["isVerified"] = this.isVerified;
        data["website"] = this.website;
        data["instagramUserName"] = this.instagramUserName;
        data["instagramUrl"] = this.instagramUrl;
        data["facebookUserName"] = this.facebookUserName;
        data["facebookUrl"] = this.facebookUrl;
        data["twitterUserName"] = this.twitterUserName;
        data["twitterUrl"] = this.twitterUrl;
        data["youtubeUserName"] = this.youtubeUserName;
        data["youtubeUrl"] = this.youtubeUrl;
        data["canBeSharer"] = this.canBeSharer;
        data["stripeOnboarded"] = this.stripeOnboarded;
        data["referralCode"] = this.referralCode;
        data["role"] = this.role;
        data["intention"] = this.intention;
        data["isBusiness"] = this.isBusiness;
        data["isSuspended"] = this.isSuspended;
        data["flagged"] = this.flagged;
        data["hasBeenReferred"] = this.hasBeenReferred;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRentMyUserPublicDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    aboutMe: string | undefined;
    joinedDate: Date;
    profileImage: IImageDto;
    bannerImage: IImageDto;
    approximateLocation: IApproximateLocation;
    followedUsers: IRentMyUserSimpleDto[] | undefined;
    followingCount: number | undefined;
    followerCount: number | undefined;
    reviewOverallAverage: number | undefined;
    reviewCommunicationAverage: number | undefined;
    reviewPickUpAverage: number | undefined;
    reviewDropOffAverage: number | undefined;
    reviewAccuracyAverage: number | undefined;
    reviewQualityAverage: number | undefined;
    reviewValueAverage: number | undefined;
    reviewCount: number;
    isVerified: boolean;
    website: string | undefined;
    instagramUserName: string | undefined;
    instagramUrl: string | undefined;
    facebookUserName: string | undefined;
    facebookUrl: string | undefined;
    twitterUserName: string | undefined;
    twitterUrl: string | undefined;
    youtubeUserName: string | undefined;
    youtubeUrl: string | undefined;
    canBeSharer: boolean;
    stripeOnboarded: boolean;
    referralCode: string | undefined;
    role: RentMyRole;
    intention: UserIntention;
    isBusiness: boolean;
    isSuspended: boolean;
    flagged: boolean;
    hasBeenReferred: boolean;
    tenant: ITenantSimpleDto;
}

export class RentMyUserPublicDetailedDtoPaginationDto implements IRentMyUserPublicDetailedDtoPaginationDto {
    data!: RentMyUserPublicDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IRentMyUserPublicDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new RentMyUserPublicDetailedDto(item) : <RentMyUserPublicDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RentMyUserPublicDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): RentMyUserPublicDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentMyUserPublicDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IRentMyUserPublicDetailedDtoPaginationDto {
    data: IRentMyUserPublicDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class RentMyUserPublicSimpleDto implements IRentMyUserPublicSimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    aboutMe!: string | undefined;
    joinedDate!: Date;
    profileImage!: ImageDto;
    bannerImage!: ImageDto;
    approximateLocation!: ApproximateLocation;
    followedUsers!: ImageableIdentifierDto[] | undefined;
    followingCount!: number | undefined;
    followerCount!: number | undefined;
    reviewScoreAverage!: number | undefined;
    reviewOverallAverage!: number | undefined;
    reviewCommunicationAverage!: number | undefined;
    reviewPickUpAverage!: number | undefined;
    reviewDropOffAverage!: number | undefined;
    reviewAccuracyAverage!: number | undefined;
    reviewQualityAverage!: number | undefined;
    reviewValueAverage!: number | undefined;
    reviewCount!: number;
    isVerified!: boolean;
    canBeSharer!: boolean;
    stripeOnboarded!: boolean;
    flagged!: boolean;
    intention!: UserIntention;
    isBusiness!: boolean;
    isSuspended!: boolean;
    tenant!: TenantSimpleDto;
    hasBeenReferred!: boolean;

    constructor(data?: IRentMyUserPublicSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.profileImage = data.profileImage && !(<any>data.profileImage).toJSON ? new ImageDto(data.profileImage) : <ImageDto>this.profileImage;
            this.bannerImage = data.bannerImage && !(<any>data.bannerImage).toJSON ? new ImageDto(data.bannerImage) : <ImageDto>this.bannerImage;
            this.approximateLocation = data.approximateLocation && !(<any>data.approximateLocation).toJSON ? new ApproximateLocation(data.approximateLocation) : <ApproximateLocation>this.approximateLocation;
            if (data.followedUsers) {
                this.followedUsers = [];
                for (let i = 0; i < data.followedUsers.length; i++) {
                    let item = data.followedUsers[i];
                    this.followedUsers[i] = item && !(<any>item).toJSON ? new ImageableIdentifierDto(item) : <ImageableIdentifierDto>item;
                }
            }
            this.tenant = data.tenant && !(<any>data.tenant).toJSON ? new TenantSimpleDto(data.tenant) : <TenantSimpleDto>this.tenant;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.aboutMe = _data["aboutMe"];
            this.joinedDate = _data["joinedDate"] ? new Date(_data["joinedDate"].toString()) : <any>undefined;
            this.profileImage = _data["profileImage"] ? ImageDto.fromJS(_data["profileImage"]) : <any>undefined;
            this.bannerImage = _data["bannerImage"] ? ImageDto.fromJS(_data["bannerImage"]) : <any>undefined;
            this.approximateLocation = _data["approximateLocation"] ? ApproximateLocation.fromJS(_data["approximateLocation"]) : <any>undefined;
            if (Array.isArray(_data["followedUsers"])) {
                this.followedUsers = [] as any;
                for (let item of _data["followedUsers"])
                    this.followedUsers!.push(ImageableIdentifierDto.fromJS(item));
            }
            this.followingCount = _data["followingCount"];
            this.followerCount = _data["followerCount"];
            this.reviewScoreAverage = _data["reviewScoreAverage"];
            this.reviewOverallAverage = _data["reviewOverallAverage"];
            this.reviewCommunicationAverage = _data["reviewCommunicationAverage"];
            this.reviewPickUpAverage = _data["reviewPickUpAverage"];
            this.reviewDropOffAverage = _data["reviewDropOffAverage"];
            this.reviewAccuracyAverage = _data["reviewAccuracyAverage"];
            this.reviewQualityAverage = _data["reviewQualityAverage"];
            this.reviewValueAverage = _data["reviewValueAverage"];
            this.reviewCount = _data["reviewCount"];
            this.isVerified = _data["isVerified"];
            this.canBeSharer = _data["canBeSharer"];
            this.stripeOnboarded = _data["stripeOnboarded"];
            this.flagged = _data["flagged"];
            this.intention = _data["intention"];
            this.isBusiness = _data["isBusiness"];
            this.isSuspended = _data["isSuspended"];
            this.tenant = _data["tenant"] ? TenantSimpleDto.fromJS(_data["tenant"]) : <any>undefined;
            this.hasBeenReferred = _data["hasBeenReferred"];
        }
    }

    static fromJS(data: any): RentMyUserPublicSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentMyUserPublicSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["aboutMe"] = this.aboutMe;
        data["joinedDate"] = this.joinedDate ? this.joinedDate.toISOString() : <any>undefined;
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>undefined;
        data["bannerImage"] = this.bannerImage ? this.bannerImage.toJSON() : <any>undefined;
        data["approximateLocation"] = this.approximateLocation ? this.approximateLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.followedUsers)) {
            data["followedUsers"] = [];
            for (let item of this.followedUsers)
                data["followedUsers"].push(item.toJSON());
        }
        data["followingCount"] = this.followingCount;
        data["followerCount"] = this.followerCount;
        data["reviewScoreAverage"] = this.reviewScoreAverage;
        data["reviewOverallAverage"] = this.reviewOverallAverage;
        data["reviewCommunicationAverage"] = this.reviewCommunicationAverage;
        data["reviewPickUpAverage"] = this.reviewPickUpAverage;
        data["reviewDropOffAverage"] = this.reviewDropOffAverage;
        data["reviewAccuracyAverage"] = this.reviewAccuracyAverage;
        data["reviewQualityAverage"] = this.reviewQualityAverage;
        data["reviewValueAverage"] = this.reviewValueAverage;
        data["reviewCount"] = this.reviewCount;
        data["isVerified"] = this.isVerified;
        data["canBeSharer"] = this.canBeSharer;
        data["stripeOnboarded"] = this.stripeOnboarded;
        data["flagged"] = this.flagged;
        data["intention"] = this.intention;
        data["isBusiness"] = this.isBusiness;
        data["isSuspended"] = this.isSuspended;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["hasBeenReferred"] = this.hasBeenReferred;
        return data;
    }
}

export interface IRentMyUserPublicSimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    aboutMe: string | undefined;
    joinedDate: Date;
    profileImage: IImageDto;
    bannerImage: IImageDto;
    approximateLocation: IApproximateLocation;
    followedUsers: IImageableIdentifierDto[] | undefined;
    followingCount: number | undefined;
    followerCount: number | undefined;
    reviewScoreAverage: number | undefined;
    reviewOverallAverage: number | undefined;
    reviewCommunicationAverage: number | undefined;
    reviewPickUpAverage: number | undefined;
    reviewDropOffAverage: number | undefined;
    reviewAccuracyAverage: number | undefined;
    reviewQualityAverage: number | undefined;
    reviewValueAverage: number | undefined;
    reviewCount: number;
    isVerified: boolean;
    canBeSharer: boolean;
    stripeOnboarded: boolean;
    flagged: boolean;
    intention: UserIntention;
    isBusiness: boolean;
    isSuspended: boolean;
    tenant: ITenantSimpleDto;
    hasBeenReferred: boolean;
}

export class RentMyUserPublicSimpleDtoPaginationDto implements IRentMyUserPublicSimpleDtoPaginationDto {
    data!: RentMyUserPublicSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IRentMyUserPublicSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new RentMyUserPublicSimpleDto(item) : <RentMyUserPublicSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RentMyUserPublicSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): RentMyUserPublicSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentMyUserPublicSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IRentMyUserPublicSimpleDtoPaginationDto {
    data: IRentMyUserPublicSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class RentMyUserSimpleDto implements IRentMyUserSimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    phoneNumber!: string | undefined;
    aboutMe!: string | undefined;
    joinedDate!: Date;
    birthdate!: Date | undefined;
    profileImage!: ImageDto;
    bannerImage!: ImageDto;
    emailAddress!: string | undefined;
    gender!: GenderSimpleDto;
    nationalityCountry!: string | undefined;
    location!: Location;
    followingCount!: number | undefined;
    followerCount!: number | undefined;
    favouriteLocations!: Location[] | undefined;
    favouriteItems!: MultiImageableIdentifierDto[] | undefined;
    followedUsers!: ImageableIdentifierDto[] | undefined;
    friends!: ImageableIdentifierDto[] | undefined;
    blockedUsers!: ImageableIdentifierDto[] | undefined;
    savedSearchIds!: string[] | undefined;
    watchedItems!: MultiImageableIdentifierDto[] | undefined;
    vouchersRedeemedIds!: string[] | undefined;
    discounts!: string[] | undefined;
    reviewOverallAverage!: number | undefined;
    reviewCommunicationAverage!: number | undefined;
    reviewPickUpAverage!: number | undefined;
    reviewDropOffAverage!: number | undefined;
    reviewAccuracyAverage!: number | undefined;
    reviewQualityAverage!: number | undefined;
    reviewValueAverage!: number | undefined;
    reviewCount!: number;
    isVerified!: boolean;
    role!: RentMyRole;
    stripeId!: string | undefined;
    stripeCustomerId!: string | undefined;
    auth0Id!: string | undefined;
    canBeSharer!: boolean;
    stripeOnboarded!: boolean;
    signalRId!: string | undefined;
    referralCode!: ReferralSimpleDto;
    referredUsers!: ImageableIdentifierDto[] | undefined;
    flagged!: boolean;
    intention!: UserIntention;
    isBusiness!: boolean;
    isSuspended!: boolean;
    tenant!: TenantSimpleDto;
    hasBeenReferred!: boolean;

    constructor(data?: IRentMyUserSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.profileImage = data.profileImage && !(<any>data.profileImage).toJSON ? new ImageDto(data.profileImage) : <ImageDto>this.profileImage;
            this.bannerImage = data.bannerImage && !(<any>data.bannerImage).toJSON ? new ImageDto(data.bannerImage) : <ImageDto>this.bannerImage;
            this.gender = data.gender && !(<any>data.gender).toJSON ? new GenderSimpleDto(data.gender) : <GenderSimpleDto>this.gender;
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
            if (data.favouriteLocations) {
                this.favouriteLocations = [];
                for (let i = 0; i < data.favouriteLocations.length; i++) {
                    let item = data.favouriteLocations[i];
                    this.favouriteLocations[i] = item && !(<any>item).toJSON ? new Location(item) : <Location>item;
                }
            }
            if (data.favouriteItems) {
                this.favouriteItems = [];
                for (let i = 0; i < data.favouriteItems.length; i++) {
                    let item = data.favouriteItems[i];
                    this.favouriteItems[i] = item && !(<any>item).toJSON ? new MultiImageableIdentifierDto(item) : <MultiImageableIdentifierDto>item;
                }
            }
            if (data.followedUsers) {
                this.followedUsers = [];
                for (let i = 0; i < data.followedUsers.length; i++) {
                    let item = data.followedUsers[i];
                    this.followedUsers[i] = item && !(<any>item).toJSON ? new ImageableIdentifierDto(item) : <ImageableIdentifierDto>item;
                }
            }
            if (data.friends) {
                this.friends = [];
                for (let i = 0; i < data.friends.length; i++) {
                    let item = data.friends[i];
                    this.friends[i] = item && !(<any>item).toJSON ? new ImageableIdentifierDto(item) : <ImageableIdentifierDto>item;
                }
            }
            if (data.blockedUsers) {
                this.blockedUsers = [];
                for (let i = 0; i < data.blockedUsers.length; i++) {
                    let item = data.blockedUsers[i];
                    this.blockedUsers[i] = item && !(<any>item).toJSON ? new ImageableIdentifierDto(item) : <ImageableIdentifierDto>item;
                }
            }
            if (data.watchedItems) {
                this.watchedItems = [];
                for (let i = 0; i < data.watchedItems.length; i++) {
                    let item = data.watchedItems[i];
                    this.watchedItems[i] = item && !(<any>item).toJSON ? new MultiImageableIdentifierDto(item) : <MultiImageableIdentifierDto>item;
                }
            }
            this.referralCode = data.referralCode && !(<any>data.referralCode).toJSON ? new ReferralSimpleDto(data.referralCode) : <ReferralSimpleDto>this.referralCode;
            if (data.referredUsers) {
                this.referredUsers = [];
                for (let i = 0; i < data.referredUsers.length; i++) {
                    let item = data.referredUsers[i];
                    this.referredUsers[i] = item && !(<any>item).toJSON ? new ImageableIdentifierDto(item) : <ImageableIdentifierDto>item;
                }
            }
            this.tenant = data.tenant && !(<any>data.tenant).toJSON ? new TenantSimpleDto(data.tenant) : <TenantSimpleDto>this.tenant;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.aboutMe = _data["aboutMe"];
            this.joinedDate = _data["joinedDate"] ? new Date(_data["joinedDate"].toString()) : <any>undefined;
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : <any>undefined;
            this.profileImage = _data["profileImage"] ? ImageDto.fromJS(_data["profileImage"]) : <any>undefined;
            this.bannerImage = _data["bannerImage"] ? ImageDto.fromJS(_data["bannerImage"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.gender = _data["gender"] ? GenderSimpleDto.fromJS(_data["gender"]) : <any>undefined;
            this.nationalityCountry = _data["nationalityCountry"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.followingCount = _data["followingCount"];
            this.followerCount = _data["followerCount"];
            if (Array.isArray(_data["favouriteLocations"])) {
                this.favouriteLocations = [] as any;
                for (let item of _data["favouriteLocations"])
                    this.favouriteLocations!.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["favouriteItems"])) {
                this.favouriteItems = [] as any;
                for (let item of _data["favouriteItems"])
                    this.favouriteItems!.push(MultiImageableIdentifierDto.fromJS(item));
            }
            if (Array.isArray(_data["followedUsers"])) {
                this.followedUsers = [] as any;
                for (let item of _data["followedUsers"])
                    this.followedUsers!.push(ImageableIdentifierDto.fromJS(item));
            }
            if (Array.isArray(_data["friends"])) {
                this.friends = [] as any;
                for (let item of _data["friends"])
                    this.friends!.push(ImageableIdentifierDto.fromJS(item));
            }
            if (Array.isArray(_data["blockedUsers"])) {
                this.blockedUsers = [] as any;
                for (let item of _data["blockedUsers"])
                    this.blockedUsers!.push(ImageableIdentifierDto.fromJS(item));
            }
            if (Array.isArray(_data["savedSearchIds"])) {
                this.savedSearchIds = [] as any;
                for (let item of _data["savedSearchIds"])
                    this.savedSearchIds!.push(item);
            }
            if (Array.isArray(_data["watchedItems"])) {
                this.watchedItems = [] as any;
                for (let item of _data["watchedItems"])
                    this.watchedItems!.push(MultiImageableIdentifierDto.fromJS(item));
            }
            if (Array.isArray(_data["vouchersRedeemedIds"])) {
                this.vouchersRedeemedIds = [] as any;
                for (let item of _data["vouchersRedeemedIds"])
                    this.vouchersRedeemedIds!.push(item);
            }
            if (Array.isArray(_data["discounts"])) {
                this.discounts = [] as any;
                for (let item of _data["discounts"])
                    this.discounts!.push(item);
            }
            this.reviewOverallAverage = _data["reviewOverallAverage"];
            this.reviewCommunicationAverage = _data["reviewCommunicationAverage"];
            this.reviewPickUpAverage = _data["reviewPickUpAverage"];
            this.reviewDropOffAverage = _data["reviewDropOffAverage"];
            this.reviewAccuracyAverage = _data["reviewAccuracyAverage"];
            this.reviewQualityAverage = _data["reviewQualityAverage"];
            this.reviewValueAverage = _data["reviewValueAverage"];
            this.reviewCount = _data["reviewCount"];
            this.isVerified = _data["isVerified"];
            this.role = _data["role"];
            this.stripeId = _data["stripeId"];
            this.stripeCustomerId = _data["stripeCustomerId"];
            this.auth0Id = _data["auth0Id"];
            this.canBeSharer = _data["canBeSharer"];
            this.stripeOnboarded = _data["stripeOnboarded"];
            this.signalRId = _data["signalRId"];
            this.referralCode = _data["referralCode"] ? ReferralSimpleDto.fromJS(_data["referralCode"]) : <any>undefined;
            if (Array.isArray(_data["referredUsers"])) {
                this.referredUsers = [] as any;
                for (let item of _data["referredUsers"])
                    this.referredUsers!.push(ImageableIdentifierDto.fromJS(item));
            }
            this.flagged = _data["flagged"];
            this.intention = _data["intention"];
            this.isBusiness = _data["isBusiness"];
            this.isSuspended = _data["isSuspended"];
            this.tenant = _data["tenant"] ? TenantSimpleDto.fromJS(_data["tenant"]) : <any>undefined;
            this.hasBeenReferred = _data["hasBeenReferred"];
        }
    }

    static fromJS(data: any): RentMyUserSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentMyUserSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["aboutMe"] = this.aboutMe;
        data["joinedDate"] = this.joinedDate ? this.joinedDate.toISOString() : <any>undefined;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>undefined;
        data["bannerImage"] = this.bannerImage ? this.bannerImage.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["nationalityCountry"] = this.nationalityCountry;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["followingCount"] = this.followingCount;
        data["followerCount"] = this.followerCount;
        if (Array.isArray(this.favouriteLocations)) {
            data["favouriteLocations"] = [];
            for (let item of this.favouriteLocations)
                data["favouriteLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.favouriteItems)) {
            data["favouriteItems"] = [];
            for (let item of this.favouriteItems)
                data["favouriteItems"].push(item.toJSON());
        }
        if (Array.isArray(this.followedUsers)) {
            data["followedUsers"] = [];
            for (let item of this.followedUsers)
                data["followedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        if (Array.isArray(this.blockedUsers)) {
            data["blockedUsers"] = [];
            for (let item of this.blockedUsers)
                data["blockedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.savedSearchIds)) {
            data["savedSearchIds"] = [];
            for (let item of this.savedSearchIds)
                data["savedSearchIds"].push(item);
        }
        if (Array.isArray(this.watchedItems)) {
            data["watchedItems"] = [];
            for (let item of this.watchedItems)
                data["watchedItems"].push(item.toJSON());
        }
        if (Array.isArray(this.vouchersRedeemedIds)) {
            data["vouchersRedeemedIds"] = [];
            for (let item of this.vouchersRedeemedIds)
                data["vouchersRedeemedIds"].push(item);
        }
        if (Array.isArray(this.discounts)) {
            data["discounts"] = [];
            for (let item of this.discounts)
                data["discounts"].push(item);
        }
        data["reviewOverallAverage"] = this.reviewOverallAverage;
        data["reviewCommunicationAverage"] = this.reviewCommunicationAverage;
        data["reviewPickUpAverage"] = this.reviewPickUpAverage;
        data["reviewDropOffAverage"] = this.reviewDropOffAverage;
        data["reviewAccuracyAverage"] = this.reviewAccuracyAverage;
        data["reviewQualityAverage"] = this.reviewQualityAverage;
        data["reviewValueAverage"] = this.reviewValueAverage;
        data["reviewCount"] = this.reviewCount;
        data["isVerified"] = this.isVerified;
        data["role"] = this.role;
        data["stripeId"] = this.stripeId;
        data["stripeCustomerId"] = this.stripeCustomerId;
        data["auth0Id"] = this.auth0Id;
        data["canBeSharer"] = this.canBeSharer;
        data["stripeOnboarded"] = this.stripeOnboarded;
        data["signalRId"] = this.signalRId;
        data["referralCode"] = this.referralCode ? this.referralCode.toJSON() : <any>undefined;
        if (Array.isArray(this.referredUsers)) {
            data["referredUsers"] = [];
            for (let item of this.referredUsers)
                data["referredUsers"].push(item.toJSON());
        }
        data["flagged"] = this.flagged;
        data["intention"] = this.intention;
        data["isBusiness"] = this.isBusiness;
        data["isSuspended"] = this.isSuspended;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["hasBeenReferred"] = this.hasBeenReferred;
        return data;
    }
}

export interface IRentMyUserSimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    aboutMe: string | undefined;
    joinedDate: Date;
    birthdate: Date | undefined;
    profileImage: IImageDto;
    bannerImage: IImageDto;
    emailAddress: string | undefined;
    gender: IGenderSimpleDto;
    nationalityCountry: string | undefined;
    location: ILocation;
    followingCount: number | undefined;
    followerCount: number | undefined;
    favouriteLocations: ILocation[] | undefined;
    favouriteItems: IMultiImageableIdentifierDto[] | undefined;
    followedUsers: IImageableIdentifierDto[] | undefined;
    friends: IImageableIdentifierDto[] | undefined;
    blockedUsers: IImageableIdentifierDto[] | undefined;
    savedSearchIds: string[] | undefined;
    watchedItems: IMultiImageableIdentifierDto[] | undefined;
    vouchersRedeemedIds: string[] | undefined;
    discounts: string[] | undefined;
    reviewOverallAverage: number | undefined;
    reviewCommunicationAverage: number | undefined;
    reviewPickUpAverage: number | undefined;
    reviewDropOffAverage: number | undefined;
    reviewAccuracyAverage: number | undefined;
    reviewQualityAverage: number | undefined;
    reviewValueAverage: number | undefined;
    reviewCount: number;
    isVerified: boolean;
    role: RentMyRole;
    stripeId: string | undefined;
    stripeCustomerId: string | undefined;
    auth0Id: string | undefined;
    canBeSharer: boolean;
    stripeOnboarded: boolean;
    signalRId: string | undefined;
    referralCode: IReferralSimpleDto;
    referredUsers: IImageableIdentifierDto[] | undefined;
    flagged: boolean;
    intention: UserIntention;
    isBusiness: boolean;
    isSuspended: boolean;
    tenant: ITenantSimpleDto;
    hasBeenReferred: boolean;
}

export class RentMyUserSimpleDtoPaginationDto implements IRentMyUserSimpleDtoPaginationDto {
    data!: RentMyUserSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IRentMyUserSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new RentMyUserSimpleDto(item) : <RentMyUserSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RentMyUserSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): RentMyUserSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentMyUserSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IRentMyUserSimpleDtoPaginationDto {
    data: IRentMyUserSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class RentMyUserWithListingsDto implements IRentMyUserWithListingsDto {
    user!: RentMyUserDetailedDto;
    listingsCount!: number;
    totalEarnings!: number;
    rentalsCount!: number;

    constructor(data?: IRentMyUserWithListingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserDetailedDto(data.user) : <RentMyUserDetailedDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? RentMyUserDetailedDto.fromJS(_data["user"]) : <any>undefined;
            this.listingsCount = _data["listingsCount"];
            this.totalEarnings = _data["totalEarnings"];
            this.rentalsCount = _data["rentalsCount"];
        }
    }

    static fromJS(data: any): RentMyUserWithListingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentMyUserWithListingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["listingsCount"] = this.listingsCount;
        data["totalEarnings"] = this.totalEarnings;
        data["rentalsCount"] = this.rentalsCount;
        return data;
    }
}

export interface IRentMyUserWithListingsDto {
    user: IRentMyUserDetailedDto;
    listingsCount: number;
    totalEarnings: number;
    rentalsCount: number;
}

export class ReportCreateDto implements IReportCreateDto {
    active!: boolean | undefined;
    userId!: string;
    description!: string | undefined;
    reportSeverity!: number;
    reportType!: ReportType;
    reportStatus!: ReportStatus;
    objectType!: string | undefined;
    objectId!: string;

    constructor(data?: IReportCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.userId = _data["userId"];
            this.description = _data["description"];
            this.reportSeverity = _data["reportSeverity"];
            this.reportType = _data["reportType"];
            this.reportStatus = _data["reportStatus"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): ReportCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["description"] = this.description;
        data["reportSeverity"] = this.reportSeverity;
        data["reportType"] = this.reportType;
        data["reportStatus"] = this.reportStatus;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface IReportCreateDto {
    active: boolean | undefined;
    userId: string;
    description: string | undefined;
    reportSeverity: number;
    reportType: ReportType;
    reportStatus: ReportStatus;
    objectType: string | undefined;
    objectId: string;
}

export class ReportDetailedDto implements IReportDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUserSimpleDto;
    description!: string | undefined;
    reportSeverity!: number;
    reportType!: string | undefined;
    reportStatus!: string | undefined;
    objectType!: string | undefined;
    objectId!: string;
    createDate!: Date;
    staffMessages!: string | undefined;
    staffNotes!: string | undefined;

    constructor(data?: IReportDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserSimpleDto(data.user) : <RentMyUserSimpleDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUserSimpleDto.fromJS(_data["user"]) : <any>undefined;
            this.description = _data["description"];
            this.reportSeverity = _data["reportSeverity"];
            this.reportType = _data["reportType"];
            this.reportStatus = _data["reportStatus"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.staffMessages = _data["staffMessages"];
            this.staffNotes = _data["staffNotes"];
        }
    }

    static fromJS(data: any): ReportDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["reportSeverity"] = this.reportSeverity;
        data["reportType"] = this.reportType;
        data["reportStatus"] = this.reportStatus;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["staffMessages"] = this.staffMessages;
        data["staffNotes"] = this.staffNotes;
        return data;
    }
}

export interface IReportDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUserSimpleDto;
    description: string | undefined;
    reportSeverity: number;
    reportType: string | undefined;
    reportStatus: string | undefined;
    objectType: string | undefined;
    objectId: string;
    createDate: Date;
    staffMessages: string | undefined;
    staffNotes: string | undefined;
}

export class ReportDetailedDtoPaginationDto implements IReportDetailedDtoPaginationDto {
    data!: ReportDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IReportDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ReportDetailedDto(item) : <ReportDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReportDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ReportDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IReportDetailedDtoPaginationDto {
    data: IReportDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ReportDetailedDtoUpdateResponseDto implements IReportDetailedDtoUpdateResponseDto {
    data!: ReportDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IReportDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new ReportDetailedDto(data.data) : <ReportDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ReportDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): ReportDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IReportDetailedDtoUpdateResponseDto {
    data: IReportDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class ReportPublicDetailedDto implements IReportPublicDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUserSimpleDto;
    description!: string | undefined;
    reportSeverity!: number;
    reportType!: string | undefined;
    reportStatus!: string | undefined;
    objectType!: string | undefined;
    objectId!: string;
    createDate!: Date;
    staffMessages!: string | undefined;

    constructor(data?: IReportPublicDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserSimpleDto(data.user) : <RentMyUserSimpleDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUserSimpleDto.fromJS(_data["user"]) : <any>undefined;
            this.description = _data["description"];
            this.reportSeverity = _data["reportSeverity"];
            this.reportType = _data["reportType"];
            this.reportStatus = _data["reportStatus"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.staffMessages = _data["staffMessages"];
        }
    }

    static fromJS(data: any): ReportPublicDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPublicDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["reportSeverity"] = this.reportSeverity;
        data["reportType"] = this.reportType;
        data["reportStatus"] = this.reportStatus;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["staffMessages"] = this.staffMessages;
        return data;
    }
}

export interface IReportPublicDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUserSimpleDto;
    description: string | undefined;
    reportSeverity: number;
    reportType: string | undefined;
    reportStatus: string | undefined;
    objectType: string | undefined;
    objectId: string;
    createDate: Date;
    staffMessages: string | undefined;
}

export class ReportPublicDetailedDtoPaginationDto implements IReportPublicDetailedDtoPaginationDto {
    data!: ReportPublicDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IReportPublicDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ReportPublicDetailedDto(item) : <ReportPublicDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReportPublicDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ReportPublicDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPublicDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IReportPublicDetailedDtoPaginationDto {
    data: IReportPublicDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ReportPublicSimpleDto implements IReportPublicSimpleDto {
    id!: string;
    active!: boolean;
    userId!: string;
    description!: string | undefined;
    reportSeverity!: number;
    reportType!: string | undefined;
    reportStatus!: string | undefined;
    objectType!: string | undefined;
    objectId!: string;
    createDate!: Date;
    staffMessages!: string | undefined;

    constructor(data?: IReportPublicSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.userId = _data["userId"];
            this.description = _data["description"];
            this.reportSeverity = _data["reportSeverity"];
            this.reportType = _data["reportType"];
            this.reportStatus = _data["reportStatus"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.staffMessages = _data["staffMessages"];
        }
    }

    static fromJS(data: any): ReportPublicSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPublicSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["description"] = this.description;
        data["reportSeverity"] = this.reportSeverity;
        data["reportType"] = this.reportType;
        data["reportStatus"] = this.reportStatus;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["staffMessages"] = this.staffMessages;
        return data;
    }
}

export interface IReportPublicSimpleDto {
    id: string;
    active: boolean;
    userId: string;
    description: string | undefined;
    reportSeverity: number;
    reportType: string | undefined;
    reportStatus: string | undefined;
    objectType: string | undefined;
    objectId: string;
    createDate: Date;
    staffMessages: string | undefined;
}

export class ReportPublicSimpleDtoPaginationDto implements IReportPublicSimpleDtoPaginationDto {
    data!: ReportPublicSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IReportPublicSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ReportPublicSimpleDto(item) : <ReportPublicSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReportPublicSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ReportPublicSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPublicSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IReportPublicSimpleDtoPaginationDto {
    data: IReportPublicSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ReportSimpleDto implements IReportSimpleDto {
    id!: string;
    active!: boolean;
    userId!: string;
    description!: string | undefined;
    reportSeverity!: number;
    reportType!: string | undefined;
    reportStatus!: string | undefined;
    objectType!: string | undefined;
    objectId!: string;
    createDate!: Date;
    staffMessages!: string | undefined;
    staffNotes!: string | undefined;

    constructor(data?: IReportSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.userId = _data["userId"];
            this.description = _data["description"];
            this.reportSeverity = _data["reportSeverity"];
            this.reportType = _data["reportType"];
            this.reportStatus = _data["reportStatus"];
            this.objectType = _data["objectType"];
            this.objectId = _data["objectId"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.staffMessages = _data["staffMessages"];
            this.staffNotes = _data["staffNotes"];
        }
    }

    static fromJS(data: any): ReportSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["description"] = this.description;
        data["reportSeverity"] = this.reportSeverity;
        data["reportType"] = this.reportType;
        data["reportStatus"] = this.reportStatus;
        data["objectType"] = this.objectType;
        data["objectId"] = this.objectId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["staffMessages"] = this.staffMessages;
        data["staffNotes"] = this.staffNotes;
        return data;
    }
}

export interface IReportSimpleDto {
    id: string;
    active: boolean;
    userId: string;
    description: string | undefined;
    reportSeverity: number;
    reportType: string | undefined;
    reportStatus: string | undefined;
    objectType: string | undefined;
    objectId: string;
    createDate: Date;
    staffMessages: string | undefined;
    staffNotes: string | undefined;
}

export class ReportSimpleDtoPaginationDto implements IReportSimpleDtoPaginationDto {
    data!: ReportSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IReportSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ReportSimpleDto(item) : <ReportSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReportSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ReportSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IReportSimpleDtoPaginationDto {
    data: IReportSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum ReportStatus {
    Created = "Created",
    UnderReview = "UnderReview",
    Completed = "Completed",
}

export enum ReportType {
    Harassment = "Harassment",
    Dispute = "Dispute",
    InnappropriateContent = "InnappropriateContent",
    Scam = "Scam",
    Spam = "Spam",
}

export class ReviewCreateDto implements IReviewCreateDto {
    active!: boolean | undefined;
    description!: string | undefined;
    communicationRating!: number;
    pickUpRating!: number;
    dropOffRating!: number;
    accuracyRating!: number;
    qualityRating!: number;
    valueRating!: number;
    imageIds!: string[] | undefined;
    videoIds!: string[] | undefined;

    constructor(data?: IReviewCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.description = _data["description"];
            this.communicationRating = _data["communicationRating"];
            this.pickUpRating = _data["pickUpRating"];
            this.dropOffRating = _data["dropOffRating"];
            this.accuracyRating = _data["accuracyRating"];
            this.qualityRating = _data["qualityRating"];
            this.valueRating = _data["valueRating"];
            if (Array.isArray(_data["imageIds"])) {
                this.imageIds = [] as any;
                for (let item of _data["imageIds"])
                    this.imageIds!.push(item);
            }
            if (Array.isArray(_data["videoIds"])) {
                this.videoIds = [] as any;
                for (let item of _data["videoIds"])
                    this.videoIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ReviewCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["description"] = this.description;
        data["communicationRating"] = this.communicationRating;
        data["pickUpRating"] = this.pickUpRating;
        data["dropOffRating"] = this.dropOffRating;
        data["accuracyRating"] = this.accuracyRating;
        data["qualityRating"] = this.qualityRating;
        data["valueRating"] = this.valueRating;
        if (Array.isArray(this.imageIds)) {
            data["imageIds"] = [];
            for (let item of this.imageIds)
                data["imageIds"].push(item);
        }
        if (Array.isArray(this.videoIds)) {
            data["videoIds"] = [];
            for (let item of this.videoIds)
                data["videoIds"].push(item);
        }
        return data;
    }
}

export interface IReviewCreateDto {
    active: boolean | undefined;
    description: string | undefined;
    communicationRating: number;
    pickUpRating: number;
    dropOffRating: number;
    accuracyRating: number;
    qualityRating: number;
    valueRating: number;
    imageIds: string[] | undefined;
    videoIds: string[] | undefined;
}

export class ReviewDetailedDto implements IReviewDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    reviewer!: RentMyUserPublicSimpleDto;
    item!: ItemSimpleDto;
    description!: string | undefined;
    communicationRating!: number;
    pickUpRating!: number;
    dropOffRating!: number;
    accuracyRating!: number;
    qualityRating!: number;
    valueRating!: number;
    images!: ImageDto[] | undefined;
    videos!: VideoDto[] | undefined;

    constructor(data?: IReviewDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.reviewer = data.reviewer && !(<any>data.reviewer).toJSON ? new RentMyUserPublicSimpleDto(data.reviewer) : <RentMyUserPublicSimpleDto>this.reviewer;
            this.item = data.item && !(<any>data.item).toJSON ? new ItemSimpleDto(data.item) : <ItemSimpleDto>this.item;
            if (data.images) {
                this.images = [];
                for (let i = 0; i < data.images.length; i++) {
                    let item = data.images[i];
                    this.images[i] = item && !(<any>item).toJSON ? new ImageDto(item) : <ImageDto>item;
                }
            }
            if (data.videos) {
                this.videos = [];
                for (let i = 0; i < data.videos.length; i++) {
                    let item = data.videos[i];
                    this.videos[i] = item && !(<any>item).toJSON ? new VideoDto(item) : <VideoDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.reviewer = _data["reviewer"] ? RentMyUserPublicSimpleDto.fromJS(_data["reviewer"]) : <any>undefined;
            this.item = _data["item"] ? ItemSimpleDto.fromJS(_data["item"]) : <any>undefined;
            this.description = _data["description"];
            this.communicationRating = _data["communicationRating"];
            this.pickUpRating = _data["pickUpRating"];
            this.dropOffRating = _data["dropOffRating"];
            this.accuracyRating = _data["accuracyRating"];
            this.qualityRating = _data["qualityRating"];
            this.valueRating = _data["valueRating"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(VideoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReviewDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["reviewer"] = this.reviewer ? this.reviewer.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["communicationRating"] = this.communicationRating;
        data["pickUpRating"] = this.pickUpRating;
        data["dropOffRating"] = this.dropOffRating;
        data["accuracyRating"] = this.accuracyRating;
        data["qualityRating"] = this.qualityRating;
        data["valueRating"] = this.valueRating;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReviewDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    reviewer: IRentMyUserPublicSimpleDto;
    item: IItemSimpleDto;
    description: string | undefined;
    communicationRating: number;
    pickUpRating: number;
    dropOffRating: number;
    accuracyRating: number;
    qualityRating: number;
    valueRating: number;
    images: IImageDto[] | undefined;
    videos: IVideoDto[] | undefined;
}

export class ReviewDetailedDtoPaginationDto implements IReviewDetailedDtoPaginationDto {
    data!: ReviewDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IReviewDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ReviewDetailedDto(item) : <ReviewDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReviewDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ReviewDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IReviewDetailedDtoPaginationDto {
    data: IReviewDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ReviewDetailedDtoUpdateResponseDto implements IReviewDetailedDtoUpdateResponseDto {
    data!: ReviewDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IReviewDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new ReviewDetailedDto(data.data) : <ReviewDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ReviewDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): ReviewDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IReviewDetailedDtoUpdateResponseDto {
    data: IReviewDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class ReviewSimpleDto implements IReviewSimpleDto {
    id!: string;
    active!: boolean;
    reviewerId!: string;
    itemId!: string;
    description!: string | undefined;
    communicationRating!: number;
    pickUpRating!: number;
    dropOffRating!: number;
    accuracyRating!: number;
    qualityRating!: number;
    valueRating!: number;
    images!: ImageDto[] | undefined;
    videos!: VideoDto[] | undefined;

    constructor(data?: IReviewSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.images) {
                this.images = [];
                for (let i = 0; i < data.images.length; i++) {
                    let item = data.images[i];
                    this.images[i] = item && !(<any>item).toJSON ? new ImageDto(item) : <ImageDto>item;
                }
            }
            if (data.videos) {
                this.videos = [];
                for (let i = 0; i < data.videos.length; i++) {
                    let item = data.videos[i];
                    this.videos[i] = item && !(<any>item).toJSON ? new VideoDto(item) : <VideoDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.reviewerId = _data["reviewerId"];
            this.itemId = _data["itemId"];
            this.description = _data["description"];
            this.communicationRating = _data["communicationRating"];
            this.pickUpRating = _data["pickUpRating"];
            this.dropOffRating = _data["dropOffRating"];
            this.accuracyRating = _data["accuracyRating"];
            this.qualityRating = _data["qualityRating"];
            this.valueRating = _data["valueRating"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(VideoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReviewSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["reviewerId"] = this.reviewerId;
        data["itemId"] = this.itemId;
        data["description"] = this.description;
        data["communicationRating"] = this.communicationRating;
        data["pickUpRating"] = this.pickUpRating;
        data["dropOffRating"] = this.dropOffRating;
        data["accuracyRating"] = this.accuracyRating;
        data["qualityRating"] = this.qualityRating;
        data["valueRating"] = this.valueRating;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReviewSimpleDto {
    id: string;
    active: boolean;
    reviewerId: string;
    itemId: string;
    description: string | undefined;
    communicationRating: number;
    pickUpRating: number;
    dropOffRating: number;
    accuracyRating: number;
    qualityRating: number;
    valueRating: number;
    images: IImageDto[] | undefined;
    videos: IVideoDto[] | undefined;
}

export class ReviewSimpleDtoPaginationDto implements IReviewSimpleDtoPaginationDto {
    data!: ReviewSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IReviewSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ReviewSimpleDto(item) : <ReviewSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReviewSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ReviewSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IReviewSimpleDtoPaginationDto {
    data: IReviewSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class ReviewViewDto implements IReviewViewDto {
    id!: string;
    overallAverage!: number | undefined;
    communicationAverage!: number | undefined;
    pickUpAverage!: number | undefined;
    dropOffAverage!: number | undefined;
    accuracyAverage!: number | undefined;
    qualityAverage!: number | undefined;
    valueAverage!: number | undefined;
    reviewCount!: number;
    reviews!: ReviewSimpleDto[] | undefined;

    constructor(data?: IReviewViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.reviews) {
                this.reviews = [];
                for (let i = 0; i < data.reviews.length; i++) {
                    let item = data.reviews[i];
                    this.reviews[i] = item && !(<any>item).toJSON ? new ReviewSimpleDto(item) : <ReviewSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.overallAverage = _data["overallAverage"];
            this.communicationAverage = _data["communicationAverage"];
            this.pickUpAverage = _data["pickUpAverage"];
            this.dropOffAverage = _data["dropOffAverage"];
            this.accuracyAverage = _data["accuracyAverage"];
            this.qualityAverage = _data["qualityAverage"];
            this.valueAverage = _data["valueAverage"];
            this.reviewCount = _data["reviewCount"];
            if (Array.isArray(_data["reviews"])) {
                this.reviews = [] as any;
                for (let item of _data["reviews"])
                    this.reviews!.push(ReviewSimpleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReviewViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["overallAverage"] = this.overallAverage;
        data["communicationAverage"] = this.communicationAverage;
        data["pickUpAverage"] = this.pickUpAverage;
        data["dropOffAverage"] = this.dropOffAverage;
        data["accuracyAverage"] = this.accuracyAverage;
        data["qualityAverage"] = this.qualityAverage;
        data["valueAverage"] = this.valueAverage;
        data["reviewCount"] = this.reviewCount;
        if (Array.isArray(this.reviews)) {
            data["reviews"] = [];
            for (let item of this.reviews)
                data["reviews"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReviewViewDto {
    id: string;
    overallAverage: number | undefined;
    communicationAverage: number | undefined;
    pickUpAverage: number | undefined;
    dropOffAverage: number | undefined;
    accuracyAverage: number | undefined;
    qualityAverage: number | undefined;
    valueAverage: number | undefined;
    reviewCount: number;
    reviews: IReviewSimpleDto[] | undefined;
}

export class SarBookingsDto implements ISarBookingsDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    itemName!: string | undefined;
    paymentAmount!: number;
    applicationFeeAmount!: number;
    bookingStatus!: BookingStatus;
    paymentStatus!: PaymentStatus;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    endDateWithTurnAround!: Date | undefined;
    handOverAgreement!: Agreement;
    completionAgreement!: Agreement;
    pickUpImages!: string[] | undefined;
    dropOffImages!: string[] | undefined;

    constructor(data?: ISarBookingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.handOverAgreement = data.handOverAgreement && !(<any>data.handOverAgreement).toJSON ? new Agreement(data.handOverAgreement) : <Agreement>this.handOverAgreement;
            this.completionAgreement = data.completionAgreement && !(<any>data.completionAgreement).toJSON ? new Agreement(data.completionAgreement) : <Agreement>this.completionAgreement;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.itemName = _data["itemName"];
            this.paymentAmount = _data["paymentAmount"];
            this.applicationFeeAmount = _data["applicationFeeAmount"];
            this.bookingStatus = _data["bookingStatus"];
            this.paymentStatus = _data["paymentStatus"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.endDateWithTurnAround = _data["endDateWithTurnAround"] ? new Date(_data["endDateWithTurnAround"].toString()) : <any>undefined;
            this.handOverAgreement = _data["handOverAgreement"] ? Agreement.fromJS(_data["handOverAgreement"]) : <any>undefined;
            this.completionAgreement = _data["completionAgreement"] ? Agreement.fromJS(_data["completionAgreement"]) : <any>undefined;
            if (Array.isArray(_data["pickUpImages"])) {
                this.pickUpImages = [] as any;
                for (let item of _data["pickUpImages"])
                    this.pickUpImages!.push(item);
            }
            if (Array.isArray(_data["dropOffImages"])) {
                this.dropOffImages = [] as any;
                for (let item of _data["dropOffImages"])
                    this.dropOffImages!.push(item);
            }
        }
    }

    static fromJS(data: any): SarBookingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SarBookingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["itemName"] = this.itemName;
        data["paymentAmount"] = this.paymentAmount;
        data["applicationFeeAmount"] = this.applicationFeeAmount;
        data["bookingStatus"] = this.bookingStatus;
        data["paymentStatus"] = this.paymentStatus;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["endDateWithTurnAround"] = this.endDateWithTurnAround ? this.endDateWithTurnAround.toISOString() : <any>undefined;
        data["handOverAgreement"] = this.handOverAgreement ? this.handOverAgreement.toJSON() : <any>undefined;
        data["completionAgreement"] = this.completionAgreement ? this.completionAgreement.toJSON() : <any>undefined;
        if (Array.isArray(this.pickUpImages)) {
            data["pickUpImages"] = [];
            for (let item of this.pickUpImages)
                data["pickUpImages"].push(item);
        }
        if (Array.isArray(this.dropOffImages)) {
            data["dropOffImages"] = [];
            for (let item of this.dropOffImages)
                data["dropOffImages"].push(item);
        }
        return data;
    }
}

export interface ISarBookingsDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    itemName: string | undefined;
    paymentAmount: number;
    applicationFeeAmount: number;
    bookingStatus: BookingStatus;
    paymentStatus: PaymentStatus;
    startDate: Date | undefined;
    endDate: Date | undefined;
    endDateWithTurnAround: Date | undefined;
    handOverAgreement: IAgreement;
    completionAgreement: IAgreement;
    pickUpImages: string[] | undefined;
    dropOffImages: string[] | undefined;
}

export class SarItemDto implements ISarItemDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    description!: string | undefined;
    quantity!: number;
    originalValue!: number | undefined;
    itemValue!: number | undefined;
    purchaseDate!: Date | undefined;
    requiresTraining!: boolean;
    requiresPpe!: boolean;
    isPublished!: boolean;
    isActive!: boolean;
    instantBooking!: boolean;
    extensionLimitDays!: number | undefined;
    extensionLimitHours!: number | undefined;
    minimumHandOverImages!: number | undefined;
    overallAverage!: number | undefined;
    communicationAverage!: number | undefined;
    pickUpAverage!: number | undefined;
    dropOffAverage!: number | undefined;
    accuracyAverage!: number | undefined;
    qualityAverage!: number | undefined;
    valueAverage!: number | undefined;
    reviewCount!: number;
    locations!: Location[] | undefined;
    images!: string[] | undefined;

    constructor(data?: ISarItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.locations) {
                this.locations = [];
                for (let i = 0; i < data.locations.length; i++) {
                    let item = data.locations[i];
                    this.locations[i] = item && !(<any>item).toJSON ? new Location(item) : <Location>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.originalValue = _data["originalValue"];
            this.itemValue = _data["itemValue"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.requiresTraining = _data["requiresTraining"];
            this.requiresPpe = _data["requiresPpe"];
            this.isPublished = _data["isPublished"];
            this.isActive = _data["isActive"];
            this.instantBooking = _data["instantBooking"];
            this.extensionLimitDays = _data["extensionLimitDays"];
            this.extensionLimitHours = _data["extensionLimitHours"];
            this.minimumHandOverImages = _data["minimumHandOverImages"];
            this.overallAverage = _data["overallAverage"];
            this.communicationAverage = _data["communicationAverage"];
            this.pickUpAverage = _data["pickUpAverage"];
            this.dropOffAverage = _data["dropOffAverage"];
            this.accuracyAverage = _data["accuracyAverage"];
            this.qualityAverage = _data["qualityAverage"];
            this.valueAverage = _data["valueAverage"];
            this.reviewCount = _data["reviewCount"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
        }
    }

    static fromJS(data: any): SarItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SarItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["originalValue"] = this.originalValue;
        data["itemValue"] = this.itemValue;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["requiresTraining"] = this.requiresTraining;
        data["requiresPpe"] = this.requiresPpe;
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["instantBooking"] = this.instantBooking;
        data["extensionLimitDays"] = this.extensionLimitDays;
        data["extensionLimitHours"] = this.extensionLimitHours;
        data["minimumHandOverImages"] = this.minimumHandOverImages;
        data["overallAverage"] = this.overallAverage;
        data["communicationAverage"] = this.communicationAverage;
        data["pickUpAverage"] = this.pickUpAverage;
        data["dropOffAverage"] = this.dropOffAverage;
        data["accuracyAverage"] = this.accuracyAverage;
        data["qualityAverage"] = this.qualityAverage;
        data["valueAverage"] = this.valueAverage;
        data["reviewCount"] = this.reviewCount;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        return data;
    }
}

export interface ISarItemDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    originalValue: number | undefined;
    itemValue: number | undefined;
    purchaseDate: Date | undefined;
    requiresTraining: boolean;
    requiresPpe: boolean;
    isPublished: boolean;
    isActive: boolean;
    instantBooking: boolean;
    extensionLimitDays: number | undefined;
    extensionLimitHours: number | undefined;
    minimumHandOverImages: number | undefined;
    overallAverage: number | undefined;
    communicationAverage: number | undefined;
    pickUpAverage: number | undefined;
    dropOffAverage: number | undefined;
    accuracyAverage: number | undefined;
    qualityAverage: number | undefined;
    valueAverage: number | undefined;
    reviewCount: number;
    locations: ILocation[] | undefined;
    images: string[] | undefined;
}

export class SarMessagesDto implements ISarMessagesDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    subject!: string | undefined;
    content!: string | undefined;
    dateSent!: Date;
    dateReceived!: Date | undefined;
    dateRead!: Date | undefined;

    constructor(data?: ISarMessagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.dateSent = _data["dateSent"] ? new Date(_data["dateSent"].toString()) : <any>undefined;
            this.dateReceived = _data["dateReceived"] ? new Date(_data["dateReceived"].toString()) : <any>undefined;
            this.dateRead = _data["dateRead"] ? new Date(_data["dateRead"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SarMessagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SarMessagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["dateSent"] = this.dateSent ? this.dateSent.toISOString() : <any>undefined;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        data["dateRead"] = this.dateRead ? this.dateRead.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISarMessagesDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    subject: string | undefined;
    content: string | undefined;
    dateSent: Date;
    dateReceived: Date | undefined;
    dateRead: Date | undefined;
}

export class SarReviewsDto implements ISarReviewsDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    item!: SarItemDto;
    description!: string | undefined;
    communicationRating!: number;
    pickUpRating!: number;
    dropOffRating!: number;
    accuracyRating!: number;
    qualityRating!: number;
    valueRating!: number;
    images!: string[] | undefined;

    constructor(data?: ISarReviewsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.item = data.item && !(<any>data.item).toJSON ? new SarItemDto(data.item) : <SarItemDto>this.item;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.item = _data["item"] ? SarItemDto.fromJS(_data["item"]) : <any>undefined;
            this.description = _data["description"];
            this.communicationRating = _data["communicationRating"];
            this.pickUpRating = _data["pickUpRating"];
            this.dropOffRating = _data["dropOffRating"];
            this.accuracyRating = _data["accuracyRating"];
            this.qualityRating = _data["qualityRating"];
            this.valueRating = _data["valueRating"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
        }
    }

    static fromJS(data: any): SarReviewsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SarReviewsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["communicationRating"] = this.communicationRating;
        data["pickUpRating"] = this.pickUpRating;
        data["dropOffRating"] = this.dropOffRating;
        data["accuracyRating"] = this.accuracyRating;
        data["qualityRating"] = this.qualityRating;
        data["valueRating"] = this.valueRating;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        return data;
    }
}

export interface ISarReviewsDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    item: ISarItemDto;
    description: string | undefined;
    communicationRating: number;
    pickUpRating: number;
    dropOffRating: number;
    accuracyRating: number;
    qualityRating: number;
    valueRating: number;
    images: string[] | undefined;
}

export class SarTransactionDto implements ISarTransactionDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    item!: ItemSimpleDto;
    amountPaid!: number;
    dateOfPayment!: Date;

    constructor(data?: ISarTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.item = data.item && !(<any>data.item).toJSON ? new ItemSimpleDto(data.item) : <ItemSimpleDto>this.item;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.item = _data["item"] ? ItemSimpleDto.fromJS(_data["item"]) : <any>undefined;
            this.amountPaid = _data["amountPaid"];
            this.dateOfPayment = _data["dateOfPayment"] ? new Date(_data["dateOfPayment"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SarTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SarTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["amountPaid"] = this.amountPaid;
        data["dateOfPayment"] = this.dateOfPayment ? this.dateOfPayment.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISarTransactionDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    item: IItemSimpleDto;
    amountPaid: number;
    dateOfPayment: Date;
}

export class SarUserActivityDto implements ISarUserActivityDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: SarUserDto;
    items!: SarItemDto[] | undefined;
    messages!: SarMessagesDto[] | undefined;
    transactions!: SarTransactionDto[] | undefined;
    reviews!: SarReviewsDto[] | undefined;
    bookings!: SarBookingsDto[] | undefined;

    constructor(data?: ISarUserActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new SarUserDto(data.user) : <SarUserDto>this.user;
            if (data.items) {
                this.items = [];
                for (let i = 0; i < data.items.length; i++) {
                    let item = data.items[i];
                    this.items[i] = item && !(<any>item).toJSON ? new SarItemDto(item) : <SarItemDto>item;
                }
            }
            if (data.messages) {
                this.messages = [];
                for (let i = 0; i < data.messages.length; i++) {
                    let item = data.messages[i];
                    this.messages[i] = item && !(<any>item).toJSON ? new SarMessagesDto(item) : <SarMessagesDto>item;
                }
            }
            if (data.transactions) {
                this.transactions = [];
                for (let i = 0; i < data.transactions.length; i++) {
                    let item = data.transactions[i];
                    this.transactions[i] = item && !(<any>item).toJSON ? new SarTransactionDto(item) : <SarTransactionDto>item;
                }
            }
            if (data.reviews) {
                this.reviews = [];
                for (let i = 0; i < data.reviews.length; i++) {
                    let item = data.reviews[i];
                    this.reviews[i] = item && !(<any>item).toJSON ? new SarReviewsDto(item) : <SarReviewsDto>item;
                }
            }
            if (data.bookings) {
                this.bookings = [];
                for (let i = 0; i < data.bookings.length; i++) {
                    let item = data.bookings[i];
                    this.bookings[i] = item && !(<any>item).toJSON ? new SarBookingsDto(item) : <SarBookingsDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? SarUserDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SarItemDto.fromJS(item));
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(SarMessagesDto.fromJS(item));
            }
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(SarTransactionDto.fromJS(item));
            }
            if (Array.isArray(_data["reviews"])) {
                this.reviews = [] as any;
                for (let item of _data["reviews"])
                    this.reviews!.push(SarReviewsDto.fromJS(item));
            }
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(SarBookingsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SarUserActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SarUserActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        if (Array.isArray(this.reviews)) {
            data["reviews"] = [];
            for (let item of this.reviews)
                data["reviews"].push(item.toJSON());
        }
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISarUserActivityDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: ISarUserDto;
    items: ISarItemDto[] | undefined;
    messages: ISarMessagesDto[] | undefined;
    transactions: ISarTransactionDto[] | undefined;
    reviews: ISarReviewsDto[] | undefined;
    bookings: ISarBookingsDto[] | undefined;
}

export class SarUserDto implements ISarUserDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    phoneNumber!: string | undefined;
    aboutMe!: string | undefined;
    joinedDate!: Date;
    profileImage!: string | undefined;
    bannerImage!: string | undefined;
    emailAddress!: string | undefined;
    gender!: string | undefined;
    nationalityCountry!: string | undefined;
    location!: Location;
    followingCount!: number | undefined;
    followerCount!: number | undefined;
    reviewOverallAverage!: number | undefined;
    reviewCommunicationAverage!: number | undefined;
    reviewPickUpAverage!: number | undefined;
    reviewDropOffAverage!: number | undefined;
    reviewAccuracyAverage!: number | undefined;
    reviewQualityAverage!: number | undefined;
    reviewValueAverage!: number | undefined;
    reviewCount!: number;
    isVerified!: boolean;
    website!: string | undefined;
    instagramUserName!: string | undefined;
    instagramUrl!: string | undefined;
    facebookUserName!: string | undefined;
    facebookUrl!: string | undefined;
    twitterUserName!: string | undefined;
    twitterUrl!: string | undefined;
    youtubeUserName!: string | undefined;
    youtubeUrl!: string | undefined;

    constructor(data?: ISarUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.aboutMe = _data["aboutMe"];
            this.joinedDate = _data["joinedDate"] ? new Date(_data["joinedDate"].toString()) : <any>undefined;
            this.profileImage = _data["profileImage"];
            this.bannerImage = _data["bannerImage"];
            this.emailAddress = _data["emailAddress"];
            this.gender = _data["gender"];
            this.nationalityCountry = _data["nationalityCountry"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.followingCount = _data["followingCount"];
            this.followerCount = _data["followerCount"];
            this.reviewOverallAverage = _data["reviewOverallAverage"];
            this.reviewCommunicationAverage = _data["reviewCommunicationAverage"];
            this.reviewPickUpAverage = _data["reviewPickUpAverage"];
            this.reviewDropOffAverage = _data["reviewDropOffAverage"];
            this.reviewAccuracyAverage = _data["reviewAccuracyAverage"];
            this.reviewQualityAverage = _data["reviewQualityAverage"];
            this.reviewValueAverage = _data["reviewValueAverage"];
            this.reviewCount = _data["reviewCount"];
            this.isVerified = _data["isVerified"];
            this.website = _data["website"];
            this.instagramUserName = _data["instagramUserName"];
            this.instagramUrl = _data["instagramUrl"];
            this.facebookUserName = _data["facebookUserName"];
            this.facebookUrl = _data["facebookUrl"];
            this.twitterUserName = _data["twitterUserName"];
            this.twitterUrl = _data["twitterUrl"];
            this.youtubeUserName = _data["youtubeUserName"];
            this.youtubeUrl = _data["youtubeUrl"];
        }
    }

    static fromJS(data: any): SarUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new SarUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["aboutMe"] = this.aboutMe;
        data["joinedDate"] = this.joinedDate ? this.joinedDate.toISOString() : <any>undefined;
        data["profileImage"] = this.profileImage;
        data["bannerImage"] = this.bannerImage;
        data["emailAddress"] = this.emailAddress;
        data["gender"] = this.gender;
        data["nationalityCountry"] = this.nationalityCountry;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["followingCount"] = this.followingCount;
        data["followerCount"] = this.followerCount;
        data["reviewOverallAverage"] = this.reviewOverallAverage;
        data["reviewCommunicationAverage"] = this.reviewCommunicationAverage;
        data["reviewPickUpAverage"] = this.reviewPickUpAverage;
        data["reviewDropOffAverage"] = this.reviewDropOffAverage;
        data["reviewAccuracyAverage"] = this.reviewAccuracyAverage;
        data["reviewQualityAverage"] = this.reviewQualityAverage;
        data["reviewValueAverage"] = this.reviewValueAverage;
        data["reviewCount"] = this.reviewCount;
        data["isVerified"] = this.isVerified;
        data["website"] = this.website;
        data["instagramUserName"] = this.instagramUserName;
        data["instagramUrl"] = this.instagramUrl;
        data["facebookUserName"] = this.facebookUserName;
        data["facebookUrl"] = this.facebookUrl;
        data["twitterUserName"] = this.twitterUserName;
        data["twitterUrl"] = this.twitterUrl;
        data["youtubeUserName"] = this.youtubeUserName;
        data["youtubeUrl"] = this.youtubeUrl;
        return data;
    }
}

export interface ISarUserDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    aboutMe: string | undefined;
    joinedDate: Date;
    profileImage: string | undefined;
    bannerImage: string | undefined;
    emailAddress: string | undefined;
    gender: string | undefined;
    nationalityCountry: string | undefined;
    location: ILocation;
    followingCount: number | undefined;
    followerCount: number | undefined;
    reviewOverallAverage: number | undefined;
    reviewCommunicationAverage: number | undefined;
    reviewPickUpAverage: number | undefined;
    reviewDropOffAverage: number | undefined;
    reviewAccuracyAverage: number | undefined;
    reviewQualityAverage: number | undefined;
    reviewValueAverage: number | undefined;
    reviewCount: number;
    isVerified: boolean;
    website: string | undefined;
    instagramUserName: string | undefined;
    instagramUrl: string | undefined;
    facebookUserName: string | undefined;
    facebookUrl: string | undefined;
    twitterUserName: string | undefined;
    twitterUrl: string | undefined;
    youtubeUserName: string | undefined;
    youtubeUrl: string | undefined;
}

export class SavedSearch implements ISavedSearch {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUser;
    categories!: Category[] | undefined;
    search!: string;

    constructor(data?: ISavedSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
            if (data.categories) {
                this.categories = [];
                for (let i = 0; i < data.categories.length; i++) {
                    let item = data.categories[i];
                    this.categories[i] = item && !(<any>item).toJSON ? new Category(item) : <Category>item;
                }
            }
        }
        if (!data) {
            this.user = new RentMyUser();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : new RentMyUser();
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(Category.fromJS(item));
            }
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): SavedSearch {
        data = typeof data === 'object' ? data : {};
        let result = new SavedSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["search"] = this.search;
        return data;
    }
}

export interface ISavedSearch {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUser;
    categories: ICategory[] | undefined;
    search: string;
}

export class SavedSearchCreateDto implements ISavedSearchCreateDto {
    active!: boolean | undefined;
    categoryIds!: string[] | undefined;
    search!: string | undefined;

    constructor(data?: ISavedSearchCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): SavedSearchCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SavedSearchCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["search"] = this.search;
        return data;
    }
}

export interface ISavedSearchCreateDto {
    active: boolean | undefined;
    categoryIds: string[] | undefined;
    search: string | undefined;
}

export class SavedSearchSimpleDto implements ISavedSearchSimpleDto {
    id!: string;
    active!: boolean;
    userId!: string;
    categoryIds!: string[] | undefined;
    search!: string | undefined;

    constructor(data?: ISavedSearchSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): SavedSearchSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SavedSearchSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["userId"] = this.userId;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["search"] = this.search;
        return data;
    }
}

export interface ISavedSearchSimpleDto {
    id: string;
    active: boolean;
    userId: string;
    categoryIds: string[] | undefined;
    search: string | undefined;
}

export class SearchLogPublicSimpleDto implements ISearchLogPublicSimpleDto {
    id!: string;
    active!: boolean;
    searchTerms!: string | undefined;
    dateTime!: Date | undefined;
    location!: string | undefined;
    categoryName!: string | undefined;

    constructor(data?: ISearchLogPublicSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.searchTerms = _data["searchTerms"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): SearchLogPublicSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLogPublicSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["searchTerms"] = this.searchTerms;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["categoryName"] = this.categoryName;
        return data;
    }
}

export interface ISearchLogPublicSimpleDto {
    id: string;
    active: boolean;
    searchTerms: string | undefined;
    dateTime: Date | undefined;
    location: string | undefined;
    categoryName: string | undefined;
}

export class SearchLogSimpleDto implements ISearchLogSimpleDto {
    id!: string;
    active!: boolean;
    searchTerms!: string | undefined;
    dateTime!: Date | undefined;
    location!: string | undefined;
    categoryName!: string | undefined;

    constructor(data?: ISearchLogSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.searchTerms = _data["searchTerms"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): SearchLogSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLogSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["searchTerms"] = this.searchTerms;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["categoryName"] = this.categoryName;
        return data;
    }
}

export interface ISearchLogSimpleDto {
    id: string;
    active: boolean;
    searchTerms: string | undefined;
    dateTime: Date | undefined;
    location: string | undefined;
    categoryName: string | undefined;
}

export class SearchLogSimpleDtoPaginationDto implements ISearchLogSimpleDtoPaginationDto {
    data!: SearchLogSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ISearchLogSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new SearchLogSimpleDto(item) : <SearchLogSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SearchLogSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): SearchLogSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLogSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ISearchLogSimpleDtoPaginationDto {
    data: ISearchLogSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum SearchOrderBy {
    Date = "Date",
    Category = "Category",
    SearchTerms = "SearchTerms",
    Location = "Location",
}

export class SeoBreadcrumb implements ISeoBreadcrumb {
    position!: number;
    name!: string | undefined;
    url!: string | undefined;

    constructor(data?: ISeoBreadcrumb) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SeoBreadcrumb {
        data = typeof data === 'object' ? data : {};
        let result = new SeoBreadcrumb();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface ISeoBreadcrumb {
    position: number;
    name: string | undefined;
    url: string | undefined;
}

export class SeoLocation implements ISeoLocation {
    name!: string | undefined;
    coordinates!: Coordinates;
    radius!: number | undefined;

    constructor(data?: ISeoLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.coordinates = data.coordinates && !(<any>data.coordinates).toJSON ? new Coordinates(data.coordinates) : <Coordinates>this.coordinates;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.coordinates = _data["coordinates"] ? Coordinates.fromJS(_data["coordinates"]) : <any>undefined;
            this.radius = _data["radius"];
        }
    }

    static fromJS(data: any): SeoLocation {
        data = typeof data === 'object' ? data : {};
        let result = new SeoLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["radius"] = this.radius;
        return data;
    }
}

export interface ISeoLocation {
    name: string | undefined;
    coordinates: ICoordinates;
    radius: number | undefined;
}

export class StatsOverview implements IStatsOverview {
    items!: number;
    bookings!: number;
    acceptedBookings!: number;
    completedBookings!: number;
    disputedBookings!: number;
    cancelledBookings!: number;
    users!: number;
    verifiedUsers!: number;
    canBeOwners!: number;
    owners!: number;
    averageListingsPerOwner!: number;
    images!: number;
    videos!: number;
    concurrentUsers!: number;
    usersWithListings!: number;
    totalListingPrice!: number;
    replacementValue!: number;
    categories!: number;
    categoriesWithItems!: number;
    categoriesWithInsurance!: number;

    constructor(data?: IStatsOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.items = _data["items"];
            this.bookings = _data["bookings"];
            this.acceptedBookings = _data["acceptedBookings"];
            this.completedBookings = _data["completedBookings"];
            this.disputedBookings = _data["disputedBookings"];
            this.cancelledBookings = _data["cancelledBookings"];
            this.users = _data["users"];
            this.verifiedUsers = _data["verifiedUsers"];
            this.canBeOwners = _data["canBeOwners"];
            this.owners = _data["owners"];
            this.averageListingsPerOwner = _data["averageListingsPerOwner"];
            this.images = _data["images"];
            this.videos = _data["videos"];
            this.concurrentUsers = _data["concurrentUsers"];
            this.usersWithListings = _data["usersWithListings"];
            this.totalListingPrice = _data["totalListingPrice"];
            this.replacementValue = _data["replacementValue"];
            this.categories = _data["categories"];
            this.categoriesWithItems = _data["categoriesWithItems"];
            this.categoriesWithInsurance = _data["categoriesWithInsurance"];
        }
    }

    static fromJS(data: any): StatsOverview {
        data = typeof data === 'object' ? data : {};
        let result = new StatsOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["items"] = this.items;
        data["bookings"] = this.bookings;
        data["acceptedBookings"] = this.acceptedBookings;
        data["completedBookings"] = this.completedBookings;
        data["disputedBookings"] = this.disputedBookings;
        data["cancelledBookings"] = this.cancelledBookings;
        data["users"] = this.users;
        data["verifiedUsers"] = this.verifiedUsers;
        data["canBeOwners"] = this.canBeOwners;
        data["owners"] = this.owners;
        data["averageListingsPerOwner"] = this.averageListingsPerOwner;
        data["images"] = this.images;
        data["videos"] = this.videos;
        data["concurrentUsers"] = this.concurrentUsers;
        data["usersWithListings"] = this.usersWithListings;
        data["totalListingPrice"] = this.totalListingPrice;
        data["replacementValue"] = this.replacementValue;
        data["categories"] = this.categories;
        data["categoriesWithItems"] = this.categoriesWithItems;
        data["categoriesWithInsurance"] = this.categoriesWithInsurance;
        return data;
    }
}

export interface IStatsOverview {
    items: number;
    bookings: number;
    acceptedBookings: number;
    completedBookings: number;
    disputedBookings: number;
    cancelledBookings: number;
    users: number;
    verifiedUsers: number;
    canBeOwners: number;
    owners: number;
    averageListingsPerOwner: number;
    images: number;
    videos: number;
    concurrentUsers: number;
    usersWithListings: number;
    totalListingPrice: number;
    replacementValue: number;
    categories: number;
    categoriesWithItems: number;
    categoriesWithInsurance: number;
}

export class StringStringIEnumerableKeyValuePair implements IStringStringIEnumerableKeyValuePair {
    key!: string | undefined;
    value!: string[] | undefined;

    constructor(data?: IStringStringIEnumerableKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): StringStringIEnumerableKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringIEnumerableKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IStringStringIEnumerableKeyValuePair {
    key: string | undefined;
    value: string[] | undefined;
}

export class StripeCheckoutRedirects implements IStripeCheckoutRedirects {
    cancel!: string | undefined;
    success!: string | undefined;

    constructor(data?: IStripeCheckoutRedirects) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cancel = _data["cancel"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): StripeCheckoutRedirects {
        data = typeof data === 'object' ? data : {};
        let result = new StripeCheckoutRedirects();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cancel"] = this.cancel;
        data["success"] = this.success;
        return data;
    }
}

export interface IStripeCheckoutRedirects {
    cancel: string | undefined;
    success: string | undefined;
}

export class StripeOnboardingRedirects implements IStripeOnboardingRedirects {
    returnUrl!: string | undefined;
    refreshUrl!: string | undefined;

    constructor(data?: IStripeOnboardingRedirects) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnUrl = _data["returnUrl"];
            this.refreshUrl = _data["refreshUrl"];
        }
    }

    static fromJS(data: any): StripeOnboardingRedirects {
        data = typeof data === 'object' ? data : {};
        let result = new StripeOnboardingRedirects();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnUrl"] = this.returnUrl;
        data["refreshUrl"] = this.refreshUrl;
        return data;
    }
}

export interface IStripeOnboardingRedirects {
    returnUrl: string | undefined;
    refreshUrl: string | undefined;
}

export class StripeResponse implements IStripeResponse {
    statusCode!: HttpStatusCode;
    headers!: StringStringIEnumerableKeyValuePair[] | undefined;
    readonly date!: Date | undefined;
    readonly idempotencyKey!: string | undefined;
    readonly requestId!: string | undefined;
    content!: string | undefined;

    constructor(data?: IStripeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.headers) {
                this.headers = [];
                for (let i = 0; i < data.headers.length; i++) {
                    let item = data.headers[i];
                    this.headers[i] = item && !(<any>item).toJSON ? new StringStringIEnumerableKeyValuePair(item) : <StringStringIEnumerableKeyValuePair>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            (<any>this).date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            (<any>this).idempotencyKey = _data["idempotencyKey"];
            (<any>this).requestId = _data["requestId"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): StripeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StripeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["idempotencyKey"] = this.idempotencyKey;
        data["requestId"] = this.requestId;
        data["content"] = this.content;
        return data;
    }
}

export interface IStripeResponse {
    statusCode: HttpStatusCode;
    headers: IStringStringIEnumerableKeyValuePair[] | undefined;
    date: Date | undefined;
    idempotencyKey: string | undefined;
    requestId: string | undefined;
    content: string | undefined;
}

export class StripeTransfer implements IStripeTransfer {
    id!: string;
    name!: string | undefined;
    stripeId!: string | undefined;
    amount!: number;
    booking!: Booking;

    constructor(data?: IStripeTransfer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.booking = data.booking && !(<any>data.booking).toJSON ? new Booking(data.booking) : <Booking>this.booking;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.stripeId = _data["stripeId"];
            this.amount = _data["amount"];
            this.booking = _data["booking"] ? Booking.fromJS(_data["booking"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StripeTransfer {
        data = typeof data === 'object' ? data : {};
        let result = new StripeTransfer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["stripeId"] = this.stripeId;
        data["amount"] = this.amount;
        data["booking"] = this.booking ? this.booking.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStripeTransfer {
    id: string;
    name: string | undefined;
    stripeId: string | undefined;
    amount: number;
    booking: IBooking;
}

export class Tenant implements ITenant {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    brandImage!: Image;
    description!: string | undefined;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.brandImage = data.brandImage && !(<any>data.brandImage).toJSON ? new Image(data.brandImage) : <Image>this.brandImage;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.brandImage = _data["brandImage"] ? Image.fromJS(_data["brandImage"]) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["brandImage"] = this.brandImage ? this.brandImage.toJSON() : <any>undefined;
        data["description"] = this.description;
        return data;
    }
}

export interface ITenant {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    brandImage: IImage;
    description: string | undefined;
}

export class TenantCreateDto implements ITenantCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    brandImage!: string | undefined;
    description!: string | undefined;

    constructor(data?: ITenantCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.brandImage = _data["brandImage"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TenantCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["brandImage"] = this.brandImage;
        data["description"] = this.description;
        return data;
    }
}

export interface ITenantCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    brandImage: string | undefined;
    description: string | undefined;
}

export class TenantDetailedDto implements ITenantDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    image!: ImageDto;
    description!: string | undefined;

    constructor(data?: ITenantDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.image = data.image && !(<any>data.image).toJSON ? new ImageDto(data.image) : <ImageDto>this.image;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TenantDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["description"] = this.description;
        return data;
    }
}

export interface ITenantDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    image: IImageDto;
    description: string | undefined;
}

export class TenantDetailedDtoPaginationDto implements ITenantDetailedDtoPaginationDto {
    data!: TenantDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ITenantDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TenantDetailedDto(item) : <TenantDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TenantDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): TenantDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ITenantDetailedDtoPaginationDto {
    data: ITenantDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export enum TenantOrderBy {
    Alphabetically = "Alphabetically",
    Relevance = "Relevance",
}

export class TenantSimpleDto implements ITenantSimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    image!: ImageDto;
    description!: string | undefined;

    constructor(data?: ITenantSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.image = data.image && !(<any>data.image).toJSON ? new ImageDto(data.image) : <ImageDto>this.image;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TenantSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["description"] = this.description;
        return data;
    }
}

export interface ITenantSimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    image: IImageDto;
    description: string | undefined;
}

export class TenantSimpleDtoPaginationDto implements ITenantSimpleDtoPaginationDto {
    data!: TenantSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ITenantSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TenantSimpleDto(item) : <TenantSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TenantSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): TenantSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ITenantSimpleDtoPaginationDto {
    data: ITenantSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class TermsCreateDto implements ITermsCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    termType!: string | undefined;
    content!: string | undefined;
    version!: number;

    constructor(data?: ITermsCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.termType = _data["termType"];
            this.content = _data["content"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): TermsCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TermsCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["termType"] = this.termType;
        data["content"] = this.content;
        data["version"] = this.version;
        return data;
    }
}

export interface ITermsCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    termType: string | undefined;
    content: string | undefined;
    version: number;
}

export class TermsDetailedDto implements ITermsDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    termType!: string | undefined;
    content!: string | undefined;
    version!: number;
    issued!: boolean;
    timeIssued!: Date | undefined;

    constructor(data?: ITermsDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.termType = _data["termType"];
            this.content = _data["content"];
            this.version = _data["version"];
            this.issued = _data["issued"];
            this.timeIssued = _data["timeIssued"] ? new Date(_data["timeIssued"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TermsDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new TermsDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["termType"] = this.termType;
        data["content"] = this.content;
        data["version"] = this.version;
        data["issued"] = this.issued;
        data["timeIssued"] = this.timeIssued ? this.timeIssued.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITermsDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    termType: string | undefined;
    content: string | undefined;
    version: number;
    issued: boolean;
    timeIssued: Date | undefined;
}

export class TermsDetailedDtoUpdateResponseDto implements ITermsDetailedDtoUpdateResponseDto {
    data!: TermsDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: ITermsDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new TermsDetailedDto(data.data) : <TermsDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TermsDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): TermsDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TermsDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ITermsDetailedDtoUpdateResponseDto {
    data: ITermsDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class TermsSimpleDto implements ITermsSimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    termType!: string | undefined;
    content!: string | undefined;
    version!: number;
    issued!: boolean;
    timeIssued!: Date | undefined;

    constructor(data?: ITermsSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.termType = _data["termType"];
            this.content = _data["content"];
            this.version = _data["version"];
            this.issued = _data["issued"];
            this.timeIssued = _data["timeIssued"] ? new Date(_data["timeIssued"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TermsSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new TermsSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["termType"] = this.termType;
        data["content"] = this.content;
        data["version"] = this.version;
        data["issued"] = this.issued;
        data["timeIssued"] = this.timeIssued ? this.timeIssued.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITermsSimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    termType: string | undefined;
    content: string | undefined;
    version: number;
    issued: boolean;
    timeIssued: Date | undefined;
}

export class TermsSimpleDtoPaginationDto implements ITermsSimpleDtoPaginationDto {
    data!: TermsSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ITermsSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TermsSimpleDto(item) : <TermsSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TermsSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): TermsSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TermsSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ITermsSimpleDtoPaginationDto {
    data: ITermsSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class TimeSpan implements ITimeSpan {
    ticks!: number;
    readonly days!: number;
    readonly hours!: number;
    readonly milliseconds!: number;
    readonly microseconds!: number;
    readonly nanoseconds!: number;
    readonly minutes!: number;
    readonly seconds!: number;
    readonly totalDays!: number;
    readonly totalHours!: number;
    readonly totalMilliseconds!: number;
    readonly totalMicroseconds!: number;
    readonly totalNanoseconds!: number;
    readonly totalMinutes!: number;
    readonly totalSeconds!: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            (<any>this).days = _data["days"];
            (<any>this).hours = _data["hours"];
            (<any>this).milliseconds = _data["milliseconds"];
            (<any>this).microseconds = _data["microseconds"];
            (<any>this).nanoseconds = _data["nanoseconds"];
            (<any>this).minutes = _data["minutes"];
            (<any>this).seconds = _data["seconds"];
            (<any>this).totalDays = _data["totalDays"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).totalMilliseconds = _data["totalMilliseconds"];
            (<any>this).totalMicroseconds = _data["totalMicroseconds"];
            (<any>this).totalNanoseconds = _data["totalNanoseconds"];
            (<any>this).totalMinutes = _data["totalMinutes"];
            (<any>this).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["microseconds"] = this.microseconds;
        data["nanoseconds"] = this.nanoseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMicroseconds"] = this.totalMicroseconds;
        data["totalNanoseconds"] = this.totalNanoseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks: number;
    days: number;
    hours: number;
    milliseconds: number;
    microseconds: number;
    nanoseconds: number;
    minutes: number;
    seconds: number;
    totalDays: number;
    totalHours: number;
    totalMilliseconds: number;
    totalMicroseconds: number;
    totalNanoseconds: number;
    totalMinutes: number;
    totalSeconds: number;
}

export class TopSearchedLocationsDto implements ITopSearchedLocationsDto {
    location!: string | undefined;
    count!: number;

    constructor(data?: ITopSearchedLocationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): TopSearchedLocationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopSearchedLocationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location;
        data["count"] = this.count;
        return data;
    }
}

export interface ITopSearchedLocationsDto {
    location: string | undefined;
    count: number;
}

export class TopStatsDto implements ITopStatsDto {
    topItemsBooked!: ItemDto[] | undefined;
    topCategories!: CategoryDetailedDto[] | undefined;
    topUsersByListings!: RentMyUserWithListingsDto[] | undefined;
    topUsersByEarnings!: RentMyUserWithListingsDto[] | undefined;
    topUsersByRentals!: RentMyUserWithListingsDto[] | undefined;

    constructor(data?: ITopStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.topItemsBooked) {
                this.topItemsBooked = [];
                for (let i = 0; i < data.topItemsBooked.length; i++) {
                    let item = data.topItemsBooked[i];
                    this.topItemsBooked[i] = item && !(<any>item).toJSON ? new ItemDto(item) : <ItemDto>item;
                }
            }
            if (data.topCategories) {
                this.topCategories = [];
                for (let i = 0; i < data.topCategories.length; i++) {
                    let item = data.topCategories[i];
                    this.topCategories[i] = item && !(<any>item).toJSON ? new CategoryDetailedDto(item) : <CategoryDetailedDto>item;
                }
            }
            if (data.topUsersByListings) {
                this.topUsersByListings = [];
                for (let i = 0; i < data.topUsersByListings.length; i++) {
                    let item = data.topUsersByListings[i];
                    this.topUsersByListings[i] = item && !(<any>item).toJSON ? new RentMyUserWithListingsDto(item) : <RentMyUserWithListingsDto>item;
                }
            }
            if (data.topUsersByEarnings) {
                this.topUsersByEarnings = [];
                for (let i = 0; i < data.topUsersByEarnings.length; i++) {
                    let item = data.topUsersByEarnings[i];
                    this.topUsersByEarnings[i] = item && !(<any>item).toJSON ? new RentMyUserWithListingsDto(item) : <RentMyUserWithListingsDto>item;
                }
            }
            if (data.topUsersByRentals) {
                this.topUsersByRentals = [];
                for (let i = 0; i < data.topUsersByRentals.length; i++) {
                    let item = data.topUsersByRentals[i];
                    this.topUsersByRentals[i] = item && !(<any>item).toJSON ? new RentMyUserWithListingsDto(item) : <RentMyUserWithListingsDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["topItemsBooked"])) {
                this.topItemsBooked = [] as any;
                for (let item of _data["topItemsBooked"])
                    this.topItemsBooked!.push(ItemDto.fromJS(item));
            }
            if (Array.isArray(_data["topCategories"])) {
                this.topCategories = [] as any;
                for (let item of _data["topCategories"])
                    this.topCategories!.push(CategoryDetailedDto.fromJS(item));
            }
            if (Array.isArray(_data["topUsersByListings"])) {
                this.topUsersByListings = [] as any;
                for (let item of _data["topUsersByListings"])
                    this.topUsersByListings!.push(RentMyUserWithListingsDto.fromJS(item));
            }
            if (Array.isArray(_data["topUsersByEarnings"])) {
                this.topUsersByEarnings = [] as any;
                for (let item of _data["topUsersByEarnings"])
                    this.topUsersByEarnings!.push(RentMyUserWithListingsDto.fromJS(item));
            }
            if (Array.isArray(_data["topUsersByRentals"])) {
                this.topUsersByRentals = [] as any;
                for (let item of _data["topUsersByRentals"])
                    this.topUsersByRentals!.push(RentMyUserWithListingsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TopStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.topItemsBooked)) {
            data["topItemsBooked"] = [];
            for (let item of this.topItemsBooked)
                data["topItemsBooked"].push(item.toJSON());
        }
        if (Array.isArray(this.topCategories)) {
            data["topCategories"] = [];
            for (let item of this.topCategories)
                data["topCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.topUsersByListings)) {
            data["topUsersByListings"] = [];
            for (let item of this.topUsersByListings)
                data["topUsersByListings"].push(item.toJSON());
        }
        if (Array.isArray(this.topUsersByEarnings)) {
            data["topUsersByEarnings"] = [];
            for (let item of this.topUsersByEarnings)
                data["topUsersByEarnings"].push(item.toJSON());
        }
        if (Array.isArray(this.topUsersByRentals)) {
            data["topUsersByRentals"] = [];
            for (let item of this.topUsersByRentals)
                data["topUsersByRentals"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITopStatsDto {
    topItemsBooked: IItemDto[] | undefined;
    topCategories: ICategoryDetailedDto[] | undefined;
    topUsersByListings: IRentMyUserWithListingsDto[] | undefined;
    topUsersByEarnings: IRentMyUserWithListingsDto[] | undefined;
    topUsersByRentals: IRentMyUserWithListingsDto[] | undefined;
}

export class TradedoublerProfileCreateDto implements ITradedoublerProfileCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    feedId!: string | undefined;
    categoryId!: string;
    hasInsurance!: boolean;

    constructor(data?: ITradedoublerProfileCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.feedId = _data["feedId"];
            this.categoryId = _data["categoryId"];
            this.hasInsurance = _data["hasInsurance"];
        }
    }

    static fromJS(data: any): TradedoublerProfileCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TradedoublerProfileCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["feedId"] = this.feedId;
        data["categoryId"] = this.categoryId;
        data["hasInsurance"] = this.hasInsurance;
        return data;
    }
}

export interface ITradedoublerProfileCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    feedId: string | undefined;
    categoryId: string;
    hasInsurance: boolean;
}

export class TradedoublerProfileDto implements ITradedoublerProfileDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    feedId!: string | undefined;
    category!: CategorySimpleDto;
    hasInsurance!: boolean;

    constructor(data?: ITradedoublerProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.category = data.category && !(<any>data.category).toJSON ? new CategorySimpleDto(data.category) : <CategorySimpleDto>this.category;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.feedId = _data["feedId"];
            this.category = _data["category"] ? CategorySimpleDto.fromJS(_data["category"]) : <any>undefined;
            this.hasInsurance = _data["hasInsurance"];
        }
    }

    static fromJS(data: any): TradedoublerProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new TradedoublerProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["feedId"] = this.feedId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["hasInsurance"] = this.hasInsurance;
        return data;
    }
}

export interface ITradedoublerProfileDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    feedId: string | undefined;
    category: ICategorySimpleDto;
    hasInsurance: boolean;
}

export class TradedoublerProfileDtoPaginationDto implements ITradedoublerProfileDtoPaginationDto {
    data!: TradedoublerProfileDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ITradedoublerProfileDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TradedoublerProfileDto(item) : <TradedoublerProfileDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TradedoublerProfileDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): TradedoublerProfileDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TradedoublerProfileDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ITradedoublerProfileDtoPaginationDto {
    data: ITradedoublerProfileDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class TradedoublerProfileDtoUpdateResponseDto implements ITradedoublerProfileDtoUpdateResponseDto {
    data!: TradedoublerProfileDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: ITradedoublerProfileDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new TradedoublerProfileDto(data.data) : <TradedoublerProfileDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TradedoublerProfileDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): TradedoublerProfileDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TradedoublerProfileDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ITradedoublerProfileDtoUpdateResponseDto {
    data: ITradedoublerProfileDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class TrainingLogCreateDto implements ITrainingLogCreateDto {
    active!: boolean | undefined;
    itemId!: string;
    userId!: string;
    answer!: boolean;

    constructor(data?: ITrainingLogCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.itemId = _data["itemId"];
            this.userId = _data["userId"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): TrainingLogCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingLogCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["itemId"] = this.itemId;
        data["userId"] = this.userId;
        data["answer"] = this.answer;
        return data;
    }
}

export interface ITrainingLogCreateDto {
    active: boolean | undefined;
    itemId: string;
    userId: string;
    answer: boolean;
}

export class TrainingLogDetailedDto implements ITrainingLogDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    item!: ItemSimpleDto;
    user!: RentMyUserSimpleDto;
    answer!: boolean;

    constructor(data?: ITrainingLogDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.item = data.item && !(<any>data.item).toJSON ? new ItemSimpleDto(data.item) : <ItemSimpleDto>this.item;
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserSimpleDto(data.user) : <RentMyUserSimpleDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.item = _data["item"] ? ItemSimpleDto.fromJS(_data["item"]) : <any>undefined;
            this.user = _data["user"] ? RentMyUserSimpleDto.fromJS(_data["user"]) : <any>undefined;
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): TrainingLogDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingLogDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["answer"] = this.answer;
        return data;
    }
}

export interface ITrainingLogDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    item: IItemSimpleDto;
    user: IRentMyUserSimpleDto;
    answer: boolean;
}

export class TrainingLogDetailedDtoPaginationDto implements ITrainingLogDetailedDtoPaginationDto {
    data!: TrainingLogDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ITrainingLogDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TrainingLogDetailedDto(item) : <TrainingLogDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TrainingLogDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): TrainingLogDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingLogDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ITrainingLogDetailedDtoPaginationDto {
    data: ITrainingLogDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class TrainingLogDetailedDtoUpdateResponseDto implements ITrainingLogDetailedDtoUpdateResponseDto {
    data!: TrainingLogDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: ITrainingLogDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new TrainingLogDetailedDto(data.data) : <TrainingLogDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TrainingLogDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): TrainingLogDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingLogDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ITrainingLogDetailedDtoUpdateResponseDto {
    data: ITrainingLogDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export class TrainingLogSimpleDto implements ITrainingLogSimpleDto {
    id!: string;
    active!: boolean;
    itemId!: string;
    userId!: string | undefined;
    answer!: boolean;

    constructor(data?: ITrainingLogSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.itemId = _data["itemId"];
            this.userId = _data["userId"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): TrainingLogSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingLogSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["itemId"] = this.itemId;
        data["userId"] = this.userId;
        data["answer"] = this.answer;
        return data;
    }
}

export interface ITrainingLogSimpleDto {
    id: string;
    active: boolean;
    itemId: string;
    userId: string | undefined;
    answer: boolean;
}

export class TrainingLogSimpleDtoPaginationDto implements ITrainingLogSimpleDtoPaginationDto {
    data!: TrainingLogSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ITrainingLogSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TrainingLogSimpleDto(item) : <TrainingLogSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TrainingLogSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): TrainingLogSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingLogSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ITrainingLogSimpleDtoPaginationDto {
    data: ITrainingLogSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class TransactionHistoryCreateDto implements ITransactionHistoryCreateDto {
    active!: boolean | undefined;
    userId!: string;
    itemId!: string;
    amountPaid!: number;
    dateOfPayment!: Date;

    constructor(data?: ITransactionHistoryCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.userId = _data["userId"];
            this.itemId = _data["itemId"];
            this.amountPaid = _data["amountPaid"];
            this.dateOfPayment = _data["dateOfPayment"] ? new Date(_data["dateOfPayment"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TransactionHistoryCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionHistoryCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["itemId"] = this.itemId;
        data["amountPaid"] = this.amountPaid;
        data["dateOfPayment"] = this.dateOfPayment ? this.dateOfPayment.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITransactionHistoryCreateDto {
    active: boolean | undefined;
    userId: string;
    itemId: string;
    amountPaid: number;
    dateOfPayment: Date;
}

export class TransactionHistoryDetailedDto implements ITransactionHistoryDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUserSimpleDto;
    item!: ItemSimpleDto;
    amountPaid!: number;
    dateOfPayment!: Date;

    constructor(data?: ITransactionHistoryDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserSimpleDto(data.user) : <RentMyUserSimpleDto>this.user;
            this.item = data.item && !(<any>data.item).toJSON ? new ItemSimpleDto(data.item) : <ItemSimpleDto>this.item;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUserSimpleDto.fromJS(_data["user"]) : <any>undefined;
            this.item = _data["item"] ? ItemSimpleDto.fromJS(_data["item"]) : <any>undefined;
            this.amountPaid = _data["amountPaid"];
            this.dateOfPayment = _data["dateOfPayment"] ? new Date(_data["dateOfPayment"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TransactionHistoryDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionHistoryDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["amountPaid"] = this.amountPaid;
        data["dateOfPayment"] = this.dateOfPayment ? this.dateOfPayment.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITransactionHistoryDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUserSimpleDto;
    item: IItemSimpleDto;
    amountPaid: number;
    dateOfPayment: Date;
}

export class TransactionHistoryDetailedDtoPaginationDto implements ITransactionHistoryDetailedDtoPaginationDto {
    data!: TransactionHistoryDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ITransactionHistoryDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TransactionHistoryDetailedDto(item) : <TransactionHistoryDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TransactionHistoryDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): TransactionHistoryDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionHistoryDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ITransactionHistoryDetailedDtoPaginationDto {
    data: ITransactionHistoryDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class TransactionHistorySimpleDto implements ITransactionHistorySimpleDto {
    id!: string;
    active!: boolean;
    userId!: string | undefined;
    itemId!: string;
    amountPaid!: number;
    dateOfPayment!: Date;

    constructor(data?: ITransactionHistorySimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.userId = _data["userId"];
            this.itemId = _data["itemId"];
            this.amountPaid = _data["amountPaid"];
            this.dateOfPayment = _data["dateOfPayment"] ? new Date(_data["dateOfPayment"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TransactionHistorySimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionHistorySimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["itemId"] = this.itemId;
        data["amountPaid"] = this.amountPaid;
        data["dateOfPayment"] = this.dateOfPayment ? this.dateOfPayment.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITransactionHistorySimpleDto {
    id: string;
    active: boolean;
    userId: string | undefined;
    itemId: string;
    amountPaid: number;
    dateOfPayment: Date;
}

export class TransactionHistorySimpleDtoPaginationDto implements ITransactionHistorySimpleDtoPaginationDto {
    data!: TransactionHistorySimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: ITransactionHistorySimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new TransactionHistorySimpleDto(item) : <TransactionHistorySimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TransactionHistorySimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): TransactionHistorySimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionHistorySimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface ITransactionHistorySimpleDtoPaginationDto {
    data: ITransactionHistorySimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class TransactionStatsDto implements ITransactionStatsDto {
    transactionCount!: number;
    transactionDate!: Date;

    constructor(data?: ITransactionStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionCount = _data["transactionCount"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TransactionStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionCount"] = this.transactionCount;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITransactionStatsDto {
    transactionCount: number;
    transactionDate: Date;
}

export class TransferFileRequest implements ITransferFileRequest {
    sourcePath!: string | undefined;
    destinationPath!: string | undefined;
    crossResource!: boolean;

    constructor(data?: ITransferFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourcePath = _data["sourcePath"];
            this.destinationPath = _data["destinationPath"];
            this.crossResource = _data["crossResource"];
        }
    }

    static fromJS(data: any): TransferFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TransferFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourcePath"] = this.sourcePath;
        data["destinationPath"] = this.destinationPath;
        data["crossResource"] = this.crossResource;
        return data;
    }
}

export interface ITransferFileRequest {
    sourcePath: string | undefined;
    destinationPath: string | undefined;
    crossResource: boolean;
}

export class UpcomingBookingDto implements IUpcomingBookingDto {
    startingDate!: Date;
    endingDate!: Date;

    constructor(data?: IUpcomingBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startingDate = _data["startingDate"] ? new Date(_data["startingDate"].toString()) : <any>undefined;
            this.endingDate = _data["endingDate"] ? new Date(_data["endingDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpcomingBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startingDate"] = this.startingDate ? this.startingDate.toISOString() : <any>undefined;
        data["endingDate"] = this.endingDate ? this.endingDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpcomingBookingDto {
    startingDate: Date;
    endingDate: Date;
}

export class UpcomingBookingsDto implements IUpcomingBookingsDto {
    itemId!: string;
    upcomingBookings!: UpcomingBookingDto[] | undefined;

    constructor(data?: IUpcomingBookingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.upcomingBookings) {
                this.upcomingBookings = [];
                for (let i = 0; i < data.upcomingBookings.length; i++) {
                    let item = data.upcomingBookings[i];
                    this.upcomingBookings[i] = item && !(<any>item).toJSON ? new UpcomingBookingDto(item) : <UpcomingBookingDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            if (Array.isArray(_data["upcomingBookings"])) {
                this.upcomingBookings = [] as any;
                for (let item of _data["upcomingBookings"])
                    this.upcomingBookings!.push(UpcomingBookingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpcomingBookingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingBookingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        if (Array.isArray(this.upcomingBookings)) {
            data["upcomingBookings"] = [];
            for (let item of this.upcomingBookings)
                data["upcomingBookings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpcomingBookingsDto {
    itemId: string;
    upcomingBookings: IUpcomingBookingDto[] | undefined;
}

export class UploadFile implements IUploadFile {
    fileName!: string | undefined;
    fileContent!: string | undefined;
    userId!: string | undefined;

    constructor(data?: IUploadFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileContent = _data["fileContent"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UploadFile {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileContent"] = this.fileContent;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUploadFile {
    fileName: string | undefined;
    fileContent: string | undefined;
    userId: string | undefined;
}

export class UserAdminSearchDto implements IUserAdminSearchDto {
    id!: string;
    active!: boolean;
    auth0Id!: string | undefined;
    name!: string | undefined;
    emailAddress!: string | undefined;
    joinDate!: string | undefined;
    image!: ImageDto;
    city!: string | undefined;
    reviewsMade!: number;
    reviewScore!: number | undefined;
    reviewCount!: number;
    isBusiness!: boolean;
    verified!: boolean;
    suspended!: boolean;
    stripeOnboarded!: boolean;
    role!: RentMyRole;
    intention!: UserIntention;

    constructor(data?: IUserAdminSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.image = data.image && !(<any>data.image).toJSON ? new ImageDto(data.image) : <ImageDto>this.image;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.auth0Id = _data["auth0Id"];
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
            this.joinDate = _data["joinDate"];
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>undefined;
            this.city = _data["city"];
            this.reviewsMade = _data["reviewsMade"];
            this.reviewScore = _data["reviewScore"];
            this.reviewCount = _data["reviewCount"];
            this.isBusiness = _data["isBusiness"];
            this.verified = _data["verified"];
            this.suspended = _data["suspended"];
            this.stripeOnboarded = _data["stripeOnboarded"];
            this.role = _data["role"];
            this.intention = _data["intention"];
        }
    }

    static fromJS(data: any): UserAdminSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAdminSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["auth0Id"] = this.auth0Id;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["joinDate"] = this.joinDate;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["city"] = this.city;
        data["reviewsMade"] = this.reviewsMade;
        data["reviewScore"] = this.reviewScore;
        data["reviewCount"] = this.reviewCount;
        data["isBusiness"] = this.isBusiness;
        data["verified"] = this.verified;
        data["suspended"] = this.suspended;
        data["stripeOnboarded"] = this.stripeOnboarded;
        data["role"] = this.role;
        data["intention"] = this.intention;
        return data;
    }
}

export interface IUserAdminSearchDto {
    id: string;
    active: boolean;
    auth0Id: string | undefined;
    name: string | undefined;
    emailAddress: string | undefined;
    joinDate: string | undefined;
    image: IImageDto;
    city: string | undefined;
    reviewsMade: number;
    reviewScore: number | undefined;
    reviewCount: number;
    isBusiness: boolean;
    verified: boolean;
    suspended: boolean;
    stripeOnboarded: boolean;
    role: RentMyRole;
    intention: UserIntention;
}

export class UserAdminSearchDtoPaginationDto implements IUserAdminSearchDtoPaginationDto {
    data!: UserAdminSearchDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IUserAdminSearchDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new UserAdminSearchDto(item) : <UserAdminSearchDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserAdminSearchDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): UserAdminSearchDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAdminSearchDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IUserAdminSearchDtoPaginationDto {
    data: IUserAdminSearchDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class UserCreateDto implements IUserCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    emailAddress!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    phoneNumber!: string | undefined;
    aboutMe!: string | undefined;
    birthdate!: Date | undefined;
    genderId!: string | undefined;
    location!: Location;
    receiveEmailsNotifications!: boolean;
    receivePhoneNotifications!: boolean;
    receiveTextNotifications!: boolean;
    receivePostNotifications!: boolean;
    role!: RentMyRole;
    intention!: UserIntention;
    tenant!: string | undefined;

    constructor(data?: IUserCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.location = data.location && !(<any>data.location).toJSON ? new Location(data.location) : <Location>this.location;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.aboutMe = _data["aboutMe"];
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : <any>undefined;
            this.genderId = _data["genderId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.receiveEmailsNotifications = _data["receiveEmailsNotifications"];
            this.receivePhoneNotifications = _data["receivePhoneNotifications"];
            this.receiveTextNotifications = _data["receiveTextNotifications"];
            this.receivePostNotifications = _data["receivePostNotifications"];
            this.role = _data["role"];
            this.intention = _data["intention"];
            this.tenant = _data["tenant"];
        }
    }

    static fromJS(data: any): UserCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["aboutMe"] = this.aboutMe;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["genderId"] = this.genderId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["receiveEmailsNotifications"] = this.receiveEmailsNotifications;
        data["receivePhoneNotifications"] = this.receivePhoneNotifications;
        data["receiveTextNotifications"] = this.receiveTextNotifications;
        data["receivePostNotifications"] = this.receivePostNotifications;
        data["role"] = this.role;
        data["intention"] = this.intention;
        data["tenant"] = this.tenant;
        return data;
    }
}

export interface IUserCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    emailAddress: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    aboutMe: string | undefined;
    birthdate: Date | undefined;
    genderId: string | undefined;
    location: ILocation;
    receiveEmailsNotifications: boolean;
    receivePhoneNotifications: boolean;
    receiveTextNotifications: boolean;
    receivePostNotifications: boolean;
    role: RentMyRole;
    intention: UserIntention;
    tenant: string | undefined;
}

export class UserDemographicsDto implements IUserDemographicsDto {
    activeUserCount!: number;
    renterIntentionCount!: number;
    sharerIntentionCount!: number;
    bothIntentionCount!: number;
    nullIntentionCount!: number;
    readonly renterIntentionPercentage!: number;
    readonly sharerIntentionPercentage!: number;
    readonly bothIntentionPercentage!: number;
    readonly nullIntentionPercentage!: number;
    femaleCount!: number;
    maleCount!: number;
    otherCount!: number;
    nullGenderCount!: number;
    ageGroups!: { [key: string]: AgeGroupData; } | undefined;
    topCities!: CityUserCount[] | undefined;
    nullCityCount!: number;

    constructor(data?: IUserDemographicsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.ageGroups) {
                this.ageGroups = {};
                for (let key in data.ageGroups) {
                    if (data.ageGroups.hasOwnProperty(key)) {
                        let item = data.ageGroups[key];
                        this.ageGroups[key] = item && !(<any>item).toJSON ? new AgeGroupData(item) : <AgeGroupData>item;
                    }
                }
            }
            if (data.topCities) {
                this.topCities = [];
                for (let i = 0; i < data.topCities.length; i++) {
                    let item = data.topCities[i];
                    this.topCities[i] = item && !(<any>item).toJSON ? new CityUserCount(item) : <CityUserCount>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeUserCount = _data["activeUserCount"];
            this.renterIntentionCount = _data["renterIntentionCount"];
            this.sharerIntentionCount = _data["sharerIntentionCount"];
            this.bothIntentionCount = _data["bothIntentionCount"];
            this.nullIntentionCount = _data["nullIntentionCount"];
            (<any>this).renterIntentionPercentage = _data["renterIntentionPercentage"];
            (<any>this).sharerIntentionPercentage = _data["sharerIntentionPercentage"];
            (<any>this).bothIntentionPercentage = _data["bothIntentionPercentage"];
            (<any>this).nullIntentionPercentage = _data["nullIntentionPercentage"];
            this.femaleCount = _data["femaleCount"];
            this.maleCount = _data["maleCount"];
            this.otherCount = _data["otherCount"];
            this.nullGenderCount = _data["nullGenderCount"];
            if (_data["ageGroups"]) {
                this.ageGroups = {} as any;
                for (let key in _data["ageGroups"]) {
                    if (_data["ageGroups"].hasOwnProperty(key))
                        (<any>this.ageGroups)![key] = _data["ageGroups"][key] ? AgeGroupData.fromJS(_data["ageGroups"][key]) : new AgeGroupData();
                }
            }
            if (Array.isArray(_data["topCities"])) {
                this.topCities = [] as any;
                for (let item of _data["topCities"])
                    this.topCities!.push(CityUserCount.fromJS(item));
            }
            this.nullCityCount = _data["nullCityCount"];
        }
    }

    static fromJS(data: any): UserDemographicsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDemographicsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeUserCount"] = this.activeUserCount;
        data["renterIntentionCount"] = this.renterIntentionCount;
        data["sharerIntentionCount"] = this.sharerIntentionCount;
        data["bothIntentionCount"] = this.bothIntentionCount;
        data["nullIntentionCount"] = this.nullIntentionCount;
        data["renterIntentionPercentage"] = this.renterIntentionPercentage;
        data["sharerIntentionPercentage"] = this.sharerIntentionPercentage;
        data["bothIntentionPercentage"] = this.bothIntentionPercentage;
        data["nullIntentionPercentage"] = this.nullIntentionPercentage;
        data["femaleCount"] = this.femaleCount;
        data["maleCount"] = this.maleCount;
        data["otherCount"] = this.otherCount;
        data["nullGenderCount"] = this.nullGenderCount;
        if (this.ageGroups) {
            data["ageGroups"] = {};
            for (let key in this.ageGroups) {
                if (this.ageGroups.hasOwnProperty(key))
                    (<any>data["ageGroups"])[key] = this.ageGroups[key] ? this.ageGroups[key].toJSON() : <any>undefined;
            }
        }
        if (Array.isArray(this.topCities)) {
            data["topCities"] = [];
            for (let item of this.topCities)
                data["topCities"].push(item.toJSON());
        }
        data["nullCityCount"] = this.nullCityCount;
        return data;
    }
}

export interface IUserDemographicsDto {
    activeUserCount: number;
    renterIntentionCount: number;
    sharerIntentionCount: number;
    bothIntentionCount: number;
    nullIntentionCount: number;
    renterIntentionPercentage: number;
    sharerIntentionPercentage: number;
    bothIntentionPercentage: number;
    nullIntentionPercentage: number;
    femaleCount: number;
    maleCount: number;
    otherCount: number;
    nullGenderCount: number;
    ageGroups: { [key: string]: IAgeGroupData; } | undefined;
    topCities: ICityUserCount[] | undefined;
    nullCityCount: number;
}

export enum UserIntention {
    Renter = "Renter",
    Sharer = "Sharer",
    Both = "Both",
}

export enum UserOrderBy {
    Relevance = "Relevance",
    Newest = "Newest",
    Alphabetically = "Alphabetically",
    TopReviewers = "TopReviewers",
    TopReviewed = "TopReviewed",
    TopRenters = "TopRenters",
    MostListings = "MostListings",
    TopEarners = "TopEarners",
}

export class Version implements IVersion {
    readonly major!: number;
    readonly minor!: number;
    readonly build!: number;
    readonly revision!: number;
    readonly majorRevision!: number;
    readonly minorRevision!: number;

    constructor(data?: IVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).major = _data["major"];
            (<any>this).minor = _data["minor"];
            (<any>this).build = _data["build"];
            (<any>this).revision = _data["revision"];
            (<any>this).majorRevision = _data["majorRevision"];
            (<any>this).minorRevision = _data["minorRevision"];
        }
    }

    static fromJS(data: any): Version {
        data = typeof data === 'object' ? data : {};
        let result = new Version();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["major"] = this.major;
        data["minor"] = this.minor;
        data["build"] = this.build;
        data["revision"] = this.revision;
        data["majorRevision"] = this.majorRevision;
        data["minorRevision"] = this.minorRevision;
        return data;
    }
}

export interface IVersion {
    major: number;
    minor: number;
    build: number;
    revision: number;
    majorRevision: number;
    minorRevision: number;
}

export class Video implements IVideo {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    dataType!: string | undefined;
    size!: number | undefined;
    path!: string | undefined;
    user!: RentMyUser;
    duration!: TimeSpan;
    width!: number | undefined;
    height!: number | undefined;
    flagged!: boolean;

    constructor(data?: IVideo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
            this.duration = data.duration && !(<any>data.duration).toJSON ? new TimeSpan(data.duration) : <TimeSpan>this.duration;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.size = _data["size"];
            this.path = _data["path"];
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : <any>undefined;
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : <any>undefined;
            this.width = _data["width"];
            this.height = _data["height"];
            this.flagged = _data["flagged"];
        }
    }

    static fromJS(data: any): Video {
        data = typeof data === 'object' ? data : {};
        let result = new Video();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["size"] = this.size;
        data["path"] = this.path;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["duration"] = this.duration ? this.duration.toJSON() : <any>undefined;
        data["width"] = this.width;
        data["height"] = this.height;
        data["flagged"] = this.flagged;
        return data;
    }
}

export interface IVideo {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    dataType: string | undefined;
    size: number | undefined;
    path: string | undefined;
    user: IRentMyUser;
    duration: ITimeSpan;
    width: number | undefined;
    height: number | undefined;
    flagged: boolean;
}

export class VideoDetailedDto implements IVideoDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    dataType!: string | undefined;
    path!: string | undefined;
    size!: number | undefined;
    duration!: TimeSpan;
    width!: number | undefined;
    height!: number | undefined;
    flagged!: boolean;
    user!: NamedIdentifierDto;

    constructor(data?: IVideoDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.duration = data.duration && !(<any>data.duration).toJSON ? new TimeSpan(data.duration) : <TimeSpan>this.duration;
            this.user = data.user && !(<any>data.user).toJSON ? new NamedIdentifierDto(data.user) : <NamedIdentifierDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.path = _data["path"];
            this.size = _data["size"];
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : <any>undefined;
            this.width = _data["width"];
            this.height = _data["height"];
            this.flagged = _data["flagged"];
            this.user = _data["user"] ? NamedIdentifierDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VideoDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["path"] = this.path;
        data["size"] = this.size;
        data["duration"] = this.duration ? this.duration.toJSON() : <any>undefined;
        data["width"] = this.width;
        data["height"] = this.height;
        data["flagged"] = this.flagged;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVideoDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    dataType: string | undefined;
    path: string | undefined;
    size: number | undefined;
    duration: ITimeSpan;
    width: number | undefined;
    height: number | undefined;
    flagged: boolean;
    user: INamedIdentifierDto;
}

export class VideoDetailedDtoPaginationDto implements IVideoDetailedDtoPaginationDto {
    data!: VideoDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IVideoDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new VideoDetailedDto(item) : <VideoDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(VideoDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): VideoDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IVideoDetailedDtoPaginationDto {
    data: IVideoDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class VideoDto implements IVideoDto {
    id!: string;
    name!: string | undefined;
    dataType!: string | undefined;
    size!: number | undefined;
    path!: string | undefined;
    user!: NamedIdentifierDto;
    duration!: TimeSpan;
    width!: number | undefined;
    height!: number | undefined;

    constructor(data?: IVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new NamedIdentifierDto(data.user) : <NamedIdentifierDto>this.user;
            this.duration = data.duration && !(<any>data.duration).toJSON ? new TimeSpan(data.duration) : <TimeSpan>this.duration;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.size = _data["size"];
            this.path = _data["path"];
            this.user = _data["user"] ? NamedIdentifierDto.fromJS(_data["user"]) : <any>undefined;
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : <any>undefined;
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): VideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["size"] = this.size;
        data["path"] = this.path;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["duration"] = this.duration ? this.duration.toJSON() : <any>undefined;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IVideoDto {
    id: string;
    name: string | undefined;
    dataType: string | undefined;
    size: number | undefined;
    path: string | undefined;
    user: INamedIdentifierDto;
    duration: ITimeSpan;
    width: number | undefined;
    height: number | undefined;
}

export enum VideoOrderBy {
    Relevance = "Relevance",
    Newest = "Newest",
    Oldest = "Oldest",
    Size = "Size",
}

export class VideoSimpleDto implements IVideoSimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    dataType!: string | undefined;
    path!: string | undefined;
    size!: number | undefined;
    duration!: TimeSpan;
    width!: number | undefined;
    height!: number | undefined;
    flagged!: boolean;
    user!: NamedIdentifierDto;

    constructor(data?: IVideoSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.duration = data.duration && !(<any>data.duration).toJSON ? new TimeSpan(data.duration) : <TimeSpan>this.duration;
            this.user = data.user && !(<any>data.user).toJSON ? new NamedIdentifierDto(data.user) : <NamedIdentifierDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.path = _data["path"];
            this.size = _data["size"];
            this.duration = _data["duration"] ? TimeSpan.fromJS(_data["duration"]) : <any>undefined;
            this.width = _data["width"];
            this.height = _data["height"];
            this.flagged = _data["flagged"];
            this.user = _data["user"] ? NamedIdentifierDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VideoSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["path"] = this.path;
        data["size"] = this.size;
        data["duration"] = this.duration ? this.duration.toJSON() : <any>undefined;
        data["width"] = this.width;
        data["height"] = this.height;
        data["flagged"] = this.flagged;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVideoSimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    dataType: string | undefined;
    path: string | undefined;
    size: number | undefined;
    duration: ITimeSpan;
    width: number | undefined;
    height: number | undefined;
    flagged: boolean;
    user: INamedIdentifierDto;
}

export class VideoSimpleDtoPaginationDto implements IVideoSimpleDtoPaginationDto {
    data!: VideoSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IVideoSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new VideoSimpleDto(item) : <VideoSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(VideoSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): VideoSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IVideoSimpleDtoPaginationDto {
    data: IVideoSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class Voucher implements IVoucher {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string;
    voucherType!: string;
    code!: string;
    available!: boolean;
    discount!: number;
    validFrom!: Date | undefined;
    validTo!: Date | undefined;
    exclusiveTo!: RentMyUser[] | undefined;
    exclusivelyFor!: Item[] | undefined;
    redemptionCount!: number;
    redemptionLimit!: number | undefined;
    isPercent!: boolean;
    minimumOrderValue!: number | undefined;
    stackable!: boolean;

    constructor(data?: IVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.exclusiveTo) {
                this.exclusiveTo = [];
                for (let i = 0; i < data.exclusiveTo.length; i++) {
                    let item = data.exclusiveTo[i];
                    this.exclusiveTo[i] = item && !(<any>item).toJSON ? new RentMyUser(item) : <RentMyUser>item;
                }
            }
            if (data.exclusivelyFor) {
                this.exclusivelyFor = [];
                for (let i = 0; i < data.exclusivelyFor.length; i++) {
                    let item = data.exclusivelyFor[i];
                    this.exclusivelyFor[i] = item && !(<any>item).toJSON ? new Item(item) : <Item>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.voucherType = _data["voucherType"];
            this.code = _data["code"];
            this.available = _data["available"];
            this.discount = _data["discount"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["exclusiveTo"])) {
                this.exclusiveTo = [] as any;
                for (let item of _data["exclusiveTo"])
                    this.exclusiveTo!.push(RentMyUser.fromJS(item));
            }
            if (Array.isArray(_data["exclusivelyFor"])) {
                this.exclusivelyFor = [] as any;
                for (let item of _data["exclusivelyFor"])
                    this.exclusivelyFor!.push(Item.fromJS(item));
            }
            this.redemptionCount = _data["redemptionCount"];
            this.redemptionLimit = _data["redemptionLimit"];
            this.isPercent = _data["isPercent"];
            this.minimumOrderValue = _data["minimumOrderValue"];
            this.stackable = _data["stackable"];
        }
    }

    static fromJS(data: any): Voucher {
        data = typeof data === 'object' ? data : {};
        let result = new Voucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["voucherType"] = this.voucherType;
        data["code"] = this.code;
        data["available"] = this.available;
        data["discount"] = this.discount;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        if (Array.isArray(this.exclusiveTo)) {
            data["exclusiveTo"] = [];
            for (let item of this.exclusiveTo)
                data["exclusiveTo"].push(item.toJSON());
        }
        if (Array.isArray(this.exclusivelyFor)) {
            data["exclusivelyFor"] = [];
            for (let item of this.exclusivelyFor)
                data["exclusivelyFor"].push(item.toJSON());
        }
        data["redemptionCount"] = this.redemptionCount;
        data["redemptionLimit"] = this.redemptionLimit;
        data["isPercent"] = this.isPercent;
        data["minimumOrderValue"] = this.minimumOrderValue;
        data["stackable"] = this.stackable;
        return data;
    }
}

export interface IVoucher {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string;
    voucherType: string;
    code: string;
    available: boolean;
    discount: number;
    validFrom: Date | undefined;
    validTo: Date | undefined;
    exclusiveTo: IRentMyUser[] | undefined;
    exclusivelyFor: IItem[] | undefined;
    redemptionCount: number;
    redemptionLimit: number | undefined;
    isPercent: boolean;
    minimumOrderValue: number | undefined;
    stackable: boolean;
}

export class VoucherCreateDto implements IVoucherCreateDto {
    active!: boolean | undefined;
    name!: string | undefined;
    voucherType!: string | undefined;
    code!: string | undefined;
    available!: boolean;
    discount!: number;
    validFrom!: Date | undefined;
    validTo!: Date | undefined;
    exclusiveTo!: string[] | undefined;
    exclusivelyFor!: string[] | undefined;
    redemptionLimit!: number | undefined;
    redemptionCount!: number;
    isPercent!: boolean;
    minimumOrderValue!: number | undefined;
    stackable!: boolean;

    constructor(data?: IVoucherCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.name = _data["name"];
            this.voucherType = _data["voucherType"];
            this.code = _data["code"];
            this.available = _data["available"];
            this.discount = _data["discount"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["exclusiveTo"])) {
                this.exclusiveTo = [] as any;
                for (let item of _data["exclusiveTo"])
                    this.exclusiveTo!.push(item);
            }
            if (Array.isArray(_data["exclusivelyFor"])) {
                this.exclusivelyFor = [] as any;
                for (let item of _data["exclusivelyFor"])
                    this.exclusivelyFor!.push(item);
            }
            this.redemptionLimit = _data["redemptionLimit"];
            this.redemptionCount = _data["redemptionCount"];
            this.isPercent = _data["isPercent"];
            this.minimumOrderValue = _data["minimumOrderValue"];
            this.stackable = _data["stackable"];
        }
    }

    static fromJS(data: any): VoucherCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["name"] = this.name;
        data["voucherType"] = this.voucherType;
        data["code"] = this.code;
        data["available"] = this.available;
        data["discount"] = this.discount;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        if (Array.isArray(this.exclusiveTo)) {
            data["exclusiveTo"] = [];
            for (let item of this.exclusiveTo)
                data["exclusiveTo"].push(item);
        }
        if (Array.isArray(this.exclusivelyFor)) {
            data["exclusivelyFor"] = [];
            for (let item of this.exclusivelyFor)
                data["exclusivelyFor"].push(item);
        }
        data["redemptionLimit"] = this.redemptionLimit;
        data["redemptionCount"] = this.redemptionCount;
        data["isPercent"] = this.isPercent;
        data["minimumOrderValue"] = this.minimumOrderValue;
        data["stackable"] = this.stackable;
        return data;
    }
}

export interface IVoucherCreateDto {
    active: boolean | undefined;
    name: string | undefined;
    voucherType: string | undefined;
    code: string | undefined;
    available: boolean;
    discount: number;
    validFrom: Date | undefined;
    validTo: Date | undefined;
    exclusiveTo: string[] | undefined;
    exclusivelyFor: string[] | undefined;
    redemptionLimit: number | undefined;
    redemptionCount: number;
    isPercent: boolean;
    minimumOrderValue: number | undefined;
    stackable: boolean;
}

export class VoucherDetailedDto implements IVoucherDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    name!: string | undefined;
    voucherType!: string | undefined;
    code!: string | undefined;
    available!: boolean;
    discount!: number;
    validFrom!: Date | undefined;
    validTo!: Date | undefined;
    exclusiveTo!: RentMyUserSimpleDto[] | undefined;
    exclusivelyFor!: ItemSimpleDto[] | undefined;
    redemptionLimit!: number | undefined;
    redemptionCount!: number;
    isPercent!: boolean;
    minimumOrderValue!: number | undefined;
    stackable!: boolean;

    constructor(data?: IVoucherDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.exclusiveTo) {
                this.exclusiveTo = [];
                for (let i = 0; i < data.exclusiveTo.length; i++) {
                    let item = data.exclusiveTo[i];
                    this.exclusiveTo[i] = item && !(<any>item).toJSON ? new RentMyUserSimpleDto(item) : <RentMyUserSimpleDto>item;
                }
            }
            if (data.exclusivelyFor) {
                this.exclusivelyFor = [];
                for (let i = 0; i < data.exclusivelyFor.length; i++) {
                    let item = data.exclusivelyFor[i];
                    this.exclusivelyFor[i] = item && !(<any>item).toJSON ? new ItemSimpleDto(item) : <ItemSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.voucherType = _data["voucherType"];
            this.code = _data["code"];
            this.available = _data["available"];
            this.discount = _data["discount"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["exclusiveTo"])) {
                this.exclusiveTo = [] as any;
                for (let item of _data["exclusiveTo"])
                    this.exclusiveTo!.push(RentMyUserSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["exclusivelyFor"])) {
                this.exclusivelyFor = [] as any;
                for (let item of _data["exclusivelyFor"])
                    this.exclusivelyFor!.push(ItemSimpleDto.fromJS(item));
            }
            this.redemptionLimit = _data["redemptionLimit"];
            this.redemptionCount = _data["redemptionCount"];
            this.isPercent = _data["isPercent"];
            this.minimumOrderValue = _data["minimumOrderValue"];
            this.stackable = _data["stackable"];
        }
    }

    static fromJS(data: any): VoucherDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["voucherType"] = this.voucherType;
        data["code"] = this.code;
        data["available"] = this.available;
        data["discount"] = this.discount;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        if (Array.isArray(this.exclusiveTo)) {
            data["exclusiveTo"] = [];
            for (let item of this.exclusiveTo)
                data["exclusiveTo"].push(item.toJSON());
        }
        if (Array.isArray(this.exclusivelyFor)) {
            data["exclusivelyFor"] = [];
            for (let item of this.exclusivelyFor)
                data["exclusivelyFor"].push(item.toJSON());
        }
        data["redemptionLimit"] = this.redemptionLimit;
        data["redemptionCount"] = this.redemptionCount;
        data["isPercent"] = this.isPercent;
        data["minimumOrderValue"] = this.minimumOrderValue;
        data["stackable"] = this.stackable;
        return data;
    }
}

export interface IVoucherDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    name: string | undefined;
    voucherType: string | undefined;
    code: string | undefined;
    available: boolean;
    discount: number;
    validFrom: Date | undefined;
    validTo: Date | undefined;
    exclusiveTo: IRentMyUserSimpleDto[] | undefined;
    exclusivelyFor: IItemSimpleDto[] | undefined;
    redemptionLimit: number | undefined;
    redemptionCount: number;
    isPercent: boolean;
    minimumOrderValue: number | undefined;
    stackable: boolean;
}

export class VoucherDetailedDtoPaginationDto implements IVoucherDetailedDtoPaginationDto {
    data!: VoucherDetailedDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IVoucherDetailedDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new VoucherDetailedDto(item) : <VoucherDetailedDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(VoucherDetailedDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): VoucherDetailedDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherDetailedDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IVoucherDetailedDtoPaginationDto {
    data: IVoucherDetailedDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class VoucherDetailedDtoUpdateResponseDto implements IVoucherDetailedDtoUpdateResponseDto {
    data!: VoucherDetailedDto;
    propertyResults!: { [key: string]: PropertyResult; } | undefined;

    constructor(data?: IVoucherDetailedDtoUpdateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.data = data.data && !(<any>data.data).toJSON ? new VoucherDetailedDto(data.data) : <VoucherDetailedDto>this.data;
            if (data.propertyResults) {
                this.propertyResults = {};
                for (let key in data.propertyResults) {
                    if (data.propertyResults.hasOwnProperty(key)) {
                        let item = data.propertyResults[key];
                        this.propertyResults[key] = item && !(<any>item).toJSON ? new PropertyResult(item) : <PropertyResult>item;
                    }
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? VoucherDetailedDto.fromJS(_data["data"]) : <any>undefined;
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (<any>this.propertyResults)![key] = _data["propertyResults"][key] ? PropertyResult.fromJS(_data["propertyResults"][key]) : new PropertyResult();
                }
            }
        }
    }

    static fromJS(data: any): VoucherDetailedDtoUpdateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherDetailedDtoUpdateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (<any>data["propertyResults"])[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IVoucherDetailedDtoUpdateResponseDto {
    data: IVoucherDetailedDto;
    propertyResults: { [key: string]: IPropertyResult; } | undefined;
}

export enum VoucherOrderBy {
    Relevance = "Relevance",
    Alphabetically = "Alphabetically",
    Discount = "Discount",
    Redemptions = "Redemptions",
}

export class VoucherRedemption implements IVoucherRedemption {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    voucher!: Voucher;
    user!: RentMyUser;
    isRedeemed!: boolean;
    currentlyReserved!: boolean;

    constructor(data?: IVoucherRedemption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.voucher = data.voucher && !(<any>data.voucher).toJSON ? new Voucher(data.voucher) : <Voucher>this.voucher;
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
        }
        if (!data) {
            this.voucher = new Voucher();
            this.user = new RentMyUser();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : new Voucher();
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : new RentMyUser();
            this.isRedeemed = _data["isRedeemed"];
            this.currentlyReserved = _data["currentlyReserved"];
        }
    }

    static fromJS(data: any): VoucherRedemption {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherRedemption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["voucher"] = this.voucher ? this.voucher.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["isRedeemed"] = this.isRedeemed;
        data["currentlyReserved"] = this.currentlyReserved;
        return data;
    }
}

export interface IVoucherRedemption {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    voucher: IVoucher;
    user: IRentMyUser;
    isRedeemed: boolean;
    currentlyReserved: boolean;
}

export class VoucherRedemptionDetailedDto implements IVoucherRedemptionDetailedDto {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    voucher!: VoucherSimpleDto;
    user!: RentMyUserSimpleDto;
    isRedeemed!: boolean;
    currentlyReserved!: boolean;

    constructor(data?: IVoucherRedemptionDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.voucher = data.voucher && !(<any>data.voucher).toJSON ? new VoucherSimpleDto(data.voucher) : <VoucherSimpleDto>this.voucher;
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUserSimpleDto(data.user) : <RentMyUserSimpleDto>this.user;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.voucher = _data["voucher"] ? VoucherSimpleDto.fromJS(_data["voucher"]) : <any>undefined;
            this.user = _data["user"] ? RentMyUserSimpleDto.fromJS(_data["user"]) : <any>undefined;
            this.isRedeemed = _data["isRedeemed"];
            this.currentlyReserved = _data["currentlyReserved"];
        }
    }

    static fromJS(data: any): VoucherRedemptionDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherRedemptionDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["voucher"] = this.voucher ? this.voucher.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["isRedeemed"] = this.isRedeemed;
        data["currentlyReserved"] = this.currentlyReserved;
        return data;
    }
}

export interface IVoucherRedemptionDetailedDto {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    voucher: IVoucherSimpleDto;
    user: IRentMyUserSimpleDto;
    isRedeemed: boolean;
    currentlyReserved: boolean;
}

export class VoucherRedemptionSimpleDto implements IVoucherRedemptionSimpleDto {
    id!: string;
    active!: boolean;
    voucherId!: string;
    userId!: string;
    isRedeemed!: boolean;
    currentlyReserved!: boolean;

    constructor(data?: IVoucherRedemptionSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.voucherId = _data["voucherId"];
            this.userId = _data["userId"];
            this.isRedeemed = _data["isRedeemed"];
            this.currentlyReserved = _data["currentlyReserved"];
        }
    }

    static fromJS(data: any): VoucherRedemptionSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherRedemptionSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["voucherId"] = this.voucherId;
        data["userId"] = this.userId;
        data["isRedeemed"] = this.isRedeemed;
        data["currentlyReserved"] = this.currentlyReserved;
        return data;
    }
}

export interface IVoucherRedemptionSimpleDto {
    id: string;
    active: boolean;
    voucherId: string;
    userId: string;
    isRedeemed: boolean;
    currentlyReserved: boolean;
}

export class VoucherSimpleDto implements IVoucherSimpleDto {
    id!: string;
    active!: boolean;
    name!: string | undefined;
    voucherType!: string | undefined;
    code!: string | undefined;
    available!: boolean;
    discount!: number;
    validFrom!: Date | undefined;
    validTo!: Date | undefined;
    exclusiveTo!: RentMyUserPublicSimpleDto[] | undefined;
    exclusivelyFor!: ItemPublicSimpleDto[] | undefined;
    redemptionLimit!: number | undefined;
    redemptionCount!: number;
    isPercent!: boolean;
    minimumOrderValue!: number | undefined;
    stackable!: boolean;

    constructor(data?: IVoucherSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.exclusiveTo) {
                this.exclusiveTo = [];
                for (let i = 0; i < data.exclusiveTo.length; i++) {
                    let item = data.exclusiveTo[i];
                    this.exclusiveTo[i] = item && !(<any>item).toJSON ? new RentMyUserPublicSimpleDto(item) : <RentMyUserPublicSimpleDto>item;
                }
            }
            if (data.exclusivelyFor) {
                this.exclusivelyFor = [];
                for (let i = 0; i < data.exclusivelyFor.length; i++) {
                    let item = data.exclusivelyFor[i];
                    this.exclusivelyFor[i] = item && !(<any>item).toJSON ? new ItemPublicSimpleDto(item) : <ItemPublicSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.name = _data["name"];
            this.voucherType = _data["voucherType"];
            this.code = _data["code"];
            this.available = _data["available"];
            this.discount = _data["discount"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["exclusiveTo"])) {
                this.exclusiveTo = [] as any;
                for (let item of _data["exclusiveTo"])
                    this.exclusiveTo!.push(RentMyUserPublicSimpleDto.fromJS(item));
            }
            if (Array.isArray(_data["exclusivelyFor"])) {
                this.exclusivelyFor = [] as any;
                for (let item of _data["exclusivelyFor"])
                    this.exclusivelyFor!.push(ItemPublicSimpleDto.fromJS(item));
            }
            this.redemptionLimit = _data["redemptionLimit"];
            this.redemptionCount = _data["redemptionCount"];
            this.isPercent = _data["isPercent"];
            this.minimumOrderValue = _data["minimumOrderValue"];
            this.stackable = _data["stackable"];
        }
    }

    static fromJS(data: any): VoucherSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["name"] = this.name;
        data["voucherType"] = this.voucherType;
        data["code"] = this.code;
        data["available"] = this.available;
        data["discount"] = this.discount;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        if (Array.isArray(this.exclusiveTo)) {
            data["exclusiveTo"] = [];
            for (let item of this.exclusiveTo)
                data["exclusiveTo"].push(item.toJSON());
        }
        if (Array.isArray(this.exclusivelyFor)) {
            data["exclusivelyFor"] = [];
            for (let item of this.exclusivelyFor)
                data["exclusivelyFor"].push(item.toJSON());
        }
        data["redemptionLimit"] = this.redemptionLimit;
        data["redemptionCount"] = this.redemptionCount;
        data["isPercent"] = this.isPercent;
        data["minimumOrderValue"] = this.minimumOrderValue;
        data["stackable"] = this.stackable;
        return data;
    }
}

export interface IVoucherSimpleDto {
    id: string;
    active: boolean;
    name: string | undefined;
    voucherType: string | undefined;
    code: string | undefined;
    available: boolean;
    discount: number;
    validFrom: Date | undefined;
    validTo: Date | undefined;
    exclusiveTo: IRentMyUserPublicSimpleDto[] | undefined;
    exclusivelyFor: IItemPublicSimpleDto[] | undefined;
    redemptionLimit: number | undefined;
    redemptionCount: number;
    isPercent: boolean;
    minimumOrderValue: number | undefined;
    stackable: boolean;
}

export class VoucherSimpleDtoPaginationDto implements IVoucherSimpleDtoPaginationDto {
    data!: VoucherSimpleDto[] | undefined;
    parameters!: { [key: string]: string; } | undefined;
    totalDataCount!: number;
    dataCount!: number;
    page!: number;
    pageCount!: number;
    pageSize!: number;
    previousPage!: string | undefined;
    nextPage!: string | undefined;

    constructor(data?: IVoucherSimpleDtoPaginationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new VoucherSimpleDto(item) : <VoucherSimpleDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(VoucherSimpleDto.fromJS(item));
            }
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (<any>this.parameters)![key] = _data["parameters"][key];
                }
            }
            this.totalDataCount = _data["totalDataCount"];
            this.dataCount = _data["dataCount"];
            this.page = _data["page"];
            this.pageCount = _data["pageCount"];
            this.pageSize = _data["pageSize"];
            this.previousPage = _data["previousPage"];
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): VoucherSimpleDtoPaginationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherSimpleDtoPaginationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (<any>data["parameters"])[key] = (<any>this.parameters)[key];
            }
        }
        data["totalDataCount"] = this.totalDataCount;
        data["dataCount"] = this.dataCount;
        data["page"] = this.page;
        data["pageCount"] = this.pageCount;
        data["pageSize"] = this.pageSize;
        data["previousPage"] = this.previousPage;
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IVoucherSimpleDtoPaginationDto {
    data: IVoucherSimpleDto[] | undefined;
    parameters: { [key: string]: string; } | undefined;
    totalDataCount: number;
    dataCount: number;
    page: number;
    pageCount: number;
    pageSize: number;
    previousPage: string | undefined;
    nextPage: string | undefined;
}

export class WalletDto implements IWalletDto {
    lifetimeEarnings!: number;
    arrivingSoon!: number;
    payoutAvailable!: number;

    constructor(data?: IWalletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lifetimeEarnings = _data["lifetimeEarnings"];
            this.arrivingSoon = _data["arrivingSoon"];
            this.payoutAvailable = _data["payoutAvailable"];
        }
    }

    static fromJS(data: any): WalletDto {
        data = typeof data === 'object' ? data : {};
        let result = new WalletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lifetimeEarnings"] = this.lifetimeEarnings;
        data["arrivingSoon"] = this.arrivingSoon;
        data["payoutAvailable"] = this.payoutAvailable;
        return data;
    }
}

export interface IWalletDto {
    lifetimeEarnings: number;
    arrivingSoon: number;
    payoutAvailable: number;
}

export class WatchedItem implements IWatchedItem {
    id!: string;
    active!: boolean;
    creation!: Date | undefined;
    lastChange!: Date | undefined;
    user!: RentMyUser;
    item!: Item;
    watchEndDateTime!: Date | undefined;

    constructor(data?: IWatchedItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new RentMyUser(data.user) : <RentMyUser>this.user;
            this.item = data.item && !(<any>data.item).toJSON ? new Item(data.item) : <Item>this.item;
        }
        if (!data) {
            this.user = new RentMyUser();
            this.item = new Item();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>undefined;
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.user = _data["user"] ? RentMyUser.fromJS(_data["user"]) : new RentMyUser();
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : new Item();
            this.watchEndDateTime = _data["watchEndDateTime"] ? new Date(_data["watchEndDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WatchedItem {
        data = typeof data === 'object' ? data : {};
        let result = new WatchedItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>undefined;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["watchEndDateTime"] = this.watchEndDateTime ? this.watchEndDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWatchedItem {
    id: string;
    active: boolean;
    creation: Date | undefined;
    lastChange: Date | undefined;
    user: IRentMyUser;
    item: IItem;
    watchEndDateTime: Date | undefined;
}

export class WatchedItemSimpleDto implements IWatchedItemSimpleDto {
    id!: string;
    active!: boolean;
    userId!: string;
    itemId!: string;
    watchEndDateTime!: Date | undefined;

    constructor(data?: IWatchedItemSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.userId = _data["userId"];
            this.itemId = _data["itemId"];
            this.watchEndDateTime = _data["watchEndDateTime"] ? new Date(_data["watchEndDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WatchedItemSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new WatchedItemSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["userId"] = this.userId;
        data["itemId"] = this.itemId;
        data["watchEndDateTime"] = this.watchEndDateTime ? this.watchEndDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWatchedItemSimpleDto {
    id: string;
    active: boolean;
    userId: string;
    itemId: string;
    watchEndDateTime: Date | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

/**
 * Configuration class needed in base class. This file is not used in compilation - just referenced by NSwag studio (hence why it's not in the src folder)
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 */
export class IConfig {
    /**
     * Returns a valid value for the Authorization header.
     * Used to dynamically inject the current auth header.
     */
    getAuthorization() {
        return this.token;
    }
    private readonly token: string;

    constructor(authToken : string) {
        this.token =`bearer `+authToken;
    }
}